"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() { }; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof2(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof2(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof2(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof2(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg; ;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg; else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray2(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }
theme.Currency = function () {
  var moneyFormat = '${{amount}}';
  var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  function formatMoney(cents, format) {
    if (!format) {
      format = theme.settings.moneyFormat;
    }
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ',');
      decimal = theme.utils.defaultTo(decimal, '.');
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        if (superScript && value && value.includes('.')) {
          value = value.replace('.', '<sup>') + '</sup>';
        }
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        if (superScript && value && value.includes('.')) {
          value = value.replace(',', '<sup>') + '</sup>';
        }
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }
    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }
    return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
  }
  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit
  };
}();
var _get = function e(t, o, i) {
  null === t && (t = Function.prototype);
  var n = Object.getOwnPropertyDescriptor(t, o);
  if (void 0 === n) {
    var r = Object.getPrototypeOf(t);
    return null === r ? void 0 : e(r, o, i);
  }
  if ("value" in n) return n.value;
  var a = n.get;
  return void 0 !== a ? a.call(i) : void 0;
},
  _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (e) {
    return _typeof2(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof2(e);
  },
  _createClass = function () {
    function i(e, t) {
      for (var o = 0; o < t.length; o++) {
        var i = t[o];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }
    return function (e, t, o) {
      return t && i(e.prototype, t), o && i(e, o), e;
    };
  }();
function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != _typeof2(t) && "function" != typeof t ? e : t;
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof2(t));
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
function _toConsumableArray(e) {
  if (Array.isArray(e)) {
    for (var t = 0, o = Array(e.length); t < e.length; t++) o[t] = e[t];
    return o;
  }
  return Array.from(e);
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
!function (s, c) {
  var e = (_createClass(t, [{
    key: "_handleize",
    value: function value() {
      for (var e = [{
        base: "A",
        letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
      }, {
        base: "AA",
        letters: "Ꜳ"
      }, {
        base: "AE",
        letters: "ÆǼǢ"
      }, {
        base: "AO",
        letters: "Ꜵ"
      }, {
        base: "AU",
        letters: "Ꜷ"
      }, {
        base: "AV",
        letters: "ꜸꜺ"
      }, {
        base: "AY",
        letters: "Ꜽ"
      }, {
        base: "B",
        letters: "BⒷＢḂḄḆɃƂƁ"
      }, {
        base: "C",
        letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
      }, {
        base: "D",
        letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
      }, {
        base: "DZ",
        letters: "ǱǄ"
      }, {
        base: "Dz",
        letters: "ǲǅ"
      }, {
        base: "E",
        letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
      }, {
        base: "F",
        letters: "FⒻＦḞƑꝻ"
      }, {
        base: "G",
        letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
      }, {
        base: "H",
        letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
      }, {
        base: "I",
        letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
      }, {
        base: "J",
        letters: "JⒿＪĴɈ"
      }, {
        base: "K",
        letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
      }, {
        base: "L",
        letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
      }, {
        base: "LJ",
        letters: "Ǉ"
      }, {
        base: "Lj",
        letters: "ǈ"
      }, {
        base: "M",
        letters: "MⓂＭḾṀṂⱮƜ"
      }, {
        base: "N",
        letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
      }, {
        base: "NJ",
        letters: "Ǌ"
      }, {
        base: "Nj",
        letters: "ǋ"
      }, {
        base: "O",
        letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
      }, {
        base: "OI",
        letters: "Ƣ"
      }, {
        base: "OO",
        letters: "Ꝏ"
      }, {
        base: "OU",
        letters: "Ȣ"
      }, {
        base: "OE",
        letters: "Œ"
      }, {
        base: "oe",
        letters: "œ"
      }, {
        base: "P",
        letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
      }, {
        base: "Q",
        letters: "QⓆＱꝖꝘɊ"
      }, {
        base: "R",
        letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
      }, {
        base: "S",
        letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
      }, {
        base: "T",
        letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
      }, {
        base: "TZ",
        letters: "Ꜩ"
      }, {
        base: "U",
        letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
      }, {
        base: "V",
        letters: "VⓋＶṼṾƲꝞɅ"
      }, {
        base: "VY",
        letters: "Ꝡ"
      }, {
        base: "W",
        letters: "WⓌＷẀẂŴẆẄẈⱲ"
      }, {
        base: "X",
        letters: "XⓍＸẊẌ"
      }, {
        base: "Y",
        letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
      }, {
        base: "Z",
        letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
      }, {
        base: "a",
        letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
      }, {
        base: "aa",
        letters: "ꜳ"
      }, {
        base: "ae",
        letters: "æǽǣ"
      }, {
        base: "ao",
        letters: "ꜵ"
      }, {
        base: "au",
        letters: "ꜷ"
      }, {
        base: "av",
        letters: "ꜹꜻ"
      }, {
        base: "ay",
        letters: "ꜽ"
      }, {
        base: "b",
        letters: "bⓑｂḃḅḇƀƃɓ"
      }, {
        base: "c",
        letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
      }, {
        base: "d",
        letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
      }, {
        base: "dz",
        letters: "ǳǆ"
      }, {
        base: "e",
        letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
      }, {
        base: "f",
        letters: "fⓕｆḟƒꝼ"
      }, {
        base: "g",
        letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
      }, {
        base: "h",
        letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
      }, {
        base: "hv",
        letters: "ƕ"
      }, {
        base: "i",
        letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
      }, {
        base: "j",
        letters: "jⓙｊĵǰɉ"
      }, {
        base: "k",
        letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
      }, {
        base: "l",
        letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
      }, {
        base: "lj",
        letters: "ǉ"
      }, {
        base: "m",
        letters: "mⓜｍḿṁṃɱɯ"
      }, {
        base: "n",
        letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
      }, {
        base: "nj",
        letters: "ǌ"
      }, {
        base: "o",
        letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
      }, {
        base: "oi",
        letters: "ƣ"
      }, {
        base: "ou",
        letters: "ȣ"
      }, {
        base: "oo",
        letters: "ꝏ"
      }, {
        base: "p",
        letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
      }, {
        base: "q",
        letters: "qⓠｑɋꝗꝙ"
      }, {
        base: "r",
        letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
      }, {
        base: "s",
        letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
      }, {
        base: "t",
        letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
      }, {
        base: "tz",
        letters: "ꜩ"
      }, {
        base: "u",
        letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
      }, {
        base: "v",
        letters: "vⓥｖṽṿʋꝟʌ"
      }, {
        base: "vy",
        letters: "ꝡ"
      }, {
        base: "w",
        letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
      }, {
        base: "x",
        letters: "xⓧｘẋẍ"
      }, {
        base: "y",
        letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
      }, {
        base: "z",
        letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
      }], i = {}, t = 0; t < e.length; t++) for (var o = e[t].letters.split(""), n = 0; n < o.length; n++) i[o[n]] = e[t].base;
      String.prototype.noAccents = function (e, t) {
        var o = this.replace(/[^\u0000-\u007E]/g, function (e) {
          return i[e] || e;
        });
        return t = t || "", e && (o = o.replace(/[^\u0000-\u007E]/g, t)), o;
      }, String.prototype.handleize = function (e, t) {
        return e = e || "-", t = t || "", this.noAccents(!0, t).trim().replace(/[^a-z0-9\s-]/gi, t).replace(/\s/gi, e).toLowerCase();
      };
    }
  }, {
    key: "toMoney",
    value: function value(e, t) {
      var o = 1 < arguments.length && void 0 !== t ? t : {};
      if (!e) return console.warn("Utilities.toMoney: Invalid price passed.", e), null;
      var i = void 0,
        n = {
          style: "currency"
        };
      function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      var txt = $('.js-localization-selector span').text();
      var spl = txt.split(" | ");
      var fin = spl[1].replace("\n  ", "").toUpperCase();
      var fn = numberWithCommas(e / 100),
        curss = document.getElementById("cursym").innerText;
      // console.log('e' + curss + fn);
      return e = fin + fn;

      //            if(typeof e === 'string' && e.includes('.')) {
      // // console.log('return 1')
      //              e = new Number(e), o.cents = o.cents || !1, o.locale = o.locale || (s.shop ? s.shop.locale : null) || "en-CA", n.currency = o.currency || (s.shop ? s.shop.currency : null) || "CAD", o.cents && (e /= 100), i = e.toLocaleString(o.locale, n), o.no_zeros && ~i.indexOf(".00") && (i = i.replace(".00", "")), i;
      //             return e = e.substring(0, e.length-3);
      //            } else {
      // // console.log('return 2')
      //              return e = new Number(e), o.cents = o.cents || !1, o.locale = o.locale || (s.shop ? s.shop.locale : null) || "en-CA", n.currency = o.currency || (s.shop ? s.shop.currency : null) || "CAD", o.cents && (e /= 100), i = e.toLocaleString(o.locale, n), o.no_zeros && ~i.indexOf(".00") && (i = i.replace(".00", "")), i;
      //            }
    }
  }, {
    key: "defaultTo",
    value: function value(e, t) {
      return e == null || e !== e ? t : e;
    }
  }, {
    key: "removeProtocol",
    value: function value(e) {
      return e ? e.replace(/http(s)?:/, "") : (console.error("Utilities.removeProtocol: Invalid path passed.", e), null);
    }
  }, {
    key: "getSizedImageUrl",
    value: function value(e, t) {
      if (!t) return console.error("Utilities.getSizedImageUrl: Invalid size passed.", t), e;
      if ("master" === t) return this.removeProtocol(e);
      var o = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (o) {
        var i = e.split(o[0]),
          n = o[0];
        return this.removeProtocol(i[0] + "_" + t + n);
      }
      return console.error("Utilities.getSizedImageUrl: Invalid image URL passed.", e), null;
    }
  }, {
    key: "toObject",
    value: function value(e) {
      var n = {};
      return e ? (e.split("&").forEach(function (e) {
        var t = e.indexOf("=");
        if (-1 == t) n[decodeURIComponent(e)] = null; else {
          var o = decodeURIComponent(e.slice(0, t)),
            i = decodeURIComponent(e.slice(t + 1)) || null;
          n[o] = i;
        }
      }), n) : {};
    }
  }, {
    key: "getURLParams",
    value: function value(e) {
      var t = (e = e || window.location.href).split(/\?([^\#]+)/)[1];
      return t ? this.toObject(t) : {};
    }
  }, {
    key: "setURLParams",
    value: function value(o, e) {
      var i = 1 < arguments.length && void 0 !== e ? e : {},
        t = this.getURLParams(),
        n = i.clear ? {} : t,
        r = [],
        a = "";
      Object.keys(o).forEach(function (e) {
        var t = o[e];
        n[e] = i.no_overwrite && n[e] || t;
      }), Object.keys(n).forEach(function (e) {
        r.push(encodeURIComponent(e) + "=" + encodeURIComponent(n[e]));
      }), r.length && (a = "?" + r.join("&")), i.push_state ? window.history.pushState({}, null, a) : window.history.replaceState({}, null, a);
    }
  }, {
    key: "modifyObject",
    value: function value(e, t, o) {
      var i = (o = o || {}).clear ? {} : e || {};
      return e && t && "object" === (void 0 === t ? "undefined" : _typeof(t)) ? (Object.keys(t).forEach(function (e) {
        i[e] = o.no_overwrite && i[e] || t[e];
      }), i) : i || {};
    }
  }, {
    key: "uniqueNumber",
    value: function value(e) {
      e = e || 6;
      for (var t = Math.floor(Math.random() * Math.pow(10, e)); -1 !== this._rendered_numbers.indexOf(t);) t = Math.floor(Math.random() * Math.pow(10, e));
      return this._rendered_numbers.push(t), t;
    }
  }, {
    key: "throttle",
    value: function value(e, t) {
      var o = Date.now();
      return function () {
        o + t - Date.now() < 0 && (e(), o = Date.now());
      };
    }
  }, {
    key: "setCookie",
    value: function value(e, t, o) {
      var i = new Date();
      i.setTime(i.getTime() + 864e5 * o), document.cookie = e + "=" + t + ";path=/;expires=" + i.toGMTString();
    }
  }, {
    key: "getCookie",
    value: function value(e) {
      var t = document.cookie.match("(^|;) ?" + e + "=([^;]*)(;|$)");
      return t ? t[2] : null;
    }
  }, {
    key: "throttled",
    value: function value(t, o) {
      var i = void 0;
      return function () {
        var e = arguments;
        i || (t.apply(this, e), i = !0, setTimeout(function () {
          return i = !1;
        }, o));
      };
    }
  }, {
    key: "accordion",
    value: function value(t, e, o, i, n, r) {
      if ("menu" == r ? n.classList.contains("hide") && t.classList.toggle("is-active") : t.classList.toggle("is-active"), n.matches(".hide")) {
        if ((t.classList.contains("js-accordion-product") || t.classList.contains("js-accordion-review")) && -1 < s.product.title.indexOf("-")) {
          var a = document.querySelector(".js-option-selector:checked").dataset.colorId;
          o.forEach(function (e) {
            (e.closest('.js-accordion-product[data-color-id="' + a + '"]') || e.closest(".js-accordion-review")) && (e.classList.add("hide"), c(e).closest(".js-accordion-item").find(".js-accordion-wrapper").slideUp().addClass("hide"));
          }), e.forEach(function (e) {
            (e.closest('.js-accordion-product[data-color-id="' + a + '"]') || e.closest(".js-accordion-review")) && (e.classList.remove("hide"), e.closest('.js-accordion-product[data-color-id="' + a + '"]') !== t && e.closest(".js-accordion-review") !== t || (e.classList.toggle("hide"), c(e).closest(".js-accordion-item").find(".js-accordion-wrapper").slideDown({
              done: function done() {
                c(this).css("display", "block");
              }
            }).removeClass("hide"), e.nextElementSibling.classList.remove("hide")));
          });
        } else e.forEach(function (e) {
          return e.classList.remove("hide");
        }), o.forEach(function (e) {
          return e.classList.add("hide");
        }), c(i).slideUp().addClass("hide"), c(t).find(i).slideDown({
          done: function done() {
            c(this).css("display", "block");
          }
        }).removeClass("hide"), t.querySelector(".js-item-open").classList.toggle("hide"), t.querySelector(".js-item-close").classList.toggle("hide");
        c(".js-recommended-product-gallery").hasClass("slick-initialized") || c(".js-recommended-product-gallery").slick({
          dots: !1,
          arrows: !0,
          infinite: !1,
          speed: 300,
          slidesToShow: 1,
          nextArrow: '<button class="slick-next slick-arrow slider-arrow slider-arrow--next js-modal-click-exclude" aria-label="Next" type="button" style="">Next</button>',
          prevArrow: '<button class="slick-prev slick-arrow slider-arrow slider-arrow--prev js-modal-click-exclude" aria-label="Previous" type="button" style="">Previous</button>'
        });
      } else c(t).find(i).slideUp().addClass("hide"), c(".js-recommended-product-gallery").hasClass("slick-initialized") && c(".js-recommended-product-gallery").slick("unslick"), t.querySelector(".js-item-open").classList.toggle("hide"), t.querySelector(".js-item-close").classList.toggle("hide");
    }
  }, {
    key: "targetIs",
    value: function value(e, t) {
      for (var o = Array.prototype.slice.call(t); e;) {
        if (-1 !== o.indexOf(e)) return !0;
        e = e.parentElement;
      }
      return !1;
    }
  }, {
    key: "setAttributes",
    value: function value(e, t) {
      for (var o in t) e.setAttribute(o, t[o]);
    }
  }, {
    key: "parseHTML",
    value: function value(e, t) {
      var o,
        i,
        n,
        r = {
          option: [1, "<select multiple='multiple'>", "</select>"],
          thead: [1, "<table>", "</table>"],
          col: [2, "<table><colgroup>", "</colgroup></table>"],
          tr: [2, "<table><tbody>", "</tbody></table>"],
          td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
          _default: [0, "", ""]
        },
        a = (t = t || document).createDocumentFragment();
      if (/<|&#?\w+;/.test(e)) {
        for (o = a.appendChild(t.createElement("div")), i = r[(/<([\w:]+)/.exec(e) || ["", ""])[1].toLowerCase()] || r._default, o.innerHTML = i[1] + e.replace(/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi, "<$1></$2>") + i[2], n = i[0]; n--;) o = o.lastChild;
        for (a.removeChild(a.firstChild); o.firstChild;) a.appendChild(o.firstChild);
      } else a.appendChild(t.createTextNode(e));
      return a;
    }
  }]), t);
  function t() {
    _classCallCheck(this, t), this._handleize(), this._rendered_numbers = [];
  }
  s.utils = new e();
}(window.theme = window.theme || {}, jQuery), function (u, h) {
  var e = (_createClass(t, [{
    key: "monetateAddCartRows",
    value: function value() {
      h.get("/cart.json").then(function (e) {
        var t = e.items,
          i = [];
        t.forEach(function (e) {
          var t = e.price / 100,
            o = e.sku;
          i.push({
            productId: e.product_id,
            quantity: e.quantity,
            unitPrice: t,
            sku: o,
            currency: cartContent.currency
          });
        }), window.monetateQ = window.monetateQ || [], window.monetateQ.push(["addCartRows", i]), window.monetateQ.push(["setPageType", u.template.page_type]), localStorage.getItem("updating-bundle") ? localStorage.removeItem("updating-bundle") : window.monetateQ.push(["trackData"]);
      });
    }
  }, {
    key: "fetch",
    value: function value(e) {
      var t = this,
        o = (0 < arguments.length && void 0 !== e ? e : {}).silent,
        i = void 0 !== o && o;
      return this._queue = this._queue.then(function () {
        return h.ajax({
          url: "/cart.js",
          type: "GET",
          dataType: "json"
        }).done(function (e) {
          t.content = e, i || h(document).trigger("Cart:fetch", t.content);
        }).fail(function (e) {
          console.error("Cart.fetch: Failed getting the cart.", e), console.warn("Clearing the theme.cart._queue object"), t._queue = h.when();
        });
      }), this._queue;
    }
  }, {
    key: "add",
    value: function value(e, t, o_p) {
      var o = this,
        i = (1 < arguments.length && void 0 !== t ? t : {}).silent,
        n = void 0 !== i && i;
      return e ? ("object" != (void 0 === e ? "undefined" : _typeof(e)) && (e = {
        id: e
      }), e.quantity = e.quantity || 1, e.properties = o_p || {}, this._queue = this._queue.then(function () {
        return h.ajax({
          url: "/cart/add.js",
          data: e,
          type: "POST",
          dataType: "json"
        }).done(function (e) {
          // console.log('cart add');
          o.fetch({
            silent: n
          }), n || (h(document).trigger("Cart:add", e), o.monetateAddCartRows());
        }).fail(function (e) {
          console.error("Cart.add: Failed adding to the cart.", e), console.warn("Clearing the theme.cart._queue object"), o._queue = h.when();
        });
      }), this._queue) : (console.warn("Cart.add: No item was passed."), h.when());
    }
  }, {
    key: "update",
    value: function value(t, e) {
      var o = this,
        i = (1 < arguments.length && void 0 !== e ? e : {}).silent,
        n = void 0 !== i && i;
      if (!t) return console.warn("Cart.update: No item was passed."), h.when();
      function r(e) {
        if ("object" === (void 0 === e ? "undefined" : _typeof(e))) {
          if (!e.id) return console.warn("Cart.update: No id was passed with the product object."), h.when();
          a[e.id] = e.quantity || 0 === e.quantity ? e.quantity : 1;
        } else a[e] = 1;
      }
      var a = {};
      return Array.isArray(t) ? t.forEach(function (e) {
        r(e);
      }) : r(t), Object.keys(a).length ? (this._queue = this._queue.then(function () {
        return h.ajax({
          url: "/cart/update.js",
          data: {
            updates: a
          },
          type: "POST",
          dataType: "json"
        }).done(function (e) {
          o.content = e, n || h(document).trigger("Cart:update", [e, t]), o.monetateAddCartRows();
        }).fail(function (e) {
          console.error("Cart.update: Failed updating a cart item.", e), console.warn("Clearing the theme.cart._queue object"), o._queue = h.when();
        });
      }), this._queue) : h.when();
    }
  }, {
    key: "change",
    value: function value(t, e) {
      var o = this,
        i = (1 < arguments.length && void 0 !== e ? e : {}).silent,
        n = void 0 !== i && i;
      return t ? ("object" != (void 0 === t ? "undefined" : _typeof(t)) && (t = {
        id: t,
        quantity: 1
      }), this._queue = this._queue.then(function () {
        return h.ajax({
          url: "/cart/change.js",
          data: t,
          type: "POST",
          dataType: "json"
        }).done(function (e) {
          o.content = e, n || (h(document).trigger("Cart:change", [e, t]), o.monetateAddCartRows());
        }).fail(function (e) {
          console.error("Cart.change: Failed changing a cart quantity.", e), console.warn("Clearing the theme.cart._queue object"), o._queue = h.when();
        });
      }), this._queue) : (console.warn("Cart.change: No item was passed."), h.when());
    }
  }, {
    key: "remove",
    value: function value(e, t) {
      var o = (1 < arguments.length && void 0 !== t ? t : {}).silent,
        i = void 0 !== o && o;
      if (!e) return console.warn("Cart.remove: No item was passed."), h.when();
      var n = [];
      return Array.isArray(e) ? e.forEach(function (e) {
        n.push({
          id: "object" === (void 0 === e ? "undefined" : _typeof(e)) ? e.id : e,
          quantity: 0
        });
      }) : n.push({
        id: "object" === (void 0 === e ? "undefined" : _typeof(e)) ? e.id : e,
        quantity: 0
      }), this.monetateAddCartRows(), this.update(n, {
        silent: i
      });
    }
  }, {
    key: "clear",
    value: function value(e) {
      var t = this,
        o = (0 < arguments.length && void 0 !== e ? e : {}).silent,
        i = void 0 !== o && o;
      return this._queue = this._queue.then(function () {
        return h.ajax({
          url: "/cart/clear.js",
          type: "POST",
          dataType: "json"
        }).done(function (e) {
          t.content = e, i || (h(document).trigger("Cart:clear", e), t.monetateAddCartRows());
        }).fail(function (e) {
          console.error("Cart.clear: Failed clearing the cart.", e), console.warn("Clearing the theme.cart._queue object"), t._queue = h.when();
        });
      }), this._queue;
    }
  }, {
    key: "updateAttributes",
    value: function value(e, t) {
      var o = this,
        i = 1 < arguments.length && void 0 !== t ? t : {},
        n = i.no_overwrite,
        r = void 0 !== n && n,
        a = i.silent,
        s = void 0 !== a && a;
      if (!e) return console.warn("Cart.updateAttribute: No attributes were passed."), h.when();
      var c = {};
      if (r) {
        var l = !0,
          d = !1,
          u = void 0;
        try {
          for (var m, p = Object.keys(e)[Symbol.iterator](); !(l = (m = p.next()).done); l = !0) {
            var f = m.value;
            this.content.attributes[f] || (c[f] = e[f]);
          }
        } catch (e) {
          d = !0, u = e;
        } finally {
          try {
            !l && p["return"] && p["return"]();
          } finally {
            if (d) throw u;
          }
        }
      } else c = e;
      return Object.keys(c).length ? (this._queue = this._queue.then(function () {
        return h.ajax({
          url: "/cart/update.js",
          data: {
            attributes: c
          },
          type: "POST",
          dataType: "json"
        }).done(function (e) {
          o.content = e, s || (h(document).trigger("Cart:update", [e, c]), o.monetateAddCartRows());
        }).fail(function (e) {
          console.error("Cart.attributeUpdate: Failed updating a cart attribute.", e), console.warn("Clearing the theme.cart._queue object"), o._queue = h.when();
        });
      }), this._queue) : h.when();
    }
  }, {
    key: "clearAttributes",
    value: function value(e, t) {
      var o = (1 < arguments.length && void 0 !== t ? t : {}).silent,
        i = void 0 !== o && o,
        n = {},
        r = void 0 !== e ? [].concat(e || []) : Object.keys(u.cart.content.attributes),
        a = !0,
        s = !1,
        c = void 0;
      try {
        for (var l, d = r[Symbol.iterator](); !(a = (l = d.next()).done); a = !0) n[l.value] = "";
      } catch (e) {
        s = !0, c = e;
      } finally {
        try {
          !a && d["return"] && d["return"]();
        } finally {
          if (s) throw c;
        }
      }
      return this.updateAttributes(n, {
        silent: i
      });
    }
  }, {
    key: "content",
    get: function get() {
      return this._object;
    },
    set: function set(e) {
      this._object = e || this._object, h(document).trigger("Cart:set", this.content);
    }
  }]), t);
  function t(e) {
    _classCallCheck(this, t), this.content = e || {}, this._queue = h.when(), e || this.fetch();
  }
  u.cart = new e(u.cart || null);
}(window.theme = window.theme || {}, jQuery), function (i, n) {
  var e = (_createClass(t, [{
    key: "update",
    value: function value(t) {
      var o = this;
      if (!t || "object" !== (void 0 === t ? "undefined" : _typeof(t))) return !1;
      t.handle ? t = [t] : Array.isArray(t) || (t = Object.keys(t).map(function (e) {
        return t[e];
      }).filter(function (e) {
        return e.handle;
      })), t.forEach(function (e) {
        if (e.handle) if (o._list[e.handle]) {
          var t = i.utils.modifyObject(o._list[e.handle], e);
          o._list[e.handle] = t, n(document).trigger("Products:update", t);
        } else o._list[e.handle] = e, n(document).trigger("Products:add", e);
      });
    }
  }, {
    key: "list",
    get: function get() {
      return this._list;
    },
    set: function set() {
      return !1;
    }
  }]), t);
  function t(e) {
    _classCallCheck(this, t), this._list = e || {};
  }
  i.products = new e(i.products && i.products.list ? i.products.list : {});
}(window.theme = window.theme || {}, jQuery), function (o, a) {
  var r = a.extend({
    closeOnEscape: !0,
    closeOnOverlayClick: !0,
    overlay: a("<div>"),
    hideOverlayOnClose: !0,
    trapTabKey: !0,
    focusOnOpen: !0
  }, o.MODAL_DEFAULTS),
    s = Object.freeze({
      CLOSED: "closed",
      OPENED: "opened"
    }),
    i = (_createClass(c, [{
      key: "_handleTabKey",
      value: function value(e) {
        e.shiftKey ? this.$firstFocusableElement.is(":focus") && (e.preventDefault(), this.$lastFocusableElement.focus()) : this.$lastFocusableElement.is(":focus") && (e.preventDefault(), this.$firstFocusableElement.focus());
      }
    }, {
      key: "open",
      value: function value() {
        this.state !== s.OPENED && (this.$overlay.removeClass("hidden").show(), this.$modal.removeClass("is-" + this.state).addClass("is-" + (this.state = s.OPENED)).show(), this.settings.focusOnOpen && (this.$focusedElementBeforeModal = a(":focus"), this.$firstFocusableElement.focus()), a("body").addClass("noscroll"));
      }
    }, {
      key: "close",
      value: function value() {
        this.state !== s.CLOSED && (this.settings.hideOverlayOnClose && this.$overlay.addClass("hidden").off("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd").on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function (e) {
          a(this).hide(), a(this).off(e);
        }), this.$modal.removeClass("is-" + this.state).addClass("is-" + (this.state = s.CLOSED)).off("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd").on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function (e) {
          a(this).hide(), a(this).off(e);
        }), a("body").removeClass("noscroll"), this.hideSaleGateway(), this.settings.focusOnOpen && this.$focusedElementBeforeModal.focus());
      }
    }, {
      key: "hideSaleGateway",
      value: function value() {
        var e = document.querySelector(".js-sales-gateway");
        if (e) {
          var t = e.querySelector(".js-sale-gateway-wrapper").dataset.redirectionUrl;
          window.location.href = o.shop.url + t, [].concat(_toConsumableArray(document.querySelectorAll(".js-slider"))).forEach(function (e) {
            return a(e).slick("setPosition");
          });
        }
      }
    }]), c);
  function c(e, t) {
    var o = this;
    _classCallCheck(this, c), this.$modal = e;
    var i = JSON.parse(e.attr("data-modal-options") || null);
    this.settings = a.extend({}, r, t, i), this.state = s.CLOSED, this.$overlay = this.settings.overlay;
    var n = this.$modal.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]');
    this.$firstFocusableElement = n.first(), this.$lastFocusableElement = n.last(), this.$modal.addClass("modal-content is-" + this.state), this.$modal.attr("role") || this.$modal.attr("aria-label") || (this.$modal.attr("role", "dialog"), this.$modal.attr("aria-label", "dialog")), this.$modal.attr("aria-modal") || this.$modal.attr("aria-modal", !0), this.$overlay.addClass("modal-overlay js-modal-click-exclude").hide().append(this.$modal).on("click", function (e) {
      e.target == e.currentTarget && o.settings.closeOnOverlayClick && o.close();
    }), this.$modal.find(".js-close-modal").on("click", function (e) {
      e.preventDefault(), o.close();
    }), a(document).on("keydown.modal", function (e) {
      o.settings.closeOnEscape && o.state === s.OPENED && 27 === e.keyCode && o.close(), o.settings.trapTabKey && o.state === s.OPENED && 9 === e.keyCode && o._handleTabKey(e);
    });
  }
  var e = (_createClass(t, [{
    key: "showModal",
    value: function value(e) {
      this.current && this.current.state == s.OPENED && this.current.close(), (this.current = this.getModal(e)) && this.current.open();
    }
  }, {
    key: "hideModal",
    value: function value() {
      try {
        this.current.close();
      } catch (e) {
        // console.log("ModalEngine::this.current is not defined", e);
      }
      this.current = null;
    }
  }, {
    key: "createModal",
    value: function value(e, t) {
      return new i(e, t);
    }
  }, {
    key: "getModal",
    value: function value(e) {
      if (!this.modals[e]) {
        var t = a("[data-modal-index=" + e + "]");
        if (!t.length) return !1;
        this.modals[e] = this.createModal(t, this.modalOptions);
      }
      return this.modals[e];
    }
  }, {
    key: "addRoles",
    value: function value(e) {
      "button" == e.prop("tagName") || "submit" == e.attr("type") || e.attr("role") || e.attr("aria-label") || (e.attr("role", "button"), e.attr("aria-label", "button"));
    }
  }, {
    key: "addTrigger",
    value: function value(e) {
      var r = this;
      e.on("click", function (e) {
        e.preventDefault();
        var t = a(e.currentTarget),
          o = t.data("modal-target") || t.attr("href"),
          i = a(o).first();
        if (!i.length) return !1;
        var n = i.data("modal-index");
        null == n && i.attr("data-modal-index", n = parseInt(r.modals.length)), r.showModal(n);
      });
    }
  }]), t);
  function t() {
    var o = this;
    _classCallCheck(this, t), this.current, this.modals = [], this.$overlay = a("<div>").appendTo(document.body), this.modalOptions = {
      overlay: this.$overlay
    }, a(".modal-content").hide(), a.each(a(".js-open-modal"), function (e, t) {
      o.addTrigger(a(t)), o.addRoles(a(t));
    }), a.each(a(".js-close-modal"), function (e, t) {
      o.addRoles(a(t));
    });
  }
  o.modal = new e();
}(window.theme = window.theme || {}, jQuery), function (t, a) {
  var i = (_createClass(s, [{
    key: "enableAtc",
    value: function value() {
      this.elements.$atc_button.prop("disabled", !1);
    }
  }, {
    key: "disableAtc",
    value: function value() {
      this.elements.$atc_button.prop("disabled", !0);
    }
  }, {
    key: "setIdField",
    value: function value(o) {
      this.check_id_field ? this.elements.$id_field.filter(function (e, t) {
        return parseInt(t.value) === o;
      }).prop("checked", !0) : this.elements.$id_field.val(o);
    }
  }]), s);
  function s(e, t) {
    var o = this;
    _classCallCheck(this, s);
    this.$container = e;
    var i = this.$container.data("variant-selector");
    this.options = a.extend(!0, {}, {
      selectors: {
        option_selector: ".js-option-selector",
        id_field: '[name="id"]',
        atc_button: '[type="submit"]'
      },
      update_atc: !0,
      update_id_field: !0,
      reset_selection: !1
    }, i, t), this.elements = {
      $id_field: a(this.options.selectors.id_field, this.$container),
      $atc_button: a(this.options.selectors.atc_button, this.$container),
      $option_selectors: a(this.options.selectors.option_selector, this.$container)
    };
    var n = this.elements.$id_field.attr("type");
    if (this.check_id_field = n && "radio" === n.toLowerCase(), this.options.update_atc ? (this.$container.on("VariantSelector:selectionComplete", function (e, t) {
      o.options.update_id_field && o.setIdField(t.id), t.available && ("continue" == t.inventory_policy || 0 < t.inventory_quantity) ? o.enableAtc() : o.disableAtc();
    }), this.$container.on("VariantSelector:selectionIllegal", function () {
      return o.disableAtc();
    }), this.$container.on("VariantSelector:selectionIncomplete", function () {
      return o.disableAtc();
    })) : this.options.update_id_field && this.$container.on("VariantSelector:selectionComplete", function (e, t) {
      o.setIdField(t.id);
    }), 0 < this.elements.$option_selectors.length) this.variant_selector = new c({
      product_handle: this.$container.data("product-handle"),
      selected_values: this.elements.$option_selectors.get().reduce(function (e, t) {
        return t.checked && (e[t.getAttribute("name")] = t.value), e;
      }, {}),
      $event_root: this.$container,
      reset_selection: this.options.reset_selection
    }), this.elements.$option_selectors.each(function (e, t) {
      "SELECT" === t.tagName ? o.variant_selector.addTrigger(a(t), "change", t.getAttribute("name"), function () {
        return t.value;
      }) : o.variant_selector.addTrigger(a(t), "change", t.getAttribute("name"), t.value);
    }); else if (this.variant_selector = new c({
      product_handle: this.$container.data("product-handle"),
      $event_root: this.$container,
      reset_selection: this.options.reset_selection
    }), this.elements.$id_field.on("change", function (e) {
      return o.variant_selector.setVariant(parseInt(e.target.value));
    }), this.check_id_field) {
      var r = this.elements.$id_field.filter(":checked");
      0 < r.length && this.variant_selector.setVariant(parseInt(r.val()));
    } else this.variant_selector.setVariant(parseInt(this.elements.$id_field.val()));
  }
  var c = (_createClass(n, [{
    key: "addTrigger",
    value: function value(t, e, o, i) {
      var n = this;
      t.on(e, function () {
        var e = void 0;
        e = "function" == typeof i ? i(t) : i, n.updateSelection(o, e);
      });
    }
  }, {
    key: "updateSelection",
    value: function value(t, e) {
      var o = this;
      if (this.variant_options[t].selected = e, this.reset_selection) {
        var i = !1;
        this.option_order.forEach(function (e) {
          e === t ? i = !0 : i && (o.variant_options[e].selected = void 0);
        });
      }
      this.updateVariantSelector();
    }
  }, {
    key: "setVariant",
    value: function value(t) {
      var o = this,
        i = this.product.variants.find(function (e) {
          return e.id === t;
        });
      this.product.options_with_values.forEach(function (e, t) {
        return o.variant_options[e.name].selected = i.options[t];
      }), this.updateVariantSelector();
    }
  }, {
    key: "updateVariantSelector",
    value: function value() {
      var i = this,
        e = this.product.variants.filter(function (t) {
          return Object.keys(i.variant_options).every(function (e) {
            return void 0 === i.variant_options[e].selected || t[i.variant_options[e].option_index] === i.variant_options[e].selected;
          });
        }),
        t = Object.keys(this.variant_options).every(function (e) {
          return !!i.variant_options[e].selected;
        }),
        n = this.product.variants || [];
      Object.keys(this.variant_options).forEach(function (o) {
        Object.keys(i.variant_options[o].values).forEach(function (e) {
          var t = i.variant_options[o].values[e];
          0 !== n.length ? t.associated_variants = n.filter(function (e) {
            return e[i.variant_options[o].option_index] === t.value;
          }) : t.associated_variants = [];
        }), n = n.filter(function (e) {
          return e[i.variant_options[o].option_index] === i.variant_options[o].selected;
        });
      }), this.$event_root.trigger("VariantSelector:selectionUpdated", [e, t]), 0 === e.length ? this.selectionIllegal() : 1 === e.length && t ? this.selectionComplete(e[0]) : this.selectionIncomplete(e);
    }
  }, {
    key: "selectionComplete",
    value: function value(e) {
      this.$event_root.trigger("VariantSelector:selectionComplete", e);
    }
  }, {
    key: "selectionIllegal",
    value: function value() {
      this.$event_root.trigger("VariantSelector:selectionIllegal");
    }
  }, {
    key: "selectionIncomplete",
    value: function value(e) {
      this.$event_root.trigger("VariantSelector:selectionIncomplete", e);
    }
  }]), n);
  function n(e) {
    var o = this;
    _classCallCheck(this, n), this.settings = e, this.product = t.products.list[e.product_handle], this.$event_root = e.$event_root || a(), this.reset_selection = e.reset_selection || !1, this.option_order = [], this.variant_options = this.product.options_with_values.reduce(function (e, t) {
      return e[t.name] = new r(t, o.$event_root), e;
    }, {}), this.reset_selection && (this.option_order = this.product.options_with_values.map(function (e) {
      return e.name;
    })), this.settings.selected_values && (Object.keys(this.settings.selected_values).forEach(function (e) {
      return o.variant_options[e].selected = o.settings.selected_values[e];
    }), this.updateVariantSelector());
  }
  var r = (_createClass(l, [{
    key: "selected",
    get: function get() {
      return this._selected ? this._selected.value : void 0;
    },
    set: function set(e) {
      this._selected && this._selected.deselect(), e ? (this._selected = this.values[e], this._selected.select()) : this._selected = void 0, this.$event_root.trigger(this.event_names.selected, e);
    }
  }]), l);
  function l(e, t) {
    var o = this;
    _classCallCheck(this, l), this.name = e.name, this.option_index = "option" + e.position, this.$event_root = t, this.values = e.values.reduce(function (e, t) {
      return e[t] = new d(t, o.name, o.$event_root), e;
    }, {}), this.event_names = {
      selected: "VariantSelector:selected:" + this.name
    };
  }
  var d = (_createClass(u, [{
    key: "deselect",
    value: function value() {
      this.$event_root.trigger(this.event_names.deselect);
    }
  }, {
    key: "select",
    value: function value() {
      this.$event_root.trigger(this.event_names.selected);
    }
  }, {
    key: "deactivate",
    value: function value() {
      this.$event_root.trigger(this.event_names.deactivated);
    }
  }, {
    key: "activate",
    value: function value() {
      this.$event_root.trigger(this.event_names.activated);
    }
  }, {
    key: "associated_variants",
    set: function set(e) {
      e && 0 !== e.length ? this.activate() : this.deactivate(), this._associated_variants = e || [], this.$event_root.trigger(this.event_names.variants_updated, e);
    },
    get: function get() {
      return this._associated_variants;
    }
  }]), u);
  function u(e, t, o) {
    _classCallCheck(this, u), this.value = e, this.$event_root = o, this._associated_variants = [];
    var i = ":" + t + ":" + e;
    this.event_names = {
      selected: "VariantSelector:selected" + i,
      deselect: "VariantSelector:deselect" + i,
      activated: "VariantSelector:activated" + i,
      deactivated: "VariantSelector:deactivated" + i,
      variants_updated: "VariantSelector:variantsUpdated" + i
    };
  }
  t.VariantSelector = i, a(function () {
    t.product_vs = a(".js-product-container").get().reduce(function (e, t) {
      var o = a(t);
      return e[o.data("product-handle")] = new i(o), e;
    }, {});
  });
}(window.theme = window.theme || {}, jQuery), function (e, t) {
  var o = (_createClass(i, [{
    key: "_run",
    value: function value() {
      var e = this;
      this.update(), t(document).scroll(t.throttle(250, function () {
        e.update();
      })), t(window).resize(t.throttle(250, function () {
        e.refresh();
      }));
    }
  }, {
    key: "_isDisabled",
    value: function value() {
      return -1 == this.max || -1 == this.min || this.max < t(window).width() || this.min > t(window).width();
    }
  }, {
    key: "update",
    value: function value() {
      if (this.disabled) return !1;
      t(document).scrollTop() > this.offset ? this.stick() : this.unstick();
    }
  }, {
    key: "refresh",
    value: function value() {
      this.offset = Math.max(this.$sticky.offset().top, 0), this.disabled = this._isDisabled(), this.disabled && this.update();
    }
  }, {
    key: "stick",
    value: function value() {
      this.stuck = !0, this.$sticky.addClass("js-stuck").trigger("Sticky:stick");
    }
  }, {
    key: "unstick",
    value: function value() {
      this.stuck = !1, this.$sticky.removeClass("js-stuck").trigger("Sticky:unstick");
    }
  }]), i);
  function i(e) {
    if (_classCallCheck(this, i), !e) return console.error("Sticky.constructor: No element was passed."), !1;
    this.$sticky = e, this.options = e.data("sticky") || {}, this.max = this.options.hasOwnProperty("max") && Math.floor(this.options.max) != this.options.max && !t.isNumeric(this.options.max) || this.max < 0 ? -1 : this.options.max, this.min = this.options.hasOwnProperty("min") && Math.floor(this.options.min) != this.options.min && !t.isNumeric(this.options.min) || this.options.min < 0 ? -1 : this.options.min, this.disabled = this._isDisabled(), this.offset = Math.max(e.offset().top, 0), this.stuck = !1, this._run();
  }
  e.Sticky = o, t(".js-sticky").each(function () {
    new e.Sticky(t(this));
  });
}(window.theme = window.theme || {}, jQuery), function (c, d) {
  var o = ".js-customer-addresses",
    t = ".js-customer-address-list",
    l = ".js-customer-address",
    r = {
      addContainer: ".js-address-add-container",
      errors: ".js-add-form-errors"
    },
    u = {
      form: ".js-customer-address-form",
      errors: ".js-update-form-errors",
      display: ".js-customer-address-display",
      "delete": ".js-address-delete",
      edit: ".js-customer-address-edit",
      cancel: ".js-customer-address-cancel",
      primaryIndicator: ".js-customer-address-primary-indicator"
    },
    i = (_createClass(e, [{
      key: "updateAddressRaw",
      value: function value(e, t) {
        return e ? d.ajax({
          url: "/account/addresses/" + e,
          data: t,
          type: "POST",
          contentType: "application/x-www-form-urlencoded"
        }) : (console.warn("No address id was provided."), d.when());
      }
    }, {
      key: "updateAddress",
      value: function value(e, t, o) {
        var i = 2 < arguments.length && void 0 !== o ? o : {},
          n = i.form_type,
          r = void 0 === n ? "customer_address" : n,
          a = i.utf8,
          s = void 0 === a ? "✓" : a,
          c = i._method,
          l = {
            form_type: r,
            utf8: s,
            address: t,
            _method: void 0 === c ? "put" : c
          };
        return this.updateAddressRaw(e, d.param(l));
      }
    }, {
      key: "createAddressRaw",
      value: function value(e) {
        return d.ajax({
          url: "/account/addresses/",
          data: e,
          type: "POST",
          contentType: "application/x-www-form-urlencoded"
        });
      }
    }, {
      key: "createAddress",
      value: function value(e, t) {
        var o = 1 < arguments.length && void 0 !== t ? t : {},
          i = o.form_type,
          n = void 0 === i ? "customer_address" : i,
          r = o.utf8,
          a = {
            form_type: n,
            utf8: void 0 === r ? "✓" : r,
            address: e
          };
        return this.createAddressRaw(d.param(a));
      }
    }, {
      key: "deleteAddress",
      value: function value(e) {
        return d.ajax({
          url: "/account/addresses/" + e,
          data: {
            _method: "delete"
          },
          type: "POST",
          contentType: "application/x-www-form-urlencoded"
        });
      }
    }]), e);
  function e() {
    _classCallCheck(this, e);
  }
  var n = (_createClass(a, [{
    key: "_initAddAddress",
    value: function value() {
      var i = this,
        e = d(r.addContainer, this.$container),
        t = d("form", e),
        n = d(r.errors, e);
      new Shopify.CountryProvinceSelector("AddressCountry_new", "AddressProvince_new", {
        hideElement: "AddressProvinceContainer_new"
      }), t.on("submit", function (e) {
        e.preventDefault(), c.addressUtils.createAddressRaw(t.serialize()).done(function (e) {
          var t = d(e),
            o = d(r.errors, t).html();
          o ? n.html(o) : n.empty(), i._addAddress(t);
        });
      });
    }
  }, {
    key: "_addAddress",
    value: function value(e) {
      var n = this,
        t = d(o, e);
      d(l, t).each(function (e, t) {
        var o = d(t);
        if (!n.addresses[o.data("address-id")]) {
          o.appendTo(n.$addressList);
          var i = new s(o);
          n.addresses[i.id] = i;
        }
      });
    }
  }, {
    key: "removeAddress",
    value: function value(e) {
      delete this.addresses[e];
    }
  }, {
    key: "updatePrimary",
    value: function value(e) {
      Object.values(this.addresses).filter(function (e) {
        return e.primary;
      }).forEach(function (e) {
        return e.removePrimary();
      }), e.makePrimary();
    }
  }]), a);
  function a(e) {
    _classCallCheck(this, a), this.$container = e, this.$addressList = d(t, e), this.addresses = d(l, this.$addressList).get().reduce(function (e, t) {
      var o = new s(d(t));
      return e[o.id] = o, e;
    }, {}), this._initAddAddress();
  }
  var s = (_createClass(m, [{
    key: "makePrimary",
    value: function value() {
      this._primary = !0, this.$primaryAddressInput.prop("checked", !0);
    }
  }, {
    key: "removePrimary",
    value: function value() {
      this._primary = !1, this.$primaryAddressInput.prop("checked", !1), d(u.primaryIndicator, this.$addressContainer).remove();
    }
  }, {
    key: "primary",
    get: function get() {
      return this._primary;
    }
  }]), m);
  function m(t) {
    var a = this;
    _classCallCheck(this, m), this.id = t.data("address-id");
    var o = d(u.form, t),
      i = d("form", o),
      s = d(u.errors, i);
    this.$addressContainer = d(u.display, t), this.$primaryAddressInput = d("#address_default_" + this.id, i), this._primary = !!t.data("primary"), new Shopify.CountryProvinceSelector("AddressCountry_" + this.id, "AddressProvince_" + this.id, {
      hideElement: "AddressProvinceContainer_" + this.id
    }), i.on("submit", function (e) {
      e.preventDefault(), c.addressUtils.updateAddressRaw(a.id, i.serialize()).done(function (e) {
        var t = d(e),
          o = d(l + '[data-address-id="' + a.id + '"]', t),
          i = d(u.errors, o).html(),
          n = d(u.display, o).html(),
          r = !!o.data("primary");
        i ? s.html(i) : s.empty(), n && a.$addressContainer.html(n), !a._primary && r && c.addressManager.updatePrimary(a);
      });
    }), d(u["delete"], i).on("click", function (e) {
      e.preventDefault(), c.addressUtils.deleteAddress(a.id).done(function (e) {
        t.remove(), c.addressManager.removeAddress(a.id);
      });
    }), d(u.edit, t).on("click", function (e) {
      o.show();
    }), d(u.cancel, i).on("click", function (e) {
      o.hide();
    });
  }
  d(function () {
    var e = d(o);
    0 < e.length && (c.addressUtils = new i(), c.addressManager = new n(e.eq(0)));
  });
}(window.theme = window.theme || {}, jQuery), function (e, i) {
  var n = {
    noScroll: "noscroll",
    flyoutActive: {
      left: "flyout-active-left",
      right: "flyout-active-right"
    },
    flyoutHidden: {
      left: "flyout-hidden-left",
      right: "flyout-hidden-right"
    }
  },
    t = (_createClass(o, [{
      key: "_run",
      value: function value() {
        var e = this;
        i(window).resize(function () {
          e._refresh();
        });
      }
    }, {
      key: "_refresh",
      value: function value() {
        this.disabled = this._isDisabled(), this._bindTriggers(), this._addRoles(), this._hideFlyout();
      }
    }, {
      key: "_isDisabled",
      value: function value() {
        return -1 == this.max || -1 == this.min || this.max < i(window).width() || this.min > i(window).width();
      }
    }, {
      key: "_addRole",
      value: function value(e) {
        "Button" == e.prop("tagName") || "submit" == e.attr("type") || e.attr("role") || e.attr("aria-label") || (e.attr("role", "button"), e.attr("aria-label", "button"));
      }
    }, {
      key: "_addRoles",
      value: function value() {
        var o = this;
        i([this.elements.toggle, this.elements.open, this.elements.close]).each(function (e, t) {
          o._addRole(i(t));
        });
      }
    }, {
      key: "_bindTriggers",
      value: function value() {
        var t = this;
        if (this.elements.toggle = i.find("[data-flyout-toggle=" + this.id + "]"), this.elements.open = i.find("[data-flyout-open=" + this.id + "]"), this.elements.close = i.find("[data-flyout-close=" + this.id + "]"), this.disabled) return i(this.elements.toggle).off("click.flyout"), i(this.elements.open).off("click.flyout"), i(this.elements.close).off("click.flyout"), !1;
        i(this.elements.toggle).off("click.flyout").on("click.flyout", function (e) {
          e.preventDefault(), t.toggle();
        }), i(this.elements.open).off("click.flyout").on("click.flyout", function (e) {
          e.preventDefault(), t.open();
        }), i(this.elements.close).off("click.flyout").on("click.flyout", function (e) {
          e.preventDefault(), t.close();
        });
      }
    }, {
      key: "_hideFlyout",
      value: function value() {
        if (this.disabled) return this.elements.flyout.hide().addClass(n.flyoutHidden[this.direction]).removeClass(n.flyoutActive[this.direction]), this.hidden = !1, i("body").removeClass(n.noScroll), !1;
        this.hidden || (this.elements.flyout.addClass(n.flyoutHidden[this.direction]), this.hidden = !0);
      }
    }, {
      key: "open",
      value: function value() {
        i("body").addClass(n.noScroll), this.elements.flyout.show().removeClass(n.flyoutHidden[this.direction]).addClass(n.flyoutActive[this.direction]).on("transitionend webkittransitionEnd otransitionEnd MStransitionEnd", function (e) {
          i(this).trigger("Flyout:open"), i(this).off(e);
        }), this.hidden = !1;
      }
    }, {
      key: "close",
      value: function value() {
        var o = this;
        i("body").removeClass(n.noScroll), this.elements.flyout.removeClass(n.flyoutActive[this.direction]).addClass(n.flyoutHidden[this.direction]), this.elements.flyout.one("transitionend webkittransitionEnd otransitionEnd MStransitionEnd", function (e) {
          var t = i(e.target);
          t.hasClass(n.flyoutHidden[o.direction]) && t.hide().trigger("Flyout:close");
        }), this.hidden = !0;
      }
    }, {
      key: "toggle",
      value: function value() {
        this.elements.flyout.trigger("Flyout:toggle"), this.hidden ? this.open() : this.close();
      }
    }]), o);
  function o(e) {
    if (_classCallCheck(this, o), !e) return console.error("Flyout.constructor: No element was passed."), !1;
    this.elements = {
      flyout: e
    }, this.id = e.data("flyout-id") || !1, this.options = e.data("flyout-options") || !1, this.direction = !this.options.direction || "left" != this.options.direction && "right" != this.options.direction ? "right" : this.options.direction, this.max = this.options.max && Math.floor(this.options.max) != this.options.max && !i.isNumeric(this.options.max) || this.max < 0 ? -1 : this.options.max, this.min = this.options.min && Math.floor(this.options.min) != this.options.min && !i.isNumeric(this.options.min) || this.options.min < 0 ? -1 : this.options.min, this.disabled = this._isDisabled(), this.hidden = !1, this.id && (this._bindTriggers(), this._addRoles(), this._hideFlyout(), this._run());
  }
  e.Flyout = t, i(".js-flyout").each(function () {
    new e.Flyout(i(this));
  });
}(window.theme = window.theme || {}, jQuery), function (n, r) {
  var a = {
    closeMenuOnSelect: !1,
    showSelectionInLabel: !0
  },
    i = "active",
    e = "open",
    s = (_createClass(c, [{
      key: "set",
      value: function value() {
        this.elements.option.trigger("DropdownOption:set", this.value);
      }
    }]), c);
  function c(e, t) {
    var o = this;
    if (_classCallCheck(this, c), !e) return !1;
    this.value = e.html(), this.elements = {
      option: e
    }, t && this.elements.option.data("option-id", t), this.elements.option.off("click.Dropdown").on("click.Dropdown", function () {
      o.set();
    });
  }
  var t = (_createClass(l, [{
    key: "bindOptions",
    value: function value() {
      var i = this,
        e = this;
      this.options = {}, this.elements.options = this.elements.list.find(".js-dropdown-option").length ? this.elements.list.find(".js-dropdown-option") : this.elements.list.find("li"), this.elements.options.each(function (e, t) {
        var o = n.utils.uniqueNumber();
        i.options[o] = new s(r(t), o);
      }), this.elements.options.on("DropdownOption:set", function () {
        e.settings.closeMenuOnSelect && e.close(), r(this).hasClass("js-option-disabled") || (e.$selected = r(this));
      });
    }
  }, {
    key: "open",
    value: function value() {
      this.expanded = !0, this.elements.list.slideDown(), this.elements.dropdown.addClass(e).trigger("Dropdown:open"), this.elements.dropdown.find(".menu").addClass(e);
    }
  }, {
    key: "close",
    value: function value() {
      this.expanded = !1, this.elements.list.slideUp(), this.elements.dropdown.removeClass(e).trigger("Dropdown:close"), this.elements.dropdown.find(".menu").removeClass(e);
    }
  }, {
    key: "toggle",
    value: function value() {
      this.expanded ? this.close() : this.open(), this.elements.dropdown.trigger("Dropdown:toggle");
    }
  }, {
    key: "$selected",
    set: function set(e) {
      if (!e || !e.data("option-id")) return !1;
      var t = e.data("option-id"),
        o = this.options[t];
      this._selected_option = o, this.elements.options.not(e).removeClass(i), o.elements.option.addClass(i), this.settings.showSelectionInLabel && this.elements.label.html(o.value), this.elements.dropdown.trigger("Dropdown:update", o);
    },
    get: function get() {
      return this._selected_option;
    }
  }]), l);
  function l(e, t) {
    var o = this;
    _classCallCheck(this, l), this.expanded = !1, this._selected_option;
    var i = e.data("dropdown-settings");
    this.settings = r.extend({}, a, t, i), this.elements = {
      dropdown: e,
      list: e.find(".js-dropdown-list").length ? e.find(".js-dropdown-list") : e.find("ul"),
      label: e.find(".js-dropdown-label"),
      trigger: e.find(".js-dropdown-trigger")
    }, 0 === this.elements.trigger.length && (this.elements.trigger = this.elements.label), this.bindOptions(), this.elements.trigger.off("click.Dropdown").on("click.Dropdown", function () {
      o.toggle();
    }), r(document).on("click.Dropdown", function (e) {
      r(e.target).parents().addBack().is(o.elements.dropdown) || o.expanded && o.close();
    });
  }
  n.Dropdown = t, r(".js-dropdown").each(function () {
    new t(r(this));
  });
}(window.theme = window.theme || {}, jQuery), function (e, o) {
  var i = ".js-entry-screen",
    n = ".js-toggle-entry-screen",
    r = "js-hide",
    a = ".js-form-address",
    t = (_createClass(s, [{
      key: "initAddresses",
      value: function value(e) {
        var t = o(e);
        new Shopify.CountryProvinceSelector(t.attr("id") + "-AddressCountry", t.attr("id") + "-AddressProvince", {
          hideElement: t.attr("id") + "-AddressProvinceContainer"
        });
      }
    }, {
      key: "toggleResetScreen",
      value: function value() {
        var e = o(i + ":not(." + r + ")"),
          t = o("." + r + i);
        e.addClass(r), t.removeClass(r);
      }
    }]), s);
  function s() {
    _classCallCheck(this, s);
    var t = this;
    o(document).on("click", n, function (e) {
      t.toggleResetScreen();
    }), o(a).each(function () {
      t.initAddresses(this);
    });
  }
  e.account = new t();
}(window.theme = window.theme || {}, jQuery), function (e, t) {
  var o = (_createClass(i, [{
    key: "_initializeHandlers",
    value: function value() {
      t(document).on("change", "#tagFilter", function () {
        location.href = t(this).val();
      });
    }
  }]), i);
  function i() {
    _classCallCheck(this, i), this._initializeHandlers();
  }
  e.blogFilters = new o();
}(window.theme = window.theme || {}, jQuery);
var Toggle = function () {
  function o(e) {
    var t = this;
    return _classCallCheck(this, o), e ? (this.settings = e.dataset.toggle ? JSON.parse(e.dataset.toggle) : {}, this.element = e, this.id = e.dataset.toggleTarget || (this.settings && this.settings.target ? this.settings.target : null), this.id ? (this.target = document.getElementById(this.id), this.group = e.dataset.toggleGroup || (this.settings && this.settings.group ? this.settings.group : null), this.focus_target = this.settings && this.settings.focusTarget ? this.settings.focusTarget : null, this.breakpoints = {
      min: this.settings && this.settings.min ? parseInt(this.settings.min) : 0,
      max: this.settings && this.settings.max ? parseInt(this.settings.max) : null
    }, this.active = !1, this.enabled = !1, this.toggleFunction = function () {
      t.toggle();
    }, this.closeOnUnfocusFunction = function (e) {
      t.closeOnUnfocus(e);
    }, void this.initialize()) : (console.error("Toggle.constructor: Target element " + this.id + " not found."), console.error(this.element), !1)) : (console.error("Toggle.constructor: Missing argument."), !1);
  }
  return _createClass(o, [{
    key: "initialize",
    value: function value() {
      var e = this;
      this.update(), window.addEventListener("resize", function () {
        e.update();
      });
    }
  }, {
    key: "update",
    value: function value() {
      this.breakpoints.min || this.breakpoints.max ? (this.breakpoints.min && (window.matchMedia("(min-width: " + this.breakpoints.min + "px)").matches ? this.enableToggle() : this.disableToggle()), this.breakpoints.max && (window.matchMedia("(max-width: " + this.breakpoints.max + "px)").matches ? this.enableToggle() : this.disableToggle())) : this.enableToggle();
    }
  }, {
    key: "enableToggle",
    value: function value() {
      this.enabled || (this.element.addEventListener("click", this.toggleFunction), this.settings.closeOnUnfocus && document.addEventListener("click", this.closeOnUnfocusFunction), this.enabled = !0);
    }
  }, {
    key: "disableToggle",
    value: function value() {
      this.enabled && (this.element.removeEventListener("click", this.toggleFunction), this.settings.closeOnUnfocus && document.removeEventListener("click", this.closeOnUnfocusFunction), this.deactivate(), this.enabled = !1);
    }
  }, {
    key: "closeOnUnfocus",
    value: function value(e) {
      this.active && (this.element.contains(e.target) || this.target.contains(e.target) || this.deactivate(), this.deactivate(), this.enabled = !1);
    }
  }, {
    key: "activate",
    value: function value() {
      // console.log('activate is called');
      this.active || (this.active = !0, this.element.classList.add("is-active"), this.element.setAttribute("aria-expanded", "true"), this.target.classList.add("is-active"), this.target.setAttribute("aria-hidden", "false"), this.target.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(function (e) {
        return e.tabIndex = 0;
      }), this.focus_target && document.getElementById(this.focus_target) && document.getElementById(this.focus_target).focus(), this.target.dispatchEvent(new CustomEvent("toggle:activate", {
        bubbles: !0,
        detail: this
      })));
      var e = this.element.querySelector(".variant__discount");
      null != e && e.classList.add("variant__discount--highlighted");
    }
  }, {
    key: "deactivate",
    value: function value() {
      this.active && (this.active = !1, this.target.classList.remove("is-active"), this.target.setAttribute("aria-hidden", "true"), this.target.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(function (e) {
        return e.tabIndex = -1;
      }), this.element.classList.remove("is-active"), this.element.setAttribute("aria-expanded", "false"), this.target.dispatchEvent(new CustomEvent("toggle:deactivate", {
        bubbles: !0,
        detail: this
      })));
      var e = this.element.querySelector(".variant__discount");
      null != e && e.classList.remove("variant__discount--highlighted");
    }
  }, {
    key: "toggle",
    value: function value() {
      this.active ? this.deactivate() : this.activate();
    }
  }]), o;
}(),
  ToggleManager = function () {
    function t(e) {
      _classCallCheck(this, t), this.toggles = [], this.group = e;
    }
    return _createClass(t, [{
      key: "add",
      value: function value(e) {
        if (!(e && e instanceof Toggle)) return console.error("ToggleManager.add: Missing or invalid argument."), !1;
        this.toggles.push(e);
      }
    }, {
      key: "remove",
      value: function value(t) {
        this.toggles = this.toggles.filter(function (e) {
          return e.id != t.id;
        });
      }
    }]), t;
  }(),
  AccordionToggle = function () {
    function t(e) {
      return _classCallCheck(this, t), e ? _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)) : (console.error("FlyoutToggle.constructor: Missing argument(s)."), !1, _possibleConstructorReturn(_this32, !1));
    }
    return _inherits(t, Toggle), _createClass(t, [{
      key: "update",
      value: function value() {
        _get(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "update", this).call(this), this.updateHeight(), this.closeOnClick();
      }
    }, {
      key: "closeOnClick",
      value: function value() {
        var t = this;
        this.target.addEventListener("accordion:close", function (e) {
          t.collapse();
        });
      }
    }, {
      key: "updateHeight",
      value: function value() {
        this.active ? this.target.style.height = this.calculateHeight() : this.target.style.height = 0;
      }
    }, {
      key: "calculateHeight",
      value: function value() {
        return this.target.clientHeight && (this.target.style.height = "auto"), this.target.scrollHeight + "px";
      }
    }, {
      key: "closeOnUnfocus",
      value: function value(e) {
        this.active && (this.element.contains(e.target) || this.target.contains(e.target) || this.collapse());
      }
    }, {
      key: "disable",
      value: function value() {
        _get(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "disable", this).call(this), this.collapse();
      }
    }, {
      key: "expand",
      value: function value() {
        this.activate(), this.target.style.height = this.target.scrollHeight + "px", this.target.dispatchEvent(new CustomEvent("accordion:expand", {
          bubbles: !1,
          detail: this
        })), this.target.addEventListener("transitionend", function () { }, !1);
      }
    }, {
      key: "collapse",
      value: function value() {
        var e = this;
        this.target.dispatchEvent(new CustomEvent("accordion:collapse", {
          bubbles: !1,
          detail: this
        })), setTimeout(function () {
          e.target.style.height = "0px", e.deactivate();
        }, 0);
      }
    }, {
      key: "toggle",
      value: function value() {
        this.active ? this.collapse() : this.expand();
      }
    }]), t;
  }(),
  AccordionManager = function () {
    function t(e) {
      return _classCallCheck(this, t), _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    }
    return _inherits(t, ToggleManager), _createClass(t, [{
      key: "add",
      value: function value(e) {
        var t = this;
        if (!(e && e instanceof AccordionToggle)) return console.error("ToggleManager.add: Missing or invalid argument."), !1;
        this.toggles.push(e), e.target.addEventListener("accordion:expand", function (o) {
          t.toggles.forEach(function (e) {
            if (e.id != o.detail.id) {
              e.collapse();
              var t = e.target.querySelector(".accordion__content");
              t && t.classList.contains("is-active") && e.target.querySelector(".js-read-more").click();
            }
          });
        });
      }
    }]), t;
  }(),
  initAccordions = function initAccordions() {
    var i = Array.from(document.querySelectorAll(".js-accordion:not(.js-initialized)")).reduce(function (e, t) {
      var o = new AccordionToggle(t);
      if (t.dataset.toggle && JSON.parse(t.dataset.toggle).group) {
        var i = JSON.parse(t.dataset.toggle).group;
        e.groups[i] || (e.groups[i] = []), e.groups[i].push(o);
      } else e.nogroup.push(o);
      return t.classList.add("js-initialized"), e;
    }, {
      nogroup: [],
      groups: {}
    });
    Object.keys(i.groups).forEach(function (e, t) {
      var o = new AccordionManager(e);
      i.groups[e].forEach(function (e) {
        o.add(e);
      });
    });
  },
  initToggle = function initToggle() {
    var e = [].concat(_toConsumableArray(document.querySelectorAll(".js-toggle"))),
      o = {};
    e.forEach(function (e) {
      var t = new Toggle(e);
      t.group && (o[t.group] || (o[t.group] = new ToggleManager(t.group)), o[t.group].add(t));
    });
  },
  initToggleAccordion = function initToggleAccordion() {
    initToggle(), initAccordions(), theme.initAccordions = initAccordions;
  };
document.addEventListener("DOMContentLoaded", initToggleAccordion), function (n) {
  [].concat(_toConsumableArray(document.querySelectorAll(".js-slider"))).forEach(function (e) {
    return function (e) {
      var t = JSON.parse(e.dataset.slider);
      n(e).slick(t);
      var o = [].concat(_toConsumableArray(e.querySelectorAll(".slider__image"))),
        i = e.parentElement.querySelector(".js-slider-title");
      o.length || i.classList.add("is-hidden");
    }(e);
  });
}(jQuery), function () {
  var s = {
    hamburger: document.querySelector(".js-hamburger-menu"),
    header: document.querySelector(".js-header"),
    headerHeight: document.querySelector(".js-header-section"),
    headerContainer: document.querySelector(".js-header-container"),
    announcement: document.querySelector(".js-announcement"),
    menu: document.querySelector(".js-menu"),
    menuFocusables: [].concat(_toConsumableArray(document.querySelector(".js-menu").querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))),
    menuItem: [].concat(_toConsumableArray(document.querySelectorAll(".js-menu-item"))),
    menuWrapper: [].concat(_toConsumableArray(document.querySelectorAll(".js-menu-wrapper"))),
    menuOverlay: document.querySelector(".js-menu-overlay"),
    menuMore: document.querySelector(".js-menu-more"),
    menuSingle: document.querySelector(".js-menu-single-item"),
    menuCountry: document.querySelectorAll(".js-country-selector"),
    open: [].concat(_toConsumableArray(document.querySelectorAll(".js-menu-item .js-item-open"))),
    close: [].concat(_toConsumableArray(document.querySelectorAll(".js-menu-item .js-item-close"))),
    breadcrumb: document.querySelector(".js-breadcrumb"),
    searchTrigger: [].concat(_toConsumableArray(document.querySelectorAll(".js-trigger-search")))
  },
    c = function c() {
      var e = s.headerContainer.offsetHeight;
      //document.getElementById("MainContent").style.marginTop = e + "px"
    };

  function e(e) {
    var t = "",
      o = "";
    o = e ? (t = "hide-from", "hide-until") : (t = "hide-until", "hide-from"), $(".js-content-video." + t + "\\@sm").get(0).paused || $(".js-content-video." + t + "\\@sm").get(0).pause(), $(".js-content-video." + o + "\\@sm").get(0).paused && $(".js-content-video." + o + "\\@sm").get(0).play();
  }
  function t() {
    c(), document.querySelector(".js-content-video") && "index" == window.theme.template.name && document.querySelector(".js-content-video.hide-from\\@sm") && ($(window).width() > window.theme.breakpoints.sm ? e(!0) : e(!1));
  }
  window.addEventListener("resize", function () {
    var e = void 0;
    clearTimeout(e), e = setTimeout(t, 100);
  });
  function o() {
  }
  function l() {
    var e = document.querySelector(".js-announcement");
    var autoRotate = $(e).data('auto-rotate');
    var autoRotateTime = $(e).data('auto-rotate-time');
    $(e).slick({
      arrows: !0,
      infinite: !0,
      speed: 300,
      slidesToShow: 1,
      autoplay: autoRotate,
      pauseOnFocus: false,
      pauseOnHover: false,
      autoplaySpeed: autoRotateTime,
      nextArrow: '<button class="slick-next slick-arrow" tabindex="0" aria-label="Next" type="button">' + theme.svgs.arrow.chevron_right_small + "</button>",
      prevArrow: '<button class="slick-prev slick-arrow" tabindex="0" aria-label="Previous" type="button">' + theme.svgs.arrow.chevron_left_small + "</button>",
      lazyLoad: "progressive"
    });
    $('#toggleAnnouncements').click(function () {
      if ($(this).attr("aria-class") == 'pause') {
        $('.js-announcement').slick('slickPause');
        // $(this).attr("aria-class", "play");
        $(this).attr("aria-label", "pause");
        $(this).find("svg.icon-play").hide();
        $(this).find("svg.icon-pause").show();
      } else {
        $('.js-announcement').slick('slickPlay');
        // $(this).attr("aria-class", "pause");
        $(this).attr("aria-label", "play");
        $(this).find("svg.icon-play").show();
        $(this).find("svg.icon-pause").hide();
      }
    });
  }
  var d = function d(e) {
    if (s.menu.matches(".is-active") && !e.target.closest(".menu")) {
      s.menuOverlay.classList.toggle("is-active"), s.menu.classList.toggle("is-active"), s.header.classList.toggle("is-active"), s.menuFocusables.forEach(function (e) {
        return e.tabIndex = e.tabIndex ? 0 : -1;
      }), document.body.classList.toggle("body--freeze", s.menuOverlay.matches(".is-active"));
      var t = !0,
        o = !1,
        i = void 0;
      try {
        for (var n, r = s.menuWrapper[Symbol.iterator](); !(t = (n = r.next()).done); t = !0) {
          n.value;
          e.target.matches(".hide") || ($(e.target).find(s.menuWrapper).slideUp().addClass("hide"), s.open.forEach(function (e) {
            return e.classList.remove("hide");
          }), s.close.forEach(function (e) {
            return e.classList.add("hide");
          }));
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          !t && r["return"] && r["return"]();
        } finally {
          if (o) throw i;
        }
      }
      s.menuCountry.parentElement && !s.menuCountry.parentElement.querySelector("ul li").matches(".hide") && s.menuCountry.click(), s.menuSingle.querySelector("li").matches(".menu__item--show") && s.menuMore.click();
    }
  };
  !function (i) {
    if (t(), "https://anine-bing-dev01-us.myshopify.com" == theme.shop.url || "https://www.aninebing.com" == theme.shop.url) {
      var n = !1,
        r = 0;
      t();
      var a = setInterval(function () {
        if (r += 1, document.getElementById("FreeShippingBanner") && 0 < document.getElementById("FreeShippingBanner").offsetHeight && document.querySelector("#ui-id-1.ui-autocomplete") && (n = !0), n) {
          clearInterval(a), document.querySelector("#ui-id-1.ui-autocomplete").classList.add("add-globale");
          var t = [].concat(_toConsumableArray(document.querySelectorAll(".geotargetlygeocontent1594765329414_content_1")));
          "US" != window.GlobalE.Country ? t.forEach(function (e) {
            return e.classList.add("hide-klarna");
          }) : t.forEach(function (e) {
            e.classList.contains("hide-klarna") && t.classList.remove("hide-klarna");
          });
        }
        if (typeof GlobalE !== 'undefined' && GlobalE) {
          if ("USD" != GlobalE.Currency || "US" != GlobalE.Country) {
            var e = document.querySelector(".js-geotargetly-announcement-bar-US");
            e && e.remove();
          } else {
            var o = document.getElementById("GlobaleFreeShippingBannerContainer");
            o && o.remove();
          }
          0 == i && (i = !0, l(), c());
        }
        5 < r && clearInterval(a);
      }, 2e3);
    } else l(), c();
    !function () {
      s.menuFocusables.forEach(function (e) {
        return e.tabIndex = -1;
      });
      var e = !0,
        t = !(s.hamburger.onclick = function (e) {
          e.preventDefault();
          var t = document.querySelector(".mobile_dropdown_btn.close_btn");
          t && t.click(), s.menu.classList.toggle("is-active"), s.menuOverlay.classList.toggle("is-active"), s.header.classList.toggle("is-active"), s.headerContainer.classList.toggle("flyout-is-open"), s.menuFocusables.forEach(function (e) {
            return e.tabIndex = e.tabIndex ? 0 : -1;
          }), 0 === s.menuFocusables[0].tabIndex && s.menuFocusables[0].focus(), document.body.classList.toggle("body--freeze", s.menuOverlay.matches(".is-active"));
          var e = document.querySelector(".js-announcement");
          $(e).slick("refresh");
          var header_element = document.querySelector(".header__wrapper.container.js-header.is-active");
          if (header_element) {
            // console.log('mobile menu opend');
          } else {
            c();
          }
        }),
        o = void 0;
      try {
        for (var i, n = s.menuItem[Symbol.iterator](); !(e = (i = n.next()).done); e = !0) {
          var r = i.value;
          r.addEventListener("click", function (e) {
            s.menuItem.forEach(function (e) {
              e.classList.contains("is-active") && e.classList.remove("is-active");
            }), theme.utils.targetIs(e.target, s.menuWrapper) || e.preventDefault();
          }), r.addEventListener("click", theme.utils.throttled(function (e) {
            var t = this.querySelector(".js-menu-wrapper");
            theme.utils.accordion(this, s.open, s.close, s.menuWrapper, t, "menu");
          }, 500));
        }
      } catch (e) {
        t = !0, o = e;
      } finally {
        try {
          !e && n["return"] && n["return"]();
        } finally {
          if (t) throw o;
        }
      }
    }(), s.searchTrigger.forEach(function (e) {
      return e.addEventListener("click", function (e) {
        return d(e);
      });
    }), s.menuOverlay.onclick = function (e) {
      d(e);
    }, function () {
      var t = document.querySelector(".js-menu-countries");
      s.menuCountry.forEach(function (e) {
        e.addEventListener("click", function (e) {
          e.preventDefault(), e.target.closest(".js-menu-country").querySelector(".menu__items li").matches(".hide") ? ($(e.target).closest(".js-menu-country").find(".menu__items li").slideDown({
            done: function done() {
              $(e.target).css("display", "flex");
            }
          }).removeClass("hide"), t.classList.add("is-active"), t.scrollIntoView(), location.href = "#js-menu-countries") : ($(e.target).closest(".js-menu-country").find(".menu__items li").slideUp().addClass("hide"), t.classList.remove("is-active")), e.target.querySelector(".js-item-down") && e.target.querySelector(".js-item-down").classList.toggle("is-active"), e.target.closest(".js-menu-country") && e.target.closest(".js-menu-country").classList.toggle("is-active");
        });
      });
    }(), "https://eu.aninebing.com" == theme.shop.url && o();
  }(!1);
}(), jQuery(document).ready(function ($) {
  var c,
    l = {
      $searchForms: $(".search-form, #menu-search"),
      $footerSubscriptionForm: $(".js-sailthru-footer"),
      $newsletterSubscriptionForm: $(".js-sailthru-newsletter"),
      $registerSubscriptionForm: $(".js-sailthru-register"),
      $createCustomerForm: $("form#create_customer"),
      $customerInfoForm: $(".step[data-step=contact_information] form"),
      $shippingStepForm: $(".step[data-step=shipping_method] form"),
      $orderForm: $("[data-step=shipping_method] .edit_checkout"),
      apiUrlUser: "/apps/api-1/v1/create_user",
      apiUrlEvent: "/apps/api-1/v1/send_event",
      apiUserExists: "/apps/api-1/v1/user_exists"
    };
  function t(i, e) {
    var t = i.target.querySelector("input[type=email]").value,
      o = i.target.querySelector(".js-checkbox-input.required"),
      n = {
        email: t,
        options: {
          key: "email",
          vars: {
            email_permission_status: !0,
            reg_source: e
          },
          lists: {
            master_list: 1
          }
        }
      };
    if (o) {
      if (o && o.checked) s(l.apiUrlUser, n).done(function (e) {
        var t = $(i.target).find(".js-success-msg"),
          o = i.target.querySelector(".input__group");
        t && a(t), o && o.classList.remove("has-error"), "popupNewsletterForm" === i.target.id && setTimeout(function () {
          i.target.closest(".js-container-popup").querySelector(".js-close-popup").click();
        }, 2e3);
      }).fail(function (e) {
        var t = $(i.target).find(".js-error-msg");
        t && a(t);
      }); else if (o && !o.checked) {
        var r = i.target.querySelector(".input__group");
        r && r.classList.add("has-error");
      }
    } else s(l.apiUrlUser, n).done(function (e) {
      ttp_subscribe();
      var t = $(i.target).find(".js-success-msg");
      t && a(t);
    }).fail(function (e) {
      var t = $(i.target).find(".js-error-msg");
      t && a(t);
    });
  }
  function a(e) {
    e.removeClass("is-hidden"), setTimeout(function () {
      e.addClass("is-hidden");
    }, 1e4);
  }
  function o(e, t) {
    if (document.querySelector("#CreateCustomer-ConfirmNewsletter").checked) {
      var o = $("form #CreateCustomer-FirstName").val(),
        i = $("form #CreateCustomer-LastName").val(),
        n = o + " " + i,
        r = {
          email: $("form #CreateCustomer-Email").val(),
          options: {
            key: "email",
            vars: {
              full_name: n,
              first_name: o,
              last_name: i,
              birth_date: "",
              reg_source: e,
              campaign_source: t(),
              shopify_customer_id: null,
              email_permission_status: !0
            },
            lists: {
              master_list: 1
            }
          }
        };
      c(l.apiUrlUser, r);
    }
  }
  function s(e, t) {
    return $.ajax({
      url: e,
      type: "POST",
      data: t
    });
  }
  function i() {
    return new URL(window.location.href).searchParams.get("utm_source");
  }
  c = function c(e, t) {
    $.ajax({
      url: e,
      type: "POST",
      data: t
    }).done(function (e) {
      // console.log(e);
      $('.modal-overlay.js-modal-click-exclude .modal-content.is-opened').not('[class*="sale-gateway-modal-"]').removeClass('is-opened').addClass('is-closed');
    }).fail(function (e) {
      // console.log(e);
      $('.modal-overlay.js-modal-click-exclude .modal-content.is-opened').not('[class*="sale-gateway-modal-"]').removeClass('is-opened').addClass('is-closed');
    });
  }, l.$footerSubscriptionForm.on("submit", function (e) {
    e.preventDefault(), t(e, "user creation - footer");
  }), l.$newsletterSubscriptionForm.on("submit", function (e) {
    e.preventDefault(), t(e, "user creation - newsletter subscription");
  }), $(document).on("click", "#privy-submit-btn", function () {
    !function (e, t) {
      var o = $(e.target).closest(".privy-popup-content").find(".privy-email-input").val(),
        i = {
          email: o,
          options: {
            key: "email",
            vars: {
              email_permission_status: !0,
              reg_source: t
            },
            lists: {
              master_list: 1
            }
          }
        };
      o.length && c(l.apiUrlUser, i);
    }(event, "user creation - pop up");
  }), $(document).on("submit", ".js-gateway-form", function (e) {
    e.preventDefault();
    var t = this.querySelector(".js-gateway-form .js-submit-btn").dataset.formSubmit;
    !function (e, t) {
      var a = $(e.target).closest("form").find("input[type=email]").val(),
        s = {
          email: a,
          options: {
            key: "email",
            vars: {
              email_permission_status: !0,
              reg_source: t
            },
            lists: {
              master_list: 1
            }
          }
        };
      $.ajax({
        url: l.apiUserExists,
        type: "POST",
        data: s
      }).done(function (e) {
        var t = e.result,
          o = document.querySelector(".js-gateway-form"),
          i = o.dataset.emailDuplication,
          n = o.querySelector(".error-msg").innerText,
          r = o.querySelector(".js-form");
        !a.length || t && "true" != i ? a.length && "false" == i && t && (r.classList.add("has-error"), r.querySelector(".error-msg").innerText = theme.locales.sale_gateway.error_email_duplication, r.querySelector(".error-msg").setAttribute("data-previous-error-message", n)) : (c(l.apiUrlUser, s), document.querySelector(".sale-gateway-modal-button").click(), $(".sale-gateway__related-slider").slick("setPosition"));
        var success_mssg = document.querySelector('.form-success-msg-give');
        var submit_give_btn = document.querySelector('.sale-gateway__form__button');
        var giveawayEmail = document.querySelector('.sale-gateway__form__input');
        var form_des = document.querySelector('.sale-gateway__form__disclaimer');
        setTimeout(function () {
          var currentUrl = window.location.href;
          window.history.replaceState({}, '', "".concat(currentUrl, "#success"));
          // console.log("Updated URL:", window.location.href);
        }, 2000);
        if (giveawayEmail) {
          giveawayEmail.style.display = 'none';
        }
        if (submit_give_btn) {
          submit_give_btn.classList.add('already-done');
        }
        if (success_mssg) {
          success_mssg.style.display = 'block';
        }
        if (form_des) {
          form_des.style.display = 'none';
        }
      }).fail(function (e) {
        // console.log(e);
      });
    }(event, t);
  }), l.$registerSubscriptionForm.closest("form").on("submit", function (e) {
    o("user creation - Registration form", i);
  }), l.$searchForms.each(function () {
    $(this).on("submit", function (e) {
      !function (e, t, o) {
        var i = $(o).find("input[type=text]").val();
        if (Shopify.customer_email) {
          var n = {
            email: Shopify.customer_email,
            event: t,
            options: {
              key: "email",
              vars: {
                search_term: i
              }
            }
          };
          ["madeleine", "madeline", "madeleine blazer", "madeline blazer", "stevie", "stevie boots", "stevie boot", "stevie booties", "tiger", "tiger tee", "tiger tshirt", "tiger t-shirt", "tiger tee shirt", "dylan", "dylan coat", "dylan jacket", "dylan trench", "bar silk", "bar silk black", "bar silk leo", "bar silk skirt", "silk skirt", "bar silk skirt black", "bar silk skirt leo", "frida", "frida jeans", "frida jean", "frida denim", "frida pants", "blazer", "blazers", "sweatshirt", "sweatshirts", "sweat shirt", "sweat shirts", "hoodie", "hoodies", "tee", "t-shirt", "tee shirt", "tshirt", "t shirt", "t-shirts", "tee shirts", "tshirts", "t shirts", "skirt", "skirts", "camisole", "cami", "camis", "camisoles", "sweater", "sweaters", "cardigan", "cardi", "cardigans", "cardis", "boots", "boot", "bootie", "booties", "jacket", "coat", "jackets", "coats", "leather", "leather jacket", "leather jackets", "leopard", "leo", "leopard print", "leo print", "jeans", "denim", "jean", "denim pants"].includes(i) && c(l.apiUrlEvent, n);
        }
      }(0, "search_abandon", this);
    }), o("user creation - custom registration form", i);
  }), Shopify.Checkout && "contact_information" === Shopify.Checkout.step && l.$customerInfoForm.on("submit", function () {
    !function (e, t) {
      if (document.querySelector("input#accepts_sms").checked) {
        var o = document.querySelector("#checkout_shipping_address_phone").value,
          i = {
            email: document.querySelector("#checkout_email").value,
            options: {
              key: "email",
              vars: {
                mobile_permission_status: !0,
                mobile_number: o,
                campaign_source: t(),
                reg_source: e
              },
              lists: {
                master_list: 1
              }
            }
          };
        c(l.apiUrlUser, i);
      }
    }("SMS landing page - Checkout flow", i);
  });
}), function () {
  function e() {
    var e = [].concat(_toConsumableArray(document.querySelectorAll(".js-input"))),
      t = [].concat(_toConsumableArray(document.querySelectorAll(".js-form"))),
      o = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-email"))),
      i = document.querySelector(".js-submit-customer-register");
    t.forEach(function (e) {
      return e.addEventListener("submit", function (e) {
        return a(e);
      });
    }), e.forEach(function (e) {
      return e.addEventListener("blur", function () {
        return n(e);
      });
    }), e.forEach(function (e) {
      return e.addEventListener("keyup", function () {
        return c(e);
      });
    }), i && i.addEventListener("click", function (e) {
      if (!s(e)) return !1;
    }), function (e) {
      e.forEach(function (e) {
        e.addEventListener("blur", function () {
          setTimeout(function () {
            n(e);
          }, 1e3);
        }), e.addEventListener("keyup", function () {
          setTimeout(function () {
            n(e);
          }, 1e3);
        });
      });
    }(o);
  }
  var n = function n(e) {
    var t = validator.isEmail(e.value),
      o = validator.isEmpty(e.value),
      i = [].concat(_toConsumableArray(document.querySelectorAll(".is-opened .js-out-of-stock-submit"))),
      n = e.getAttribute("type");
    "email" === n ? !t && e.value ? (e.parentElement.classList.add("has-error"), 0 < i.length && i.forEach(function (e) {
      return r(!1, e);
    })) : (e.parentElement.classList.remove("has-error"), o ? (e.parentElement.classList.add("has-error"), i.forEach(function (e) {
      return r(!1, e);
    })) : i.forEach(function (e) {
      return r(!0, e);
    })) : "checkbox" === n ? !e.checked && e.classList.contains("required") ? e.parentElement.classList.add("has-error") : e.parentElement.classList.remove("has-error") : o ? (e.parentElement.classList.add("has-error"), 0 < i.length && i.forEach(function (e) {
      return r(!1, e);
    })) : (e.parentElement.classList.remove("has-error"), 0 < i.length && i.forEach(function (e) {
      return r(!0, e);
    })), e.value || e.classList.remove("has-focus");
  };
  function r(e, t) {
    e ? (t.classList.remove("button--secondary"), t.classList.add("button--primary"), t.removeAttribute("disabled", !1)) : (t.classList.remove("button--primary"), t.classList.add("button--secondary"), t.setAttribute("disabled", !0));
  }
  var a = function a(t) {
    var e = t.target,
      o = [].concat(_toConsumableArray(e.querySelectorAll(".js-input"))),
      i = e.querySelector(".js-submit-btn");
    o.forEach(function (e) {
      n(e), e.parentElement.classList.contains("has-error") ? (t.preventDefault(), i.classList.add("has-error")) : i.classList.remove("has-error");
    });
  };
  var t,
    s = function s() {
      var e = document.querySelector(".js-customer-password"),
        t = document.querySelector(".js-customer-confirm-password"),
        o = theme.locales.customer.register.default_password_length,
        i = theme.locales.customer.register.password_match;
      if (e && t) return e.value.length < 5 || t.value.length < 5 ? e.setCustomValidity(o) : e.setCustomValidity(""), "" == e.value || "" == t.value || e.value !== t.value ? (t.setCustomValidity(i), !1) : (t.setCustomValidity(""), !0);
    },
    c = function c(e) {
      return e.value ? e.classList.add("has-focus") : e.classList.remove("has-focus");
    };
  (t = [].concat(_toConsumableArray(document.querySelectorAll(".js-success-msg")))).length && t.forEach(function (e) {
    e.classList.contains("is-hidden") || setTimeout(function () {
      e.classList.add("is-hidden");
    }, 1e4);
  }), e();
}();
var updateBannerTitle = function updateBannerTitle() {
  var o = document.querySelector(".js-collection-content");
  if (o) {
    var e = document.querySelector(".js-collection-title");
    if (e) {
      var i = e.dataset.collectionHandle;
      document.querySelector(".js-collection-pre-title");
      [].concat(_toConsumableArray(document.querySelectorAll(".menu__subcategories"))).forEach(function (e) {
        if (-1 < e.pathname.indexOf(i)) {
          var t = e.closest(".js-menu-wrapper");
          if (!t) return;
          t.parentElement.querySelector(".menu__categories");
        }
        o.classList.remove("is-hidden");
      });
    }
  }
};
updateBannerTitle();
var gridView = function gridView() {
  var viewIcons = _toConsumableArray2(document.querySelectorAll('.js-grid-view'));
  viewIcons.forEach(function (icon) {
    return icon.addEventListener('click', function () {
      return changeView(icon);
    });
  });
};
var preOrderCheck = function preOrderCheck(key, currProps) {
  // console.log('preOrderCheck fired');
};
var outOfStockMsgChange = function outOfStockMsgChange(eachProductGrid, variantOutOfStock, singleOutOfStock, outOfStockMsg, replacingOOSMsg) {
  eachProductGrid.forEach(function (product) {
    var variantOOS = product.querySelector(variantOutOfStock);
    var singleOOS = product.querySelector(singleOutOfStock);
    var variantOOSInfo = variantOOS ? variantOOS.closest('.isp_product_quick_view_button') : '';
    var singleComingSoonTarget = singleOOS ? singleOOS.dataset.modalTarget.indexOf('coming-soon') > -1 : false;
    var variantComingSoonTarget = variantOOS ? variantOOSInfo.dataset.modalTarget.indexOf('coming-soon') > -1 : false;
    var genericButton = product.querySelector('.isp_product_quick_view_button');

    // Add to Cart Message Changes
    if (genericButton && genericButton.dataset.modalTarget == 'add') {
      if (replacingOOSMsg == theme.locales.collection.out_of_stock_short) {
        if (genericButton.querySelector('a')) {
          // genericButton.querySelector('a').innerText = theme.locales.collection.quick_add_mobile;
          genericButton.querySelector('a').innerText = theme.locales.collection.add_to_cart;
        } else {
          // genericButton.value = theme.locales.collection.quick_add_mobile;
          genericButton.value = theme.locales.collection.add_to_cart;
        }
      } else if (genericButton.querySelector('a')) {
        genericButton.querySelector('a').innerText = theme.locales.collection.add_to_cart;
      } else {
        genericButton.value = theme.locales.collection.add_to_cart;
      }
    }

    // Out of Stock Message Changes
    if (!!variantOOS && variantOOS.innerText == outOfStockMsg && !variantComingSoonTarget) {
      variantOOS.innerText = replacingOOSMsg;
    }
    if (!!singleOOS && singleOOS.value == '+ ' + outOfStockMsg && !singleComingSoonTarget) {
      if (replacingOOSMsg == theme.locales.collection.out_of_stock) {
        singleOOS.value = "+ ".concat(replacingOOSMsg);
      } else {
        if (document.body.clientWidth < 997 || document.documentElement.clientWidth < 997) {
          singleOOS.value = "+ ".concat(replacingOOSMsg);
        } else {
          singleOOS.value = "".concat(replacingOOSMsg);
        }
      }
    }

    // Coming Soon Message Changes
    if (!!variantOOS && variantComingSoonTarget) {
      if (replacingOOSMsg == theme.locales.collection.out_of_stock_short) {
        variantOOS.innerText = theme.locales.collection.coming_soon_short;
      } else {
        variantOOS.innerText = theme.locales.collection.coming_soon;
      }
    }
    if (!!singleOOS && singleComingSoonTarget) {
      if (replacingOOSMsg == theme.locales.collection.out_of_stock_short) {
        singleOOS.value = "+ ".concat(theme.locales.collection.coming_soon_short);
      } else if (document.body.clientWidth < 997 || document.documentElement.clientWidth < 997) {
        singleOOS.value = "+ ".concat(theme.locales.collection.coming_soon);
      } else {
        singleOOS.value = "".concat(theme.locales.collection.coming_soon);
      }
    }
  });
};
var changeView = function changeView(icon) {
  // console.log('sss');
  var iconType = icon.classList.contains('js-grid-view-single') ? 'single-view' : 'double-view';
  var customShadowRoot = document.querySelector('#fast-simon-serp-app').shadowRoot;
  var grid = customShadowRoot.querySelector('#products-grid');
  var variantOutOfStock = '.isp_product_quick_view_button a';
  var singleOutOfStock = '.isp_product_info .isp_quick_view_sold_out_btn';
  var eachProductGrid = _toConsumableArray2(document.querySelectorAll('.isp_grid_product.is-active'));
  if (iconType === 'single-view') {
    grid.classList.remove('is-double-view');
    grid.classList.add('is-single-view');
    outOfStockMsgChange(eachProductGrid, variantOutOfStock, singleOutOfStock, theme.locales.collection.out_of_stock_short, theme.locales.collection.out_of_stock);
  } else {
    grid.classList.remove('is-single-view');
    grid.classList.add('is-double-view');
    if (document.body.clientWidth < 997 || document.documentElement.clientWidth < 997) {
      outOfStockMsgChange(eachProductGrid, variantOutOfStock, singleOutOfStock, theme.locales.collection.out_of_stock, theme.locales.collection.out_of_stock_short);
    }
  }
};
(function () {
  return gridView();
})();
var revealElement = function revealElement(e) {
  (document.body.scrollHeight || document.documentElement.scrollHeight) / 2 < document.documentElement.scrollTop ? e.classList.add("is-visible") : e.classList.remove("is-visible");
},
  backToTop = function backToTop() {
    navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/) ? document.body.scrollTo({
      left: 0,
      top: 0,
      behavior: "smooth"
    }) : document.documentElement.scrollTo({
      left: 0,
      top: 0,
      behavior: "smooth"
    });
  };
!function (e) {
  var t;
  (t = document.querySelector(".js-back-to-top")) && (t.addEventListener("click", backToTop), window.addEventListener("scroll", function () {
    return e.utils.throttle(revealElement(t), 100);
  }));
}(window.theme = window.theme || {});
var getProductsDetails = function getProductsDetails(e) {
  return fetch(theme.shop.url + "/products/" + e + "?view=details").then(function (e) {
    return e.json();
  }).then(function (e) {
    return e;
  });
};
!function (e) {
  e.isp = e.isp || {}, e.isp.productsDetails = getProductsDetails;
}(window.theme = window.theme || {});
var updatePrice = function updatePrice(product, productData) {
  var isOnSale = false;
  var selectedProducts = window.pJsonData.products.filter(function (product) {
    return product.id == productData.id;
  });
  var selectedProduct = selectedProducts[0];
  if (selectedProduct == undefined) return false;
  if (productData.p_max !== 0 && productData.p_min !== 0 && productData.p_max > productData.p_min) isOnSale = true;
  if (parseInt(productData.p) !== 0 && parseInt(productData.p_c) !== 0 && parseInt(productData.p_c) > parseInt(productData.p)) isOnSale = true;
  var currencies = {
    USD: "$",
    GBP: "£",
    EUR: "€",
    ILS: "₪",
    AFN: "Af",
    DZD: "DA",
    ARS: "AR$",
    AMD: "AMD",
    AWG: "Afl.",
    AUD: "AU$",
    AZN: "man.",
    BSD: "BS$",
    BHD: "BD",
    THB: "฿",
    PAB: "B/.",
    BBD: "Bds$",
    BYR: "BYR",
    BZD: "BZ$",
    BMD: "BD$",
    BOB: "Bs",
    BRL: "R$",
    BND: "BN$",
    BGN: "BGN",
    BIF: "FBu",
    CAD: "CA$",
    CVE: "CV$",
    KYD: "KY$",
    XOF: "CFA",
    XAF: "XAF",
    XPF: "CFPF",
    CLP: "CL$",
    COP: "COP",
    KMF: "CF",
    CDF: "CDF",
    BAM: "KM",
    NIO: "NIO",
    CRC: "₡",
    CUP: "CU$",
    CZK: "Kč",
    GMD: "GMD",
    DKK: "kr",
    MKD: "MKD",
    DJF: "Fdj",
    STD: "Db",
    DOP: "RD$",
    VND: "₫",
    XCD: "EC$",
    EGP: "EGP",
    ETB: "Br",
    FKP: "FK£",
    FJD: "FJ$",
    HUF: "Ft",
    GHS: "GH₵",
    HTG: "HTG",
    PYG: "₲",
    GNF: "FG",
    GYD: "GY$",
    HKD: "HK$",
    UAH: "₴",
    ISK: "kr",
    INR: "₹",
    IRR: "IRR",
    IQD: "IQD",
    JMD: "J$",
    JOD: "JD",
    KES: "KSh",
    PGK: "PGK",
    LAK: "₭",
    KWD: "KD",
    MWK: "MWK",
    AOA: "Kz",
    MMK: "MMK",
    GEL: "GEL",
    LBP: "LBP",
    ALL: "ALL",
    HNL: "HNL",
    SLL: "Le",
    LRD: "L$",
    LYD: "LD",
    SZL: "SZL",
    LSL: "LSL",
    MGA: "MGA",
    MYR: "RM",
    MUR: "MURs",
    MXN: "Mex$",
    MDL: "MDL",
    MAD: "MAD",
    MZN: "MTn",
    NGN: "₦",
    ERN: "Nfk",
    NAD: "N$",
    NPR: "NPRs",
    ANG: "NAf.",
    RON: "RON",
    TWD: "NT$",
    NZD: "NZ$",
    BTN: "Nu.",
    KPW: "KPW",
    NOK: "kr",
    PEN: "S/.",
    MRO: "UM",
    TOP: "T$",
    PKR: "Rs",
    MOP: "MOP$",
    UYU: "$U",
    PHP: "₱",
    BWP: "BWP",
    QAR: "QR",
    GTQ: "GTQ",
    ZAR: "R",
    OMR: "OMR",
    KHR: "KHR",
    MVR: "MVR",
    IDR: "Rp",
    RUB: "RUB",
    RWF: "RWF",
    SHP: "SH£",
    SAR: "SAR",
    RSD: "din.",
    SCR: "SRe",
    SGD: "S$",
    SBD: "SI$",
    KGS: "KGS",
    SOS: "Ssh",
    TJS: "TJS",
    LKR: "SLRs",
    SDG: "SDG",
    SRD: "SR$",
    SEK: "kr",
    CHF: "CHF",
    SYP: "SY£",
    BDT: "Tk",
    WST: "WS$",
    TZS: "TSh",
    KZT: "KZT",
    TTD: "TT$",
    MNT: "₮",
    TND: "DT",
    TRY: "TL",
    TMT: "TMT",
    AED: "AED",
    UGX: "USh",
    UZS: "UZS",
    VUV: "VT",
    KRW: "₩",
    YER: "YR",
    JPY: "¥",
    CNY: "CN¥",
    ZMW: "ZMW",
    ZWL: "ZWL",
    PLN: "zł",
    BYN: "BYN"
  };
  var current_currency = currencies[theme.shop.currency];
  if (!isOnSale) {
    var currencyConfig = {
      style: 'currency',
      currency: productData.c
    };
    var updatedPriceDecimal = selectedProduct.price;
    // console.log('updatedPriceDecimal = ', updatedPriceDecimal);
    if (updatedPriceDecimal == undefined) {
      updatedPriceDecimal = productData.p;
    }
    if (updatedPriceDecimal == undefined) {
      return false;
    }
    var updatedPriceContainer = document.createElement('span');
    //updatedPriceDecimal = updatedPriceDecimal.replace(/[^\d.,]/g, '');
    var updatedPriceDecimal_number = [];
    for (var i = 0; i < updatedPriceDecimal.length; i++) {
      if (updatedPriceDecimal[i] == '.' || updatedPriceDecimal[i] == ',' || updatedPriceDecimal[i] == '1' || updatedPriceDecimal[i] == '2' || updatedPriceDecimal[i] == '3' || updatedPriceDecimal[i] == '4' || updatedPriceDecimal[i] == '5' || updatedPriceDecimal[i] == '6' || updatedPriceDecimal[i] == '7' || updatedPriceDecimal[i] == '8' || updatedPriceDecimal[i] == '9' || updatedPriceDecimal[i] == '0') {
        updatedPriceDecimal_number.push(updatedPriceDecimal[i]);
      }
    }
    updatedPriceDecimal = updatedPriceDecimal_number.join('');
    var updatedPriceDecimalArr = updatedPriceDecimal.split('.');
    if (updatedPriceDecimalArr.length > 1 && updatedPriceDecimalArr[updatedPriceDecimalArr.length - 1].length < 3) {
      updatedPriceDecimal = updatedPriceDecimal.replace('.' + updatedPriceDecimalArr[updatedPriceDecimalArr.length - 1], '');
    } else {
      updatedPriceDecimalArr = updatedPriceDecimal.split(',');
      if (updatedPriceDecimalArr.length > 1 && updatedPriceDecimalArr[updatedPriceDecimalArr.length - 1].length < 3) {
        updatedPriceDecimal = updatedPriceDecimal.replace(',' + updatedPriceDecimalArr[updatedPriceDecimalArr.length - 1], '');
      }
    }
    updatedPriceDecimal = updatedPriceDecimal.replace('.', '');
    updatedPriceDecimal = updatedPriceDecimal.replace(',', '');
    updatedPriceDecimal = Number(updatedPriceDecimal).toLocaleString('en-US');
    updatedPriceContainer.innerText = current_currency + '' + updatedPriceDecimal;

    // updatedPriceContainer.innerText = updatedPriceDecimal + ' ' + theme.shop.currency;

    updatedPriceContainer.classList.add('isp_product_price', 'money');
    var _priceContainer = product.querySelector('.isp_product_price_wrapper');
    _priceContainer.innerText = '';
    _priceContainer.appendChild(updatedPriceContainer);
    return false;
  }

  // span isp_product_price money
  /*
  let currencyConfig = { style: 'currency', currency: productData.c }
  let minPriceDecimal = (Number(productData.p)).toLocaleString('en-US', currencyConfig);
  let maxPriceDecimal = (Number(productData.p_c)).toLocaleString('en-US', currencyConfig);
     if (Shopify.currency.active === 'EUR') {
    currencyConfig = { style: 'currency', currency: 'EUR' }
    minPriceDecimal = (Number(productData.p)).toLocaleString('en', currencyConfig);
    maxPriceDecimal = (Number(productData.p_c)).toLocaleString('en', currencyConfig);
  }
  const minPrice = minPriceDecimal.split('.');
  const maxPrice = maxPriceDecimal.split('.');
  */

  //const minPrice = productData.p.split('.');
  //const maxPrice = productData.p_c.split('.');    

  var minPrice = selectedProduct.price.replace('$', '').split('.');
  var maxPrice = selectedProduct.compare_at_price.replace('$', '').split('.');
  var minPriceContainer = document.createElement('span');
  var maxPriceContainer = document.createElement('span');
  minPriceContainer.innerText = current_currency + Number(minPrice[0]).toLocaleString('en-US');
  maxPriceContainer.innerText = current_currency + Number(maxPrice[0]).toLocaleString('en-US');

  // Show the minimum price for gift cards
  var productTags = productData.att[1][1];
  var productTypes = productData.att[2][1];
  var productTagsLowercase = productTags.map(function (el) {
    return el.toLowerCase();
  });
  var productTypesLowercase = productTypes.map(function (el) {
    return el.toLowerCase();
  });
  if (productTagsLowercase.includes('gift card') || productTypesLowercase.includes('gift card')) {
    maxPriceContainer.innerHTML = 'Starting from &nbsp;';
    maxPriceContainer.classList.add('isp_product_price');
    minPriceContainer.classList.add('isp_product_price', 'money');
  } else {
    maxPriceContainer.classList.add('isp_product_price', 'money', 'on-sale');
    minPriceContainer.classList.add('isp_product_price', 'money');
  }
  var priceContainer = product.querySelector('.isp_product_price_wrapper');
  priceContainer.innerText = '';
  priceContainer.appendChild(maxPriceContainer);
  priceContainer.appendChild(minPriceContainer);
  return true;
},
  paginationRedesign = function paginationRedesign(a, s) {
    var c = document.getElementById("isp_pagination_anchor");
    // console.log('c', c);
    if (c) {
      var l = new MutationObserver(function () {
        // console.log('mutation observed');
        var e = c.querySelector(".isp_pagination"),
          t = document.createElement("span");
        if (0 !== a.total_p) {
          var o = document.querySelector(".page-item.active");
          if (o) {
            t.classList.add("pagination__view-all"), t.innerText = s.general.pagination.view_all;
            var i = document.createElement("span");
            if (i.classList.add("pagination__pages"), a.p) {
              var n = a.p,
                r = a.total_p;
              i.innerText = "Page " + n + " of " + r, o.innerHTML = "", e.querySelector(".pagination__pages") || o.append(i), l.disconnect();
            }
          }
        }
      });
      l.observe(c, {
        childList: !0
      });
      s.general.pagination.view_all;
    }
  },
  updateBadges = function updateBadges(o, e, t) {
    // // console.log('updateBadges (o)',o);
    // // console.log('updateBadges (e)',e);
    // // console.log('updateBadges (t)',t);

    var sizes = [];
    if (t.vra.length > 0) {
      t.vra.forEach(function (item) {
        var itemSize = item[1].find(function (attr) {
          return attr[0] === "Size";
        });
        if (itemSize) {
          itemSize.forEach(function (item2) {
            if (item2 != "Size") var sizeItem = '<label class="option style style--secondary" role="checkbox" tabindex="0" aria-checked="false" data-variant-price="" data-variant-id="" data-variant-sku="" for="">' + item2 + '</label>';
            sizes.push(sizeItem);
          });
        }
      });
    }
    var sizeFiltered = sizes.filter(function (a) {
      return a;
    });
    var sizeString = sizeFiltered.join('');
    var bProductData = wixobGetProductData(t.id);
    var i = o.querySelector(".isp_product_info"),
      n = document.createElement("div"),
      r = !1;
    if (!t) return !1;
    n.classList.add('isp_product_tagged');
    if (t.att && t.att[1][1].includes('swym-comingsoon')) {
      r = true;
      n.innerText = e.product.coming_soon_tag;
      n.classList.add('isp_product_tagged--coming-soon');
      if (!o.querySelector('.isp_product_tagged')) i.querySelector('a').appendChild(n);
    } else {
      n.innerText = e.product.sold_out_tag;
    }
    if (t.att && t.att[1][1].includes("app-exclusive")) {
      if (!o.querySelector('.isp_product_tagged')) i.querySelector('a').appendChild(n);
      n.innerText = 'APP EXCLUSIVE';
    } else {
      if (!r) {
        if (t.iso) {
          // ISP mentions that it sometimes get called twice so we need to check that the element isn't already present before appending it.
          if (!o.querySelector('.isp_product_tagged')) i.querySelector('a').appendChild(n);
        } else {
          if (typeof bProductData !== "undefined" && bProductData !== null && !bProductData.available) {
            if (!o.querySelector('.isp_product_tagged')) i.querySelector('a').appendChild(n);
          } else {
            // Isolate the array containing all the products tags
            t.att && t.att.forEach(function (attribute) {
              if (!attribute.includes('Tag')) {
                return;
              }
              // Check if tags array contains new tag to output corresponding badge
              attribute[1].forEach(function (tag) {
                if (tag.toLowerCase() == 'online exclusive') {
                  n.innerText = tag;
                  if (!o.querySelector('.isp_product_tagged')) i.querySelector('a').appendChild(n);
                } else {
                  if (!tag.includes('pdp_') && !tag.includes("PDP_")) {
                    return false;
                  }
                  var getTagName = tag.split('_');
                  n.innerText = getTagName[1];

                  // ISP mentions that it sometimes get called twice so we need to check that the element isn't already present before appending it.
                  if (!o.querySelector('.isp_product_tagged')) i.querySelector('a').appendChild(n);
                  if (getTagName[1] == 'limited time only') {
                    i.classList.add('pdp_limited_time_only');
                  }
                }
              });
            });
          }
        }
      }
    }
    if (t.l.indexOf("-")) {
      var color = t.l.split("- ")[1];
      if (color) {
        color = color.replace(/\s+/g, '-').toLowerCase();
        var a = t.l.split("- ")[0],
          s = 1 < t.l.split("- ").length ? t.l.split("- ")[1] : "",
          c = "";
        t.att && t.att.forEach(function (e) {
          e[1].forEach(function (e) {
            "multiple-colors" == e && (c = '<span class="text-title-space text-title-space--gap">' + theme.locales.product.more_colors + "</span>");
          });
        });
        i.querySelector(".isp_product_title").innerHTML = '<span class="main-title">' + a + '</span><span class="text-title-space"><span class="text-title-wrap">' + s + c + '</span><span style="display:none;" class="wixob-color-image"><img src="https://cdn.shopify.com/s/files/1/0150/1528/files/' + color + '.png" alt="" /></span>' + "<span style='display:none;' class='plus-count'></span></span>" + c;
      } else {
        i.querySelector(".isp_product_title").innerHTML = t.l + '<br><span class="text-title-space"><span style="display:none;" class="wixob-color-image"></span>' + "<span style='display:none;' class='plus-count'></span></span>";
      }

      // Insert Sizes
      // var atcButton = $(o.querySelector(".isp_product_image_wrapper"));

      var sizesCount = t.v_c;
      var preOrderCount = 0;
      var outOfStockCount = 0;
      var atcButton = $(o).find(".isp_product_image_wrapper");
      var productId = $(o).attr('product_id');
      var wixobProductData = wixobGetProductData(productId);

      // // console.log('wixobProductData',wixobProductData)

      if (wixobProductData.sale_item) {
        //$(o).hide();
      }
      // Colors count
      if (wixobProductData.id != undefined) {
        var pId = wixobProductData.id;
        // Count Colors
        var colorsLength = 0;
        var colorsArray = wixobProductData.colors_count;
        $.each(colorsArray, function (index, val) {
          if (window.allProductsAvailableData[val] !== undefined && val != wixobProductData.handle) {
            colorsLength++;
          }
        });
        if (wixobProductData.add_colors_count) {
          var add_colors_count = wixobProductData.add_colors_count;
          $.each(add_colors_count, function (index, val) {
            if (window.allProductsAvailableData[val] !== undefined && val != wixobProductData.handle) {
              colorsLength++;
            }
          });
        }
        if (colorsLength > 0) {
          $('ul#isp_search_results_container li[product_id=' + pId + ']').find("span.wixob-color-image").css("display", "initial");
          $('ul#isp_search_results_container li[product_id=' + pId + ']').find("span.plus-count").css("display", "initial");
        }
        $('ul#isp_search_results_container li[product_id=' + pId + ']').find("span.plus-count").empty().append("+" + colorsLength);
      }

      // options box
      if (atcButton.find(".options__group").find(".inner-option-wrapper").find("label.option").length == 0) {
        var sizes = [];
        var notifyMeButton = '';
        var multi_size_option_available = false;
        if (t.vra.length > 0) {
          t.vra.forEach(function (item) {
            var variationId = item[0];
            var variationData = wixobGetVariationData(wixobProductData, variationId);
            var itemSize = item[1].find(function (attr) {
              return attr[0] === "Size";
            });
            if (itemSize) {
              itemSize.forEach(function (item2) {
                if (item2 != "Size") {
                  var sizeItem = '';
                  var outOfStock = '';
                  var preOrder = '';
                  var preOrderAttr = '';
                  var active = '';
                  var ariaLabel = "";
                  var warehouseInv = '';
                  if (variationData) {
                    ariaLabel = " " + item2;
                    if ($(o).find(".isp_product_tagged--coming-soon").length > 0) {
                      outOfStock = 'out-of-stock';
                      ariaLabel = "Coming Soon - " + item2;
                      outOfStockCount++;
                      notifyMeButton += '<button style="display:none;" data-id="' + productId + '" data-variantId="' + variationId + '" class="singlevariants-btn mob-addtocart mob-addtocart-' + productId + '" data-modal-target="#coming-soon-modal-' + productId + '" data-swaction="addToWatchlist" data-product-id="' + productId + '">Coming Soon - Notify Me</button>';
                    } else if (variationData.inventory_quantity == 0 && variationData.inventory_management == "shopify") {
                      // out of stock
                      outOfStock = 'out-of-stock';
                      ariaLabel = "Sold Out - " + item2;
                      outOfStockCount++;
                      notifyMeButton += '<button style="display:none;" data-id="' + productId + '" data-variantId="' + variationId + '" class="singlevariants-btn mob-addtocart mob-addtocart-' + productId + '" data-modal-target="#my-signup-modal-' + productId + '" data-swaction="addToWatchlist" data-product-id="' + productId + '">+ NOTIFY ME</button>';
                    }
                    if (variationData.preorder == true || wixobProductData.all_preorder == true) {
                      if (outOfStock != "out-of-stock") {
                        preOrder = 'pre-order';
                        var preOrderAttr = '';
                        var DatapreOrderAttr = '';
                        var d_s = '';
                        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                        var date_property = new Date(variationData.preorder_date),
                          utc = date_property.getTime() + date_property.getTimezoneOffset() * 60000,
                          corrected_date = new Date(utc);
                        if (corrected_date.getDate() > 3 && corrected_date.getDate() < 21) {
                          d_s = 'th';
                        } else {
                          switch (corrected_date.getDate() % 10) {
                            case 1:
                              d_s = 'st';
                              break;
                            case 2:
                              d_s = 'nd';
                              break;
                            case 3:
                              d_s = 'rd';
                            default:
                              d_s = 'th';
                          }
                        }
                        preOrderAttr = theme.locales.product.preorder_date + ' ' + months[corrected_date.getMonth()] + ' ' + corrected_date.getDate() + d_s + ', ' + corrected_date.getFullYear();
                        DatapreOrderAttr = months[corrected_date.getMonth()] + ' ' + corrected_date.getDate() + d_s + ', ' + corrected_date.getFullYear();
                      }
                      preOrderCount++;
                    }
                    // console.log('warehouse check 1')
                    if ("inventory_warehouse" in variationData) {
                      warehouseInv = variationData.inventory_warehouse;
                    }
                    if (t.vra.length == 1 && t.vra.length > 0) active = "active";
                  }
                  var comingSoon = "";
                  if ($(o).find(".isp_product_tagged--coming-soon").length > 0) {
                    comingSoon = "is-coming-soon";
                  }
                  if (t.att && t.att[1][1].includes("app-exclusive")) {
                    comingSoon = "is-app-exclusive";
                  }
                  var multi_option_class = "";
                  if (item2[0].includes('/')) {
                    multi_option_class = " size-multi-label";
                    multi_size_option_available = true;
                  }
                  var sizeItem = '<label data-preorder-text="' + DatapreOrderAttr + '" pre-order-text="' + preOrderAttr + '" aria-label="' + ariaLabel + '" class="' + comingSoon + ' option ' + active + ' ' + preOrder + ' ' + outOfStock + ' option-class-' + item2 + multi_option_class + ' style style--secondary" role="checkbox" tabindex="0" role="checkbox" aria-checked="false" data-variant-price="" data-variant-id="' + variationId + '" data-inventory-warehouse="' + warehouseInv + '" data-variant-sku="" for="">' + item2 + '</label>';
                  sizes.push(sizeItem);
                }
              });
            }
          });
        }
        var sizeFiltered = sizes.filter(function (a) {
          return a;
        });
        var sizeString = sizeFiltered.join('');
        var buttonText = "Add To Cart";
        if (preOrderCount == sizesCount) {
          buttonText = "PreOrder";
        }
        if (outOfStockCount == sizesCount) {
          buttonText = "Sold Out - Notify Me";
        }
        if ($(o).find(".isp_product_tagged--coming-soon").length > 0) {
          buttonText = "Coming Soon - Notify Me";
        }
        if (t.att && t.att[1][1].includes("app-exclusive")) {
          buttonText = theme.locales.collection.download_app;
        }
        var multi_option_wrap_class = "";
        if (multi_size_option_available) {
          multi_option_wrap_class = "size-multi-label-wrap";
        }
        var checkoutButton = '<div class="wixob-checkout-wrapper" style="display:none;"><button type="button" class="wixob-gtc button button--secondary"><a class="cart__checkout button button--primary" href="/checkout">CHECKOUT</a></button><a href="#/" class="wixob-continue-shopping">Continue Shopping</a></div>';
        // @wx-merge: Allyant ADA Updates
        if (t.att && t.att[1][1].includes("app-exclusive")) {
          var sizesString = "<div class='options__group options__group--gap d-flex-class size-wrapper'><div class='inner-option-wrapper " + multi_option_wrap_class + "'><fieldset><legend class='sr-only'>Select Size</legend>" + sizeFiltered.join('') + "</fieldset></div><div class='wixob-atc-wrapper'><a href='https://www.aninebing.com/pages/app' class='button button--secondary app-download-link'>" + buttonText + "</a>" + checkoutButton + "</div>" + notifyMeButton + "<div style='display: none;' class='wixob-preorder-note'></div></div>";
        } else {
          var sizesString = "<div class='options__group options__group--gap d-flex-class size-wrapper'><div class='inner-option-wrapper " + multi_option_wrap_class + "'><fieldset><legend class='sr-only'>Select Size</legend>" + sizeFiltered.join('') + "</fieldset></div><div class='wixob-atc-wrapper'><button type='button' class='button wixob-atc disabled button--secondary'>" + buttonText + "</button>" + checkoutButton + "</div>" + notifyMeButton + "<div style='display: none;' class='wixob-preorder-note'></div></div>";
        }
        // @end-wx-merge: Allyant ADA Updates
        atcButton.append(sizesString);
        atcButton.attr("data-sizes", sizesString);
        // Click on first
        if (atcButton.find(".options__group fieldset label.option").length == 1) {
          atcButton.find(".options__group fieldset label.option").trigger('click');
          // atcButton.find(".options__group > label.option:first-child").hide();
        }
      }

      // END Insert Sizes

      // Quick Add Button
      $(".isp_product_quick_view_button").css("visibility", "visible");
      var wixobAgc = $(o).find(".isp_product_quick_view_button a.agc-test");
      if (wixobAgc.text() == "Quick view") {
        $(this).addClass("wixob-hide-visibility");
      }
    }
    var rolloverImages = wixobProductData.rolloverImages;
    if (rolloverImages != undefined && rolloverImages.length > 1) {
      var pLink = $(o).find("a.isp_product_image_href").attr("href");
      if ($(o).find(".wximage-container").length == 0) {
        var wxCount = 0;
        var images = '<div  class="wximage-container" data-state="played"><a href="' + pLink + '">';
        if (typeof col_pack_model !== 'undefined' && col_pack_model && wixobProductData.model_image && wixobProductData.model_image != 'no') {
          images += '<img loading="lazy" alt="' + wixobProductData.title + '" src="' + wixobProductData.model_image + '" class="active">';
          images += '<img loading="lazy" alt="' + wixobProductData.title + '" src="' + rolloverImages[0] + '">';
        } else if (wixobProductData.featured_video && wixobProductData.featured_video_link != '') {
          images += wixobProductData.featured_video_link;
          images += '<img loading="lazy" alt="' + wixobProductData.title + '" src="' + rolloverImages[0] + '">';
        } else {
          rolloverImages.forEach(function (image, index) {
            var active = '';
            if (wxCount == 0) active = 'active';
            if (wxCount == 0 || wxCount == 1) {
              images += '<img loading="lazy" alt="' + wixobProductData.title + '" src="' + image + '" class="' + active + ' " alt="' + wixobProductData.title + '">';
            }
            wxCount++;
          });
        }
        images += '</a>';
        images += '<div class="pause-play-btn pc"> <button style="display: none;" type="button" id="play-button" class="play" aria-label="Play"> <svg aria-hidden="true" focusable="false" role="presentation" fill="#000000" class="svg-icon icon-play" viewBox="18.24 17.35 24.52 28.3"><path d="M22.1 19.151v25.5l20.4-13.489-20.4-12.011z"></path></svg> </button> <button  type="button" id="pause-button" class="pause" aria-label="Pause"> <svg class="svg-icon icon-pause" viewBox="0 0 8 12" fill="none" focusable="false" aria-hidden="true"> <path d="M1.2 0.75C0.813401 0.75 0.5 0.985051 0.5 1.275V10.725C0.5 11.0149 0.813401 11.25 1.2 11.25C1.5866 11.25 1.9 11.0149 1.9 10.725V1.275C1.9 0.985051 1.5866 0.75 1.2 0.75Z" fill="#000000"></path> <path d="M6.8 0.75C6.4134 0.75 6.1 0.985051 6.1 1.275V10.725C6.1 11.0149 6.4134 11.25 6.8 11.25C7.1866 11.25 7.5 11.0149 7.5 10.725V1.275C7.5 0.985051 7.1866 0.75 6.8 0.75Z" fill="#000000"></path></svg> </button> </div>';
        images += '</div>';
        $(o).find(".isp_product_image_wrapper").prepend(images);
        initAnimation($(o).find(".wximage-container"));

        // $(o).find("a.isp_product_image_href").hide();
      }
    } else {
      $(o).find(".isp_product_image_href").attr('style', 'display: block !important');
    }
    return !0;
  };
!function (a, c) {
  window.theme.splitModalTitle = function (e, t, preOrderData) {
    var preOrderState = preOrderData ? preOrderData.product.pro_preorder_all : '';
    var appExclusiveState = preOrderData ? preOrderData.product.app_exclusive : false;
    var o = t.split("- ")[0],
      i = 1 < t.split("- ").length ? t.split("- ")[1] : "";
    var addToCart = document.querySelector('#isp_product_quick_view_model .isp_quick_view_add_to_cart_btn');
    if (preOrderState != '') {
      e.innerHTML = 1 < t.split("- ").length ? o + '<br><span class="text-title-space">' + i.toLowerCase() + '</span><br><span class="text-title-space">' + theme.locales.product.preorder + "</span>" : t + '<br><span class="text-title-space">' + theme.locales.product.preorder + "</span>";
      addToCart.value = theme.locales.product.preorder;
    } else {
      if (appExclusiveState) {
        var appLink = document.createElement('a');
        appLink.innerText = theme.locales.collection.download_app;
        appLink.href = '/pages/app';
        appLink.classList.add('isp_quick_view_add_to_cart_btn', 'app-download-link');
        appLink.setAttribute('id', 'app-download-link');
        addToCart.parentNode.insertBefore(appLink, addToCart);
      }
      e.innerHTML = 1 < t.split("- ").length ? o + '<br><span class="text-title-space">' + i.toLowerCase() + "</span>" : t;
    }
  }, a.isp = a.isp || {}, a.isp.outOfStock = function () {
    [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-submit"))).forEach(function (e) {
      e.onclick = function (e) {
        t(e.target);
      };
    });
    var t = function t(e) {
      e.removeAttribute("disabled", !0);
      var t = document.querySelector(".modal-content.is-opened .js-out-of-stock-email").value;
      if (0 == Object.keys(a.outOfStockData).length && "collection" == a.template.name) {
        if (document.querySelector("#fast-simon-serp-app")) {
          let modal_type = document.querySelector("#fast-simon-serp-app").getAttribute("data-modaltype");
          let modal = null;
          if (modal_type == 'soldout') {
            modal = document.querySelector('#out-of-stock-wrap .js-out-of-stock-modal');
          }
          if (modal_type == 'comingsoon') {
            modal = document.querySelector('#coming-soon-modal-wrap .js-out-of-stock-modal');
          }
          if (modal) {
            let variant_id = modal.getAttribute('data-variantid');
            let product_id = modal.getAttribute('data-productid');
            let price = modal.getAttribute('data-price');
            let image = modal.getAttribute('data-image');
            a.outOfStockData = {
              price: price,
              variant_id: variant_id,
              product_id: product_id,
              image: image,
              modal_type: modal_type
            }
          }
        }
      }
      if (0 == Object.keys(a.outOfStockData).length && "product" == a.template.name) {
        var o = document.querySelector(".js-single-product"),
          i = document.querySelector(".js-product-pricing .price--final .money").innerText,
          n = {
            price: "https://anine-bing-dev01-us.myshopify.com" == a.shop.url || "https://www.aninebing.com" == a.shop.url ? i.split("$")[1] : i.split("€")[1],
            variant_id: o.value,
            product_id: o.getAttribute("data-product-id"),
            image: o.getAttribute("data-image")
          };
        a.outOfStockData = {
          price: n.price,
          variant_id: n.variant_id,
          product_id: n.product_id,
          image: n.image,
          modal_type: "comingsoon"
        };
      }
      !function (e, n) {
        var t = e.image,
          o = e.price,
          i = e.product_id,
          r = e.variant_id,
          a = e.modal_type;
        window.SwymCallbacks || (window.SwymCallbacks = []);
        function s(e, t, o, i) {
          try {
            !function (e, t) {
              c.ajax({
                url: e,
                type: "POST",
                data: t
              });
            }(o, {
              email: n,
              options: {
                key: "email",
                vars: {
                  email_permission_status: t,
                  reg_source: i
                },
                lists: e
              }
            });
          } catch (e) {
            console.error(e);
          }
        }
        window.SwymCallbacks.push(function () {
          if ("comingsoon" == a) {
            window._swat.subscribeForProductAlert(n, "email", {
              epi: r,
              empi: i,
              iu: t,
              pr: o
            }, function (e) {
              // console.log(e);
            }, function (e) {
              // console.log(e);
            }, document.getElementById("agree-coming-soon").checked ? 1 : 0, "comingsoon");
            if (document.getElementById("agree-coming-soon").checked) {
              s({
                master_list: 1
              }, !0, "/apps/api-1/v1/create_user", "user subscription - coming soon notification form");
            }
          } else {
            window._swat.sendWatchlist(n, "email", {
              epi: r,
              empi: i,
              iu: t,
              pr: o
            }, function (e) {
              // console.log(e);
            }, function (e) {
              // console.log(e);
            }, document.getElementById("agree").checked ? 1 : 0);
            if (document.getElementById("agree").checked) {
              s({
                master_list: 1
              }, !0, "/apps/api-1/v1/create_user", "user subscription - out of stock notification form");
            }
          }
        });
      }(a.outOfStockData, t);
      var r = document.querySelector(".js-thank-you-message");
      "comingsoon" == a.outOfStockData.modal_type ? r.innerText = a.locales.product.success_message_coming_soon : r.innerText = a.locales.product.success_message, [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-modal .modal-close"))).forEach(function (e) {
        return e.click();
      }), setTimeout(function () {
        var modalOverlay = document.querySelector('.modal-overlay.js-modal-click-exclude');
        if (modalOverlay) {
          modalOverlay.style.display = 'none';
        }
        var thankyouModal = document.querySelector('.thank-you-success');
        if (thankyouModal) {
          thankyouModal.classList.remove('is-closed');
          thankyouModal.classList.add('is-opened');
          thankyouModal.style.display = 'block';
          thankyouModal.style.zIndex = '9';
        }
      }, 100), setTimeout(function () {
        if (document.querySelector(".js-product-success-open")) document.querySelector(".js-product-success-open").click();
      }, 1e3), setTimeout(function () {
        if (document.querySelector(".js-product-thank-you-close")) document.querySelector(".js-product-thank-you-close").click();
      }, 3e3);
    };
  }, a.isp.outOfStock();
}(window.theme = window.theme || {}, jQuery);
var singleVariantDrawerBtnsUpdate = function singleVariantDrawerBtnsUpdate(e) {
  var t = e.product,
    i = e.locales,
    n = e.productData,
    r = e.index,
    o = e.priceWrapper,
    appOnly = n.att[1][0] == 'Tag' && n.att[1][1].includes('app-exclusive') ? true : false;

  // // console.log('singleVariantDrawerBtnsUpdate n',n)
  // // console.log('singleVariantDrawerBtnsUpdate n.att[1]',n.att[1])
  // // console.log('appOnly',appOnly)

  function a() {
    var e = !1;
    return n.att && n.att[1][1].includes("swym-comingsoon") && (e = !0), e;
  }
  function s(e, t) {
    return appOnly ? "\n      <a href=\"/pages/app\" class=\"isp_quick_view_add_to_cart_btn app-download-link\">".concat(theme.locales.collection.download_app, "</a>\n    ") : '\n      <input type="submit" value="' + e + '" name="button" class="js-iso-product is-selected js-open-modal isp_quick_view_sold_out_btn button button--primary" data-modal-target="#' + t + '">\n    ';
  }
  if (!t.querySelectorAll(".isp-quick-add-atc__form-container").length) {
    var c = +t.getAttribute("product_id"),
      l = n.vra[0][0],
      d = document.createElement("div");
    d.classList.add("isp_product_quick_view_button", "isp-quick-add-atc__form-container");
    var u = '<input type="submit" value="' + i.collection.add_to_cart + '" name="button" class="js-atc-quick-add button button--primary">';
    a() ? u = 997 < document.body.clientWidth || 997 < document.documentElement.clientWidth ? s("" + i.collection.coming_soon, "coming-soon-modal") : (document.body.clientWidth < 640 || document.documentElement.clientWidth < 640) && !$("#isp_search_results_container").hasClass("is-double-view") && "isp-search" != window.theme.template.suffix ? s("+ " + i.collection.coming_soon, "coming-soon-modal") : s("+ " + i.collection.coming_soon_short, "coming-soon-modal") : n.iso && (u = 997 < document.body.clientWidth || 997 < document.documentElement.clientWidth ? s("" + i.collection.out_of_stock, "my-signup-modal") : (document.body.clientWidth < 640 || document.documentElement.clientWidth < 640) && !$("#isp_search_results_container").hasClass("is-double-view") && "isp-search" != window.theme.template.suffix ? s("+ " + i.collection.out_of_stock, "my-signup-modal") : s("+ " + i.collection.out_of_stock_short, "my-signup-modal"));
    var m = appOnly ? "<a href=\"/pages/app\" class=\"isp_quick_view_add_to_cart_btn app-download-link\">".concat(theme.locales.collection.download_app, "</a>") : '\n    <form id="form_quick_view_' + c + '" class="isp_quick_view_add_to_cart_form js-single-variant-atc" data-price="' + n.p + '" data-sku="' + n.sku + '" action="/cart/add" method="post">\n      <input id="isp_selected_variant_id" name="id" type="hidden" value="' + l + '">\n      ' + u + "\n    </form>\n  ";
    d.insertAdjacentHTML("afterbegin", m);
    var p = t.querySelector(".isp_product_quick_view_button");
    p && p.parentNode.replaceChild(d, p);
    var f = t.querySelector(".js-atc-quick-add");
    f && (f.setAttribute("disabled", !1), f.disabled = !1);
    var h = d.cloneNode(!0);
    if (o.appendChild(h), n.iso || a()) [].concat(_toConsumableArray(t.querySelectorAll(".js-iso-product"))).forEach(function (e) {
      theme.modal.addTrigger($(e)), e.addEventListener("click", function () {
        // console.log("comingSoonBooleanSingleProduct", a()), fillModal(n.l, "ONE", e, n);
      });
    });

    //
    // Event Listener - On Submit
    //
    var atcForms = _toConsumableArray2(t.querySelectorAll('.js-single-variant-atc'));
    atcForms.forEach(function (form) {
      return form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (n.iso || a()) return;
        // console.log('quick add to cart - one variant from collection');

        // Prevent Flyout from opening
        window.theme.addedFromQuickAdd = true;
        var checkProductInCart = isSelectedItemInCart(l);
        if (!checkProductInCart.isInCart) {
          window.theme.cart.add(l);
        } else {
          window.theme.cart.update({
            id: l,
            quantity: checkProductInCart.quantity + 1
          });
        }

        // Adds gift automatically when theme.settings.gift.add_type == automatic,  found on gift.js
        // ISP QUICK ADD TO CART FOR SINGLE PRODUCTS
        theme.deleteGiftSessionStorage();
        displayProductQuickView(c, r);
        var price = "$".concat(n.p);
        if (window.theme.shop.url !== 'https://www.aninebing.com') {
          price = "\u20AC".concat(n.p);
        }
        var href = n.u;
        fetch(href + '?view=array').then(function (response) {
          return response.text();
        }).then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var preOrderData = doc.querySelector('#product-preorder-' + n.id).innerText;
          preOrderData = JSON.parse(preOrderData);
          window.theme.isp.quickAdd.checkoutView({
            productTitle: n.l,
            productOption: 'ONE',
            productImgUrl: n.t,
            productPrice: price
          }, i, "collection", preOrderData);
        });
      });
    });
    var v,
      _ = function _(e, t, o) {
        997 < document.body.clientWidth || 997 < document.documentElement.clientWidth ? e.forEach(function (e) {
          return e.value = "" + o;
        }) : (document.body.clientWidth < 640 || document.documentElement.clientWidth < 640) && !$("#isp_search_results_container").hasClass("is-double-view") && "isp-search" != window.theme.template.suffix ? e.forEach(function (e) {
          return e.value = "+ " + t;
        }) : e.forEach(function (e) {
          return e.value = "+ " + t;
        });
      };
    v = t.querySelector(".isp_product_price_wrapper .js-atc-quick-add"), y(), window.addEventListener("resize", window.theme.utils.throttle(y, 100));
  }
  function y() {
    (document.body.clientWidth < 997 || document.documentElement.clientWidth < 997) && (!n.iso || a()) && v ? v.value = "+" + i.collection.add_to_cart : n.iso && !a() || !v || (v.value = i.collection.quick_add);
    var e = t.querySelectorAll(".isp_product_quick_view_button .js-iso-product");
    a() ? _(e, i.collection.coming_soon_short, i.collection.coming_soon) : n.iso && _(e, i.collection.out_of_stock_short, i.collection.out_of_stock);
  }
},
  fillModal = function fillModal(t, o, e, i) {
    var n = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-modal-prod-title"))),
      r = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-size"))),
      a = -1 < e.dataset.modalTarget.indexOf("coming-soon") ? "comingsoon" : "";
    n.forEach(function (e) {
      theme.splitModalTitle(e, t);
    }), r.forEach(function (e) {
      e && (e.innerText = "Size: " + o);
    }), console.log("SINGLE Modal Type Update", a), theme.outOfStockData = {
      price: +i.p,
      variant_id: +i.vra[0][0],
      product_id: +i.id,
      image: i.image,
      modal_type: a
    };
  },
  ispQuickAdd = function ispQuickAdd(e, t, o, i) {
    var n = e.querySelector(".isp_product_price_wrapper"),
      r = e.querySelector(".isp_product_image_wrapper"),
      a = e.querySelector(".isp_product_quick_view_button");
    if (1 === o.v_c) return singleVariantDrawerBtnsUpdate({
      product: e,
      locales: t,
      productData: o,
      index: i,
      priceWrapper: n,
      imgWrapper: r
    });
    var s = document.createElement("a");
    s.setAttribute("href", "#ModalCloseButton"), s.classList.add("button", "button--secondary", "agc-test"), a || 1 === o.v_c || ((a = document.createElement("a")).classList.add("isp_product_quick_view_button"), a.addEventListener("click", function () {
      displayProductQuickView(o.id, i);
    })), updateIspQuickAdd({
      span: s,
      priceWrapper: n,
      imgWrapper: r,
      btn: a,
      productData: o,
      locales: t
    });
  },
  updateIspQuickAdd = function updateIspQuickAdd(e) {
    var t = e.span,
      o = e.priceWrapper,
      i = e.imgWrapper,
      n = e.btn,
      r = e.productData,
      a = e.locales;
    function s() {
      if (t.innerText = a.product.coming_soon, r.att && r.att[1][1].includes("no-quick-view")) {
        var e = i.querySelector(".isp_product_quick_view_button");
        e && e.remove();
      } else !function () {
        var e = !1;
        return r.att && r.att[1][1].includes("swym-comingsoon") && (e = !0), e;
      }() ? r.iso ? 997 < document.body.clientWidth || 997 < document.documentElement.clientWidth ? (i.appendChild(n), t.innerText = "" + a.collection.out_of_stock) : (document.body.clientWidth < 640 || document.documentElement.clientWidth < 640) && !$("#isp_search_results_container").hasClass("is-double-view") && "isp-search" != window.theme.template.suffix ? (o.appendChild(n), t.innerText = "" + a.collection.out_of_stock) : (o.appendChild(n), t.innerText = "" + a.collection.out_of_stock_short) : 997 < document.body.clientWidth || 997 < document.documentElement.clientWidth ? (t.innerText = "" + a.collection.quick_add, i.appendChild(n)) : ((document.body.clientWidth < 640 || document.documentElement.clientWidth < 640) && !$("#isp_search_results_container").hasClass("is-double-view") && window.theme.template.suffix, t.innerText = "" + a.collection.add_to_cart, o.appendChild(n)) : 997 < document.body.clientWidth || 997 < document.documentElement.clientWidth ? (i.appendChild(n), setTimeout(function () {
        i.querySelector(".isp_product_quick_view_button a") ? i.querySelector(".isp_product_quick_view_button a").innerText = "" + a.collection.coming_soon : i.querySelector(".isp_product_quick_view_button .js-atc-quick-add").value = "" + a.collection.coming_soon;
      }, 1e3)) : (document.body.clientWidth < 640 || document.documentElement.clientWidth < 640) && !$("#isp_search_results_container").hasClass("is-double-view") && "isp-search" != window.theme.template.suffix ? (o.appendChild(n), setTimeout(function () {
        o.querySelector(".isp_product_quick_view_button a") ? o.querySelector(".isp_product_quick_view_button a").innerText = "" + a.collection.coming_soon : o.querySelector(".isp_product_quick_view_button").value = "" + a.collection.coming_soon;
      }, 1e3)) : (o.appendChild(n), setTimeout(function () {
        o.querySelector(".isp_product_quick_view_button a") ? o.querySelector(".isp_product_quick_view_button a").innerText = "" + a.collection.coming_soon_short : o.querySelector(".isp_product_quick_view_button").value = "" + a.collection.coming_soon_short;
        o.querySelector(".isp_product_quick_view_button a") && o.querySelector(".isp_product_quick_view_button a").classList.add("show");
      }, 1e3));
      var product_tags = r.att[1][1];
      product_tags.forEach(function (e) {
        if (!e.includes("PDP_")) return !1;
        var tag = e.split("_");
        if (tag[1] == 'Pre-Order') {
          t.innerText = theme.locales.collection.preorder;
          n.dataset.atcText = theme.locales.collection.preorder;
        }
      });
      if (product_tags.includes('app-exclusive')) {
        t.innerText = theme.locales.collection.download_app;
        t.href = '/pages/app';
      }
      setTimeout(function () {
        n.innerHTML = t.outerHTML;
      }, 500);
    }
    s();

    //window.addEventListener("resize", window.theme.utils.throttle(s, 100))
  },
  isSelectedItemInCart = function isSelectedItemInCart(t) {
    var e = theme.cart._object.items.filter(function (e) {
      return e.variant_id === +t;
    });
    if (e.length) {
      var object = [].concat(_toConsumableArray(document.querySelectorAll(".js-selected-option"))).find(function (e) {
        return +e.dataset.variantId == +t;
      });
      if (object) {
        object.closest(".js-cart-item").querySelector(".js-cart-item-quantity");
        return object.innerText = +object.innerText + 1, {
          isInCart: !0,
          quantity: e[0].quantity
        };
      } else {
        return {
          isInCart: !1
        };
      }
    }
    return {
      isInCart: !1
    };
  };
!function (e) {
  e.quickAdd = ispQuickAdd;
}(window.isp = window.isp || {}, jQuery, window.theme);
var ispQuickAddModal = function ispQuickAddModal(e, t) {
  var o = document.querySelector(".isp_quick_view_variant"),
    i = document.getElementById("isp_product_quick_view_model"),
    n = document.querySelector(".isp_quick_view_content_right"),
    r = document.getElementById("isp_product_quick_view_close_button"),
    a = document.querySelector("#isp_product_quick_view_model .isp_quick_view_add_to_cart_btn"),
    s = document.createElement("button");
  s.id = "ModalCloseButton", s.title = r.title, s.innerHTML = r.innerHTML, s.addEventListener("click", function () {
    return closeQuickView();
  }), i.prepend(s), r.style.display = "none", s.focus(), a && (a.disabled = !0);
  var c = '<a class="isp_quick_view_continue_shopping js-continue-shopping link link--primary">' + e.collection.continue_shopping + "</a>",
    l = t.utils.parseHTML(c),
    d = document.createElement("div");
  d.classList.add("options__group"), d.classList.add("options__group--gap");
  var u = document.createElement("p");
  u.classList.add("isp_quick_view_subtitle"), u.innerText = e.collection.quick_add_select;
  var m = t.utils.parseHTML('<img class="isp_quick_view_logo" src="https://cdn.shopify.com/s/files/1/0150/1528/files/monogram-logo-2019-black_3x_249a7963-7a91-452b-90da-2ff0df0bdadc.png?171833" alt="Anine Bing Logo" />'),
    p = document.querySelector("#isp_product_quick_view_model .isp_quick_view_variant_select");
  if (i.appendChild(m), p) {
    var f = ["XS", "S", "M", "L", "XL"],
      h = "",
      v = "",
      _ = void 0,
      y = void 0,
      g = [].concat(_toConsumableArray(p.children)).sort(function (e, t) {
        return h = e.value.split(": ")[1], v = t.value.split(": ")[1], (y = isNaN(h) ? (_ = f.indexOf(h), f.indexOf(v)) : (_ = parseInt(h), parseInt(v))) < _ ? 1 : _ < y ? -1 : 0;
      });
    buildNewOptionSelector(g, d, p, e), n.appendChild(l), o.before(u), o.appendChild(d), document.querySelector(".js-continue-shopping").addEventListener("click", function () {
      return r.click();
    }), updateUnavailableModalDescription(n);
  }
},
  updateUnavailableModalDescription = function updateUnavailableModalDescription(e, t) {
    var o = document.querySelector("#isp_product_quick_view_model .isp_quick_view_sold_out_btn"),
      i = document.querySelector(".isp_quick_view_content_wrapper");
    if (o) {
      var n = o.value,
        r = document.querySelector(".isp_quick_view_type_description"),
        a = void 0;
      i.classList.contains("isp_quick_view_content_wrapper--unavailable-product") || i.classList.add("isp_quick_view_content_wrapper--unavailable-product"), r && r.remove(), n == theme.locales.product.coming_soon ? a = '\n        <h2 class="isp_quick_view_type_description">\n          <span aria-label="Sold Out">' + theme.locales.product.modal_coming_soon_description + "</span>\n        </h2>\n      " : n == theme.locales.product.out_of_stock.toUpperCase() && (a = '\n        <h2 class="isp_quick_view_type_description">\n          <span aria-label="Sold Out">' + theme.locales.product.modal_out_of_stock_description + "</span>\n        </h2>\n      "), o.setAttribute("data-atc-text", n), "on-select-add-to-cart" != t && (o && "on-option-select" != t && (o.value = theme.locales.product.select_size), a && e.insertAdjacentHTML("afterbegin", a));
    }
  },
  buildNewOptionSelector = function buildNewOptionSelector(s, c, l, d) {
    var e = document.querySelector(".isp_quick_view_title"),
      u = e.getAttribute("product_id"),
      m = document.querySelector('.isp_grid_product[product_id="' + u + '"] .isp_product_quick_view_button').dataset.atcText == theme.locales.product.coming_soon,
      appCheck = document.querySelector('.isp_grid_product[product_id="' + u + '"] .isp_product_quick_view_button').dataset.atcText == theme.locales.collection.download_app;
    var href = document.querySelector('.isp_grid_product[product_id="' + u + '"] .isp_product_image_href').getAttribute("href");
    href = href.split('?')[0];
    fetch(href + '?view=array').then(function (response) {
      return response.text();
    }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var preOrderData = doc.querySelector('#product-preorder-' + u).innerText;
      preOrderData = JSON.parse(preOrderData);
      theme.splitModalTitle(e, e.innerText, preOrderData), s.map(function (e) {
        var t = e.getAttribute("variant_id"),
          o = e.getAttribute("disabled"),
          i = e.value.split("|"),
          n = 2 === i.length ? i[1].split(":") : i[0].split(":"),
          z = document.createElement("input"),
          r = document.createElement("label");
        null === o && !m || (!0, m ? r.classList.add("is-coming-soon") : r.classList.add("is-oos"), r.classList.add("is-disabled"));
        null === o && !appCheck || (!0, appCheck ? r.classList.add('is-app-exclusive') : r.classList.add('is-oos'), r.classList.add("is-disabled"));
        var a = parseFloat(ISP_PRODUCTS[+u].vra.filter(function (e) {
          return e.includes(+t);
        })[0][1].filter(function (e) {
          return "Price" == e[0];
        })[0][1][0].split(":")[1]);
        z.classList.add('is-hidden');
        z.setAttribute('type', 'radio');
        z.setAttribute('type', 'radio');
        z.setAttribute('name', 'isp-quick-modal-option' + u);
        z.setAttribute("id", "isp-quick-modal-option-" + t);
        r.classList.add("option", "style", "style--secondary"), r.setAttribute("role", "checkbox"), r.setAttribute("tabindex", "0"), r.setAttribute("aria-checked", "false"), r.setAttribute("data-variant-price", parseFloat(a).toFixed(2)), r.setAttribute("data-variant-id", t), r.setAttribute("data-variant-sku", ISP_PRODUCTS[+u].sku), r.setAttribute("for", "isp-quick-modal-option-" + t), r.innerText = n[1] ? n[1].trim() : n[0].trim(), r.addEventListener("click", function (e) {
          return selectOption(e, s, l, d, m, preOrderData);
        }), c.appendChild(r), c.appendChild(z);
      }), (s.every(function (e) {
        return e.disabled;
      }) || m) && productIsSoldOut(d, s, m), lastAvailableItemAdded();
    });
  },
  lastAvailableItemAdded = function lastAvailableItemAdded() {
    var e = document.querySelector(".isp_quick_view_show_more").href.split("/");
    theme.isp.productsDetails(e[4]).then(function (e) {
      if (e) {
        var o = theme.cart._object.items || theme.cart.items;
        e.variants.filter(function (t) {
          o.filter(function (e) {
            return +e.variant_id == +t.id;
          }).forEach(function (e) {
            e.quantity >= t.quantity && [].concat(_toConsumableArray(document.querySelectorAll(".option"))).forEach(function (e) {
              e.classList.contains("is-disabled") || +e.dataset.variantId !== t.id || e.classList.add("is-disabled");
            });
          });
        });
      }
    });
  },
  selectOption = function selectOption(e, t, o, i, n, preOrderData) {
    var r = document.querySelector(".isp_quick_view_content_right"),
      a = document.querySelector(".isp_quick_view_title"),
      s = document.querySelector(".isp_quick_view_image").src,
      c = a.getAttribute("product_id"),
      d_s,
      l = (document.querySelector(".isp_grid_product[product_id='" + c + "'] .isp_product_price_wrapper .isp_product_price").getAttribute("title"), document.querySelector("#isp_product_quick_view_model .isp_quick_view_add_to_cart_btn")),
      d = document.querySelector("#isp_product_quick_view_model .isp_quick_view_sold_out_btn"),
      u = [].concat(_toConsumableArray(document.querySelectorAll("#isp_product_quick_view_model .isp_quick_view_add_to_cart_btn"))),
      m = e.target,
      p = n ? "comingsoon" : "",
      presale_variant = preOrderData.product.variants.filter(function (variant) {
        return variant.id === parseInt(m.dataset.variantId);
      }),
      preorder_note = document.getElementById('preorder_note'),
      o_p;
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var daySuffix = ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"];
    $('.options__group .option').attr("aria-checked", "false");
    m.setAttribute("aria-checked", "true");
    // console.log('selectOption clicked');
    presale_variant[0].preorder ? u[0].value = theme.locales.product.preorder : u[0].value = theme.locales.product.add_to_bag;
    if (presale_variant[0].preorder) {
      window.theme.giftPreorderPrevent = true;
      o_p = {
        '_preorderDate': presale_variant[0].preorder_date
      };
      var date_property = new Date(presale_variant[0].preorder_date),
        utc = date_property.getTime() + date_property.getTimezoneOffset() * 60000,
        corrected_date = new Date(utc);
      if (!preorder_note) {
        var last_cart_btn = document.querySelector("#isp_product_quick_view_model .isp_quick_view_add_to_cart_form"),
          preorder_note = document.createElement('div');
        preorder_note.id = 'preorder_note';
        last_cart_btn.parentNode.insertBefore(preorder_note, last_cart_btn.nextSibling);
      }
      if (corrected_date.getDate() > 3 && corrected_date.getDate() < 21) {
        d_s = 'th';
      } else {
        switch (corrected_date.getDate() % 10) {
          case 1:
            d_s = 'st';
            break;
          case 2:
            d_s = 'nd';
            break;
          case 3:
            d_s = 'rd';
          default:
            d_s = 'th';
        }
      }
      preorder_note.innerText = theme.locales.product.preorder_date + ' ' + months[corrected_date.getMonth()] + ' ' + corrected_date.getDate() + d_s + ', ' + corrected_date.getFullYear();
    } else {
      if (preorder_note) {
        preorder_note.innerText = '';
      }
    }
    d && (d.value = d.dataset.atcText), t.forEach(function (e) {
      return e.removeAttribute("selected");
    });
    var f = t.filter(function (e) {
      return e.getAttribute("variant_id") === m.dataset.variantId;
    });
    [].concat(_toConsumableArray(m.parentElement.querySelectorAll(".option"))).forEach(function (e) {
      return e.classList.remove("is-selected");
    }), m.classList.add("is-selected"), l.classList.add("is-selected");
    var h = +document.querySelector(".isp_quick_view_variant .is-selected").dataset.variantPrice;
    theme.outOfStockData = {
      price: h,
      variant_id: +m.getAttribute("data-variant-id"),
      product_id: +c,
      image: s,
      modal_type: p
    }, u.forEach(function (e) {
      return e.disabled = !1;
    }), document.querySelector("#isp_product_quick_view_model .isp_quick_view_sold_out_btn") || productIsSoldOut(i);
    var v = document.querySelector("#isp_product_quick_view_model .isp_quick_view_sold_out_btn");
    if (m.classList.contains("is-disabled") && !m.classList.contains('is-app-exclusive')) fillBackInStock(m, t, i), l.style.display = "none", v.style.display = "block", v.disabled = !1, v.classList.contains("button--secondary") && (v.classList.remove("button--secondary"), v.classList.add("button--primary")), updateUnavailableModalDescription(r, "on-option-select"); else {
      var _ = document.querySelector(".isp_quick_view_content_wrapper");
      l.style.display = "block", v.style.display = "none", l.disabled = !1, l.classList.contains("button--secondary") && (l.classList.remove("button--secondary"), l.classList.add("button--primary")), document.querySelector(".isp_quick_view_type_description") && document.querySelector(".isp_quick_view_type_description").remove(), updateUnavailableModalDescription(r, "on-select-add-to-cart"), _.classList.contains("isp_quick_view_content_wrapper--unavailable-product") && _.classList.remove("isp_quick_view_content_wrapper--unavailable-product");
    }
    if (f[0].setAttribute("selected", !0), ispQuickViewVariantChange(o, c), !e.target.classList.contains("is-disabled")) {
      var y = document.querySelector("#isp_product_quick_view_model .isp_quick_view_add_to_cart_form");
      y.addEventListener("error", function () {
        return // console.log("error");
      }), y.onsubmit = function (e) {
        e.preventDefault(), theme.isp.quickAdd.checkoutView({
          productTitle: a.innerText,
          productOption: m.innerText,
          productImgUrl: s,
          productPrice: theme.utils.toMoney(100 * h, {
            cents: !0,
            no_zeros: !0
          }),
          productPriceReal: h,
          productId: c
        }, i, "collection", preOrderData), theme.isp.addToCartActions(theme, o_p);
      };
    }
  },
  productIsSoldOut = function productIsSoldOut(locales, options, comingSoon) {
    var addToCartWrapper = document.querySelector('.isp_quick_view_price_add_to_cart_wrapper');
    var addToCartForm = document.querySelector('#isp_product_quick_view_model .isp_quick_view_add_to_cart_form');
    var soldOutButton = document.createElement('input');
    var ispModalAddButton = document.querySelector('#isp_product_quick_view_model .isp_quick_view_add_to_cart_form');
    var variantSizes = _toConsumableArray2(document.querySelectorAll('.isp_quick_view_variant_select option')).length;
    soldOutButton.classList.add('isp_quick_view_add_to_cart_btn', 'is-selected', 'js-open-modal', 'isp_quick_view_sold_out_btn');
    if (comingSoon) {
      // To hide the ATC button
      if (ispModalAddButton) ispModalAddButton.style.display = 'none';
      theme.utils.setAttributes(soldOutButton, {
        'type': 'submit',
        'value': locales.product.coming_soon,
        'name': 'button',
        'data-atc-text': locales.product.coming_soon,
        'data-modal-target': '#coming-soon-modal'
      });
    } else {
      theme.utils.setAttributes(soldOutButton, {
        'type': 'submit',
        'value': locales.collection.out_of_stock,
        'name': 'button',
        'data-atc-text': locales.collection.out_of_stock,
        'data-modal-target': '#my-signup-modal'
      });
    }
    if (variantSizes > 1) soldOutButton.disabled = true;

    // Add Button to page
    // Add Trigger to open back in stock modal on sold out button click
    // On sold out button click close quick view modal

    if (addToCartForm) {
      addToCartForm.parentNode.insertBefore(soldOutButton, addToCartForm.nextSibling);
    } else {
      addToCartWrapper.appendChild(soldOutButton);
    }
    theme.modal.addTrigger($(soldOutButton));
    soldOutButton.addEventListener('click', closeQuickView);

    //
    // Fill back in stock modal with first option
    //

    if (options) {
      fillBackInStock(options[0], options, locales);
    }
  },
  fillBackInStock = function fillBackInStock(e, t, o) {
    var i = e.innerText,
      n = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-modal-prod-title"))),
      r = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-size"))),
      a = document.querySelector(".isp_quick_view_title").getAttribute("product_id");
    "OPTION" === e.tagName ? r.forEach(function (e) {
      e.innerText = i;
    }) : r.forEach(function (e) {
      e.innerText = o.collection.out_of_stock_selected_option + " " + i;
    }), n.forEach(function (e) {
      e && (e.innerHTML = "", e.insertAdjacentHTML("beforeend", document.querySelector(".isp_grid_product[product_id='" + a + "'] .isp_product_title").innerHTML));
    });
  },
  closeQuickView = function closeQuickView() {
    // console.log('Closes is fired...');
    // console.log(localStorage.getItem("product"));
    setTimeout(function () {
      $('body').find(".isp_grid_product[product_id='" + localStorage.getItem("product") + "'] .isp_product_title").attr('tabindex', '1').get(0).focus();
      // console.log('focuccess...');
    }, 1000);
    var e = document.getElementById("isp_product_quick_view_close_button");
    theme.settings.gift_bundle_enabled && "modal" == theme.settings.gift.add_type && theme.giftBundle.updateGiftFlyout(!0), null != e && e.click();
  },
  checkoutView = function checkoutView(e, t, page, preOrderData) {
    var o = e.productTitle,
      i = e.productOption,
      n = e.productImgUrl,
      r = e.productPrice,
      a = document.querySelector(".isp_quick_view_content_wrapper"),
      s = [].concat(_toConsumableArray(document.querySelectorAll(".js-quickAdd-checkout-view")));
    var preOrderState = preOrderData ? preOrderData.product.pro_preorder_all : false;
    s.length && s.forEach(function (e) {
      return e.parentNode.removeChild(e);
    }), document.querySelector(".isp_quick_view_content_right").style.display = "none", document.getElementById("isp_product_quick_view_model").classList.add("is-checkout-view");
    if (preOrderState) {
      // console.log('pre order data.................', preOrderData);
      var title = "<h3 class=\"quickAdd-checkout-view__title\">".concat(o, "</h3><p class=\"quickAdd-checkout-view__preorder text-small\">").concat(theme.locales.product.preorder, "</p>\n                    <p class=\"quickAdd-checkout-view__preorder_date\">Expected to Ship: ").concat(preOrderData.product.variants[0].preorder_date, "</p>\n            ");
    } else {
      var title = "<h3 class=\"quickAdd-checkout-view__title\">".concat(o, "</h3>");
    }
    var c = "\n              <div class=\"quickAdd-checkout-view js-quickAdd-checkout-view\">\n                <h2 class=\"quickAdd-checkout-view__caption\">".concat(t.collection.added_to_cart, "</h2>\n                <div class=\"quickAdd-checkout-view__content\">\n                  <img class=\"quickAdd-checkout-view__image\" src=\"").concat(n, "\" alt=\"\" />\n                  <div class=\"quickAdd-checkout-view__content-details\">\n\t\t\t\t\t").concat(title, "\n                    <p class=\"quickAdd-checkout-view__option text-small\">").concat(i, "</p>\n                    <p class=\"quickAdd-checkout-view__quantity text-small\">QTY 1</p>\n                  </div>\n                  <p class=\"quickAdd-checkout-view__price text-small\">").concat(r, "</p>\n                </div>\n                <a href=\"/checkout\" class=\"quickAdd-checkout-view__button button button--primary\" role=\"button\">").concat(t.collection.checkout, "</a>\n                <a href=\"#MainContent\" class=\"quickAdd-checkout-view__link link link--primary\">").concat(t.collection.continue_shopping, "</a>\n              </div>\n            "),
      l = theme.utils.parseHTML(c);
    a.appendChild(l), theme.settings.gift_bundle_enabled && (document.querySelector(".quickAdd-checkout-view__button").style.pointerEvents = "none", setTimeout(function () {
      null != document.querySelector(".quickAdd-checkout-view__button") && (document.querySelector(".quickAdd-checkout-view__button").style.pointerEvents = "auto");
    }, 3e3));
    var d = document.querySelector(".quickAdd-checkout-view__link"),
      u = document.querySelector("#isp_product_quick_view_overlay");
    d.addEventListener("click", closeQuickView), u.addEventListener("click", closeQuickView);
  };
!function (e) {
  e.isp = e.isp || {}, e.settings = e.settings || {}, e.isp.quickAdd = e.isp.quickAdd || {}, e.outOfStockData = e.outOfStockData || {}, e.isp.quickAdd.checkoutView = checkoutView, e.isp.lastAvailableItemAdded = lastAvailableItemAdded;
}(window.theme = window.theme || {});
var ispHeaderSearch = function ispHeaderSearch(r) {
  var a = {
    triggers: [].concat(_toConsumableArray(document.querySelectorAll(".js-trigger-search"))),
    searchContainer: document.getElementById("isp_search_box_container"),
    input: document.getElementById("isp_main_search_box"),
    searchResultTitle: document.querySelector(".js-result-count"),
    header: document.querySelector("#section-header")
  };
  a.triggers.forEach(function (e) {
    return e.onclick = function (e) {
      return o(e, a);
    };
  });
  function e(e) {
    var t = e.input;
    document.body.clientWidth < 997 ? t.setAttribute("placeholder", r.locales.general.search.name) : t.setAttribute("placeholder", "");
  }
  var t,
    o = function o(e, t) {
      var o = t.searchContainer,
        i = t.input,
        n = t.header;
      e.preventDefault();
      var r = document.querySelector(".js-result-count"),
        a = r ? r.classList.contains("isp-search-results__title--result-count-active") : "";
      $('.search-btn').attr('aria-expanded', 'true');
      if (o.style.transform = "translateY(0)", o.classList.toggle("is-active"), o.classList.contains("is-active")) {
        setTimeout(function () {
          return i.focus();
        }, 500), r && !a && r.classList.add("isp-search-results__title--result-count-active");
        var s = document.querySelector(".js-announcement"),
          c = n.clientHeight + s.clientHeight - 2;
        o.style.transform = "translateY(" + c + "px)";
      } else {
        i.blur();
        $('.search-btn').attr('aria-expanded', 'false');
      }
    },
    s = function s(e) {
      var t = e.input,
        o = e.searchContainer,
        i = document.getElementById("ui-id-1"),
        n = document.querySelector(".js-result-count"),
        r = n ? n.classList.contains("isp-search-results__title--result-count-active") : "";
      i && (o.classList.remove("is-active"), n && r && n.classList.remove("isp-search-results__title--result-count-active"), document.getElementById("ui-id-1").classList.remove("is-open"), t.blur());
      $('.search-btn').attr('aria-expanded', 'false');
    };
  document.addEventListener("keyup", function (e) {
    27 === e.keyCode && s(a);
  }), document.addEventListener("click", function (e) {
    var t = a.searchContainer,
      o = a.triggers,
      i = r.utils.targetIs(e.target, o),
      n = r.utils.targetIs(e.target, [t]);
    i || n || s(a);
  }), window.addEventListener("resize", r.utils.throttle(function () {
    return e(a);
  }, 100)), function (e) {
    var t = e.searchContainer,
      o = document.createElement("span");
    o.setAttribute("role", "button"), o.setAttribute("title", "Search close button"), o.setAttribute("aria-label", r.locales.general.search.close), o.classList.add("search-close__trigger"), o.addEventListener("click", function () {
      return s(a);
    }), t.appendChild(o);
    var i = document.createElement("label");
    i.setAttribute("for", "isp_main_search_box"), i.innerText = r.locales.general.search.name, i.classList.add("search-form__label", "uppercase-text"), t.appendChild(i);
  }(a), e(a), updateSearchResultPageTitle(a)
},
  ispAutoCompleteSearchResults = function ispAutoCompleteSearchResults(t, e) {
    var o = {
      announcement: document.querySelector(".js-announcement"),
      ispAutocompleteAnnouncementBar: document.querySelector("#ui-id-1.ui-autocomplete")
    };
    0 < !o.announcement.clientHeight && o.ispAutocompleteAnnouncementBar && o.ispAutocompleteAnnouncementBar.classList.add("no-announcement");
    var i,
      n,
      r,
      a,
      s,
      c,
      l,
      d,
      u = {
        parentContainer: document.getElementById("ui-id-1"),
        otherParentContainer: document.getElementById("ui-id-2"),
        collectionsContainer: document.querySelector("li.isp_section_categories"),
        collectionsResults: [].concat(_toConsumableArray(document.querySelectorAll(".ui-menu-item[isp_category=true]"))),
        productsContainer: document.querySelector(".isp_section_products"),
        productsResults: [].concat(_toConsumableArray(document.querySelectorAll(".ui-menu-item[isp_product]"))),
        popularSearchesContainer: document.querySelector(".isp_section_searches"),
        popularSearchesResults: [].concat(_toConsumableArray(document.querySelectorAll(".ui-menu-item[isp_pop_suggest]"))),
        showAllSearchResults: document.querySelector(".acp_footer_css"),
        inputSearch: document.getElementById("isp_main_search_box")
      };
    i = u.parentContainer, n = u.collectionsContainer, r = u.collectionsResults, a = u.productsResults, c = u.showAllSearchResults, l = u.inputSearch, d = [].concat(_toConsumableArray(s = u.popularSearchesResults), _toConsumableArray(a), _toConsumableArray(r)), n && n.innerText !== e.general.search.related_collections && (n.innerText = e.general.search.related_collections), c && (c.childNodes[0].textContent = e.general.search.view_all_results_1 + " " + d.length + " " + e.general.search.view_all_results_2 + ' "', c.addEventListener("click", function (e) {
      e.preventDefault(), window.location.href = t.shop.url + "/pages/search-results?q=" + l.value;
    })), d.forEach(function (e) {
      e.querySelector(".as_magento_img") && (e.querySelector(".as_magento_img").alt = e.querySelector(".as_magento_product_name").innerText + " product image");
    }), s.forEach(function (e) {
      return e.addEventListener("click", function (e) {
        e.preventDefault(), window.location.href = t.shop.url + "/pages/search-results?q=" + e.target.innerText;
      });
    }), i && "none" !== i.style.display ? i.classList.add("is-open") : i.classList.remove("is-open");
  },
  updateSearchResultPageTitle = function updateSearchResultPageTitle(n) {
    setTimeout(function () {
      var e = document.querySelector(".js-result-count");
      if (window.ISP_LAST_SEARCH && e && n.locales) {
        var t = ISP_LAST_SEARCH,
          o = t.total_results,
          i = t.search_term;
        e.textContent = o ? o + " " + n.locales.general.search.total_results + ' "' + i + '"' : "";
      }
    }, 1e3);
  };
!function (e) {
  updateSearchResultPageTitle(e), e.isp = e.isp || {}, e.isp.headerSearch = ispHeaderSearch, e.isp.autoCompleteSearchResults = ispAutoCompleteSearchResults;
}(window.theme = window.theme || {});
var ispSort = function ispSort(theme) {
  var elements = {
    container: document.querySelector('.js-filter-dropdown'),
    sort: document.querySelector('.isp_sorting_and_result_view_wrapper'),
    sortLinks: _toConsumableArray2(document.querySelectorAll('.js-sorting-drop-list li input')),
    sortLabels: _toConsumableArray2(document.querySelectorAll('.js-sorting-drop-list li label')),
    sortTrigger: document.querySelector('.js-collection-sort'),
    close: document.querySelector('.js-filter-dropdown-close'),
    body: document.querySelector('#body'),
    submit: document.querySelector('.js-apply-sort'),
    filterTrigger: document.querySelector('.js-collection-filter'),
    filterContainer: document.querySelector('.js-filter-dropdown-content'),
    sortContainer: document.querySelector('.js-sort-dropdown-content')
  };

  // @wx-merge: Allyant ADA Updates 
  var toggleSort = function toggleSort(_ref) {
    var container = _ref.container,
      sortTrigger = _ref.sortTrigger,
      filterTrigger = _ref.filterTrigger,
      sortContainer = _ref.sortContainer,
      filterContainer = _ref.filterContainer;
    sortTrigger.classList.toggle('is-active');
    // Prevent scroll on body (only mobile)
    body.classList.toggle('prevent-scrolling');
    // Hide filters
    filterTrigger.classList.remove('is-active');
    // filterTrigger.setAttribute('aria-expanded', 'false');
    filterContainer.classList.remove('is-active');
    if (sortTrigger.classList.contains('is-active')) {
      // Show sort related content
      container.classList.add('is-active');
      sortContainer.classList.add('is-active');
      // sortTrigger.setAttribute('aria-expanded', 'true');
    } else {
      // Hide sort related content
      container.classList.remove('is-active');
      sortContainer.classList.remove('is-active');
      // sortTrigger.setAttribute('aria-expanded', 'false');
    }
  };
  // @end-wx-merge: Allyant ADA Updates 

  var closeFilters = function closeFilters(_ref2) {
    var container = _ref2.container,
      sortTrigger = _ref2.sortTrigger,
      body = _ref2.body;
    container.classList.remove('is-active');
    sortTrigger.classList.remove('is-active');
    sortTrigger.setAttribute('aria-expanded', 'false');
    body.classList.remove('prevent-scrolling');
  };
  var linkFeedback = function linkFeedback(target, sortLinks, elements) {
    var elTarget = target.getAttribute('id');
    elements.forEach(function (el) {
      return el.classList.remove('is-active');
    });
    sortLinks.forEach(function (el) {
      return el.setAttribute('aria-checked', 'false');
    });
    document.querySelector('[for="' + elTarget + '"]').classList.add('is-active');
    target.setAttribute('aria-checked', 'true');
  };
  var sortMobile = function sortMobile(_ref3) {
    var sortLinks = _ref3.sortLinks,
      submit = _ref3.submit;
    var documentWidth = document.body.clientWidth;
    var sortSettings = {};
    if (documentWidth < 997) {
      sortLinks.forEach(function (link) {
        return link.addEventListener('change', function (e) {
          linkFeedback(e.target, sortLinks, elements.sortLabels);
          reworkSorting(e);
        });
      });
    } else {
      sortLinks.forEach(function (link) {
        return link.addEventListener('change', function (e) {
          linkFeedback(e.target, sortLinks, elements.sortLabels);
          updateSortingchoice(e.target);
        });
      });
    }
    var updateSortingchoice = function updateSortingchoice(e) {
      var _ = e.getAttribute("sort_value");
      null == _ && (_ = ""), ISP_LAST_SEARCH.sort_by = _, ispDoFullTextSearch(get_last_search_term(), 1, ISP_LAST_SEARCH.narrow_by, _, !0, ISP_LAST_SEARCH.category, ISP_LAST_SEARCH.disable_semantics, !1, ISP_LAST_SEARCH.disable_merchandising, ISP_LAST_SEARCH.landing_page_slug), toggleDropdownSort(!1);
    };
    var reworkSorting = function reworkSorting(e) {
      e.preventDefault();
      sortSettings.event = e;
      sortSettings.element = e.target;
    };
    submit.addEventListener('click', function () {
      closeFilters(elements);
      ispHandleSortingChoice(sortSettings.event, sortSettings.element);
    });
  };
  if (theme.template.name !== 'collection') return;
  elements.sortTrigger.addEventListener('click', function () {
    return toggleSort(elements);
  });
  elements.close.addEventListener('click', function () {
    return closeFilters(elements);
  });
  sortMobile(elements);
  window.addEventListener('resize', theme.utils.throttle(function () {
    return sortMobile(elements);
  }, 100));
};
!function (e) {
  e.isp = e.isp || {}, e.isp.collectionSort = ispSort;
}(window.theme);
var ispFilter = function ispFilter(theme) {
  var elements = {
    container: document.querySelector('.js-filter-dropdown'),
    close: document.querySelector('.js-filter-dropdown-close'),
    body: document.querySelector('#body'),
    sortTrigger: document.querySelector('.js-collection-sort'),
    sortContainer: document.querySelector('.js-sort-dropdown-content'),
    filterTrigger: document.querySelector('.js-collection-filter'),
    filterContainer: document.querySelector('.js-filter-dropdown-content'),
    ispFilters: document.querySelector('#isp_left_container_facets'),
    ispFiltersFallback: document.querySelector('.isp_search_res_facets_container'),
    ispFilterOptionValues: _toConsumableArray2(document.querySelectorAll('.isp_facet_value')),
    clearBtn: document.querySelector('.js-filter-banner__clear-btn'),
    applyBtn: document.querySelector('.js-filter-banner__apply-btn'),
    hiddenOptions: _toConsumableArray2(document.querySelectorAll('.isp_facet_show_hide_values')),
    clearFilters: _toConsumableArray2(document.querySelectorAll('.js-clear-active-filters'))
  };
  var toggleFilter = function toggleFilter(_ref4) {
    var filterTrigger = _ref4.filterTrigger,
      filterContainer = _ref4.filterContainer,
      sortTrigger = _ref4.sortTrigger,
      sortContainer = _ref4.sortContainer,
      container = _ref4.container,
      body = _ref4.body;
    filterTrigger.classList.toggle('is-active');
    // Prevent scroll on body (only mobile)
    body.classList.toggle('prevent-scrolling');
    // Hide Sort
    sortTrigger.classList.remove('is-active');
    sortContainer.classList.remove('is-active');
    if (filterTrigger.classList.contains('is-active')) {
      container.classList.add('is-active');
      filterContainer.classList.add('is-active');
    } else {
      container.classList.remove('is-active');
      filterContainer.classList.remove('is-active');
    }
  };
  var ispFilterContainerDOMAdjustment = function ispFilterContainerDOMAdjustment(_ref5) {
    var ispFilters = _ref5.ispFilters,
      ispFiltersFallback = _ref5.ispFiltersFallback,
      filterContainer = _ref5.filterContainer,
      hiddenOptions = _ref5.hiddenOptions;
    var ispCurrentFilters = ispFilters == null ? ispFiltersFallback : ispFilters;
    filterContainer.appendChild(ispCurrentFilters);
    hiddenOptions.forEach(function (option) {
      return option.click();
    });
  };
  elements.filterTrigger.addEventListener('click', function () {
    toggleFilter(elements);
  });

  // Need to do this because there's an inline onclick with stop propagation.
  // Therefore, needed to add our own function which will trigger before theirs because the
  // checkbox is not selected on their side on the first clicks depending on the collection.
  // Need to add "selected" to "isp_facet_value"
  elements.ispFilterOptionValues.forEach(function (filterOption) {
    var filterOptionClick = filterOption.querySelector('a').getAttribute('onclick');
    filterOption.querySelector('a').setAttribute('onclick', "(function(){ event.target.closest('.isp_facet_value').classList.toggle('selected'); })();".concat(filterOptionClick));
  });
  elements.clearFilters.forEach(function (clearFilter) {
    return clearFilter.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.location.href = theme.shop.url + window.location.pathname;

      // Making sure that clearing the filter does not erase the sort
      var sortBy = '';
      if (window.location.href.indexOf('sort_by') > -1) {
        sortBy = "?sort_by".concat(window.location.href.split('sort_by')[1]);
        var sortByTypeOriginal = window.location.href.split('&sort_by=')[1];
        var _sortByType = sortByTypeOriginal.split('&')[0];
        localStorage.setItem('isp_collection_sort_type', _sortByType);
        window.location.replace(theme.shop.url + window.location.pathname + sortBy);
      } else {
        if (sortBy != '') localStorage.removeItem(sortByType);
        window.location.replace(theme.shop.url + window.location.pathname + sortBy);
      }
    });
  });
  if (localStorage.getItem('isp_collection_sort_type') && window.location.href.indexOf('sort_by') > -1) document.querySelector(".js-sort-option[sort_value=".concat(localStorage.getItem('isp_collection_sort_type'), "]")).classList.add('is-active');
  elements.close.addEventListener('click', function () {
    return closeFilters(elements);
  });
  elements.applyBtn.addEventListener('click', function () {
    return closeFilters(elements);
  });
  ispFilterContainerDOMAdjustment(elements);
  setTimeout(showSelectedFilters, 1000);
};
var ispFilterADARework = function ispFilterADARework() {
  var facetTitles = _toConsumableArray2(document.querySelectorAll('.isp_facet_title'));
  var facetCheckboxes = _toConsumableArray2(document.querySelectorAll('.isp_facet_check_box_icon'));
  facetTitles.forEach(function (title) {
    return title.setAttribute('role', 'button');
  });
  facetCheckboxes.forEach(function (checkbox) {
    return checkbox.setAttribute('role', 'checkbox');
  });
};
var closeFilters = function closeFilters(_ref6) {
  var container = _ref6.container,
    sortTrigger = _ref6.sortTrigger,
    body = _ref6.body,
    filterTrigger = _ref6.filterTrigger;
  filterTrigger.classList.remove('is-active');
  container.classList.remove('is-active');
  sortTrigger.classList.remove('is-active');
  body.classList.remove('prevent-scrolling');
  showSelectedFilters();
};
var showSelectedFilters = function showSelectedFilters() {
  // const optionContainers = [...document.querySelectorAll('.isp_facet_value.selected')];
  var optionContainers = document.querySelector('.isp_search_res_facets_container').querySelectorAll('.isp_facet_value.selected');
  var activeFilters = document.querySelector('.js-current-active-filters');
  var filterTrigger = document.querySelector('.js-collection-filter');
  if (optionContainers.length) {
    filterTrigger.classList.add('has-active-filters');
    activeFilters.innerText = "(".concat(optionContainers.length, ")");
  } else {
    filterTrigger.classList.remove('has-active-filters');
    activeFilters.innerText = '';
  }
};
(function (theme) {
  theme.isp = theme.isp || {};
  theme.isp.collectionFilter = ispFilter;
  theme.isp.adaRework = ispFilterADARework;
})(window.theme);
var buttonType = function buttonType(e, t, o) {
  997 < document.body.clientWidth || 997 < document.documentElement.clientWidth ? e.forEach(function (e) {
    e.innerText = "" + o;
  }) : (document.body.clientWidth < 640 || document.documentElement.clientWidth < 640) && !$("#isp_search_results_container").hasClass("is-double-view") && "isp-search" != window.theme.template.suffix ? e.forEach(function (e) {
    return e.innerText = "" + t;
  }) : e.forEach(function (e) {
    return e.innerText = "" + t;
  });
},
  productsManipulation = function productsManipulation(e, u) {
    return e.forEach(function (e, t) {
      var o = e.getAttribute("product_id"),
        i = ISP_PRODUCTS[o];
      if ("object" === (void 0 === i ? "undefined" : _typeof(i))) {
        if (updateBadges(e, u, i), updatePrice(e, i), window.isp.quickAdd(e, u, i, t), e.classList.add("is-active"), theme.settings.gift_bundle_enabled && !theme.settings.gift.purchasable) {
          var n = null != e.querySelector(".isp_product_image_wrapper .isp_quick_view_add_to_cart_form .js-atc-quick-add") ? e.querySelector(".isp_product_image_wrapper .isp_quick_view_add_to_cart_form .js-atc-quick-add") : e.querySelector(".isp_product_image_wrapper .isp_quick_view_add_to_cart_form .js-iso-product"),
            r = null != e.querySelector(".isp_product_price_wrapper .isp_quick_view_add_to_cart_form .js-atc-quick-add") ? e.querySelector(".isp_product_price_wrapper .isp_quick_view_add_to_cart_form .js-atc-quick-add") : e.querySelector(".isp_product_price_wrapper .isp_quick_view_add_to_cart_form .js-iso-product"),
            a = i.u.split("/"),
            s = a[a.length - 1],
            c = e.querySelector(".isp_product_price_wrapper .isp_product_price");
          null == n || s != theme.settings.gift.gift1 && s != theme.settings.gift.gift2 || (n.classList.add("button--secondary", "button--gift"), n.classList.remove("button--primary"), n.value = u.gift_product.atc, r.classList.add("hide"), c.classList.add("hide--gift-price"), null == r.closest("form").querySelector("button--gift-grid") && r.closest("form").insertAdjacentHTML("afterbegin", '<input type="button" class="button button--primary button--gift-grid" value="' + theme.locales.gift_product.atc_mobile + '">'), r.value = u.gift_product.atc, n.disabled = !0, r.disabled = !0);
        }
        if (!e.querySelector(".js-variant-atc")) {
          var l = e.querySelector(".isp_product_quick_view_button"),
            d = e.querySelectorAll(".isp_product_quick_view_button a");
          i.att && i.att[1][1].includes("no-quick-view") && l ? l.remove() : i.att && i.att[1][1].includes("swym-comingsoon") ? (l.setAttribute("data-atc-text", theme.locales.product.coming_soon), l.setAttribute("data-modal-target", "coming-soon"), buttonType(d, u.collection.coming_soon_short, u.collection.coming_soon, i)) : i.iso ? (l.setAttribute("data-atc-text", theme.locales.product.out_of_stock), l.setAttribute("data-modal-target", "out-of-stock"), buttonType(d, u.collection.out_of_stock_short, u.collection.out_of_stock, i)) : l && (l.setAttribute("data-atc-text", theme.locales.collection.quick_add), l.setAttribute("data-modal-target", "add"), buttonType(d, u.collection.add_to_cart, u.collection.quick_add, i));
          var product_tags = i.att[1][1];
          product_tags.forEach(function (e) {
            if (e === 'app-exclusive') {
              d.forEach(function (btn) {
                btn.innerText = theme.locales.collection.download_app;
              });
              l.dataset.atcText = theme.locales.collection.download_app;
            }
            var tag = e.split("_");
            if (tag[1] == 'Pre-Order') {
              d.innerText = theme.locales.collection.preorder;
              l.dataset.atcText = theme.locales.collection.preorder;
            }
          });
        }
      }
    }), !!e.every(function (e) {
      return e.classList.contains("is-active");
    });
  },
  monetateAddProducts = function monetateAddProducts(e, o) {
    window.monetateQ = window.monetateQ || [];
    var i = [];
    e.forEach(function (e) {
      var t = "filter-sort" == o ? e.getAttribute("product_id") : e;
      i.push({
        productId: t
      });
    }), window.monetateQ.push(["addProducts", i]), window.monetateQ.push(["setPageType", theme.template.page_type]), window.monetateQ.push(["trackData"]);
  },
  fixProductsOnLoadMore = function fixProductsOnLoadMore(n) {
    var r = Object.keys(ISP_PRODUCTS).length;
    window.addEventListener("scroll", function () {
      theme.utils.throttle(function () {
        var e = [].concat(_toConsumableArray(document.querySelectorAll(".isp_grid_product"))),
          t = [].concat(_toConsumableArray(document.querySelectorAll(".isp_grid_product.is-active"))),
          o = e.filter(function (e) {
            return !e.classList.contains("is-active");
          }),
          i = "filter-sort" == theme.template.product_tile_type ? t : Object.keys(ISP_PRODUCTS);
        productsManipulation(o, n), r != i.length && (r = i.length, monetateAddProducts(i, theme.template.product_tile_type));
      }(), 50);
    });
  },
  updateProductLayout = function t(o) {
    setTimeout(function () {
      theme.isp.adaRework();
      var e = [].concat(_toConsumableArray(document.querySelectorAll(".isp_grid_product")));
      e.length ? productsManipulation(e, o) : t();
    }, 1e3);
  },
  cartItemQtyQuickAdd = function cartItemQtyQuickAdd(e) {
    var t = [].concat(_toConsumableArray(document.querySelectorAll(".js-selected-option"))),
      o = document.querySelector(".isp_quick_view_variant_select option[selected=true]"),
      i = t.find(function (e) {
        return +e.dataset.variantId == +o.getAttribute("variant_id");
      });
    if (!i || !e || !o) return !1;
    var n = i.closest(".js-cart-item").querySelector(".js-cart-item-quantity");
    return n.innerText = +n.innerText + 1, !(e = !1);
  },
  getAddedToCartProduct = function getAddedToCartProduct(e) {
    e.addedFromQuickAdd = !0;
    var t = document.querySelector(".isp_quick_view_title").innerText,
      o = document.querySelector(".isp_quick_view_title").getAttribute("product_id"),
      i = document.querySelector(".isp_grid_product[product_id='" + document.querySelector(".isp_quick_view_title").getAttribute("product_id") + "'] .isp_product_price_wrapper .isp_product_price").dataset.currencyUsd;
    return "https://eu.aninebing.com" == e.shop.url && (i = document.querySelector(".isp_grid_product[product_id='" + document.querySelector(".isp_quick_view_title").getAttribute("product_id") + "'] .isp_product_price_wrapper .isp_product_price").dataset.currencyEur), {
      url: document.querySelector(".isp_quick_view_show_more").href,
      image: document.querySelector(".isp_quick_view_image").src,
      title: t,
      price: i + "00",
      key: null,
      variant_id: document.querySelector(".isp_quick_view_variant .option.is-selected").dataset.variantId,
      variant_title: document.querySelector(".isp_quick_view_variant .option.is-selected").innerText,
      quantity: 1,
      handle: document.querySelector(".isp_quick_view_show_more").href.split("/")[4],
      id: o
    };
  },
  addToCartActions = function addToCartActions(e, o_p) {
    var t = getAddedToCartProduct(e);
    document.querySelector("body").setAttribute("style", ""), cartItemQtyQuickAdd(!0) ? e.cart.update({
      id: t.variant_id,
      quantity: t.quantity + 1
    }) : e.cart.add(t.variant_id, o_p), e.deleteGiftSessionStorage(), e.cart._object.items = [t].concat(_toConsumableArray(e.cart._object.items)), e.cart._object.item_count = e.cart._object.item_count + 1, 0 === e.cart._object.items_subtotal_price ? e.cart._object.items_subtotal_price = +t.price : e.cart._object.items_subtotal_price += +t.price, $(document).trigger("Cart:set", e.cart._object);
  };
if (!function (n) {
  var r = n.locales;
  n.isp = n.isp || {}, n.isp.addToCartActions = addToCartActions, "collection" !== n.template.name && n.isp.headerSearch(n);
  __isp_options.isp_serp_quickview_callback = function () {
    ispQuickAddModal(r, n);
    postISPada();
  };
  __isp_options.isp_dropdown_open_callback = function () {
    !0 && (n.isp.autoCompleteSearchResults(n, r), !1, setTimeout(function () {
      var e = [].concat(_toConsumableArray(document.querySelectorAll(".isp_grid_product")));
      productsManipulation(e, r);
      postISPada();
      //reorderResults();
    }, 1e3));
  };
  n.isp.hasLoaded = !0, n.isp.productsManipulation = productsManipulation, __isp_options.isp_serp_callback = function (e, t) {
    if (-1 < window.location.pathname.indexOf("search-results") || -1 < window.location.pathname.indexOf("collections")) {
      !function t() {
        setTimeout(function () {
          var e = [].concat(_toConsumableArray(document.querySelectorAll(".isp_grid_product")));
          productsManipulation(e, r) || t();
        }, 1e3);
      }();
    }
    var o = [].concat(_toConsumableArray(document.querySelectorAll(".isp_grid_product"))),
      i = [document.querySelector(".js-apply-sort")].concat(_toConsumableArray(document.querySelectorAll(".js-sorting-drop-list li a")));
    "collection" == n.template.name && -1 < window.location.href.indexOf("?q=") && monetateAddProducts(o, "filter-sort"), productsManipulation(o, r), i.length && i.every(function (e) {
      return null !== e;
    }) && i.forEach(function (e) {
      return e.addEventListener("click", function () {
        setTimeout(function () {
          var e = [].concat(_toConsumableArray(document.querySelectorAll(".isp_grid_product"))),
            t = [].concat(_toConsumableArray(document.querySelectorAll(".isp_grid_product.is-active")));
          productsManipulation(e, r), n.template.product_tile_type = "filter-sort", monetateAddProducts(t, n.template.product_tile_type);
        }, 1e3);
      });
    }), setTimeout(function () {
      return n.isp.adaRework();
    }, 1e3), __isp_options.isp_serp_pre_filter_callback = function (e) {
      setTimeout(function () {
        var e = [].concat(_toConsumableArray(document.querySelectorAll(".isp_grid_product.is-active")));
        n.template.product_tile_type = "filter-sort", monetateAddProducts(e, n.template.product_tile_type);
      }, 1e3), updateProductLayout(r);
    }, n.isp.hasLoaded && (document.getElementById("isp_search_results_container").classList.add("is-double-view"), n.isp.hasLoaded = !1, paginationRedesign(e, r), n.isp.headerSearch(n), "collection" === n.template.name && (n.isp.collectionSort(n), n.isp.collectionFilter(n)), fixProductsOnLoadMore(r), updateProductLayout(r), $jquery_isp(".isp_sold_out_banner_container").remove(), monetateAddProducts(Object.keys(ISP_PRODUCTS), n.template.product_tile_type));
    postISPada();
  };
}(window.theme, jQuery), function (theme) {
  // NOTE: For automatic gift coded is included in ajax-cart.js, product-form.js, isp.js, and isp-quick-add.js
  // Setting gift-removed="true" if the gift product has been voluntarily removed by user
  // Adding product to cart or updating the cart should set the gift-removed=""
  // Should only add gift automatically if above threshold and does not have gift-removed="true"

  var MINIMUM_PRICE = +theme.settings.gift.minimum_amount; // Price in cents
  var previousCartSubtotal = theme.cart.content.items_subtotal_price;
  var GWP_LIMITER = theme.cart.content.gwp_limiter;
  // console.log('GWP_LIMITER', GWP_LIMITER);
  var cartLoadAdd = function cartLoadAdd() {
    var genericCart;
    if (theme.template.name == 'cart') {
      genericCart = document.querySelector('.js-cart');
    } else {
      genericCart = document.querySelector('#cart-flyout.js-cart');
    }
    genericCart.classList.add('is-loading');
  };
  var cartLoadRemove = function cartLoadRemove() {
    var genericCart;
    if (theme.template.name == 'cart') {
      genericCart = document.querySelector('.js-cart');
    } else {
      genericCart = document.querySelector('#cart-flyout.js-cart');
    }
    if (genericCart.classList.contains('is-loading')) genericCart.classList.remove('is-loading');
  };
  var isGiftAvailable = function isGiftAvailable(gift, giftDescriptionDOM, giftDescription, buttonTextDOM, buttonText, giftDOM, bothGiftItemsPresent) {
    // console.log('isGiftAvailable');
    if (document.querySelector('.js-cart-gift-button')) document.querySelector('.js-cart-gift-button').disabled = true;
    $.getJSON('/products/' + gift + '.js', function (product) {
      var giftAvailable = product.variants[0].available;
      if (giftAvailable) {
        if (giftDescriptionDOM) giftDescriptionDOM.innerText = giftDescription;
        if (buttonTextDOM) buttonTextDOM.innerText = buttonText;
        if (giftDOM) giftDOM.classList.remove('hide');
        cartLoadRemove();
        if (document.querySelector('.js-cart-gift-button')) document.querySelector('.js-cart-gift-button').disabled = false;
      } else {
        if (!giftDOM.classList.contains('hide')) giftDOM.classList.add('hide');
        if (theme.settings.gift.gift2 && bothGiftItemsPresent) {
          $.getJSON('/products/' + theme.settings.gift.gift2 + '.js', function (product) {
            var gift2Available = product.variants[0].available;
            if (gift2Available) {
              if (giftDescriptionDOM) giftDescriptionDOM.innerText = giftDescription;
              if (buttonTextDOM) buttonTextDOM.innerText = buttonText;
              if (giftDOM) giftDOM.classList.remove('hide');
              cartLoadRemove();
              if (document.querySelector('.js-cart-gift-button')) document.querySelector('.js-cart-gift-button').disabled = false;
            } else {
              if (!giftDOM.classList.contains('hide')) giftDOM.classList.add('hide');
            }
          });
        }
      }
    });
  };

  // Delete Gift Cookie when updating or adding to cart to prevent gift to get readded on page load
  // Only for theme.settings.gift.add_type == 'automatic'
  var deleteGiftSessionStorage = function deleteGiftSessionStorage() {
    if (theme.settings.gift_bundle_enabled) {
      if (document.querySelector('.js-cart-gift-button')) document.querySelector('.js-cart-gift-button').disabled = true;
    }
    if (theme.settings.gift_bundle_enabled && sessionStorage.getItem('gift-removed') && theme.settings.gift.add_type == 'automatic') {
      // Remove gift-removed session storage
      sessionStorage.removeItem('gift-removed');
    }
  };
  var removeAllGiftItems = function removeAllGiftItems() {
    // Removing item from cart.
    //const flyoutItems = [...document.querySelectorAll('#Cart .js-selected-option')];
    var cart = theme.cart.content;
    if (theme.settings.gift.add_type == 'automatic') sessionStorage.removeItem('gift-removed');
    cart.items.forEach(function (item) {
      if (item.properties && '_gift' in item.properties) {
        var cartItem = document.querySelector('#Cart .cart__item.js-cart-item[data-key="' + item.key + '"]');
        var animationTiming = 300;
        if (!cartItem) {
          document.querySelector('.cart-flyout .cart__item.js-cart-item[data-key="' + item.key + '"]');
        }
        if (cartItem) {
          cartItem.classList.add('is-removed');
          setTimeout(function () {
            return cartItem.remove();
          }, animationTiming);
        }

        // flyoutItems.forEach(flyoutItem => {
        //   const flyoutProperties = JSON.parse(flyoutItem.dataset.itemProperties);
        //   let valid = false;

        //   if (!flyoutProperties) {
        //     valid = false;
        //   }

        //   else if (Array.isArray(flyoutProperties)) {
        //     flyoutProperties.forEach(hash => {
        //       if (hash[0] === '_gift') {
        //         valid = true;
        //       }
        //     });
        //   }

        //   else if (flyoutProperties._gift) {
        //     valid = true;
        //   }

        //   if (valid) {
        //     const flyoutItemContainer = flyoutItem.closest('.js-cart-item');
        //     const animationTiming = 300;
        //     flyoutItemContainer.classList.add('is-removed');
        //     setTimeout(() => flyoutItemContainer.remove(), animationTiming);
        //   }
        // });

        theme.cart.remove(item.key);
      }
    });
  };
  var cartContainsGift = function cartContainsGift() {
    var containsGift = false;
    var cart = theme.cart._object;
    cart.items.forEach(function (item) {
      if (item.properties && '_gift' in item.properties) {
        containsGift = true;
      }
    });
    return containsGift;
  };
  var onlycartContainsGift = function onlycartContainsGift() {
    var containsGift = false;
    var cart = theme.cart._object;
    var count = 0;
    cart.items.forEach(function (item) {
      if (item.properties && '_gift' in item.properties) {
        count++;
      }
    });
    if (count == cart.item_count) {
      containsGift = true;
    }
    return containsGift;
  };
  var onlycartContainsGiftCard = function onlycartContainsGiftCard() {
    var containsGiftGard = false;
    var cart = theme.cart._object;
    var count = 0;
    cart.items.forEach(function (item) {
      // console.log('item', item);
      // console.log('item.title.toLowerCase', item.title.toLowerCase());
      if (item.title.toLowerCase().includes('gift card')) {
        count += item.quantity;
      }
    });
    if (count == cart.item_count) {
      containsGiftGard = true;
    }
    return containsGiftGard;
  };
  var onlycartContainsPreorder = function onlycartContainsPreorder() {
    var containsPreorder = false;
    var cart = theme.cart._object;
    var count = 0;
    cart.items.forEach(function (item) {
      if (item.properties) {
        if ('_preorderDate' in item.properties || '_gift' in item.properties) {
          count++;
        }
      }
    });
    if (count == cart.item_count) {
      containsPreorder = true;
    }
    return containsPreorder;
  };
  var onlycartContainsPreorderOrGiftCard = function onlycartContainsPreorderOrGiftCard() {
    var containsPreorderOrGiftCard = false;
    var cart = theme.cart._object;
    var count = 0;
    cart.items.forEach(function (item) {
      // console.log('item', item);
      // console.log('item.title.toLowerCase', item.title.toLowerCase());
      if (item.title.toLowerCase().includes('gift card') || item.properties && ('_preorderDate' in item.properties || '_gift' in item.properties)) {
        count += item.quantity;
      }
    });
    if (count == cart.item_count) {
      containsPreorderOrGiftCard = true;
    }
    return containsPreorderOrGiftCard;
  };
  var initModal = function initModal() {
    var giftAddButtons = _toConsumableArray2(document.querySelectorAll('.js-gift-add-button'));
    giftAddButtons.forEach(function (button) {
      return button.addEventListener('click', theme.utils.throttled(function (e) {
        e.preventDefault();

        // Remove any previous gift item from cart
        removeAllGiftItems();

        // Add gift item to cart
        var item = {
          id: e.target.dataset.variantId,
          quantity: 1,
          properties: {
            '_gift': 'true',
            '_giftThreshold': MINIMUM_PRICE
          }
        };
        setTimeout(function () {
          theme.cart.add(item, {}, item.properties)

            // Close the modal
            .then(function () {
              document.querySelector('.js-gift-close-modal').click();
              setTimeout(function () {
                return button.removeAttribute('disabled');
              }, 1000); // This makes sure the modal is gone before the button is activated again.
            });
        }, 300);
        if (theme.template.name !== 'cart') {
          return theme.openFlyout();
        }
      }, 1000));
    });
  };
  var initEmbed = function initEmbed() {
    var giftAddButtons = _toConsumableArray2(document.querySelectorAll('.js-gift-add-button'));
    giftAddButtons.forEach(function (button) {
      return button.addEventListener('click', theme.utils.throttled(function (e) {
        e.preventDefault();

        // Remove any previous gift item from cart
        removeAllGiftItems();

        // Add gift item to cart
        var item = {
          id: e.target.dataset.variantId,
          quantity: 1,
          properties: {
            _gift: 'true',
            '_giftThreshold': MINIMUM_PRICE
          }
        };
        setTimeout(function () {
          theme.cart.add(item, {}, item.properties)

            // Close the modal
            .then(function () {
              document.querySelector('.js-gift-close-modal').click();
              setTimeout(function () {
                return button.removeAttribute('disabled');
              }, 1000); // This makes sure the modal is gone before the button is activated again.
            });
        }, 300);
        if (theme.template.name !== 'cart') {
          return theme.openFlyout();
        }
      }, 1000));
    });
  };

  // Note: If it's automatic, only the first gift will be taken into account
  var initAutomaticAdd = function initAutomaticAdd() {
    var cart = theme.cart._object;
    // console.log('cart = ', cart);
    // Get the proper id of the product.
    $.getJSON('/products/' + theme.settings.gift.gift1 + '.js', function (product) {
      var giftVariant = product.variants[0].id;
      var giftAvailable = product.variants[0].available;
      if (giftAvailable) {
        document.querySelector('.js-cart-gift').classList.remove('hide');
        // Add gift item to cart
        var item = {
          id: giftVariant,
          quantity: 1,
          properties: {
            '_gift': 'true',
            '_giftThreshold': MINIMUM_PRICE
          }
        };
        setTimeout(function () {
          theme.cart.add(item, {}, item.properties).then(function () {
            document.querySelector('.gift-popup').classList.add('show');
            document.querySelector('.gift-popup-overlay').classList.add('show');
            //  setTimeout(function() {
            //   document.querySelector('.gift-popup').classList.remove('show');
            // document.querySelector('.gift-popup-overlay').classList.remove('show');
            //  }, 4000);
          });
        }, 300);
        sessionStorage.setItem("gift-removed", "true");
        if (theme.template.name !== 'cart') {
          return theme.openFlyout();
        }
      } else {
        // If gift product is not available 
        if (!document.querySelector('.js-cart-gift').classList.contains('hide')) document.querySelector('.js-cart-gift').classList.add('hide');
      }
    });
  };
  const cartContainsSpecificGift = () => {
    let containsSpecificGift = false;
    const cart = theme.cart._object;
    cart.items.forEach(item => {
      if (item.properties && '_specificgift' in item.properties) {
        containsSpecificGift = true;
      }
    })
    return containsSpecificGift;
  };

  const cartContainsSpecificProduct = () => {
    let giftWithSpecificProduct = false;
    let specificProducts = theme.settings.specific_gift.gift_for;
    const cart = theme.cart._object;
    if (specificProducts) {
      cart.items.forEach(item => {
        let item_handle = item.handle;
        specificProducts.forEach(sp_product => {
          if (item_handle == sp_product) {
            giftWithSpecificProduct = true;
          }
        });
      })
      return giftWithSpecificProduct;
    }
  };

  const onlycartContainsSpecificGift = () => {
    let containsSpecificGift = false;
    const cart = theme.cart._object;
    let count = 0;
    cart.items.forEach(item => {
      if (item.properties && '_specificgift' in item.properties) {
        count += item.quantity;
      }
    })
    if (count == cart.item_count) {
      containsSpecificGift = true;
      sessionStorage.removeItem("specific-gift")
    }
    return containsSpecificGift;
  };

  const initAutomaticAddSpecificGift = () => {
    const cart = theme.cart._object;
    $.getJSON('/products/' + theme.settings.specific_gift.gift + '.js', function (product) {
      const giftVariant = product.variants[0].id;
      const giftAvailable = product.variants[0].available;
      if (giftAvailable) {
        // Add gift item to cart
        const item = {
          id: giftVariant,
          quantity: 1,
          properties: { '_specificgift': 'true' }
        }

        setTimeout(() => {
          theme.cart.add(item, {}, item.properties)
            .then(() => {

            });
        }, 300);
        sessionStorage.setItem("specific-gift", "true");
        if (theme.template.name !== 'cart') {
          // return theme.openFlyout();
        }
      }
    });
  };
  const removeAllSpecificGiftItems = () => {
    const cart = theme.cart.content;

    cart.items.forEach(item => {
      if (item.properties && '_specificgift' in item.properties) {

        let cartItem = document.querySelector('#Cart .cart__item.js-cart-item[data-key="' + item.key + '"]');
        const animationTiming = 300;
        if (!cartItem) { document.querySelector('.cart-flyout .cart__item.js-cart-item[data-key="' + item.key + '"]') }
        if (cartItem) {
          cartItem.classList.add('is-removed');
          setTimeout(() => cartItem.remove(), animationTiming);
        }

        theme.cart.remove(item.key);
        sessionStorage.removeItem("specific-gift")
      }
    })
  };
  var initFlyout = function initFlyout() {
    updateGiftFlyout();
  };
  const initSpecificFlyout = () => {
    updateSpecificGiftFlyout();
  };
  var btnClickHanlder = function btnClickHanlder() {
    var cart = theme.cart.content;
    var genericCart;
    var items_subtotal_amount = 0;
    cart.items.forEach(function (item) {
      // console.log('item', item);
      if (item.title.toLowerCase().includes('gift card') || item.properties && ('_preorderDate' in item.properties || '_gift' in item.properties)) { } else {
        items_subtotal_amount = items_subtotal_amount + item.final_line_price;
      }
    });
    if (theme.template.name == 'cart') {
      genericCart = document.querySelector('.js-cart');
      genericCart.classList.add('is-loading');
    } else {
      genericCart = document.querySelector('#cart-flyout.js-cart');
      genericCart.classList.add('is-loading');
    }

    // If is below MINIMUM_PRICE
    if (items_subtotal_amount < MINIMUM_PRICE) {
      window.location.href = theme.shop.url + theme.locales.gift_product.collection_to_redirect_under_400;
    } else {
      if (theme.settings.gift.add_type == 'modal') {
        if (genericCart.classList.contains('is-loading')) genericCart.classList.remove('is-loading');
        document.querySelector('.js-gift-open-modal').click();
      } else {
        deleteGiftSessionStorage();
        if (!cartContainsGift()) initAutomaticAdd();
      }
    }
  };
  var cartQualifiesForGift = function cartQualifiesForGift() {
    return $.ajax({
      url: "/cart.js",
      type: "GET",
      dataType: "json"
    }).done(function (cart) { });
  };
  const updateSpecificGiftFlyout = (fromQuickAddModal = theme.addedFromQuickAdd) => {
    if (theme.settings.gift.gift_start_date > theme.settings.gift.now_date || theme.settings.gift.gift_end_date < theme.settings.gift.now_date) {
      removeAllSpecificGiftItems()
    }
    else {
      const cart = theme.cart.content;
      let specificGiftInCart = false;
      let storageSpeicficGift = sessionStorage.getItem("specific-gift");

      if (storageSpeicficGift) {
        specificGiftInCart = true;
      }


      if (cartContainsSpecificProduct() && !cartContainsSpecificGift() && !specificGiftInCart) {
        initAutomaticAddSpecificGift()
      }
      else if (!cartContainsSpecificProduct() && cartContainsSpecificGift()) {
        removeAllSpecificGiftItems()
      }
      else if (onlycartContainsSpecificGift()) {
        removeAllSpecificGiftItems()
      }


    }
  }
  var updateGiftFlyout = function updateGiftFlyout() {
    var fromQuickAddModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme.addedFromQuickAdd;
    // console.log('updateGiftFlyout fired');
    // console.log('document.querySelector(.quickAdd-checkout-view__button)', document.querySelector('.quickAdd-checkout-view__button'));
    // console.log('theme.settings', theme.settings);
    var cart = theme.cart.content;
    var alreadyContainsGift = cartContainsGift();
    var pathname = window.location.pathname;
    var giftAdd = document.querySelectorAll('.js-cart-gift');
    var items_subtotal_amount = 0;
    var cartFlyout = {
      gift: document.querySelector('.js-cart-gift'),
      button: document.querySelector('.js-cart-gift-button'),
      giftDescription: document.querySelector('.js-cart-gift-description'),
      giftWorkaround: document.querySelector('.gift-workaround'),
      allGiftItemsAreAvailable: _toConsumableArray2(document.querySelectorAll('.js-gift-add-button')).every(function (btn) {
        return btn.disabled === false;
      }),
      bothGiftItemsPresent: false
    };
    if (cartFlyout.giftWorkaround) {
      cartFlyout.giftWorkaround.classList.add('hide');
    }
    cart.items.forEach(function (item) {
      // console.log('item', item);
      if (item.title.toLowerCase().includes('gift card') || item.properties && ('_preorderDate' in item.properties || '_gift' in item.properties)) { } else {
        items_subtotal_amount = items_subtotal_amount + item.final_line_price;
      }
    });
    cartFlyout.bothGiftItemsPresent = theme.settings.gift.gift1 && theme.settings.gift.gift2 ? true : false;
    if (onlycartContainsGift() || onlycartContainsPreorderOrGiftCard() || theme.settings.gift.gift_limiter && (theme.customer == null || !theme.customer.tags.some(function (tag) {
      return theme.settings.gift.gift_limiter_group.includes(tag);
    }))) {
      // console.log('fired the onlycartContainsPreorderOrGiftCard');
      if (cartFlyout.button) {
        // console.log('there is a flyout button');
        cartFlyout.button.innerText = theme.locales.gift_product.shop_now;
        if (cartFlyout.giftWorkaround) {
          // console.log('there is a giftworkaround button');
          cartFlyout.giftWorkaround.classList.remove('hide');
        }
      }
      removeAllGiftItems();
      if (document.querySelector('.cart__checkout')) document.querySelector('.cart__checkout').classList.remove('hide');
      if (document.querySelector('.quickAdd-checkout-view__button')) document.querySelector('.quickAdd-checkout-view__button').classList.remove('hide');
      return false;
    }
    if (window.theme.giftPreorderPrevent || alreadyContainsGift || onlycartContainsPreorderOrGiftCard()) {
      // console.log('cartFlyout', cartFlyout);
      cartFlyout.gift.classList.add('hide');
      if (document.querySelector('.cart__checkout')) document.querySelector('.cart__checkout').classList.remove('hide');
      if (document.querySelector('.quickAdd-checkout-view__button')) document.querySelector('.quickAdd-checkout-view__button').classList.remove('hide');
      if (alreadyContainsGift) {
        cartFlyout.gift.classList.add('hide');
        giftAdd.forEach(function (container) {
          return container.classList.add('hide');
        });
        if (theme.settings.gift.add_type != 'embed' && items_subtotal_amount < MINIMUM_PRICE) {
          removeAllGiftItems();
        }
      }
      return false;
    }
    if (theme.settings.gift.add_type == 'modal') {
      // if (items_subtotal_amount >= MINIMUM_PRICE && previousCartSubtotal < MINIMUM_PRICE && theme.template.name !== 'collection' && pathname.indexOf('search-results') === -1) {
      if (theme.settings.gift.gift_start_date > theme.settings.gift.now_date || theme.settings.gift.gift_end_date < theme.settings.gift.now_date) {
        removeAllGiftItems();
        cartFlyout.gift.classList.add('hide');
      } else {
        if (items_subtotal_amount >= MINIMUM_PRICE && theme.template.name !== 'collection' && pathname.indexOf('search-results') === -1) {
          document.querySelector('.js-gift-open-modal').click();
          document.querySelector('.modal-overlay').style['z-index'] = 10000001;
          // } else if (fromQuickAddModal && items_subtotal_amount >= MINIMUM_PRICE && previousCartSubtotal < MINIMUM_PRICE) {
        } else if (fromQuickAddModal && items_subtotal_amount >= MINIMUM_PRICE) {
          document.querySelector('.js-gift-open-modal').click();
          document.querySelector('.modal-overlay').style['z-index'] = 10000001;
        }
      }
    }
    if (theme.settings.gift.add_type == 'modal') {
      // MODAL
      // If is above MINIMUM_PRICE and has gift in cart
      // console.log('is modal');
      if (items_subtotal_amount >= MINIMUM_PRICE && alreadyContainsGift) {
        // console.log('items_subtotal_amount >= MINIMUM_PRICE && alreadyContainsGift');
        cartFlyout.giftDescription.innerText = theme.locales.gift_product.eligible;
        cartFlyout.gift.classList.add('hide');
        if (cartFlyout.allGiftItemsAreAvailable && cartFlyout.bothGiftItemsPresent) {
          // If all gifts are available too
          cartFlyout.button.innerText = theme.locales.gift_product.change_gift;
          cartFlyout.gift.classList.remove('hide');
        }
        if (theme.settings.gift.gift_start_date > theme.settings.gift.now_date || theme.settings.gift.gift_end_date < theme.settings.gift.now_date) {
          removeAllGiftItems();
          cartFlyout.gift.classList.add('hide');
        }
        // If is above MINIMUM_PRICE and doesn't have gift in cart
      } else if (items_subtotal_amount >= MINIMUM_PRICE && !alreadyContainsGift) {
        // console.log('items_subtotal_amount >= MINIMUM_PRICE && !alreadyContainsGift');
        // If is above MINIMMUM_PRICE and doesnt have gift in cart
        var gift = theme.settings.gift.gift1 != '' ? theme.settings.gift.gift1 : theme.settings.gift.gift2;
        var giftDescriptionDOM = cartFlyout.giftDescription;
        var giftDescription = theme.locales.gift_product.eligible;
        var buttonTextDOM = cartFlyout.button;
        var buttonText = theme.locales.gift_product.add_gift;
        var giftDOM = cartFlyout.gift;
        cartFlyout.gift.classList.remove('hide');
        if (theme.settings.gift.gift_start_date > theme.settings.gift.now_date || theme.settings.gift.gift_end_date < theme.settings.gift.now_date) {
          removeAllGiftItems();
          cartFlyout.gift.classList.add('hide');
        } else {
          isGiftAvailable(gift, giftDescriptionDOM, giftDescription, buttonTextDOM, buttonText, giftDOM, cartFlyout.bothGiftItemsPresent);
        }

        // If is below MINIMUM_PRICE
      } else if (items_subtotal_amount < MINIMUM_PRICE) {
        // console.log('items_subtotal_amount < MINIMUM_PRICE');
        removeAllGiftItems();
        var _gift = theme.settings.gift.gift1 != '' ? theme.settings.gift.gift1 : theme.settings.gift.gift2;
        var _giftDescriptionDOM = cartFlyout.giftDescription;
        var _giftDescription = theme.locales.gift_product.add_more_products;
        var _buttonTextDOM = cartFlyout.button;
        var _buttonText = theme.locales.gift_product.shop_now;
        var _giftDOM = cartFlyout.gift;
        if (theme.settings.gift.gift_start_date > theme.settings.gift.now_date || theme.settings.gift.gift_end_date < theme.settings.gift.now_date) {
          // console.log('we are hiding');
          cartFlyout.gift.classList.add('hide');
        } else {
          // console.log('passed along info to isGiftAvailable');
          isGiftAvailable(_gift, _giftDescriptionDOM, _giftDescription, _buttonTextDOM, _buttonText, _giftDOM, cartFlyout.bothGiftItemsPresent);
        }
      }
    } else if (theme.settings.gift.add_type == 'embed') {
      // MODAL
      // If is above MINIMUM_PRICE and has gift in cart
      if (items_subtotal_amount >= MINIMUM_PRICE && alreadyContainsGift) {
        cartFlyout.giftDescription.innerText = theme.locales.gift_product.eligible;
        cartFlyout.gift.classList.add('hide');
        if (cartFlyout.allGiftItemsAreAvailable && cartFlyout.bothGiftItemsPresent) {
          // If all gifts are available too
          cartFlyout.gift.classList.remove('hide');
        }
        // If is above MINIMUM_PRICE and doesn't have gift in cart
      } else if (items_subtotal_amount >= MINIMUM_PRICE && !alreadyContainsGift) {
        // If is above MINIMMUM_PRICE and doesnt have gift in cart
        cartFlyout.gift.classList.remove('hide');

        // If is below MINIMUM_PRICE
      } else if (items_subtotal_amount < MINIMUM_PRICE) {
        removeAllGiftItems();
      }
      if (theme.settings.gift.gift_start_date > theme.settings.gift.now_date || theme.settings.gift.gift_end_date < theme.settings.gift.now_date) {
        removeAllGiftItems();
        cartFlyout.gift.classList.add('hide');
      }
    } else {
      if (theme.settings.gift.gift_start_date < theme.settings.gift.now_date && theme.settings.gift.gift_end_date > theme.settings.gift.now_date) {
        // If is above MINIMUM_PRICE and has gift in cart
        if (items_subtotal_amount >= MINIMUM_PRICE && alreadyContainsGift) {
          // If is above MINIMUM_PRICE and has gift in cart
          cartFlyout.gift.classList.add('hide');
          // If is above MINIMUM_PRICE and doesn't have gift in cart
        } else if (items_subtotal_amount >= MINIMUM_PRICE && !alreadyContainsGift) {
          if (sessionStorage.getItem('gift-removed')) {
            // if gift-removed exists
            var _gift2 = theme.settings.gift.gift1 != '' ? theme.settings.gift.gift1 : theme.settings.gift.gift2;
            var _giftDescriptionDOM2 = cartFlyout.giftDescription;
            var _giftDescription2 = theme.locales.gift_product.eligible;
            var _buttonTextDOM2 = cartFlyout.button;
            var _buttonText2 = theme.locales.gift_product.add_gift;
            var _giftDOM2 = cartFlyout.gift;
            isGiftAvailable(_gift2, _giftDescriptionDOM2, _giftDescription2, _buttonTextDOM2, _buttonText2, _giftDOM2, false);
          } else {
            // If it does NOT have session storage gift-removed
            initAutomaticAdd();
          }
          // If is below MINIMUM_PRICE
        } else if (items_subtotal_amount < MINIMUM_PRICE) {
          removeAllGiftItems();
          var _gift3 = theme.settings.gift.gift1 != '' ? theme.settings.gift.gift1 : theme.settings.gift.gift2;
          var _giftDescriptionDOM3 = cartFlyout.giftDescription;
          var _giftDescription3 = theme.locales.gift_product.add_more_products;
          var _buttonTextDOM3 = cartFlyout.button;
          var _buttonText3 = theme.locales.gift_product.shop_now;
          var _giftDOM3 = cartFlyout.gift;
          isGiftAvailable(_gift3, _giftDescriptionDOM3, _giftDescription3, _buttonTextDOM3, _buttonText3, _giftDOM3, false);
        }
      }
      if (!document.querySelector('#isp_product_quick_view_model') || fromQuickAddModal) {
        previousCartSubtotal = items_subtotal_amount;
      }
    }
    if (document.querySelector('.cart__checkout')) document.querySelector('.cart__checkout').classList.remove('hide');
    if (document.querySelector('.quickAdd-checkout-view__button')) document.querySelector('.quickAdd-checkout-view__button').classList.remove('hide');
  };
  var init = function init() {
    theme.giftBundle = theme.giftBundle || {};
    theme.giftBundle.updateGiftFlyout = updateGiftFlyout;
    theme.giftBundle.updateSpecificGiftFlyout = updateSpecificGiftFlyout;
    theme.settings = theme.settings || {};
    if (theme.settings.gift_bundle_enabled) {
      if (!document.querySelector('.js-gift-open-modal') || theme.settings.gift.gift_limiter && (theme.customer == null || !theme.customer.tags.some(function (tag) {
        return theme.settings.gift.gift_limiter_group.includes(tag);
      }))) {
        return false;
      }
      if (document.querySelector('.js-cart-gift-button')) {
        document.querySelector('.js-cart-gift-button').addEventListener('click', theme.utils.throttled(function (e) {
          btnClickHanlder();
        }, 2000));
      }
      initFlyout();
      if (theme.settings.gift.add_type == 'modal') {
        initModal(0);
      }
      if (theme.settings.gift.add_type == 'embed') {
        initEmbed();
      }
      $(document).on('Cart:set', function (e, cart) {
        setTimeout(function () {
          updateGiftFlyout();
        }, 500);
      });
    }
    if (theme.settings.specific_gift.enable_gift) {
      initSpecificFlyout()
      $(document).on('Cart:set', (e, cart) => {
        setTimeout(function () {
          updateSpecificGiftFlyout()
        }, 500);
      });
    }
  };
  init();
  window.theme.cartLoadAdd = cartLoadAdd;
  window.theme.deleteGiftSessionStorage = deleteGiftSessionStorage;
  window.theme.isGiftAvailable = isGiftAvailable;
  window.theme.updateGiftFlyout = updateGiftFlyout;
  window.theme.updateSpecificGiftFlyout = updateSpecificGiftFlyout;
  window.theme.initModal = initModal;
  window.theme.cartContainsGift = cartContainsGift;
  window.theme.initAutomaticAdd = initAutomaticAdd;
  window.theme.cartQualifiesForGift = cartQualifiesForGift;
}(window.theme = window.theme || {}), "product" == theme.template.name) {
  var buildVariantSlider = function buildVariantSlider(t, e, o) {
    e.map(function (e) {
      e.classList.contains("hide") && e.classList.remove("hide"), t.appendChild(e);
    }), $(t).slick({
      dots: !1,
      arrows: !0,
      infinite: !0,
      speed: 300,
      slidesToShow: 1,
      nextArrow: '<button class="slick-next slick-arrow slider-arrow slider-arrow--next" aria-label="Next" type="button" style="">Next</button>',
      prevArrow: '<button class="slick-prev slick-arrow slider-arrow slider-arrow--prev" aria-label="Previous" type="button" style="">Previous</button>'
    }), 0 != o && t.classList.add("hide");
  },
    buildSlider = function buildSlider(e) {
      var eleFeaturedImg = document.querySelector(".js-product-thumbnail-slider");
      var postFeaturedImg = eleFeaturedImg.getAttribute('data-featured-img');
      if (postFeaturedImg == -1)
        postFeaturedImg = 0;
      // var t = document.querySelector(".js-product-slider");
      // $(t).slick({
      //   dots: !1,
      //   arrows: !0,
      //   infinite: !0,
      //   speed: 300,
      //   slidesToShow: 1,
      //   nextArrow: '<button class="slick-next slick-arrow slider-arrow slider-arrow--next" aria-label="Next" type="button" style="">Next</button>',
      //   prevArrow: '<button class="slick-prev slick-arrow slider-arrow slider-arrow--prev" aria-label="Previous" type="button" style="">Previous</button>',
      //   lazyLoad: "progressive",
      //   initialSlide: postFeaturedImg,
      //   responsive: [{
      //     breakpoint: 996,
      //     settings: {
      //       dots: true
      //     }
      //   }]
      // });
      //       var $slider = $(".js-product-slider");

      // $slider.slick({
      //   dots: false,
      //   arrows: true,
      //   infinite: true,
      //   speed: 300,
      //   slidesToShow: 1,
      //   nextArrow: '<button class="slick-next slick-arrow slider-arrow slider-arrow--next" aria-label="Next" type="button">Next</button>',
      //   prevArrow: '<button class="slick-prev slick-arrow slider-arrow slider-arrow--prev" aria-label="Previous" type="button">Previous</button>',
      //   lazyLoad: "progressive",
      //   initialSlide: postFeaturedImg,
      //   responsive: [{
      //     breakpoint: 996,
      //     settings: {
      //       dots: true
      //     }
      //   }]
      // });

      // function protectAriaHidden($slide, value) {
      //   const target = $slide[0];
      //   const observer = new MutationObserver(function (mutations) {
      //     mutations.forEach(function (mutation) {
      //       if (
      //         mutation.type === "attributes" &&
      //         mutation.attributeName === "aria-hidden" &&
      //         $slide.attr("aria-hidden") !== value
      //       ) {
      //         $slide.attr("aria-hidden", value); // Restore it
      //       }
      //     });
      //   });

      //   observer.observe(target, {
      //     attributes: true,
      //     attributeFilter: ["aria-hidden"],
      //   });

      //   $slide.attr("aria-hidden", value); 
      // }


      // $slider.on('afterChange', function (event, slick, currentSlide) {
      //   var $slides = $(slick.$slides);

      //   $slides.each(function (index, slide) {
      //     var $slide = $(slide);
      //     if (index === currentSlide) {
      //       protectAriaHidden($slide, "false");
      //       $slide.find('a, button, input, [tabindex]').removeAttr('tabindex');
      //     } else {
      //       protectAriaHidden($slide, "true");
      //       $slide.find('a, button, input, [tabindex]').attr('tabindex', '-1');
      //     }
      //   });
      // });


      // $('.thumbnail').on('click', function () {
      //   var index = $(this).index();
      //   $slider.slick('slickGoTo', index);
      // });


      //       var $slider = $(".js-product-slider");

      // $slider.slick({
      //   dots: false,
      //   arrows: true,
      //   infinite: true,
      //   speed: 300,
      //   slidesToShow: 1,
      //   nextArrow: '<button class="slick-next slick-arrow slider-arrow slider-arrow--next" aria-label="Next" type="button">Next</button>',
      //   prevArrow: '<button class="slick-prev slick-arrow slider-arrow--prev" aria-label="Previous" type="button">Previous</button>',
      //   lazyLoad: "progressive",
      //   initialSlide: postFeaturedImg,
      //   responsive: [{
      //     breakpoint: 996,
      //     settings: {
      //       dots: true
      //     }
      //   }]
      // });

      // function fixAriaHidden(currentSlideIndex) {
      //   const $slides = $slider.slick('getSlick').$slides;

      //   $slides.each(function (index, slide) {
      //     const $slide = $(slide);

      //     if (index === currentSlideIndex) {
      //       $slide.attr('aria-hidden', 'false');
      //       $slide.find('a, button, input, [tabindex]').removeAttr('tabindex');
      //     } else {
      //       $slide.attr('aria-hidden', 'true');
      //       $slide.find('a, button, input, [tabindex]').attr('tabindex', '-1');
      //     }
      //   });
      // }

      // // After Slick changes slides
      // $slider.on('afterChange', function (event, slick, currentSlide) {
      //   // Wait till slick finishes its update
      //   setTimeout(() => {
      //     fixAriaHidden(currentSlide);
      //   }, 50);
      // });

      // // Thumbnail click
      // $('.thumbnail').on('click', function () {
      //   var index = $(this).index();  // Get the index of the clicked thumbnail
      //   $slider.slick('slickGoTo', index);  // Go to the corresponding slide

      //   // Apply fix after slick goes to the slide
      //   setTimeout(() => {
      //     fixAriaHidden(index);
      //   }, 100);
      // });

      // P2-548
      var $slider = $(".js-product-slider");

      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        nextArrow: '<button class="slick-next slick-arrow slider-arrow slider-arrow--next" aria-label="Next" type="button">Next</button>',
        prevArrow: '<button class="slick-prev slick-arrow slider-arrow--prev" aria-label="Previous" type="button">Previous</button>',
        lazyLoad: "progressive",
        initialSlide: postFeaturedImg,  // Dynamically set the initial slide index
        responsive: [{
          breakpoint: 996,
          settings: {
            dots: true
          }
        }]
      });

      // Function to handle aria-hidden
      function fixAriaHidden() {
        const $slides = $slider.find('.slick-slide'); // Includes cloned slides

        // Set all slides to aria-hidden true by default
        $slides.each(function (index, slide) {
          const $slide = $(slide);
          $slide.attr('aria-hidden', 'true');
          $slide.find('a, button, input, [tabindex]').attr('tabindex', '-1');
        });

        // Set active slide's aria-hidden to false
        const activeSlide = $slider.find('.slick-current');
        activeSlide.attr('aria-hidden', 'false');
        activeSlide.find('a, button, input, [tabindex]').removeAttr('tabindex');
      }

      // Initialize with aria-hidden by default after slick is initialized with a delay
      $slider.on('init', function (event, slick) {
        setTimeout(() => {
          fixAriaHidden(); // Apply aria-hidden after a delay (e.g., 1 second)
        }, 1000); // 1000 milliseconds = 1 second delay
      });

      // After slide change, update aria-hidden
      $slider.on('afterChange', function (event, slick, currentSlide) {
        setTimeout(() => {
          fixAriaHidden(); // Reapply aria-hidden after slide change
        }, 50); // Minimal delay after slide change
      });

      // Thumbnail click functionality for direct navigation
      $('.thumbnail').on('click', function () {
        var index = $(this).index();  // Get the index of the clicked thumbnail
        $slider.slick('slickGoTo', index);  // Go to the corresponding slide
        setTimeout(() => {
          fixAriaHidden(); // Reapply aria-hidden after clicking a thumbnail
        }, 100); // Short delay to ensure slider transitions properly
      });
      // P2-548


      var ss = document.querySelector(".js-product-thumbnail-slider");
      // var ssScroll = ss.dataset.scroll;
      //   var tSS = $(ss).slick({
      //       dots: false,
      //       arrows: true,
      //       infinite: true,
      //       speed: 300,
      //       slidesToShow: 4,
      //       nextArrow: '<button class="product-media-thumbnail-arrow product-media-thumbnail-arrow-down js-product-thumbnail-arrow" data-type="down"></button>',
      //       prevArrow: '<button class="product-media-thumbnail-arrow product-media-thumbnail-arrow-up js-product-thumbnail-arrow" data-type="up"></button>',
      //       lazyLoad: "progressive",
      //       vertical: true,
      //       verticalSwiping: true
      //   });

      // if(ssScroll == 'true'){
      //   tSS.on('wheel', (function(e) {
      //     e.preventDefault();

      //     if (e.originalEvent.deltaY < 0) {
      //       $(this).slick('slickPrev');
      //     } else {
      //       $(this).slick('slickNext');
      //     }
      //   }));
      // }
    },
    productSliderInit = function productSliderInit() {
      buildSlider();
    };
  document.addEventListener("DOMContentLoaded", productSliderInit);
}
!function (a) {
  var s = {
    item: [].concat(_toConsumableArray(document.querySelectorAll(".js-accordion-item"))),
    wrapper: [].concat(_toConsumableArray(document.querySelectorAll(".js-accordion-wrapper"))),
    open: [].concat(_toConsumableArray(document.querySelectorAll(".js-accordion-item .js-item-open"))),
    close: [].concat(_toConsumableArray(document.querySelectorAll(".js-accordion-item .js-item-close")))
  },
    c = ".js-accordion-wrapper";
  function e() {
    function e(e) {
      var o = !0;
      e.onclick = function (e) {
        if (!a.utils.targetIs(e.target, s.wrapper)) if (o) {
          e.preventDefault();
          var t = this.querySelector(c);
          a.utils.accordion(this, s.open, s.close, s.wrapper, t), o = !1, setTimeout(function () {
            return o = !0;
          }, 500);
        } else e.preventDefault();
      };
    }
    var t = !0,
      o = !1,
      i = void 0;
    try {
      for (var n, r = s.item[Symbol.iterator](); !(t = (n = r.next()).done); t = !0) {
        e(n.value);
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        !t && r["return"] && r["return"]();
      } finally {
        if (o) throw i;
      }
    }
  }
  function t() {
    s = {
      item: [].concat(_toConsumableArray(document.querySelectorAll(".js-accordion-item"))),
      wrapper: [].concat(_toConsumableArray(document.querySelectorAll(".js-accordion-wrapper"))),
      open: [].concat(_toConsumableArray(document.querySelectorAll(".js-accordion-item .js-item-open"))),
      close: [].concat(_toConsumableArray(document.querySelectorAll(".js-accordion-item .js-item-close")))
    }, e(), document.onclick = function (e) {
      e.target.closest(".js-accordion-list") || e.target.closest(".js-modal-click-exclude") || !(document.querySelector(".js-cart-flyout-container") && document.querySelector(".js-cart-flyout-container").classList.contains("is-active")) || (setTimeout(function () {
        $(c).slideUp().addClass("hide");
      }, 300), s.open.forEach(function (e) {
        return e.classList.remove("hide");
      }), s.close.forEach(function (e) {
        return e.classList.add("hide");
      }));
    };
  }
  "product" != a.template.name && t(), window.theme.initAccordion = t;
}(window.theme = window.theme || {}), function (theme, $) {
  if (!document.location.pathname.includes('/cart')) {
    var cartFlyout = {
      trigger: document.querySelector('.js-cart-flyout-trigger'),
      container: document.querySelector('.js-cart-flyout-container'),
      overlay: document.querySelector('.js-cart-flyout-overlay'),
      close: document.querySelector('.js-close-cart-flyout'),
      focusables: _toConsumableArray2(document.querySelector('.js-cart-flyout-container').querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')),
      header: document.querySelector('.js-header-container')
    };
    var toggleFlyout = function toggleFlyout(e) {
      if (cartFlyout.container.matches('.is-active')) {
        if (!e.target.closest('.cart-flyout')) {
          if (document.querySelector('.js-product-recommended-content').classList.contains('is-active')) {
            document.querySelector('.js-slider-title').click();
          }
          updateClasses();
        } else if (e.target.classList.contains('js-close-cart-flyout')) {
          if (document.querySelector('.js-product-recommended-content').classList.contains('is-active')) {
            document.querySelector('.js-slider-title').click();
          }
          closeFlyout();
        }
      } else {
        e.preventDefault();
        updateClasses();
      }
    };
    var updateClasses = function updateClasses() {
      cartFlyout.container.classList.toggle('is-active');
      cartFlyout.overlay.classList.toggle('is-active');
      cartFlyout.header.classList.toggle('flyout-is-open');
      document.body.classList.toggle('body--freeze', cartFlyout.overlay.matches('.is-active'));
      cartFlyout.focusables.forEach(function (focusable) {
        return focusable.tabIndex = focusable.tabIndex ? 0 : -1;
      });
      // if (cartFlyout.focusables[0].tabIndex === 0) {
      //   cartFlyout.focusables[0].focus();
      // }

    };
    var closeFlyout = function closeFlyout() {
      cartFlyout.container.classList.remove('is-active');
      cartFlyout.overlay.classList.remove('is-active');
      cartFlyout.header.classList.remove('flyout-is-open');
      document.body.classList.remove('body--freeze', cartFlyout.overlay.matches('.is-active'));
      cartFlyout.focusables.forEach(function (focusable) {
        return focusable.tabIndex = -1;
      });

      // Focus back to cart button
      var cartButton = document.querySelector('.header__tool-link.header__tool-cart');
      if (cartButton) {
        cartButton.focus();
        setTimeout(function () {
          cartButton.focus();
        }, 500);
      }
    };
    var openFlyout = function openFlyout() {
      cartFlyout.container.classList.add('is-active');
      cartFlyout.overlay.classList.add('is-active');
      cartFlyout.header.classList.add('flyout-is-open');
      document.body.classList.add('body--freeze', cartFlyout.overlay.matches('.is-active'));
      cartFlyout.focusables.forEach(function (focusable) {
        return focusable.tabIndex = 0;
      });
      cartFlyout.focusables[0].focus();


      let cartDialog = document.querySelector('.cart-flyout--container');
      if (cartDialog) {

        var firstFocusableElement = cartDialog.querySelector('.cart-flyout__close.js-close-cart-flyout');
        var lastFocusableElement = cartDialog.querySelector('.last-focusable-element');

        cartDialog.addEventListener('keydown', function (e) {
          // console.log('shld last test');
          if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
            e.preventDefault();
            // console.log('shld last');
            lastFocusableElement.focus();
          } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
            e.preventDefault();
            // console.log('shld first')
            firstFocusableElement.focus();
          }
        });

      }



    };
    var cartFlyoutInit = function cartFlyoutInit() {
      //cartFlyout.overlay.addEventListener('click', e => toggleFlyout(e));
      if (cartFlyout.trigger) cartFlyout.trigger.addEventListener('click', function (e) {
        return toggleFlyout(e);
      });
      cartFlyout.focusables.forEach(function (focusable) {
        return focusable.tabIndex = -1;
      });
      theme.openFlyout = openFlyout;
      theme.closeFlyout = closeFlyout;
    };
    $(document).on('Cart:add', function () {
      if (!theme.addedFromQuickAdd && theme.template.suffix != 'bundle') {
        openFlyout();
      }
      if (theme.settings.specific_gift.enable_gift) {
        theme.giftBundle.updateSpecificGiftFlyout(theme.addedFromQuickAdd);
      }
      if (theme.settings.gift_bundle_enabled) {
        if (document.querySelector('.cart__checkout')) document.querySelector('.cart__checkout').classList.add('hide');
        if (document.querySelector('.quickAdd-checkout-view__button')) document.querySelector('.quickAdd-checkout-view__button').classList.add('hide');
        theme.giftBundle.updateGiftFlyout(theme.addedFromQuickAdd);
      }
      /*
      // console.log('theme giftBundle updateGiftFlyout is',theme.giftBundle.updateGiftFlyout(theme.addedFromQuickAdd));
      const alreadyContainsGift = () => {
        let containsGift = false;
        const cart = theme.cart._object;
        cart.items.forEach(item => {
          if (item.properties && '_gift' in item.properties) {
            containsGift = true;
          }
        })
        return containsGift;
      }
                 // console.log('alreadyContainsGift is now ',alreadyContainsGift());
                 if (!alreadyContainsGift() && theme.addedFromQuickAdd) {
        // console.log('does not have gift, so I am clikering',);
        document.querySelector('.js-gift-open-modal').click();
        document.querySelector('.modal-overlay').style['z-index'] = 10000001;
      }
      */
    });

    $(document).on('Cart:ready', function () {
      cartFlyout.focusables = _toConsumableArray2(cartFlyout.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
    });
    cartFlyoutInit();
    window.theme.openFlyout = openFlyout;
  }
}(window.theme, jQuery), function (E) {
  if ("product" == E.template.name) {
    var e = function e(_e) {
      var t = [].concat(_toConsumableArray(document.querySelectorAll(".js-add-to-wishlist"))),
        o = window.SwymPageData.empi,
        i = window.SwymPageData.epi,
        n = _e.find(function (e) {
          return e.empi == o && e.epi == i;
        });
      t.forEach(function (e) {
        n ? e.classList.add("swym-added") : (e.classList.contains("swym-added") && e.classList.remove("swym-added"), r());
      });
    },
      w = {
        prodSizeToggle: [].concat(_toConsumableArray(document.querySelectorAll(".js-size-toggle"))),
        prodSize: [].concat(_toConsumableArray(document.querySelectorAll(".js-button-size"))),
        sizeAccordion: document.querySelector(".js-form-size"),
        prodInfo: document.querySelector(".js-product-info"),
        prodMobImg: document.querySelector(".js-prod-mob-image"),
        prodDeskImg: document.querySelector(".js-prod-desk-image"),
        prodOption: [].concat(_toConsumableArray(document.querySelectorAll(".js-product-option label"))),
        prodOptionAll: [].concat(_toConsumableArray(document.querySelectorAll('.js-product-option[data-color-id="color--' + E.product.id + '"]'))),
        prodOptionSingleAll: [].concat(_toConsumableArray(document.querySelectorAll('.js-product-option[data-color-id="color--' + E.product.id + '"] label'))),
        prodPricing: document.querySelector(".js-product-pricing"),
        prodAtc: [].concat(_toConsumableArray(document.querySelectorAll(".js-product-atc"))),
        additionalPaymentButton: [].concat(_toConsumableArray(document.querySelectorAll(".js-additional-payment-button"))),
        prodAtcNoVariants: [].concat(_toConsumableArray(document.querySelectorAll(".js-product-atc-no-variants"))),
        prodModal: document.querySelector(".js-open-modal.js-product-atc"),
        prodOutSize: [].concat(_toConsumableArray(document.querySelectorAll(".js-out-size"))),
        prodLoyaltyPoints: document.querySelector(".js-product-points"),
        qtyLimit: [].concat(_toConsumableArray(document.querySelectorAll(".js-qty-limit"))),
        slider: document.querySelector(".js-product-slider")
      },
      x = function x(e, t) {
        var o = [];
        o.push([{
          productId: t,
          sku: e
        }]), window.monetateQ = window.monetateQ || [], window.monetateQ.push(["setPageType", E.template.page_type]), o.forEach(function (e) {
          window.monetateQ.push(["addProductDetails", e]);
        }), window.monetateQ.push(["trackData"]);
      },
      t = {
        oldSize: E.locales.product.select_size,
        oldAtc: E.locales.product.add_to_bag
      },
      o = function o(e) {
        e.matches(".is-active") ? $(e).slideDown().removeClass("is-active") : $(e).addClass("is-active").slideDown();
      },
      i = function i() {
        // If only one variant, pre-select it
        if (w.prodOptionAll.every(function (optionSelector) {
          return optionSelector.classList.contains('js-has-one-variant');
        })) {
          w.prodOptionSingleAll.forEach(function (option) {
            return n(option, w.prodOptionSingleAll, t);
          });
        }
        w.prodOption.forEach(function (option) {
          // For ADA, need to trigger click event when pressing enter
          function myEventHandler(e) {
            var keyCode = e.keyCode;
            if (keyCode == 13) {
              n(e.target, w.prodOption, t);
            }
          }
          option.addEventListener('click', function (e) {
            return n(e.target, w.prodOption, t);
          });
          option.addEventListener("keypress", myEventHandler, false);
        });
      },
      r = function r() {
        [].concat(_toConsumableArray(document.querySelectorAll(".js-add-to-wishlist"))).forEach(function (t) {
          t.addEventListener("click", function (e) {
            window.SwymPageData && (window.SwymPageData.et = 4, _swat.addToWishList(window.SwymPageData, function (e) {
              t.classList.add("swym-added");
            }));
          });
        });
      },
      S = function S() {
        0 < [].concat(_toConsumableArray(document.querySelectorAll(".js-add-to-wishlist"))).length && _swat.fetchWrtEventTypeET(e, 4);
      },
      k = function k() {
        var e = [].concat(_toConsumableArray(document.querySelectorAll(".js-swatch input:checked"))),
          t = "";
        return 0 < e.length ? e.forEach(function (e) {
          t = "", e.parentElement.querySelector("label").dataset.atcText == E.locales.product.coming_soon && (t = "comingsoon");
        }) : E.product.tags.includes("swym-comingsoon") && (t = "comingsoon"), t;
      },
      appOnlyCheck = function appOnlyCheck() {
        var e = [].concat(_toConsumableArray(document.querySelectorAll(".js-swatch input:checked"))),
          t = "";
        return 0 < e.length ? e.forEach(function (e) {
          t = "", e.parentElement.querySelector("label").dataset.atcText == E.locales.product.download_app && (t = "app-exclusive");
        }) : E.product.tags.includes("app-exclusive") && (t = "app-exclusive"), t;
      },
      n = function n(t, e, o) {
        [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-modal-prod-title"))).forEach(function (e) {
          E.splitModalTitle(e, t.dataset.productTitle);
        }), e.forEach(function (e) {
          e.classList.remove("style--primary"), e.classList.add("style--secondary");
        }), e.forEach(function (e) {
          return e.classList.remove("is-selected");
        });
        var i = t.dataset.variantId,
          n = [].concat(_toConsumableArray(document.querySelectorAll('.js-product-option label[for^="' + i + '"]')));
        if (-1 < E.product.tags.indexOf("by-variant-images")) {
          var r = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-slider"))),
            a = [].concat(_toConsumableArray(document.querySelectorAll(".js-prod-desk-image")));
          r.forEach(function (e) {
            e.classList.contains("hide") || e.classList.add("hide");
          }), a.forEach(function (e) {
            e.classList.contains("hide") || e.classList.add("hide"), e.getAttribute("data-variant-id") != i && "" != e.getAttribute("data-variant-id") || e.classList.remove("hide");
          }), $('.js-product-slider[data-variant-id="' + i + '"]').removeClass("hide").get(0).slick.setPosition();
        }
        [].concat(_toConsumableArray(document.querySelectorAll(".form__atc-wishlist button"))).forEach(function (e) {
          e.classList.contains("js-product-atc") && (e.setAttribute("data-price", +t.getAttribute("data-price") / 100), e.setAttribute("data-variant-id", +t.dataset.variantId), e.setAttribute("data-product-id", +t.dataset.productId), e.setAttribute("data-image", t.dataset.image), e.setAttribute("data-product-title", t.dataset.productTitle), e.setAttribute("data-option1", t.dataset.option1), e.setAttribute("data-sku", t.dataset.currentSku));
        });
        var s = k();
        E.outOfStockData = {
          price: +t.getAttribute("data-price") / 100,
          variant_id: +t.dataset.variantId,
          product_id: +t.dataset.productId,
          image: t.dataset.image,
          modal_type: s
        }, n.forEach(function (e) {
          option_clicked_product_page(e);
          e.classList.remove("style--secondary"), e.classList.add("style--primary", "is-selected");
        });
        var c = document.querySelector(".style.is-selected").getAttribute("data-limit-msg");
        w.qtyLimit.forEach(function (e) {
          "" != c ? e.classList.contains("hidden") && e.classList.remove("hidden") : e.classList.contains("hidden") || e.classList.add("hidden");
        });
        var l = document.querySelector(".style.is-selected"),
          d = l.dataset.productId,
          u = l.dataset.currentSku;
        x(u, d);
        var m = parseInt(l.dataset.variantId),
          p = parseInt(l.dataset.price),
          f = parseInt(l.dataset.variantQty),
          h = JSON.parse(l.dataset.currentVariant),
          v = parseInt(l.dataset.productId),
          appexclusive = l.dataset.appexclusive,
          _ = l.dataset.productTitle,
          d_s,
          y = l.dataset.image,
          g = E.shop.url + "/products/" + l.dataset.productHandle,
          preorder = l.dataset.preorder,
          preorderEl = document.querySelectorAll('input[name="properties[Pre Order]"]'),
          preorder_date = l.dataset.preorderDate,
          preorder_dateEl = document.querySelectorAll('input[name="properties[Pre Order Date]"]'),
          preorder_note = document.getElementById('preorder_note'),
          preorder_tag = document.querySelectorAll('.js-product-tag--preorder');
        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var daySuffix = ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"];
        preorderEl.forEach(function (e) {
          if (preorder == 'false') {
            e.disabled = true;
          } else {
            e.disabled = false;
            e.value = preorder;
          }
        });
        preorder_dateEl.forEach(function (e) {
          e.value = preorder_date;
        });
        o.oldAtc = E.locales.product.add_to_bag;
        if (preorder === 'true') {
          var date_property = new Date(preorder_date),
            preorderDate = Math.round(date_property / 1000),
            now_date = Math.round(Date.now() / 1000),
            utc = date_property.getTime() + date_property.getTimezoneOffset() * 60000,
            corrected_date = new Date(utc);
          if (preorderDate > now_date) {
            o.oldAtc = E.locales.product.preorder;
            if (!preorder_note) {
              var last_cart_btn = w.prodAtc[w.prodAtc.length - 1],
                preorder_note = document.createElement('div');
              preorder_note.id = 'preorder_note';
              last_cart_btn.parentNode.parentNode.insertBefore(preorder_note, last_cart_btn.parentNode.nextSibling);
            }
            if (corrected_date.getDate() > 3 && corrected_date.getDate() < 21) {
              d_s = 'th';
            } else {
              switch (corrected_date.getDate() % 10) {
                case 1:
                  d_s = 'st';
                  break;
                case 2:
                  d_s = 'nd';
                  break;
                case 3:
                  d_s = 'rd';
                default:
                  d_s = 'th';
              }
            }
            preorder_note.innerText = theme.locales.product.preorder_date + ' ' + months[corrected_date.getMonth()] + ' ' + corrected_date.getDate() + d_s + ', ' + corrected_date.getFullYear();
            preorder_tag.forEach(function (e) {
              e.classList.remove('hide');
            });
          }
        } else {
          if (preorder_note) {
            preorder_note.innerText = '';
          }
          preorder_tag.forEach(function (e) {
            e.classList.add('hide');
          });
        }
        if (appexclusive === 'true') {
          o.oldAtc = theme.locales.collection.download_app;
        }
        if (w.prodAtc.forEach(function (e) {
          return e.setAttribute("data-variant-id", i);
        }), t.matches(".is-disabled")) w.prodSize.forEach(function (e) {
          e.classList.remove("button--primary"), e.classList.add("button--secondary"), e.querySelector(".style").textContent = 1 < w.prodSize.length ? t.getAttribute("data-option1") : o.oldSize;
        }), w.prodOutSize.forEach(function (e) {
          return e.textContent = t.getAttribute("data-option1");
        }), w.prodModal.classList.remove("button--secondary", "hide"), w.prodModal.classList.add("button--primary"), w.prodAtc.forEach(function (e) {
          return q(e, o, !0);
        }); else {
          var b = t.getAttribute("data-option1");
          if (!t.matches(".style--primary")) return;
          w.prodAtc.forEach(function (e) {
            return q(e, o, !1);
          }), w.prodSize.forEach(function (e) {
            e.querySelector(".style").textContent = b, e.classList.remove("button--primary"), e.classList.add("button--secondary");
          });
        }
        window.triggerSwymVariantEvent && window.triggerSwymVariantEvent(i), window.SwymPageData && (window.SwymPageData.empi = v, window.SwymPageData.epi = m, window.SwymPageData.pr = p % 100 == 0 ? parseInt(p / 100) : parseFloat(p / 100).toFixed(2), window.SwymPageData.stk = f, window.SwymPageData.dt = _, window.SwymPageData.iu = y, window.SwymPageData.du = g, window.SwymPageData.variants = h, window.SwymPageData.uri = g), window._swat && window._swat.initializeActionButtons && window._swat.initializeActionButtons(".product__grid .form__atc-wishlist"), window.SwymCallbacks || (window.SwymCallbacks = []), window.SwymCallbacks.push(S), function () {
          var t = document.querySelector(".js-product-atc").dataset.variantId;
          [].concat(_toConsumableArray(document.querySelectorAll(".js-hidden-variant"))).forEach(function (e) {
            e.value = t;
          });
        }(), function () {
          w.prodAtc;
          document.querySelector(".js-product-atc").classList.contains("hide") ? w.additionalPaymentButton.forEach(function (e) {
            e.classList.contains("hide") || e.classList.add("hide");
          }) : w.additionalPaymentButton.forEach(function (e) {
            e.classList.contains("hide") && e.classList.remove("hide");
          });
        }();
      },
      l = function l(e, t, o) {
        var i = E.cart.content.items.filter(function (e) {
          return !(e.variant_id !== +t || e.properties && e.properties._gift);
        });
        return i.length ? {
          isInCart: !0,
          quantity: i[0].quantity
        } : {
          isInCart: !1
        };
      },
      q = function q(btn, text, outOfStock) {
        var comingSoon = k();
        var appCheck = appOnlyCheck();
        var swatches = _toConsumableArray2(document.querySelectorAll('.js-swatch input:checked'));
        var appExclusive = false;
        if (swatches.length > 0) {
          // Swatches
          swatches.forEach(function (swatch) {
            if (swatch.parentElement.querySelector('label').dataset.tag == 'app-exclusive') {
              appExclusive = true;
            }
          });
        }
        if (appCheck) {
          if (btn.classList.contains('js-app-exclusive')) {
            btn.classList.remove('hide', 'button--secondary');
            btn.classList.add('button--primary');
            btn.removeAttribute('disabled');
          } else {
            btn.classList.add('hide');
            btn.removeAttribute('disabled');
          }
        } else {
          if (comingSoon) {
            if (btn.classList.contains('js-coming-soon')) {
              btn.classList.remove('hide', 'button--secondary');
              btn.classList.add('button--primary');
              btn.removeAttribute('disabled');
            } else {
              btn.classList.add('hide');
              btn.removeAttribute('disabled');
            }
          } else if (outOfStock) {
            if (btn.classList.contains('js-notify-me')) {
              btn.classList.remove('hide', 'button--secondary');
              btn.classList.add('button--primary');
              btn.removeAttribute('disabled');
            } else {
              btn.classList.add('hide');
              btn.removeAttribute('disabled');
            }
          } else {
            if (btn.classList.contains('js-notify-me') || btn.classList.contains('js-coming-soon') || btn.classList.contains('js-preorder') || btn.classList.contains('js-app-exclusive')) {
              btn.classList.remove('button--primary');
              btn.classList.add('hide', 'button--secondary');
            } else {
              btn.removeAttribute('disabled');
              btn.textContent = text.oldAtc;
              btn.classList.remove('button--secondary', 'hide');
              btn.classList.add('button--primary');
            }
          }
        }
      },
      T = function T(e, t, o) {
        e.classList.contains("hide") || e.classList.add("hide"), e.dataset.colorId == t && (e.classList.remove("hide"), "mobile-image" == o && $(e).get(0).slick.setPosition());
      },
      Z = function Z(e, t, o) {
        e.classList.contains("hidden") || e.classList.add("hidden"), e.dataset.colorId == t && (e.classList.remove("hidden"), "mobile-image" == o && $(e).get(0).slick.setPosition());
      };
    window.theme.initProductColor = function () {
      w = {
        prodSizeToggle: [].concat(_toConsumableArray(document.querySelectorAll(".js-size-toggle"))),
        prodSize: [].concat(_toConsumableArray(document.querySelectorAll(".js-button-size"))),
        sizeAccordion: document.querySelector(".js-form-size"),
        prodInfo: document.querySelector(".js-product-info"),
        prodMobImg: document.querySelector(".js-prod-mob-image"),
        prodDeskImg: document.querySelector(".js-prod-desk-image"),
        prodOption: [].concat(_toConsumableArray(document.querySelectorAll(".js-product-option label"))),
        prodOptionAll: [].concat(_toConsumableArray(document.querySelectorAll('.js-product-option[data-color-id="color--' + E.product.id + '"]'))),
        prodOptionSingleAll: [].concat(_toConsumableArray(document.querySelectorAll('.js-product-option[data-color-id="color--' + E.product.id + '"] label'))),
        prodPricing: document.querySelector(".js-product-pricing"),
        prodAtc: [].concat(_toConsumableArray(document.querySelectorAll(".js-product-atc"))),
        additionalPaymentButton: [].concat(_toConsumableArray(document.querySelectorAll(".js-additional-payment-button"))),
        prodAtcNoVariants: [].concat(_toConsumableArray(document.querySelectorAll(".js-product-atc-no-variants"))),
        prodModal: document.querySelector(".js-open-modal.js-product-atc"),
        prodOutSize: [].concat(_toConsumableArray(document.querySelectorAll(".js-out-size"))),
        prodLoyaltyPoints: document.querySelector(".js-product-points"),
        qtyLimit: [].concat(_toConsumableArray(document.querySelectorAll(".js-qty-limit"))),
        slider: document.querySelector(".js-product-slider")
      }, E.outOfStockData = E.outOfStockData || {}, E.isp = E.isp || {}, window.SwymCallbacks || (window.SwymCallbacks = []), window.SwymCallbacks.push(S), function () {
        var e = [].concat(_toConsumableArray(document.querySelectorAll(".form__atc-wishlist .js-out-of-stock"))),
          n = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-modal-prod-title"))),
          r = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-size")));
        e.forEach(function (i) {
          i.onclick = function () {
            var t = i.dataset.productTitle,
              o = i.dataset.option1,
              e = i.innerText.toUpperCase().trim() == E.locales.product.coming_soon.toUpperCase() ? "comingsoon" : "";
            n.forEach(function (e) {
              E.splitModalTitle(e, t);
            }), r.forEach(function (e) {
              e && (e.innerText = o);
            }), E.outOfStockData = {
              price: +i.getAttribute("data-price"),
              variant_id: +i.dataset.variantId,
              product_id: +i.dataset.productId,
              image: i.dataset.image,
              modal_type: e
            };
          };
        });
      }(), function () {
        var e = [].concat(_toConsumableArray(document.querySelectorAll(".js-form-colors .swatch label"))),
          a = [].concat(_toConsumableArray(document.querySelectorAll(".js-form-add-colors .swatch label"))),
          g = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-option[data-color-id]"))),
          b = [].concat(_toConsumableArray(document.querySelectorAll(".js-accordion-product"))),
          w = [].concat(_toConsumableArray(document.querySelectorAll(".js-featured-image"))),
          S = [].concat(_toConsumableArray(document.querySelectorAll(".js-other-product-images"))),
          k = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-slider"))),
          q = [].concat(_toConsumableArray(document.querySelectorAll(".js-color-name"))),
          aq = [].concat(_toConsumableArray(document.querySelectorAll(".js-add-color-name"))),
          t = document.querySelector("#ProductForm--desktop .js-color-name"),
          td = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-thumbnail-slider"))),
          tda = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-thumbnail-arrow-wrap"))),
          j = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-pricing"))),
          A = [].concat(_toConsumableArray(document.querySelectorAll(".js-complete-the-look"))),
          C = "",
          L = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-modal-prod-title")));
        e.forEach(function (y) {
          y.addEventListener("mouseover", function (e) {
            // console.log(e);
            document.querySelector("#ProductForm--desktop .js-swatch input:checked + label").dataset.productId != y.dataset.productId && (t.innerText = y.querySelector("span").textContent);
          }), y.addEventListener("mouseout", function (e) {
            t.innerText = document.querySelector("#ProductForm--desktop .js-swatch input:checked + label span").textContent;
          }), y.addEventListener("click", function (e) {
            if (checkSale()) {
              document.querySelector('.product-sale-msg') && (document.querySelector('.product-sale-msg').style.display = 'block');
              document.querySelector('.product__shipping-return') && (document.querySelector('.product__shipping-return').style.display = 'none');
            } else {
              document.querySelector('.product__shipping-return') && (document.querySelector('.product__shipping-return').style.display = 'block');
              document.querySelector('.product-sale-msg') && (document.querySelector('.product-sale-msg').style.display = 'none');
            }
            var productTitle = y.dataset.productTitle.split("-")[0];
            $('.product__title').text(productTitle);
            //ttp_viewcontent_product_variant_change(y.dataset.productId, y.dataset.color, y.dataset.price / 100);
            var t = y.dataset.colorId,
              o = y.dataset.productId,
              i = y.dataset.price,
              n = y.dataset.compareAtPrice,
              r = y.dataset.atcText,
              a = "true" === y.dataset.available,
              s = y.dataset.color,
              c = "true" === y.dataset.completeTheLook,
              l = "eu.aninebing.com" == E.shop.domain ? "E0438DADA0F4BE0C1FA8" : "F2E9471174A699850039",
              ssm = y.dataset.specialMessage,
              priceCents = parseInt(i, 10) || 0,
              compareCents = n ? parseInt(n, 10) || 0 : 0,
              hasSalePrice = compareCents > priceCents;
            c ? (findmine_params = {
              application: l,
              product_price: i / 100,
              product_in_stock: a,
              product_id: s,
              return_pdp_item: !0,
              event_handlers: {
                onFinish: function onFinish() {
                  A.forEach(function (e) {
                    e.classList.contains("hidden") && e.classList.remove("hidden");
                  });
                }
              }
            }, window.FindMine.match(findmine_params)) : A.forEach(function (e) {
              e.classList.contains("hidden") || e.classList.add("hidden");
            });
            // console.log('y', y);
            var appExclusive = document.querySelectorAll('.app-exclusive-tag');
            if (appExclusive) {
              appExclusive.forEach(function (el) {
                y.dataset.app === 'true' ? el.classList.remove('hide') : el.classList.add('hide');
              });
            }
            var badgeWrap = document.querySelector('.js-product-badge-wrap');
            if (badgeWrap) {
              var rawBadge = y.getAttribute('data-badge-text');
              var badgeHtml = '';
              if (rawBadge !== null && rawBadge !== '') {
                try {
                  badgeHtml = decodeURIComponent(rawBadge);
                } catch (err) {
                  badgeHtml = rawBadge;
                }
              }
              badgeWrap.innerHTML = badgeHtml;
              badgeWrap.style.display = badgeHtml ? '' : 'none';
            }
            var d = JSON.parse(y.dataset.skus);
            x(d[0], o);
            var u = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-klarna-message")));
            1 < u.length && (u.forEach(function (e) {
              e.setAttribute("data-purchase-amount", i);
            }), window.KlarnaOnsiteService = window.KlarnaOnsiteService || [], window.KlarnaOnsiteService.push({
              eventName: "refresh-placements"
            }));
            document.querySelector("#ProductForm--desktop .js-option-selector:checked").dataset.colorId;
            document.querySelector(".js-review-wrapper") && !document.querySelector(".js-review-wrapper").classList.contains("hide") && document.querySelector(".js-accordion-review").click(), L.forEach(function (e) {
              e.innerText = y.dataset.productTitle;
            });
            var m = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-atc")));
            document.querySelector(".style.is-selected") || (m.forEach(function (e) {
              e.classList.contains("hide") || e.classList.add("hide");
            }), m.forEach(function (e) {
              e.innerText.trim() == r && e.classList.remove("hide");
            })), j.forEach(function (e) {
              var compareMoneyEl = e.querySelector(".price.price--compare-at .money") || e.querySelector(".price.price--compare-at .price__value"),
                finalMoneyEl = e.querySelector(".price.price--final .money") || e.querySelector(".price.price--final .price__value"),
                compareWrap = e.querySelector(".price.price--compare-at");
              finalMoneyEl && (finalMoneyEl.innerText = E.utils.toMoney(i, {
                cents: !0,
                no_zeros: !0
              }));
              if (compareMoneyEl) {
                if (hasSalePrice && n) {
                  var cmpTxt = E.utils.toMoney(n, {
                    cents: !0,
                    no_zeros: !0
                  });
                  compareMoneyEl.innerText = cmpTxt != null ? cmpTxt : '';
                } else {
                  compareMoneyEl.innerText = '';
                }
              }
              compareWrap && (hasSalePrice ? compareWrap.classList.add("js-price-compare-at-style") : compareWrap.classList.remove("js-price-compare-at-style"), compareWrap.style.display = hasSalePrice ? '' : 'none');
            }), q.forEach(function (e) {
              e.closest('.label').classList.remove('hide');
              e.innerText = y.querySelector("span").textContent;
              aq.forEach(function (c) {
                c.closest('.label').classList.add('hide');
              });
            }), 0 < [].concat(_toConsumableArray(document.querySelectorAll(".js-product-option label.is-selected"))).length && (C = document.querySelector(".js-product-option label.is-selected").dataset.option1), [].concat(_toConsumableArray(document.querySelectorAll(".swym-heart.icon-heart"))).forEach(function (e) {
              var t = e.dataset.productId;
              e.dataset.productId = o, e.classList.remove("product_" + t), e.classList.add("product_" + o);
            });
            var p = y.closest(".js-swatch label").dataset.colorId;
            [].concat(_toConsumableArray(document.querySelectorAll(".js-swatch input." + p))).forEach(function (e) {
              e.click();
            }), g.forEach(function (e) {
              e.classList.contains("hide") || e.classList.add("hide"), e.dataset.colorId == t && ("" != C && e.querySelector('label[data-option1="' + C + '"]') ? e.querySelector('label[data-option1="' + C + '"]').click() : "" != C && e.querySelector("label").click(), e.classList.remove("hide"));
            });
            var f = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-message"))),
              h = document.querySelector(".js-product-option:not(.hide)");
            f.forEach(function (e) {
              r.toUpperCase() == E.locales.product.coming_soon.toUpperCase() ? (e.innerText = E.settings.coming_soon_message, e.classList.contains("is-active") || e.classList.add("is-active")) : JSON.parse(h.dataset.anyVariantOos) ? (e.innerText = E.settings.out_of_stock_message, e.classList.contains("is-active") || e.classList.add("is-active")) : (e.innerText = "", e.classList.contains("is-active") && e.classList.remove("is-active"));
            });
            if (ssm == "true") {
              var psm = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-special-message")));
              psm.forEach(function (e) {
                e.classList.add("is-active");
                e.innerHTML = theme.settings.special_message;
              });
              var dr = document.querySelector(".desktop-range");
              if (dr && dr.innerText != "") {
                dr.classList.add("is-active");
              }
              var mr = document.querySelector(".mobile-range");
              if (mr && mr.innerText != "") {
                mr.classList.add("is-active");
              }
              var fg = document.querySelector(".js-fit-guide-option-mobile");
              if (fg) {
                fg.classList.add("is-active");
              }
            } else {
              var psm = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-special-message")));
              psm.forEach(function (e) {
                e.classList.remove("is-active");
                e.innerHTML = "";
              });
              var dr = document.querySelector(".desktop-range");
              if (dr) {
                dr.classList.remove("is-active");
              }
              var mr = document.querySelector(".mobile-range");
              if (mr) {
                mr.classList.remove("is-active");
              }
              var fg = document.querySelector(".js-fit-guide-option-mobile");
              if (fg) {
                fg.classList.remove("is-active");
              }
            }
            var v = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-tag"))),
              _ = document.querySelector(".js-form-colors .js-swatch input:checked").nextElementSibling;
            _.dataset.atcText == E.locales.product.coming_soon ? v.forEach(function (e) {
              e.innerText = "" + E.locales.product.coming_soon_tag.toUpperCase();
            }) : v.forEach(function (e) {
              e.innerText = _.dataset.tag.replace(/-/g, ' ').toUpperCase();
            }), w.forEach(function (e) {
              T(e, t);
            }), S.forEach(function (e) {
              T(e, t);
            }), k.forEach(function (e) {
              T(e, t, "mobile-image");
            }), td.forEach(function (e) {
              Z(e, t);
            }), b.forEach(function (e) {
              T(e, t);
            }), tda.forEach(function (e) {
              T(e, t);
            }), E.zoomImage();
          });
        });
        a.forEach(function (y) {
          y.addEventListener("mouseover", function (e) { }), y.addEventListener("mouseout", function (e) { }), y.addEventListener("click", function (e) {
            checkSale();
            var productTitle = y.dataset.productTitle.split("-")[0];
            $('.product__title').text(productTitle);
            //ttp_viewcontent_product_variant_change(y.dataset.productId, y.dataset.color, y.dataset.price / 100);
            var t = y.dataset.colorId,
              o = y.dataset.productId,
              i = y.dataset.price,
              n = y.dataset.compareAtPrice,
              r = y.dataset.atcText,
              a = "true" === y.dataset.available,
              s = y.dataset.color,
              c = "true" === y.dataset.completeTheLook,
              l = "eu.aninebing.com" == E.shop.domain ? "E0438DADA0F4BE0C1FA8" : "F2E9471174A699850039",
              ssm = y.dataset.specialMessage,
              priceCents = parseInt(i, 10) || 0,
              compareCents = n ? parseInt(n, 10) || 0 : 0,
              hasSalePrice = compareCents > priceCents;
            c ? (findmine_params = {
              application: l,
              product_price: i / 100,
              product_in_stock: a,
              product_id: s,
              return_pdp_item: !0,
              event_handlers: {
                onFinish: function onFinish() {
                  A.forEach(function (e) {
                    e.classList.contains("hidden") && e.classList.remove("hidden");
                  });
                }
              }
            }, window.FindMine.match(findmine_params)) : A.forEach(function (e) {
              e.classList.contains("hidden") || e.classList.add("hidden");
            });
            var badgeWrap = document.querySelector('.js-product-badge-wrap');
            if (badgeWrap) {
              var rawBadge = y.getAttribute('data-badge-text');
              var badgeHtml = '';
              if (rawBadge !== null && rawBadge !== '') {
                try {
                  badgeHtml = decodeURIComponent(rawBadge);
                } catch (err) {
                  badgeHtml = rawBadge;
                }
              }
              badgeWrap.innerHTML = badgeHtml;
              badgeWrap.style.display = badgeHtml ? '' : 'none';
            }
            var d = JSON.parse(y.dataset.skus);
            x(d[0], o);
            var u = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-klarna-message")));
            1 < u.length && (u.forEach(function (e) {
              e.setAttribute("data-purchase-amount", i);
            }), window.KlarnaOnsiteService = window.KlarnaOnsiteService || [], window.KlarnaOnsiteService.push({
              eventName: "refresh-placements"
            }));
            document.querySelector("#ProductForm--desktop .js-option-selector:checked").dataset.colorId;
            document.querySelector(".js-review-wrapper") && !document.querySelector(".js-review-wrapper").classList.contains("hide") && document.querySelector(".js-accordion-review").click(), L.forEach(function (e) {
              e.innerText = y.dataset.productTitle;
            });
            var m = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-atc")));
            document.querySelector(".style.is-selected") || (m.forEach(function (e) {
              e.classList.contains("hide") || e.classList.add("hide");
            }), m.forEach(function (e) {
              e.innerText.trim() == r && e.classList.remove("hide");
            })), j.forEach(function (e) {
              var compareMoneyEl = e.querySelector(".price.price--compare-at .money") || e.querySelector(".price.price--compare-at .price__value"),
                finalMoneyEl = e.querySelector(".price.price--final .money") || e.querySelector(".price.price--final .price__value"),
                compareWrap = e.querySelector(".price.price--compare-at");
              finalMoneyEl && (finalMoneyEl.innerText = E.utils.toMoney(i, {
                cents: !0,
                no_zeros: !0
              }));
              if (compareMoneyEl) {
                if (hasSalePrice && n) {
                  var cmpTxt = E.utils.toMoney(n, {
                    cents: !0,
                    no_zeros: !0
                  });
                  compareMoneyEl.innerText = cmpTxt != null ? cmpTxt : '';
                } else {
                  compareMoneyEl.innerText = '';
                }
              }
              compareWrap && (hasSalePrice ? compareWrap.classList.add("js-price-compare-at-style") : compareWrap.classList.remove("js-price-compare-at-style"), compareWrap.style.display = hasSalePrice ? '' : 'none');
            }), aq.forEach(function (e) {
              e.closest('.label').classList.remove('hide');
              e.innerText = y.querySelector("span").textContent;
              q.forEach(function (c) {
                c.closest('.label').classList.add('hide');
              });
            }), 0 < [].concat(_toConsumableArray(document.querySelectorAll(".js-product-option label.is-selected"))).length && (C = document.querySelector(".js-product-option label.is-selected").dataset.option1), [].concat(_toConsumableArray(document.querySelectorAll(".swym-heart.icon-heart"))).forEach(function (e) {
              var t = e.dataset.productId;
              e.dataset.productId = o, e.classList.remove("product_" + t), e.classList.add("product_" + o);
            });
            var p = y.closest(".js-swatch label").dataset.colorId;
            [].concat(_toConsumableArray(document.querySelectorAll(".js-swatch input." + p))).forEach(function (e) {
              e.click();
            }), g.forEach(function (e) {
              e.classList.contains("hide") || e.classList.add("hide"), e.dataset.colorId == t && ("" != C && e.querySelector('label[data-option1="' + C + '"]') ? e.querySelector('label[data-option1="' + C + '"]').click() : "" != C && e.querySelector("label").click(), e.classList.remove("hide"));
            });
            var f = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-message"))),
              h = document.querySelector(".js-product-option:not(.hide)");
            f.forEach(function (e) {
              r.toUpperCase() == E.locales.product.coming_soon.toUpperCase() ? (e.innerText = E.settings.coming_soon_message, e.classList.contains("is-active") || e.classList.add("is-active")) : JSON.parse(h.dataset.anyVariantOos) ? (e.innerText = E.settings.out_of_stock_message, e.classList.contains("is-active") || e.classList.add("is-active")) : (e.innerText = "", e.classList.contains("is-active") && e.classList.remove("is-active"));
            });
            if (ssm == "true") {
              var psm = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-special-message")));
              psm.forEach(function (e) {
                e.classList.add("is-active");
                e.innerHTML = theme.settings.special_message;
              });
              var dr = document.querySelector(".desktop-range");
              if (dr && dr.innerText != "") {
                dr.classList.add("is-active");
              }
              var mr = document.querySelector(".mobile-range");
              if (mr && mr.innerText != "") {
                mr.classList.add("is-active");
              }
              var fg = document.querySelector(".js-fit-guide-option-mobile");
              if (fg) {
                fg.classList.add("is-active");
              }
            } else {
              var psm = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-special-message")));
              psm.forEach(function (e) {
                e.classList.remove("is-active");
                e.innerHTML = "";
              });
              var dr = document.querySelector(".desktop-range");
              if (dr) {
                dr.classList.remove("is-active");
              }
              var mr = document.querySelector(".mobile-range");
              if (mr) {
                mr.classList.remove("is-active");
              }
              var fg = document.querySelector(".js-fit-guide-option-mobile");
              if (fg) {
                fg.classList.remove("is-active");
              }
            }
            var v = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-tag"))),
              _ = document.querySelector("#ProductForm--desktop .js-form-add-colors .js-swatch input:checked").nextElementSibling;
            _.dataset.atcText == E.locales.product.coming_soon ? v.forEach(function (e) {
              e.innerText = "" + E.locales.product.coming_soon_tag.toUpperCase();
            }) : v.forEach(function (e) {
              e.innerText = _.dataset.tag.replace(/-/g, ' ').toUpperCase();
            }), w.forEach(function (e) {
              T(e, t);
            }), S.forEach(function (e) {
              T(e, t);
            }), k.forEach(function (e) {
              T(e, t, "mobile-image");
            }), td.forEach(function (e) {
              Z(e, t);
            }), b.forEach(function (e) {
              T(e, t);
            }), tda.forEach(function (e) {
              T(e, t);
            }), E.zoomImage();
          });
        });
      }(), w.prodSizeToggle.forEach(function (e) {
        e.addEventListener("click", function () {
          return o(w.sizeAccordion);
        });
      }), w.prodSize.length && i(), function () {
        w.prodAtc.forEach(function (e) {
          return e.addEventListener("click", E.utils.throttled(function (e) {
            t(e);
          }, 500));
        });
        var t = function t(_t) {
          _t.preventDefault();
          var e = _t.target.closest("form").querySelector(".is-selected"),
            preorder = _t.target.closest('form').querySelector('input[name="properties[Pre Order]"]'),
            preorder_el = _t.target.closest('form').querySelector('input[name="properties[Pre Order Date]"]'),
            finalSale = _t.target.closest('form').querySelector('input[name="properties[Final Sale]"]'),
            finalSaleInternal = _t.target.closest('form').querySelector('input[name="properties[_finalSale]"]'),
            o = _t.target.dataset.variantId,
            o_p = {};
          window.theme.giftPreorderPrevent = false;
          // console.log('wareshouse check 2')
          if (e && 'inventoryWarehouse' in e.dataset) {
            o_p['_warehouse'] = e.dataset.inventoryWarehouse;
          }
          if (preorder && preorder.value == 'true') {
            var date_property = new Date(preorder_el.value),
              preorder_date = Math.round(date_property / 1000),
              now_date = Math.round(Date.now() / 1000);
            if (preorder_date > now_date) {
              window.theme.giftPreorderPrevent = true;
              o_p['_preorderDate'] = preorder_el.value;
            }
          }
          if (finalSaleInternal && finalSaleInternal.value) {
            o_p['_finalSale'] = finalSaleInternal.value;
          }
          if (!e && !_t.target.classList.contains("js-open-modal") && !_t.target.classList.contains("js-app-exclusive")) {
            var i = l(o);
            if (i.isInCart) {
              var n = i.quantity + 1;
              E.cart.content.items.filter(function (e) {
                if (e.variant_id == +o && "true" !== e.properties._gift) return o = e.key, E.cart.update({
                  id: o,
                  quantity: n
                });
              });
            } else E.cart.add(o, undefined, o_p);
            return E.settings.gift_bundle_enabled && (document.querySelector(".js-cart-gift-button").disabled = !0, E.cartLoadAdd(), E.deleteGiftSessionStorage()), E.openFlyout();
          }
          if (!_t.target.classList.contains("js-open-modal") && !_t.target.classList.contains("js-app-exclusive")) {
            var r = e.dataset.variantId,
              a = l(r);
            if (a.isInCart) {
              var s = a.quantity + 1;
              E.cart.content.items.filter(function (e) {
                if (e.variant_id == +_t.target.dataset.variantId && (!e.properties || "true" !== e.properties._gift)) return r = e.key, E.cart.update({
                  id: r,
                  quantity: s
                }), E.openFlyout();
              });
            } else E.openFlyout(), E.cart.add(r, undefined, o_p);
            var c = parseInt(E.cart.content.item_count) + 1;
            1 == c && document.querySelector(".js-cart-count").classList.remove("hide"), document.querySelector(".js-cart-count>span").innerHTML = c, E.settings.gift_bundle_enabled && (document.querySelector(".js-cart-gift-button").disabled = !0, E.cartLoadAdd(), E.deleteGiftSessionStorage());
          }
        };
      }(), E.isp.outOfStock(), w.prodAtc.forEach(function (e) {
        w.prodOption.length || (e.removeAttribute("disabled"), e.classList.remove("button--secondary"), e.classList.add("button--primary"));
      });
    };
  }
}(window.theme = window.theme || {}), function () {
  function t(e) {
    var t = e.querySelector(".js-close-popup"),
      o = JSON.parse(e.dataset.settings);
    theme.utils.getCookie("hasSeenPopup") || (setTimeout(function () {
      !function (e) {
        e.classList.remove("is-hidden");
      }(e);
      document.documentElement.scrollTop;
      navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/) && document.body.scrollTop, o.allow_hide_on_scroll && window.addEventListener("scroll", theme.utils.throttle(function () {
        return function (e, t, o) {
          var i = document.documentElement.scrollTop;
          navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/) && (i = document.body.scrollTop), t + o < i && n(e);
        }(e, null, o.pixel_to_scroll);
      }, 100)), theme.utils.setCookie("hasSeenPopup", !0, o.delay);
    }, o.timing), t.addEventListener("click", function () {
      return n(e);
    }));
  }
  var n = function n(e) {
    return e.classList.add("is-hidden");
  };
  [].concat(_toConsumableArray(document.querySelectorAll(".js-container-popup"))).forEach(function (e) {
    return t(e);
  });
}(), function (e) {
  e.shop.url;
  try {
    document.querySelector(".js-related-product-gallery-shopify") && $(".js-related-product-gallery-shopify").slick({
      dots: !1,
      arrows: !1,
      infinite: !0,
      speed: 300,
      slidesToShow: 4,
      nextArrow: '<button class="slick-next slick-arrow slider-arrow slider-arrow--next" aria-label="Next" type="button" style="">Next</button>',
      prevArrow: '<button class="slick-prev slick-arrow slider-arrow slider-arrow--prev" aria-label="Previous" type="button" style="">Previous</button>',
      lazyLoad: "progressive",
      responsive: [{
        breakpoint: 996,
        settings: {
          dots: !1,
          arrows: !1,
          infinite: !0,
          speed: 300,
          slidesToShow: 2,
          centerMode: !0,
          lazyLoad: "progressive",
          variableWidth: !0,
          swipeToSlide: !0
        }
      }]
    });
  } catch (e) {
    // console.log("ST is not defined");
  }
  e.outOfStockData = e.outOfStockData || {};
}(window.theme = window.theme || {});
var productInfo = function productInfo() {
  var e = document.querySelector(".js-keep-in-view"),
    t = document.scrollingElement || document.documentElement;
  navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/) && (t = document.body), t.clientWidth > window.theme.breakpoints.md && "product" === window.theme.template.name || !e || e.classList.add("is-visible");
},
  productBreadcrumb = function productBreadcrumb() {
    var e = document.querySelector(".js-product-attribute"),
      t = window.location.href.split("/products")[0],
      o = e.querySelector(".js-product-attribute-title"),
      i = e.querySelector(".js-product-attribute-link");
    null != o && ("" == document.referrer || -1 < document.referrer.indexOf(t) && document.referrer == window.location.href) && ("" != o.dataset.fallbackType ? (o.innerText = o.dataset.fallbackType.toLowerCase(), i.href = o.dataset.fallbackUrl, i.classList.remove("attributes__link-disabled")) : (o.innerText = o.dataset.productType.toLowerCase(), i.href = "javascript:void(0)", i.classList.add("attributes__link-disabled")));
  };
if ("product" === theme.template.name ? (window.addEventListener("resize", theme.utils.throttle(productInfo, 100)), document.addEventListener("DOMContentLoaded", productInfo)) : (window.removeEventListener("resize", theme.utils.throttle(productInfo, 100)), document.removeEventListener("DOMContentLoaded", productInfo)), function () {
  var e,
    t = {
      search: document.querySelector(".js-faq-search"),
      searchError: document.querySelector(".js-faq-search-error"),
      content: document.querySelector(".js-faq-content"),
      blocks: [].concat(_toConsumableArray(document.querySelectorAll(".js-faq-block"))),
      categories: [].concat(_toConsumableArray(document.querySelectorAll(".js-faq-category"))),
      filters: [].concat(_toConsumableArray(document.querySelectorAll(".js-faq-filter"))),
      filterHeader: document.querySelector(".js-faq-filter-header")
    };
  t.filters && t.filters.forEach(function (o) {
    return o.addEventListener("click", function (e) {
      t.filterHeader.innerText = o.dataset.category, t.filters.forEach(function (e) {
        return e.style.textDecoration = e === o ? "underline" : "";
      }), e.target.parentElement.dispatchEvent(new CustomEvent("accordion:close", {
        bubbles: !0,
        detail: e.target.parentElement
      })), t.categories.forEach(function (e) {
        var t = "All" === o.dataset.category || e.dataset.category === o.dataset.category;
        e.style.display = t ? "" : "none", e.setAttribute("aria-hidden", t ? "false" : "true"), e.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(function (e) {
          e.tabIndex = t ? 0 : -1;
        });
      });
    });
  }), t.search && (e = t.filterHeader.innerText, t.search.addEventListener("keyup", function () {
    if (t.blocks.forEach(function (e) {
      e.querySelector(".faq__block__question__text").innerHTML = e.querySelector(".faq__block__question__text").innerHTML.replace(/<\/*strong>/g, ""), [].concat(_toConsumableArray(e.querySelector(".faq__block__answer").children)).forEach(function (e) {
        return e.innerHTML = e.innerHTML.replace(/<\/*strong>/g, "");
      });
    }), t.filterHeader.innerText = e, t.filters.forEach(function (e) {
      return e.style.textDecoration = "";
    }), 0 < t.search.value.length) {
      var o = !1,
        a = t.search.value.split(/\s/);
      a = (a = [].concat(_toConsumableArray(new Set(a)))).filter(function (e) {
        return 0 < e.length;
      }), t.categories.forEach(function (e) {
        var t = !1;
        [].concat(_toConsumableArray(e.querySelectorAll(".js-faq-block"))).forEach(function (e) {
          var i = !1,
            n = e.querySelector(".faq__block__question__text"),
            r = e.querySelector(".faq__block__answer");
          a.forEach(function (t) {
            var o = new RegExp("(" + t + ")", "gi");
            n.innerText.match(o) && (i = !!(i || 2 < t.length)), [].concat(_toConsumableArray(r.children)).forEach(function (e) {
              e.innerText.match(o) && (i = !!(i || 3 < t.length));
            });
          }), e.style.display = i ? "" : "none", e.setAttribute("aria-hidden", i ? "false" : "true"), t = t || i;
        }), e.style.display = t ? "" : "none", e.setAttribute("aria-hidden", t ? "false" : "true"), o = o || t;
      }), t.searchError.style.display = o ? "" : "block", t.searchError.setAttribute("aria-hidden", o ? "true" : "false");
    } else t.searchError.style.display = "", t.searchError.setAttribute("aria-hidden", "true"), t.categories.forEach(function (e) {
      e.style.display = "", e.setAttribute("aria-hidden", "false");
    }), t.blocks.forEach(function (e) {
      e.style.display = "", e.setAttribute("aria-hidden", "false");
    });
  }));
}(), function () {
  var p = {
    shows: [].concat(_toConsumableArray(document.querySelectorAll(".js-region-show"))),
    filters: [].concat(_toConsumableArray(document.querySelectorAll(".js-region-filter"))),
    items: [].concat(_toConsumableArray(document.querySelectorAll(".js-region-item")))
  };
  function e() {
    function e(s) {
      s.addEventListener("click", function (e) {
        document.querySelector(".js-region-title").innerHTML = s.innerHTML;
        var t = !0,
          o = !1,
          i = void 0;
        try {
          for (var n, r = p.items[Symbol.iterator](); !(t = (n = r.next()).done); t = !0) {
            var a = n.value;
            s.dataset.region == a.dataset.region ? a.style = "" : a.style.display = "none";
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            !t && r["return"] && r["return"]();
          } finally {
            if (o) throw i;
          }
        }
        c(s), l();
      });
    }
    var t = !0,
      o = !1,
      i = void 0;
    try {
      for (var n, r = p.filters[Symbol.iterator](); !(t = (n = r.next()).done); t = !0) {
        e(n.value);
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        !t && r["return"] && r["return"]();
      } finally {
        if (o) throw i;
      }
    }
    [].concat(_toConsumableArray(p.shows), _toConsumableArray(p.filters)).forEach(function (e) {
      return e.addEventListener("click", function (e) {
        e.target.parentElement.dispatchEvent(new CustomEvent("accordion:close", {
          bubbles: !0,
          detail: e.target.parentElement
        }));
      });
    });
  }
  function t() {
    function e(a) {
      a.addEventListener("click", function (e) {
        document.querySelector(".js-region-title").innerHTML = a.innerHTML;
        var t = !0,
          o = !1,
          i = void 0;
        try {
          for (var n, r = p.items[Symbol.iterator](); !(t = (n = r.next()).done); t = !0) {
            n.value.style = "";
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            !t && r["return"] && r["return"]();
          } finally {
            if (o) throw i;
          }
        }
        c(a), l();
      });
    }
    var t = !0,
      o = !1,
      i = void 0;
    try {
      for (var n, r = p.shows[Symbol.iterator](); !(t = (n = r.next()).done); t = !0) {
        e(n.value);
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        !t && r["return"] && r["return"]();
      } finally {
        if (o) throw i;
      }
    }
  }
  function c(e) {
    var t = !0,
      o = !1,
      i = void 0;
    try {
      for (var n, r = p.filters[Symbol.iterator](); !(t = (n = r.next()).done); t = !0) {
        var a = n.value;
        a.className = a.className.replace(/is-active/, "");
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        !t && r["return"] && r["return"]();
      } finally {
        if (o) throw i;
      }
    }
    var s = !0,
      c = !1,
      l = void 0;
    try {
      for (var d, u = p.shows[Symbol.iterator](); !(s = (d = u.next()).done); s = !0) {
        var m = d.value;
        m.className = m.className.replace(/is-active/, "");
      }
    } catch (e) {
      c = !0, l = e;
    } finally {
      try {
        !s && u["return"] && u["return"]();
      } finally {
        if (c) throw l;
      }
    }
    e.classList.add("is-active");
  }
  function l() {
    var e = !0,
      t = !1,
      o = void 0;
    try {
      for (var i, n = p.items[Symbol.iterator](); !(e = (i = n.next()).done); e = !0) {
        var r = i.value;
        r.className = r.className.replace(/store-grid--\d+-\d+/, "");
      }
    } catch (e) {
      t = !0, o = e;
    } finally {
      try {
        !e && n["return"] && n["return"]();
      } finally {
        if (t) throw o;
      }
    }
    for (var a = 1, s = 1, c = 1, l = !1, d = 0; d < p.items.length; d++) {
      var u = p.items[d];
      "none" != u.style.display && (l ? l = !1 : "IMG" == u.tagName ? (l = !0, c = c ? (u.classList.add("store-grid--" + s + "-" + a), p.items[d + 1].classList.add("store-grid--" + (s + 1) + "-" + a), 0) : (u.classList.add("store-grid--" + (s + 1) + "-" + a), p.items[d + 1].classList.add("store-grid--" + s + "-" + a), 1), a++) : (u.classList.add("store-grid--" + s + "-" + a), 2 < ++s && a++));
    }
  }
  e(), t();
}(jQuery), function (i) {
  var e;
  !function () {
    if (i.settings.account_toggle) {
      var e = [].concat(_toConsumableArray(document.querySelectorAll(".js-customer-toggle"))),
        t = document.querySelector(".js-customer-register"),
        o = document.querySelector(".js-customer-login");
      e.forEach(function (e) {
        e.addEventListener("click", function (e) {
          e.preventDefault(), t.classList.toggle("hide-until@md"), o.classList.toggle("hide-until@md");
        });
      });
    }
  }(), e = document.querySelector(".js-customer-activation-button"), -1 < window.location.href.indexOf("account?from=registration") && e.click(), function () {
    if (-1 < window.location.href.indexOf("account/login?from=loyalty-program")) {
      var e = "/pages/loyalty-program";
      document.getElementById("CreateCustomer").insertAdjacentHTML("afterbegin", '<input type="hidden" value="' + e + '" name="return_to">'), document.getElementById("CustomerLogin").insertAdjacentHTML("afterbegin", '<input type="hidden" value="' + e + '" name="return_to">');
    }
  }(), function () {
    if (-1 < window.location.href.indexOf("account/login?from=header-wishlist")) {
      var e = "/pages/custom-wishlist";
      document.getElementById("CreateCustomer").insertAdjacentHTML("beforeend", '<input type="hidden" value="' + e + '" name="return_to">'), document.getElementById("CustomerLogin").insertAdjacentHTML("afterbegin", '<input type="hidden" value="' + e + '" name="return_to">');
    }
  }(), window.theme = i;
}(window.theme), function (o) {
  var i = "product" == o.template.name && "bundle" == o.template.suffix ? "bundle" : "product";
  if ("product" == o.template.name && "addresses" == o.template.name) return;
  var n = {
    header: document.querySelector(".js-header"),
    announcement: document.querySelector(".js-announcement"),
    breadcrumb: document.querySelector(".js-breadcrumb"),
    headerContainer: document.querySelector(".js-header-container")
  },
    r = {
      prodInfo: "bundle" == i ? document.querySelector(".js-product-bundle-wrapper") : document.querySelector(".js-product-info"),
      prodMobImg: document.querySelector(".js-prod-mob-image"),
      prodDeskImg: document.querySelector(".js-prod-desk-image")
    };
  function a() {
    "product" == window.theme.template.name && e(), t();
  }
  window.onresize = function (e) {
    var t = void 0;
    clearTimeout(t), t = setTimeout(a, 100);
  };
  var e = function e() {
    // var e = document.querySelector(".js-prod-desk-image:not(.hide)") ? document.querySelector(".js-prod-desk-image:not(.hide)") : document.querySelector(".js-prod-desk-image"),
    //     t = void 0,
    //     o = document.querySelector(".js-product-bundle-featured-image .js-zoom");
    // t = "bundle" == i ? 4 * (o.offsetHeight + 25) + 150 : e.offsetHeight, r.prodInfo && ($(window).width() > window.theme.breakpoints.md ? r.prodInfo.style.maxHeight = t + "px" : r.prodInfo.style.height = "auto")
  };
  var t = function t() {
    var e = n.headerContainer.offsetHeight,
      t = ".js-" + window.theme.template.name;
    //document.getElementById("MainContent").style.marginTop = e + "px", "product" != o.template.name ? n.breadcrumb ? (n.breadcrumb.style.top = (s(), s() + "px"), document.querySelector(t).style.marginTop = n.breadcrumb.offsetHeight + s() + "px") : document.querySelector(t) && (document.querySelector(t).style.marginTop = s() + "px") : document.querySelector(t) && $(window).width() < window.theme.breakpoints.md && "bundle" != o.template.suffix && (document.querySelector(t).style.marginTop = s() + "px")
  },
    s = function s() {
      return document.querySelector(".js-header-container").offsetHeight;
    },
    c = window.pageYOffset;
  window.onscroll = function () {
    var e = window.pageYOffset,
      t = ".js-" + window.theme.template.name;
    //n.breadcrumb && (c < 0 || e < c && n.breadcrumb ? (n.breadcrumb.classList.remove("scroll-down"), n.breadcrumb.style.top = (s(), s() + "px"), document.querySelector(t).style.marginTop = n.breadcrumb.offsetHeight + s() + "px") : document.querySelector(t) && n.breadcrumb && n.breadcrumb.classList.add("scroll-down"), c = e)
  };

  function l() {
    $(window).width() > window.theme.breakpoints.md && e();
  }
  var d, u, m;
  m = ".js-" + window.theme.template.name, "bundle" != o.template.suffix && "product" == o.template.name && l(), n.breadcrumb && "product" != o.template.name && (n.breadcrumb.style.top = s() + "px", document.querySelector(m).style.marginTop = n.breadcrumb.offsetHeight + s() + "px"), t(), d = document.querySelector("header"), u = document.querySelector(".js-announcement-remove"), d.classList.contains("js-announcement-bar-active") && (u.onclick = function () {
    var e = document.querySelector("#ui-id-1.ui-autocomplete");
    e && e.classList.contains("add-globale") && (e.classList.remove("add-globale"), e.classList.add("no-announcement")), d.classList.remove("js-announcement-bar-active"), t();
  }), window.theme.initCalculateHeight = l;
}(window.theme), function (v) {
  function i() {
    var e = [].concat(_toConsumableArray(document.querySelectorAll(".js-read-more")));
    e.forEach(function (e) {
      e.onclick = function () {
        this.closest(".js-review").querySelector(".js-initial-review-comment").classList.toggle("is-active"), this.classList.toggle("review__read-more--active"), this.classList.contains("review__read-more--active") ? this.innerText = v.locales.general.review.read_less : this.innerText = v.locales.general.review.read_more;
      };
    });
  }
  function n() {
    var e = void 0;
    switch (v.shop.domain) {
      case "www.aninebing.com":
        e = "PROzW4b465I9n5LmsIeARiCOAHvgJRUYkDTpY76F";
        break;
      case "eu.aninebing.com":
        e = "dWvnf4oVLG2vJoHvchXVtb2g8AkqIP7GoQcPZNB0";
        break;
      case "anine-bing-dev01-us.myshopify.com":
        e = "9BOd25iwVsDnNcJHiY30jFOSZ8l3P99QpqiH9iRn";
    }
    return e;
  }
  function s() {
    document.querySelector(".js-review-load-more") && (document.querySelector(".js-review-load-more").onclick = function () {
      !function (t) {
        if ("product" == v.template.name) {
          var e = "&page=" + t,
            o = v.product.id;
          $.get("https://api.yotpo.com/v1/widget/" + n() + "/products/" + o + "/reviews.json?sort=date" + e, function (e) {
            e.response.bottomline.total_review, e.response.pagination.per_page;
            r(e, t);
          }).done(function (e, t, o) {
            i();
          });
        }
      }(parseInt(this.getAttribute("data-current-page")) + 1);
    });
  }
  function _(e, t) {
    for (var o = "", i = 0; i < e; i++) o += i < t ? window.theme.svgs.star.filled : window.theme.svgs.star.empty;
    return o;
  }
  function e() {
    if ("product" === v.template.name) {
      var t = {
        modal: document.querySelector(".js-create-review-modal"),
        form: document.querySelector(".js-create-review-form"),
        starsContainer: document.querySelector(".js-create-review-stars"),
        firstName: document.querySelector("#CreateReviewFirstName"),
        lastName: document.querySelector("#CreateReviewLastName"),
        email: document.querySelector("#CreateReviewEmail"),
        city: document.querySelector("#CreateReviewCity"),
        province: document.querySelector("#CreateReviewProvince"),
        title: document.querySelector("#CreateReviewTitle"),
        content: document.querySelector("#CreateReviewContent"),
        success: document.querySelector(".js-create-review-success")
      },
        o = n();
      (function (e) {
        for (var o = [], t = function t(e) {
          var t = document.createElement("button");
          t.setAttribute("type", "button"), t.innerHTML = window.theme.svgs.star.empty, t.dataset.score = e, t.classList.add("js-create-review-star"), t.setAttribute("aria-label", e + " stars"), t.setAttribute("aria-selected", e == 5 ? true : false), t.addEventListener("click", function () {
            return a(e);
          }), o.push(t);
        }, i = 1; i <= e; i++) t(i);
        return o;
      })(5).forEach(function (e) {
        return t.starsContainer && t.starsContainer.appendChild(e);
      }), t.starsContainer && t.starsContainer.lastChild.click(), t.form && t.form.addEventListener("submit", function (e) {
        // e.preventDefault(), t.starsContainer.dataset.score && o && $.post("https://api.yotpo.com/v1/widget/reviews", {
        //     appkey: o,
        //     domain: v.shop.domain,
        //     sku: v.product.id,
        //     product_title: v.product.title,
        //     product_url: window.location.href,
        //     display_name: t.firstName.value + " " + t.lastName.value,
        //     email: t.email.value,
        //     review_content: t.content.value,
        //     review_title: t.title.value,
        //     review_score: t.starsContainer.dataset.score,
        //     customer_metadata: {
        //         custom_properties: [{
        //             name: "city",
        //             value: t.city.value
        //         }, {
        //             name: "province",
        //             value: t.province.value
        //         }]
        //     }
        // }).done(function () {
        //     t.modal.style.display = "none", t.success.style.display = "block", setTimeout(function () {
        //         document.querySelector("#CreateReviewModal").querySelector(".js-close-modal").click()
        //     }, 4e3)
        // })
      });
    }
  }
  var r = function r(e, t) {
    if (document.querySelector(".js-review-label")) {
      var o = +e.response.bottomline.total_review / +e.response.pagination.per_page,
        to = e.response.bottomline.total_review,
        i = v.locales.general.review.load_more,
        ecount = 0,
        h = v.locales.general.review.read_more;
      e.response.reviews.forEach(function (e) {
        var t = e.user.display_name,
          o = e.content,
          i = e.id,
          n = e.created_at.split("T")[0].split("-"),
          r = n[0],
          a = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"][parseInt(n[1]) - 1],
          s = n[2],
          c = +v.locales.general.review.split_by,
          l = e.score,
          d = _(5, l),
          u = void 0,
          m = function (e, t) {
            var o = [];
            if (e.length > t) {
              var i = e.substring(0, t),
                n = void 0;
              if (" " != i[e.length - 1]) {
                var r = i.lastIndexOf(" ");
                i = e.substring(0, r), n = e.substring(r, e.length);
              }
              o.push(i), o.push(n);
            } else o.push(e);
            return o;
          }(o, c);
        u = 1 < m.length ? '\n            <div class="review__content js-review">\n              <div class="review__user">\n                <span class="review__author">' + t + '</span>\n                <span class="review__star">' + d + '</span>\n              </div>\n              <p class="review__date">' + a + " " + s + ", " + r + '</p>\n              <span class="review__comment review__comment--split js-initial-review-comment">' + m[0] + '</span>\n              <span class="review__comment-initial js-review-comment js-accordion-content" id="readmore_content-' + i + '">' + m[1] + '</span>\n                <a class="review__read-more-wrapper">\n                  <button role="button" class="review__read-more link link--primary js-read-more js-accordion" data-toggle=\'{ "target": "readmore_content-' + i + "\"}'>" + h + "</button>\n                </a>\n              </div>\n            </div>" : '\n            <div class="review__content js-review">\n              <div class="review__user">\n                <span class="review__author">' + t + '</span>\n                <span class="review__star">' + d + '</span>\n              </div>\n              <p class="review__date">' + a + " " + s + ", " + r + '</p>\n              <div class="review__comment js-initial-review-comment">' + m[0] + "</div>\n              </div>\n            </div>";
        var p = document.querySelector(".js-review-load-more"),
          f = document.querySelector(".js-review-wrapper");
        ecount++;
        if (to == 1) {
          p ? p.insertAdjacentHTML("beforebegin", u) : f && f.insertAdjacentHTML("beforeend", u);
        } else {
          if (ecount > 1) {
            p ? p.insertAdjacentHTML("beforebegin", u) : f && f.insertAdjacentHTML("beforeend", u);
          }
        }
      }), initToggleAccordion();
      // var n = '<button class="review__load-more button button--secondary js-review-load-more" data-current-page="' + t + '">' + i + "</button>",
      //@wx-merge: Allyant ADA Updates 
      var n = '<button class="review__load-more button button--secondary js-review-load-more" data-current-page="' + t + '"><span aria-hidden="true">' + i + '</span><span class="sr-only">Click to ' + i + ' reviews</span></button>',
        //@end-wx-merge: Allyant ADA Updates 
        r = document.querySelector(".js-review-load-more"),
        a = document.querySelector(".js-review-wrapper");
      Math.ceil(o) > t ? r ? r.setAttribute("data-current-page", t) : a.insertAdjacentHTML("beforeend", n) : r && r.classList.add("hide"), s();
    }
  },
    a = function a(t) {
      var e = document.querySelectorAll(".js-create-review-star");
      document.querySelector(".js-create-review-stars").dataset.score = t, e.forEach(function (e) {
        e.dataset.score <= t ? e.innerHTML = window.theme.svgs.star.filled : e.innerHTML = window.theme.svgs.star.empty;
      });
    };
  !function () {
    if ("product" == v.template.name) {
      var e = v.product.id;
      $.get("https://api.yotpo.com/v1/widget/" + n() + "/products/" + e + "/reviews.json?sort=date", function (e) {
        var t = e.response.bottomline.average_score,
          o = e.response.bottomline.total_review,
          i = _(5, t);
        // @wixob-updated: reviews rating
        if ($(".js-yotpo-product").length > 0) {
          $(".sr-rating-count").append(" " + t);
        }
        // @wixob-updated: end reviews rating
        document.querySelector(".js-yotpo-product") && (document.querySelector(".js-yotpo-product").innerHTML = i, document.querySelector(".js-review-label") && (document.querySelector(".js-review-label").innerHTML = v.locales.product.review + " (" + o + ")")), r(e, 1);
      }).done(function (e) {
        i();
      });
    }
  }(), s(), e(), window.theme = v;
}(window.theme || {}), $(document).ready(function () {
  !function () {
    var t = document.querySelector(".js-sale-gateway-input");
    if (t) {
      var o = [].concat(_toConsumableArray(document.querySelectorAll(".js-sale-gateway-submit")));
      t.addEventListener("blur", function () {
        return function (e, t) {
          var o = e.closest(".js-form").querySelector(".error-msg"),
            i = o.dataset.previousErrorMessage;
          !e.parentElement.classList.contains("has-error") && e.value || (t.forEach(function (e) {
            return e.disabled = !0;
          }), o.innerText = i);
        }(t, o);
      }), t.addEventListener("keyup", function (e) {
        13 === e.keyCode ? o[0].click() : function (e, t) {
          e.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) && t.forEach(function (e) {
            return e.disabled = !1;
          });
        }(t, o);
      });
    }
  }();
}), function () {
  if ("custom-wishlist" == theme.template.suffix) {
    var currencies = {
      USD: "$",
      GBP: "£",
      EUR: "€",
      ILS: "₪",
      AFN: "Af",
      DZD: "DA",
      ARS: "AR$",
      AMD: "AMD",
      AWG: "Afl.",
      AUD: "AU$",
      AZN: "man.",
      BSD: "BS$",
      BHD: "BD",
      THB: "฿",
      PAB: "B/.",
      BBD: "Bds$",
      BYR: "BYR",
      BZD: "BZ$",
      BMD: "BD$",
      BOB: "Bs",
      BRL: "R$",
      BND: "BN$",
      BGN: "BGN",
      BIF: "FBu",
      CAD: "CA$",
      CVE: "CV$",
      KYD: "KY$",
      XOF: "CFA",
      XAF: "XAF",
      XPF: "CFPF",
      CLP: "CL$",
      COP: "COP",
      KMF: "CF",
      CDF: "CDF",
      BAM: "KM",
      NIO: "NIO",
      CRC: "₡",
      CUP: "CU$",
      CZK: "Kč",
      GMD: "GMD",
      DKK: "kr",
      MKD: "MKD",
      DJF: "Fdj",
      STD: "Db",
      DOP: "RD$",
      VND: "₫",
      XCD: "EC$",
      EGP: "EGP",
      ETB: "Br",
      FKP: "FK£",
      FJD: "FJ$",
      HUF: "Ft",
      GHS: "GH₵",
      HTG: "HTG",
      PYG: "₲",
      GNF: "FG",
      GYD: "GY$",
      HKD: "HK$",
      UAH: "₴",
      ISK: "kr",
      INR: "₹",
      IRR: "IRR",
      IQD: "IQD",
      JMD: "J$",
      JOD: "JD",
      KES: "KSh",
      PGK: "PGK",
      LAK: "₭",
      KWD: "KD",
      MWK: "MWK",
      AOA: "Kz",
      MMK: "MMK",
      GEL: "GEL",
      LBP: "LBP",
      ALL: "ALL",
      HNL: "HNL",
      SLL: "Le",
      LRD: "L$",
      LYD: "LD",
      SZL: "SZL",
      LSL: "LSL",
      MGA: "MGA",
      MYR: "RM",
      MUR: "MURs",
      MXN: "Mex$",
      MDL: "MDL",
      MAD: "MAD",
      MZN: "MTn",
      NGN: "₦",
      ERN: "Nfk",
      NAD: "N$",
      NPR: "NPRs",
      ANG: "NAf.",
      RON: "RON",
      TWD: "NT$",
      NZD: "NZ$",
      BTN: "Nu.",
      KPW: "KPW",
      NOK: "kr",
      PEN: "S/.",
      MRO: "UM",
      TOP: "T$",
      PKR: "Rs",
      MOP: "MOP$",
      UYU: "$U",
      PHP: "₱",
      BWP: "BWP",
      QAR: "QR",
      GTQ: "GTQ",
      ZAR: "R",
      OMR: "OMR",
      KHR: "KHR",
      MVR: "MVR",
      IDR: "Rp",
      RUB: "RUB",
      RWF: "RWF",
      SHP: "SH£",
      SAR: "SAR",
      RSD: "din.",
      SCR: "SRe",
      SGD: "S$",
      SBD: "SI$",
      KGS: "KGS",
      SOS: "Ssh",
      TJS: "TJS",
      LKR: "SLRs",
      SDG: "SDG",
      SRD: "SR$",
      SEK: "kr",
      CHF: "CHF",
      SYP: "SY£",
      BDT: "Tk",
      WST: "WS$",
      TZS: "TSh",
      KZT: "KZT",
      TTD: "TT$",
      MNT: "₮",
      TND: "DT",
      TRY: "TL",
      TMT: "TMT",
      AED: "AED",
      UGX: "USh",
      UZS: "UZS",
      VUV: "VT",
      KRW: "₩",
      YER: "YR",
      JPY: "¥",
      CNY: "CN¥",
      ZMW: "ZMW",
      ZWL: "ZWL",
      PLN: "zł",
      BYN: "BYN"
    };
    var current_currency = currencies[window.Shopify.currency.active];
    var o = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_o, e) {
        var t, i, n;

        function fetchProductDetails(productHandle, e) {
          return new Promise((resolve, reject) => {
            $.get(`/products/${productHandle}?view=json`, function (resp) {
              try {
                var obj = JSON.parse(resp);
                e.pr = Number(obj.price / 100).toLocaleString('en-US').replace(',', '');
                e.cu = current_currency;
                e.variants = obj.variants;
                $("#wishlist-items-container span[data-empi=\"".concat(obj.id, "\"]")).html(current_currency + e.pr);

                resolve(e); // Resolve with the updated product object
              } catch (error) {
                console.error('Error processing product details:', error);
                reject(error);
              }
            });
          });
        }

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              t = document.getElementById("wishlist-items-container");
              if (!t) {
                _context2.next = 7;
                break;
              }
              _context2.next = 4;
              return Promise.all(e.map( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
                  var productHandleArr, productHandle, t;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        productHandleArr = e.du.split('/');
                        productHandle = productHandleArr[productHandleArr.length - 1].split('?')[0];
                        _context.next = 4;
                        return fetchProductDetails(productHandle, e);
                      case 4:
                        var epi = e.epi;
                        t = (e = SwymUtils.formatProductPrice(e)).dt.split("- ");
                        return _context.abrupt("return", (
                          e.colorAssociated = !1,
                          1 < t.length && (e.genericTitle = t[0], e.color = t[1], e.colorAssociated = !0),
                          e.remove = theme.svgs.remove,
                          e.isInCart = _o.platform.isInDeviceCart(e.epi) || e.et == _o.EventTypes.addToCart,
                          e.variantinfo = e.variants ? function (t) {
                            try {
                              var e = t;
                              const v = e.find(ve => ve.id === epi);
                              const o = e.length > 0 ? (v.title === "Default Title" ? "" : v.title) : "";
                              return o;
                            } catch (e) {
                              // console.log('error e = ', e);
                              return t;
                            }
                          }(e.variants) : "", e));
                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x3) {
                  return _ref8.apply(this, arguments);
                };
              }()));
            case 4:
              i = _context2.sent;
              n = SwymUtils.renderTemplateString(p, {
                products: i.map(product => ({
                  ...product,
                  allVariants: product.variants || []
                }))
              });
              t.innerHTML = n;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function o(_x, _x2) {
        return _ref7.apply(this, arguments);
      };
    }(),
      i = function i(t, e) {
        n(t, e, function (e) {
          console.time("Second Render Update OOS Products"), o(t, e), a(!0), console.timeEnd("Second Render Update OOS Products");
        });
      },
      n = function n(i, _n, r) {
        _n.forEach(function (e, t) {
          console.time("Fetching Complete Details for Each Product Begin GetProductDetails");
          var o = {
            epi: e.epi,
            empi: e.empi,
            du: e.du
          };
          i.getProductDetails(o, function (e) {
            _n.forEach(function (t) {
              t.empi == e.id && (t.comingSoon = !!e.tags.includes("swym-comingsoon"), t.comingSoon && r(_n), e.variants.forEach(function (e) {
                t.epi != e.id || e.available || (t.isOOS = !e.available, r(_n));
              }));
            });
          }), console.timeEnd("Fetching Complete Details for Each Product Begin GetProductDetails");
        });
      },
      r = function r(o) {
        o.preventDefault(), theme.openFlyout();
        var e = o.target.getAttribute("data-product-id"),
          i = o.target.getAttribute("data-variant-id"),
          t = o.target.getAttribute("data-url");
        o.target.innerHTML = l, window._swat.replayAddToCart({
          empi: e,
          du: t
        }, i, function (e) {
          o.target.innerHTML = c;
          var t = _(i);
          t.isInCart ? theme.cart.update({
            id: i,
            quantity: t.quantity + 1
          }) : ($(document).trigger("Cart:add", JSON.parse(e)), theme.cart.update({
            id: i,
            quantity: 1
          })), console.log("Successfully added product to cart.");
          var removeButton = o.target.closest(".cart__item-details").querySelector(".js-remove-cart-item");
          if (removeButton) {
            removeButton.click();
          }
        }, function (e) {
          // console.log(e);
        });
      },
      k = function k(o) {
        o.preventDefault();
        const e = o.target.getAttribute("data-dropdown-id");
        if (o.target.classList.contains('is-active')) {
          o.target.classList.remove('is-active');
          document.querySelector(`#${e}`).classList.remove('open');
        } else {
          const dp = [].concat(_toConsumableArray(document.querySelectorAll(".cart__item-dropdown-panel")));
          dp.forEach(function (p) {
            p.classList.remove('open');
          });
          const dt = [].concat(_toConsumableArray(document.querySelectorAll(".custom-wishlist .cart__item-options-container .dropdown__trigger")));
          dt.forEach(function (p) {
            p.classList.remove('is-active');
          });
          o.target.classList.add('is-active');
          document.querySelector(`#${e}`).classList.add('open');
        }
      },
      w = function w(o) {
        o.preventDefault();
        const e = o.target.getAttribute("data-product-id"),
          i = o.target.getAttribute("data-variant-id"),
          t = o.target.getAttribute("data-url"),
          a = parseInt(o.target.getAttribute("data-inventory")),
          b = o.target.getAttribute("data-coming-soon"),
          f = o.target.getAttribute("data-variant-price"),
          q = o.target.innerHTML;
        const z = o.target.closest('.cart__item');
        const m = z.querySelector('.cart__item-details .cart__item-out-of-stock.is-coming-soon');
        const n = z.querySelector('.cart__item-details .js-add-to-cart');
        const k = z.querySelector('.cart__item-details .cart__item-out-of-stock.is-oos');

        if (b != "true") {
          if (a > 0) {
            n.setAttribute('data-product-id', e);
            n.setAttribute('data-variant-id', i);
            n.setAttribute('data-url', t);
            n.classList.remove('hide');
            m.classList.add('hide');
            k.classList.add('hide');
          } else {
            k.setAttribute('data-id', e);
            k.setAttribute('data-product-id', e);
            k.setAttribute('data-variant-id', i);
            k.setAttribute('data-url', t);
            k.setAttribute('data-price', f);
            k.setAttribute('data-pr', f);
            k.setAttribute('data-variant-info', q);
            n.classList.add('hide');
            m.classList.add('hide');
            k.classList.remove('hide');
          }
        } else {
          m.setAttribute('data-price', f);
          m.setAttribute('data-variant-id', i);
          m.setAttribute('data-id', e);
          m.setAttribute('data-variant-info', q);
          n.classList.add('hide');
          m.classList.remove('hide');
          k.classList.add('hide');
        }

        const d = z.querySelector('.dropdown__trigger');
        d.innerHTML = q;
        const p = z.querySelector('[id*="js-dropdown-container--"]');
        d.classList.remove('is-active');
        p.classList.remove('open');
        const pb = [].concat(_toConsumableArray(p.querySelectorAll('.js-cart-item-option')));
        pb.forEach(function (e) {
          e.classList.remove('is-selected');
        });
        o.target.classList.add('is-selected');

      },
      a = function a(e) {
        var t = [].concat(_toConsumableArray(document.querySelectorAll(".custom-wishlist .js-cart-item .js-remove-cart-item"))),
          o = [].concat(_toConsumableArray(document.querySelectorAll(".custom-wishlist .js-add-to-cart")));
        document.querySelector(".js-share-wishlist").addEventListener("click", function () {
          y();
        }), /*t.forEach(function (e) {
          e.addEventListener("click", s, !1);
        }), o.forEach(function (e) {
          return e.addEventListener("click", r, !1);
        }),*/ e && [].concat(_toConsumableArray(document.querySelectorAll(".custom-wishlist .js-out-of-stock-trigger"))).forEach(function (e) {
          g(e), e.onclick = function () {
            b(e);
          };
        });
      },
      j = function j(e) {
        $(document).on('click', '.custom-wishlist .js-cart-item .js-remove-cart-item', s);
        $(document).on('click', '.custom-wishlist .js-add-to-cart', r);
        $(document).on('click', '.custom-wishlist .js-out-of-stock-trigger', b);
        $(document).on('click', '.custom-wishlist .cart__item-options-container .dropdown__trigger', k);
        $(document).on('click', '.custom-wishlist .cart__item .dropdown__list button', w);
      },
      s = function s(e) {
        e.preventDefault();
        var i = e.target,
          t = e.target.closest("button").getAttribute("data-product-id"),
          o = e.target.closest("button").getAttribute("data-variant-id");
        v.forEach(function (e) {
          e.empi == t && e.epi == o && window._swat.removeFromWishList(e, function (e) {
            var t = i.closest(".js-remove-cart-item"),
              o = [].concat(_toConsumableArray(document.querySelectorAll(".custom-wishlist .js-cart-item")));
            t.closest(".js-cart-item").remove(), o.length - 1 < 1 && (document.querySelector(".js-share-wishlist").classList.add("hide"), d.innerHTML = f);
          });
        });
      },
      c = theme.locales.customer.wishlist.add,
      e = theme.locales.customer.wishlist.empty,
      t = theme.locales.customer.wishlist.continue_shopping,
      l = theme.locales.customer.wishlist.adding,
      d = document.getElementById("wishlist-items-container"),
      u = document.querySelector(".js-wishlist-link-copied"),
      m = theme.locales.customer.wishlist.loading,
      // p = '\n      <ul class="cart__items">\n        {{#products}}\n          <li class="cart__item js-cart-item">\n            <a class="cart__item-image" href="{{du}}" aria-label="Link to {{dt}}">\n              <img class="grid-view-item__image lazyautosizes" src="{{{iu}}}" alt="{{dt}}" />\n            </a>\n            <div class="cart__item-details">\n              <p class="cart__item-title uppercase-text js-cart-item-title">\n                {{#colorAssociated}}{{genericTitle}}<br><span class="text-title-space">{{ color }}</span>{{/colorAssociated}}\n                {{^colorAssociated}}{{dt}}{{/colorAssociated}}\n              </p>\n              <p class="test1 cart__item-price-container price js_thm1" data-price="">\n                <span class="test4 cart__item-price cart__item-price--final small-text js-cart-item-price" data-empi="{{ empi }}">\n                  {{cu}}{{pr}}\n                </span>\n              </p>\n              <div>\n                <div class="cart__item-options-container">\n                  <button class="cart__item-option-single-variant cart__item-option-selected dropdown__trigger  js-selected-option" aria-label="Variant selector" aria-expanded="false" data-variant-price="{{pr}}" data-variant-id="{{id}}" data-inventory="{{inventory_quantiy}}" data-toggle="{&quot;target&quot;:&quot;js-dropdown-container--{{epi}}--cart-flyout&quot;,&quot;group&quot;:&quot;js-dropdown-container&quot;, &quot;focusTarget&quot;: &quot;js-dropdown-container&quot;, &quot;closeOnUnfocus&quot;: true}">\n                    <span class="small-text">{{variantinfo}}</span>\n                  </button>\n                  {{#allVariants}}\n                    {{#.}}\n                      <div id="js-dropdown-container--{{epi}}--cart-flyout" class="cart__item-dropdown dropdown__list js-dropdown-container" style="height: 0px;" aria-hidden="true">\n                        <button tabindex="-1"  aria-label="{{dt}}" class="cart__item-option js-cart-item-option small-text" \n                          data-product-id="{{empi}}" \n                          data-image="{{iu}}" \n                          data-price="{{pr}}"\n                          data-variant-price="{{pr}}" \n                          data-variant-id="{{id}}" \n                          data-inventory="{{inventory_quantity}}"\n                          data-oversell="">{{title}}</button>\n                      </div>\n                    {{/.}}\n                  {{/allVariants}}\n                </div>\n              </div>\n              {{#comingSoon}}\n                <a class="cart__item-out-of-stock cart__item-add link link--primary js-out-of-stock-trigger is-coming-soon" data-modal-target="#coming-soon-modal" name="modal" role="button" aria-label="button" data-price="{{pr}}" data-variant-id="{{epi}}" data-id="{{empi}}" data-image="{{iu}}" data-variant-info="{{variantinfo}}" data-title="{{dt}}" data-atc-text="' + theme.locales.cart.coming_soon + '">' + theme.locales.cart.coming_soon + '</a>\n                <p class="cart__item-error-message small-text js-cart-error-message"></p>\n              {{/comingSoon}}\n              {{^comingSoon}}\n                {{^isOOS}}\n                <a class="cart__item-add heading--3 js-add-to-cart" href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" aria-label="Add {{dt}} to Cart" data-atc-text="' + c + '">\n                  ' + c + '\n                </a>\n                {{/isOOS}}\n                {{#isOOS}}\n                  <a class="cart__item-out-of-stock cart__item-add link link--primary js-out-of-stock-trigger is-oos" data-modal-target="#my-signup-modal" name="modal" role="button" aria-label="button" data-price="{{pr}}" data-variant-id="{{epi}}" data-id="{{empi}}" data-image="{{iu}}" data-variant-info="{{variantinfo}}" data-title="{{dt}}" data-atc-text="' + theme.locales.cart.out_of_stock + '" data-iu="{{iu}}" data-pr="{{pr}}" data-product-id="{{empi}}" data-url="{{du}}">' + theme.locales.cart.out_of_stock + '</a>\n                  <p class="cart__item-error-message small-text js-cart-error-message"></p>\n                {{/isOOS}}\n              {{/comingSoon}}\n              <button class="cart__item-remove cart__item-remove--wishlist js-remove-cart-item" data-id="{{_id}}" data-product-id="{{empi}}" data-variant-id="{{epi}}" aria-label="Remove {{dt}} from Wishlist">\n                {{{remove}}}\n              </button>\n            </div>\n          </li>\n        {{/products}}\n      </ul>\n      <input class="custom-wishlist__share-url js-share-wishlist-clipboard" type="text" />\n    ',
      // p = '\n      <ul class="cart__items">\n        {{#products}}\n          <li class="cart__item js-cart-item">\n            <a class="cart__item-image" href="{{du}}" aria-label="Link to {{dt}}">\n              <img class="grid-view-item__image lazyautosizes" src="{{{iu}}}" alt="{{dt}}" />\n            </a>\n            <div class="cart__item-details">\n              <p class="cart__item-title uppercase-text js-cart-item-title">\n                {{#colorAssociated}}{{genericTitle}}<br><span class="text-title-space">{{ color }}</span>{{/colorAssociated}}\n                {{^colorAssociated}}{{dt}}{{/colorAssociated}}\n              </p>\n              <p class="test2 cart__item-price-container price js_thm2" data-price="">\n                <span class="test6 cart__item-price cart__item-price--final small-text js-cart-item-price" data-empi="{{ empi }}">\n                  {{cu}}{{pr}}\n                </span>\n              </p>\n              <div style="position: absolute; bottom: 0;">\n                <div class="cart__item-options-container">\n                  <button class="cart__item-option-single-variant cart__item-option-selected dropdown__trigger  js-selected-option" aria-label="Variant selector" aria-expanded="false" data-variant-price="{{pr}}" data-variant-id="{{id}}" data-inventory="{{inventory_quantiy}}" data-dropdown-id="js-dropdown-container--{{epi}}" data-toggle="{&quot;target&quot;:&quot;js-dropdown-container--{{epi}}--cart-flyout&quot;,&quot;group&quot;:&quot;js-dropdown-container&quot;, &quot;focusTarget&quot;: &quot;js-dropdown-container&quot;, &quot;closeOnUnfocus&quot;: true}">\n                    {{variantinfo}}\n                  </button>\n                </div>\n              </div>\n				<div id="js-dropdown-container--{{epi}}" class="cart__item-dropdown cart__item-dropdown-panel dropdown__list js-dropdown-container">\n			      {{#allVariants}}\n                    {{#.}}\n			          	<div id="js-dropdown-container--{{epi}}--cart-flyout" class="cart__item-dropdown dropdown__list-item js-dropdown-container" style="height: auto;">\n                        <button tabindex="-1"  aria-label="{{dt}}" class="cart__item-option js-cart-item-option small-text" \n                          data-product-id="{{empi}}" \n                          data-image="{{iu}}" \n                          data-price="{{pr}}"\n                          data-variant-price="{{pr}}" \n                          data-variant-id="{{id}}" \n                          data-inventory="{{inventory_quantity}}"\n                          data-oversell=""\n							data-url="{{url}}"\n 							data-coming-soon="{{#comingSoon}}true{{/comingSoon}}">{{title}}</button>\n                      </div>\n			          {{/.}}\n                  {{/allVariants}}\n			    </div>\n                <a class="cart__item-out-of-stock cart__item-add link link--primary js-out-of-stock-trigger is-coming-soon {{^comingSoon}}hide{{/comingSoon}}" data-modal-target="#coming-soon-modal-wrap" name="modal" role="button" aria-label="button" data-price="{{pr}}" data-variant-id="{{epi}}" data-id="{{empi}}" data-image="{{iu}}" data-variant-info="{{variantinfo}}" data-title="{{dt}}" data-atc-text="' + theme.locales.cart.coming_soon + '">' + theme.locales.cart.coming_soon + '</a>\n                <p class="cart__item-error-message small-text js-cart-error-message"></p>\n                <a class="cart__item-add heading--3 js-add-to-cart {{#comingSoon}}hide{{/comingSoon}} {{^comingSoon}}{{#isOOS}}hide{{/isOOS}}{{/comingSoon}}" href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" aria-label="Add {{dt}} to Cart" data-atc-text="' + c + '">\n                  ' + c + '\n                </a>\n                  <a class="cart__item-out-of-stock cart__item-add link link--primary js-out-of-stock-trigger is-oos {{#comingSoon}}hide{{/comingSoon}} {{^comingSoon}}{{^isOOS}}hide{{/isOOS}}{{/comingSoon}}" data-modal-target="#out-of-stock-wrap" name="modal" role="button" aria-label="button" data-price="{{pr}}" data-variant-id="{{epi}}" data-id="{{empi}}" data-image="{{iu}}" data-variant-info="{{variantinfo}}" data-title="{{dt}}" data-atc-text="' + theme.locales.cart.out_of_stock + '" data-iu="{{iu}}" data-pr="{{pr}}" data-product-id="{{empi}}" data-url="{{du}}">' + theme.locales.cart.out_of_stock + '</a>\n                  <p class="cart__item-error-message small-text js-cart-error-message"></p>\n              <button class="cart__item-remove cart__item-remove--wishlist js-remove-cart-item" data-id="{{_id}}" data-product-id="{{empi}}" data-variant-id="{{epi}}" aria-label="Remove {{dt}} from Wishlist">\n                {{{remove}}}\n              </button>\n            </div>\n          </li>\n        {{/products}}\n      </ul>\n      <input class="custom-wishlist__share-url js-share-wishlist-clipboard" type="text" />\n    ',
      p = '\n      <ul class="cart__items">\n        {{#products}}\n          <li class="cart__item js-cart-item">\n            <a class="cart__item-image" href="{{du}}" aria-label="Link to {{dt}}">\n              <img class="grid-view-item__image lazyautosizes" src="{{{iu}}}" alt="{{dt}}" />\n            </a>\n            <div class="cart__item-details">\n              <p class="cart__item-title uppercase-text js-cart-item-title">\n                {{#colorAssociated}}{{genericTitle}}<br><span class="text-title-space">{{ color }}</span>{{/colorAssociated}}\n                {{^colorAssociated}}{{dt}}{{/colorAssociated}}\n              </p>\n              <p class="test3 cart__item-price-container price js_thm3" data-price="">\n                <span class="test8 cart__item-price cart__item-price--final small-text js-cart-item-price" data-test="{{cu}}{{pr}}" data-empi="{{ empi }}">\n                  {{cu}}{{pr}}\n                </span>\n              </p>\n              <div style="position: absolute; bottom: 0;">\n                <div class="cart__item-options-container">\n                  <button class="cart__item-option-single-variant cart__item-option-selected dropdown__trigger  js-selected-option" aria-label="Variant selector" aria-expanded="false" data-variant-price="{{pr}}" data-variant-id="{{id}}" data-inventory="{{inventory_quantiy}}" data-dropdown-id="js-dropdown-container--{{epi}}" data-toggle="{&quot;target&quot;:&quot;js-dropdown-container--{{epi}}--cart-flyout&quot;,&quot;group&quot;:&quot;js-dropdown-container&quot;, &quot;focusTarget&quot;: &quot;js-dropdown-container&quot;, &quot;closeOnUnfocus&quot;: true}">\n                    {{variantinfo}}\n                  </button>\n                </div>\n              </div>\n                <a class="cart__item-out-of-stock cart__item-add link link--primary js-out-of-stock-trigger is-coming-soon {{^comingSoon}}hide{{/comingSoon}}" data-modal-target="#coming-soon-modal-wrap" name="modal" role="button" aria-label="button" data-price="{{pr}}" data-variant-id="{{epi}}" data-id="{{empi}}" data-image="{{iu}}" data-variant-info="{{variantinfo}}" data-title="{{dt}}" data-atc-text="' + theme.locales.cart.coming_soon + '">' + theme.locales.cart.coming_soon + '</a>\n                <p class="cart__item-error-message small-text js-cart-error-message"></p>\n                <a class="cart__item-add heading--3 js-add-to-cart {{#comingSoon}}hide{{/comingSoon}} {{^comingSoon}}{{#isOOS}}hide{{/isOOS}}{{/comingSoon}}" href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" aria-label="Add {{dt}} to Cart" data-atc-text="' + c + '">\n                  ' + c + '\n                </a>\n                  <a class="cart__item-out-of-stock cart__item-add link link--primary js-out-of-stock-trigger is-oos {{#comingSoon}}hide{{/comingSoon}} {{^comingSoon}}{{^isOOS}}hide{{/isOOS}}{{/comingSoon}}" data-modal-target="#out-of-stock-wrap" name="modal" role="button" aria-label="button" data-price="{{pr}}" data-variant-id="{{epi}}" data-id="{{empi}}" data-image="{{iu}}" data-variant-info="{{variantinfo}}" data-title="{{dt}}" data-atc-text="' + theme.locales.cart.out_of_stock + '" data-iu="{{iu}}" data-pr="{{pr}}" data-product-id="{{empi}}" data-url="{{du}}">' + theme.locales.cart.out_of_stock + '</a>\n                  <p class="cart__item-error-message small-text js-cart-error-message"></p>\n              <button class="cart__item-remove cart__item-remove--wishlist js-remove-cart-item" data-id="{{_id}}" data-product-id="{{empi}}" data-variant-id="{{epi}}" aria-label="Remove {{dt}} from Wishlist">\n                {{{remove}}}\n              </button>\n            </div>\n				<div id="js-dropdown-container--{{epi}}" class="cart__item-dropdown cart__item-dropdown-panel dropdown__list js-dropdown-container">\n 				  <h3>CHANGE OPTION</h3>\n 			  	  <div class="cart__item-dropdown-section">\n			      {{#allVariants}}\n                    {{#.}}\n			          	<div id="js-dropdown-container--{{epi}}--cart-flyout" class="cart__item-dropdown dropdown__list-item js-dropdown-container" style="height: auto;">\n                        <button tabindex="-1"  aria-label="{{dt}}" class="cart__item-option js-cart-item-option small-text" \n                          data-product-id="{{empi}}" \n                          data-image="{{iu}}" \n                          data-price="{{pr}}"\n                          data-variant-price="{{pr}}" \n                          data-variant-id="{{id}}" \n                          data-inventory="{{inventory_quantity}}"\n                          data-oversell=""\n							data-url="{{url}}"\n 							data-coming-soon="{{#comingSoon}}true{{/comingSoon}}">{{title}}</button>\n                      </div>\n			          {{/.}}\n                {{/allVariants}}\n 			  	  </div>\n			    </div>\n          </li>\n        {{/products}}\n      </ul>\n      <input class="custom-wishlist__share-url js-share-wishlist-clipboard" type="text" />\n    ',
      f = '\n      <div class="cart__empty is-visible">\n        <p class="cart__empty-body">' + e + '</p>\n        <a class="cart__empty-link link link--primary" href="/" title="' + t + '" aria-label="' + t + '">' + t + "</a>\n      </div>\n    ",
      h = '\n      <div class="cart__empty is-visible">\n        <p class="cart__empty-body">' + m + "</p>\n      </div>\n    ",
      v = [];
    window.SwymCallbacks || (window.SwymCallbacks = []), window.SwymCallbacks.push(function (t) {
      SwymUtils.getHostedURL = function () {
        return "/pages/custom-wishlist?";
      }, t.fetchWrtEventTypeET(function (e) {
        0 < e.length ? (v = e, console.time("Initial Wishlist Fetched and Rendered"), o(t, e, !1), a(!1), i(t, e), j(!1), console.timeEnd("Initial Wishlist Fetched and Rendered")) : (document.querySelector(".js-share-wishlist").classList.add("hide"), d.innerHTML = f);
      }, window._swat.EventTypes.addToWishList);
    });
    var _ = function _(t) {
      var e = theme.cart._object.items.filter(function (e) {
        return e.variant_id === +t;
      });
      if (e.length) {
        var o = [].concat(_toConsumableArray(document.querySelectorAll(".js-selected-option"))).find(function (e) {
          return +e.dataset.variantId == +t;
        }).closest(".js-cart-item").querySelector(".js-cart-item-quantity");
        return o.innerText = +o.innerText + 1, {
          isInCart: !0,
          quantity: e[0].quantity
        };
      }
      return {
        isInCart: !1
      };
    },
      y = function y() {
        window._swat.generateSharedWishlistURL(null, function (e) {
          document.querySelector(".js-share-wishlist-clipboard").value = e, document.querySelector(".js-share-wishlist-clipboard").select(), document.execCommand("copy"), u.classList.add("is-active"), setTimeout(function () {
            u.classList.remove("is-active");
          }, 3e3);
        }, function (e) {
          // console.log(e);
        });
      },
      g = function g(e) {
        theme.modal.addTrigger($(e));
      },
      b = function b(t) {
        var e = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-modal-prod-title"))),
          o = [].concat(_toConsumableArray(document.querySelectorAll(".js-option-title"))),
          i = t.dataset.atcText,
          n = t.dataset.title,
          r = "";
        e.forEach(function (e) {
          !function (e, t) {
            var o = t.split("- ")[0],
              i = t.split("- ")[1];
            1 < o.length && (e.innerHTML = 1 < t.split("- ").length ? o + '<br><span class="text-title-space">' + i.toLowerCase() + "</span>" : t);
          }(e, n);
        }), o.forEach(function (e) {
          e && (e.innerText = t.dataset.variantInfo);
        }), i == theme.locales.product.coming_soon && (r = "comingsoon"), theme.outOfStockData = {
          price: +t.dataset.price,
          variant_id: +t.dataset.variantId,
          product_id: +t.dataset.id,
          image: t.dataset.image,
          modal_type: r
        };
      };
    d.innerHTML = h;
  }
}(), function () {
  if ("fit-guide" == theme.template.suffix) {
    o = [].concat(_toConsumableArray(document.querySelectorAll(".js-fit-guide-category"))), i = [].concat(_toConsumableArray(document.querySelectorAll(".js-fit-guide-image"))), o.forEach(function (t) {
      t.addEventListener("click", function (e) {
        o.forEach(function (e) {
          return e.classList.remove("is-active");
        }), i.forEach(function (e) {
          e.classList.contains("hide") || e.classList.add("hide"), t.getAttribute("data-fit-category") == e.getAttribute("data-fit-category") && e.classList.remove("hide");
        }), t.classList.add("is-active");
      });
    });
  }
  var o, i;
}(), function (d, u) {
  var a = void 0,
    e = void 0,
    m = void 0,
    t = void 0,
    p = void 0,
    f = function f() {
      e.forEach(function (e) {
        e.classList.add("is-loading"), [].concat(_toConsumableArray(e.querySelectorAll(".js-cart-overview button"))).forEach(function (e) {
          return e.setAttribute("disabled", "");
        });
      }), t = !0;
    },
    h = function h(e, t, o) {
      var i = e.querySelector(".js-cart-error-message");
      o ? i.classList.add("is-visible", "is-red") : i.classList.add("is-visible");
      i.innerText = t;
      i.setAttribute('role', 'alert');
      i.setAttribute('aria-live', 'polite');
      i.setAttribute('tabindex', '-1');
      i.focus();

      setTimeout(function () {
        i.innerText = "";
        i.classList.remove("is-visible", "is-red");
      }, 20000);
    },
    v = function v(e, t, o, i) {
      var n = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-of-stock-modal-prod-title"))),
        r = [].concat(_toConsumableArray(document.querySelectorAll(".js-out-size"))),
        a = t.dataset.productId,
        s = e.dataset.variantId,
        c = t.dataset.price,
        l = t.dataset.image;
      n.forEach(function (e) {
        e.innerHTML = "", e.innerHTML = o;
      }), r.forEach(function (e) {
        e && (e.innerText = "SIZE: " + i);
      }), d.outOfStockData = {
        price: +c / 100,
        product_id: +a,
        variant_id: +s,
        image: l,
        modal_type: ""
      };
    },
    o = function o() {
      var r = d.cart.content;
      p = 0, function (e) {
        u.get("/cart?view=ajax").then(e);
      }(function (n) {
        e.forEach(function (e) {
          if (theme.template.name == 'product') {
            var productFoundInCart = theme.cart._object.items.filter(function (e) {
              return e.product_id === window.theme.product.id;
            }),
              prodAtc = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-atc")));
            if (window.theme.product.tags.includes('limitone') && productFoundInCart.length > 0) {
              prodAtc.forEach(function (e) {
                // console.log('prodAtc ' + e, e);
                e.setAttribute("disabled", true);
                e.classList.add("button--secondary");
                e.classList.remove("button--primary");
                e.innerText = theme.locales.product.limit_one;
              });
            }
          }
          if (!theme.settings.gift_bundle_enabled) {
            if (document.querySelector('.cart__checkout')) document.querySelector('.cart__checkout').classList.remove('hide');
            if (document.querySelector('.quickAdd-checkout-view__button')) document.querySelector('.quickAdd-checkout-view__button').classList.remove('hide');
          }
          var t = e.querySelector(".js-cart-items-count");
          var giftNote = e.querySelector('.js-cart-gift-note');
          var only_preorder = true;
          t && (t.innerText = r.item_count + " item" + (1 < r.item_count ? "s" : "")), document.querySelector(".js-cart-count>span").innerText = r.item_count, 0 === r.item_count ? (e.classList.add("is-empty"), document.querySelector(".js-cart-count").classList.add("hide")) : (e.classList.remove("is-empty"), document.querySelector(".js-cart-count").classList.remove("hide"));
          var o = e.querySelector(a.overview);
          if (o.innerHTML = n, o.querySelector(".js-cart-is-empty")) e.classList.remove("is-loading"); else {
            m = [].concat(_toConsumableArray(o.querySelectorAll(".js-cart-item")));
            var i = o.querySelector(".js-cart-items");
            i.innerHTML = "", m.sort(function (e, t) {
              return e.dataset.title > t.dataset.title ? 1 : -1;
            }), m.forEach(function (e) {
              if (e.getAttribute('data-product-preorder-property') == 'false') {
                only_preorder = false;
                // console.log('only_preorder need to be set by false');
                // console.log('removing the overlay');
                setTimeout(function () {
                  $('.cart.js-cart.is-loading').removeClass('is-loading');
                  $('.cart-flyout.js-cart.is-loading').removeClass('is-loading');
                }, 1000);
                $('.cart.js-cart.is-loading').removeClass('is-loading');
                $('.cart-flyout.js-cart.is-loading').removeClass('is-loading');
              }
              return i.append(e);
            }), m.forEach(function (e) {
              return function (i) {
                var n = i.dataset.key,
                  r = parseInt(i.dataset.quantity),
                  e = parseInt(i.dataset.inventory),
                  t = i.querySelector(".js-remove-cart-item"),
                  a = [].concat(_toConsumableArray(i.querySelectorAll(".js-cart-item-option"))),
                  o = i.querySelector(".js-cart-item-quantity-minus"),
                  s = i.querySelector(".js-cart-item-quantity-plus"),
                  c = i.querySelector(".js-cart-item-quantity"),
                  l = +i.dataset.originalLinePrice,
                  props = JSON.parse(i.dataset.props),
                  preorder_test = i.dataset.productPreorder,
                  preorder_set = i.dataset.productPreorderProperty === 'true';
                window.theme.giftPreorderPrevent = false;
                if (preorder_test.length > 0 && !preorder_set) {
                  // console.log('n', n);
                  var date_property = new Date(preorder_test),
                    preorderDate = Math.round(date_property / 1000),
                    now_date = Math.round(Date.now() / 1000),
                    utc = date_property.getTime() + date_property.getTimezoneOffset() * 60000,
                    corrected_date = new Date(utc);
                  if (preorderDate > now_date) {
                    window.theme.giftPreorderPrevent = true;
                    props['_preorderDate'] = preorder_test;
                    // console.log('props', props);
                    setTimeout(function () {
                      d.cart.change({
                        id: n,
                        quantity: r,
                        properties: props
                      });
                    }, 300);
                  }
                }
                i.dataset.productDiscountTag && (p += l), d && d.initAccordions(), t.addEventListener("click", function () {
                  f();
                  var e = i.dataset.productGift;
                  if (i.classList.add("is-removed"), d.settings.gift_bundle_enabled && e && "automatic" == d.settings.gift.add_type && !sessionStorage.getItem("gift-removed")) {
                    sessionStorage.setItem("gift-removed", "true");
                    var t = "" != d.settings.gift.gift1 ? d.settings.gift.gift1 : d.settings.gift.gift2;
                    u.getJSON("/products/" + t + ".js", function (e) {
                      e.variants[0].available && (document.querySelector(".js-cart-gift").classList.remove("hide"), document.querySelector(".js-cart-gift-button").disabled = !0);
                    });
                  }
                  setTimeout(function () {
                    i.remove(), d.cart.change({
                      id: n,
                      quantity: 0
                    });
                  }, 300);
                }), a.forEach(function (t) {
                  var e = parseInt(t.dataset.inventory),
                    o = !0;
                  m.forEach(function (e) {
                    o && e.dataset.variantId === t.dataset.variantId && (t.addEventListener("click", function () {
                      h(i, d.locales.cart.error_in_cart, !0);
                    }), o = !1);
                  }), 0 == e && (t.addEventListener("click", function () {
                    var e = i.querySelector(".js-out-of-stock-trigger-cart");
                    e.classList.contains("hide") && (e.classList.remove("hide"), d.modal.addTrigger(u(e)), a.forEach(function (e) {
                      e.dataset.variantId === i.dataset.variantId && e.addEventListener("click", function () {
                        f();
                        i.querySelector(".js-cart-error-message").style.display = "none";
                        // Preserve existing properties when changing variant
                        var updatedProps = JSON.parse(JSON.stringify(props));
                        // Remove old item and add new variant with preserved properties
                        d.cart.change({
                          id: n,
                          quantity: 0
                        }).then(function () {
                          return d.cart.add({
                            id: parseInt(e.dataset.variantId),
                            quantity: r
                          }, {}, updatedProps);
                        });
                      });
                    })), a.forEach(function (e) {
                      return e.removeAttribute("disabled");
                    }), t.setAttribute("disabled", "true"), i.querySelector(".js-selected-option").innerText = t.innerText, i.querySelector(".js-cart__item-sold-out").innerText = d.locales.cart.item_sold_out, e.addEventListener("click", function () {
                      v(t, i, i.querySelector(".js-cart-item-title").innerHTML, t.innerText);
                    });
                  }), o = !1), o && e < r && t.addEventListener("click", function () {
                    h(i, d.locales.cart.error_quantity1 + " " + e + ". " + d.locales.cart.error_quantity2, !1), r = e;
                  }), o && t.addEventListener("click", function () {
                    f();
                    // Preserve existing properties when changing variant
                    var updatedProps = JSON.parse(JSON.stringify(props));
                    // Remove old item and add new variant with preserved properties
                    d.cart.change({
                      id: n,
                      quantity: 0
                    }).then(function () {
                      return d.cart.add({
                        id: parseInt(t.dataset.variantId),
                        quantity: r
                      }, {}, updatedProps);
                    });
                  });
                }), o.addEventListener("click", function () {
                  0 < r - 1 && (f(), r--, i.dataset.quantity = r, c.innerText = r, d.cart.change({
                    id: n,
                    quantity: r
                  }), d.deleteGiftSessionStorage());
                }), s.addEventListener("click", function () {
                  r + 1 <= e ? (f(), r++, i.dataset.quantity = r, c.innerText = r, d.cart.change({
                    id: n,
                    quantity: r
                  }), d.deleteGiftSessionStorage()) : h(i, d.locales.cart.max_quantity);
                });
              }(e);
            }), d.settings.discount.show_message && m.forEach(function (e) {
              return function (e) {
                var t = e.dataset.productDiscountTag;
                t && p > +d.settings.discount.minimum_price2 ? e.querySelector(".js-item-discount-message").innerText = d.settings.discount.message2 : t && p > +d.settings.discount.minimum_price1 && (e.querySelector(".js-item-discount-message").innerText = d.settings.discount.message1);
              }(e);
            }), e.querySelector(".js-total-price").innerText = d.utils.toMoney(r.items_subtotal_price, {
              cents: !0
            }), localStorage.getItem("bundle-submit") || e.classList.remove("is-loading");
            var currencies = {
              USD: "$",
              GBP: "£",
              EUR: "€",
              ILS: "₪",
              AFN: "Af",
              DZD: "DA",
              ARS: "AR$",
              AMD: "AMD",
              AWG: "Afl.",
              AUD: "AU$",
              AZN: "man.",
              BSD: "BS$",
              BHD: "BD",
              THB: "฿",
              PAB: "B/.",
              BBD: "Bds$",
              BYR: "BYR",
              BZD: "BZ$",
              BMD: "BD$",
              BOB: "Bs",
              BRL: "R$",
              BND: "BN$",
              BGN: "BGN",
              BIF: "FBu",
              CAD: "CA$",
              CVE: "CV$",
              KYD: "KY$",
              XOF: "CFA",
              XAF: "XAF",
              XPF: "CFPF",
              CLP: "CL$",
              COP: "COP",
              KMF: "CF",
              CDF: "CDF",
              BAM: "KM",
              NIO: "NIO",
              CRC: "₡",
              CUP: "CU$",
              CZK: "Kč",
              GMD: "GMD",
              DKK: "kr",
              MKD: "MKD",
              DJF: "Fdj",
              STD: "Db",
              DOP: "RD$",
              VND: "₫",
              XCD: "EC$",
              EGP: "EGP",
              ETB: "Br",
              FKP: "FK£",
              FJD: "FJ$",
              HUF: "Ft",
              GHS: "GH₵",
              HTG: "HTG",
              PYG: "₲",
              GNF: "FG",
              GYD: "GY$",
              HKD: "HK$",
              UAH: "₴",
              ISK: "kr",
              INR: "₹",
              IRR: "IRR",
              IQD: "IQD",
              JMD: "J$",
              JOD: "JD",
              KES: "KSh",
              PGK: "PGK",
              LAK: "₭",
              KWD: "KD",
              MWK: "MWK",
              AOA: "Kz",
              MMK: "MMK",
              GEL: "GEL",
              LBP: "LBP",
              ALL: "ALL",
              HNL: "HNL",
              SLL: "Le",
              LRD: "L$",
              LYD: "LD",
              SZL: "SZL",
              LSL: "LSL",
              MGA: "MGA",
              MYR: "RM",
              MUR: "MURs",
              MXN: "Mex$",
              MDL: "MDL",
              MAD: "MAD",
              MZN: "MTn",
              NGN: "₦",
              ERN: "Nfk",
              NAD: "N$",
              NPR: "NPRs",
              ANG: "NAf.",
              RON: "RON",
              TWD: "NT$",
              NZD: "NZ$",
              BTN: "Nu.",
              KPW: "KPW",
              NOK: "kr",
              PEN: "S/.",
              MRO: "UM",
              TOP: "T$",
              PKR: "Rs",
              MOP: "MOP$",
              UYU: "$U",
              PHP: "₱",
              BWP: "BWP",
              QAR: "QR",
              GTQ: "GTQ",
              ZAR: "R",
              OMR: "OMR",
              KHR: "KHR",
              MVR: "MVR",
              IDR: "Rp",
              RUB: "RUB",
              RWF: "RWF",
              SHP: "SH£",
              SAR: "SAR",
              RSD: "din.",
              SCR: "SRe",
              SGD: "S$",
              SBD: "SI$",
              KGS: "KGS",
              SOS: "Ssh",
              TJS: "TJS",
              LKR: "SLRs",
              SDG: "SDG",
              SRD: "SR$",
              SEK: "kr",
              CHF: "CHF",
              SYP: "SY£",
              BDT: "Tk",
              WST: "WS$",
              TZS: "TSh",
              KZT: "KZT",
              TTD: "TT$",
              MNT: "₮",
              TND: "DT",
              TRY: "TL",
              TMT: "TMT",
              AED: "AED",
              UGX: "USh",
              UZS: "UZS",
              VUV: "VT",
              KRW: "₩",
              YER: "YR",
              JPY: "¥",
              CNY: "CN¥",
              ZMW: "ZMW",
              ZWL: "ZWL",
              PLN: "zł",
              BYN: "BYN"
            };
            var current_currency = currencies[r.currency];
            var current_subtotal_price = r.items_subtotal_price / 100;
            var items_subtotal_price = Number(current_subtotal_price).toLocaleString('en-US');
            e.querySelector(".js-total-price").innerText = current_currency + '' + items_subtotal_price;
            // console.log('only_preorder = ', only_preorder);


            if (window.lastFocusedQuantity) {
              const quantityElement = document.querySelector(`button[data-focus-target="${window.lastFocusedQuantity}"]`);
              // console.log('quantityElement',quantityElement);
              if (quantityElement) {
                setTimeout(() => {
                  quantityElement.focus();
                }, 100);
              }
            }


            if (only_preorder) {
              //if (giftNote) giftNote.classList.add('hide');
            } else {
              //if (giftNote) giftNote.classList.remove('hide');
            }
          }
        });
      });
    };
  a = {
    cart: ".js-cart",
    overview: ".js-cart-overview"
  }, e = [].concat(_toConsumableArray(document.querySelectorAll(a.cart))), o(), u(document).on("Cart:set", function () {
    t || f(), o();
  });
}(window.theme, jQuery), function () {
  if (theme.template.name == 'product') {
    var modalZoom = document.getElementById('zoom-modal');
    var modalImg = document.querySelector('.js-img-zoom-modal');
    var isModalDisplayed = false;

    // Hammer JS needed for listening to pinch and double tap event and then when it triggers
    // we add add the pinchzoom to the image for the modal
    var modalImageZoom = function modalImageZoom(zoomElem) {
      var elemImgSrc = zoomElem.querySelector('img').dataset.src;
      var elemImgAlt = zoomElem.querySelector('img').alt;
      var hammerTime = new Hammer(zoomElem, {
        touchAction: 'auto'
      });
      hammerTime.get('pinch').set({
        enable: true
      });
      hammerTime.on('pinch doubletap', function (event) {
        if (!isModalDisplayed) {
          var getTransformValues = function getTransformValues(element) {
            var transformValue = element.css("transform");
            if (transformValue && transformValue !== "none") {
              var matrix = transformValue.match(/^matrix\((.+)\)$/);
              if (matrix && matrix[1]) {
                var matrixValues = matrix[1].split(", ");
                if (matrixValues.length >= 6) {
                  var translateX = parseFloat(matrixValues[4]);
                  var translateY = parseFloat(matrixValues[5]);
                  return {
                    translateX: translateX,
                    translateY: translateY
                  };
                }
              }
            }
            return {
              translateX: 0,
              translateY: 0
            };
          };
          var updateTransform = function updateTransform(element, translateX, translateY) {
            var transformValue = "translate(" + translateX + "px, " + translateY + "px)";
            element.css("transform", transformValue);
          };
          var handleKeyDown = function handleKeyDown(event) {
            // console.log("Key Events");
            var step = 25; // Adjust the step size as desired
            var newTransform = getTransformValues(image);
            switch (event.key) {
              case '+':
              case '=':
                wZoom.zoomUp();
                break;
              case '-':
                wZoom.zoomDown();
                break;
              case 'ArrowUp':
                newTransform.translateY -= step;
                updateTransform(image, newTransform.translateX, newTransform.translateY);
                break;
              case 'ArrowDown':
                newTransform.translateY += step;
                updateTransform(image, newTransform.translateX, newTransform.translateY);
                break;
              case 'ArrowLeft':
                newTransform.translateX -= step;
                updateTransform(image, newTransform.translateX, newTransform.translateY);
                break;
              case 'ArrowRight':
                newTransform.translateX += step;
                updateTransform(image, newTransform.translateX, newTransform.translateY);
                break;
              default:
                break;
            }
          };
          document.querySelector('.btn-img-zoom').click();
          modalImg.src = elemImgSrc;
          modalImg.alt = elemImgAlt;
          isModalDisplayed = true;
          document.body.classList.add('body--freeze');
          var wZoom = WZoom.create(modalImg, {
            dragScrollableOptions: {
              onGrab: function onGrab() {
                modalImg.style.cursor = 'grabbing';
              },
              onDrop: function onDrop() {
                modalImg.style.cursor = 'grab';
              }
            }
          });
          wZoom.prepare();
          var productImageZoomCell = document.querySelector('.modal-content--image-zoom .modal-content--img-wrap');
          productImageZoomCell.addEventListener('keydown', handleKeyDown);
          productImageZoomCell.setAttribute('tabindex', '0');
          var image = $("img.js-img-zoom-modal");
          var currentTransform = getTransformValues(image);
        } else {
          document.body.classList.remove('body--freeze');
        }
      });
    };
    var zoomImageInit = function zoomImageInit(allZoom) {
      // Mutation observer to observe the class modal-content to verify if the modal is closed.
      // If it is, set the modalDisplayed to false.
      var zobserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "class") {
            var attributeValue = $(mutation.target).prop(mutation.attributeName);
            if (attributeValue.includes('is-closed')) {
              isModalDisplayed = false;
              document.body.classList.remove('body--freeze');
            }
          }
        });
      });
      zobserver.observe(modalZoom, {
        attributes: true
      });
      allZoom.forEach(function (zoomElem) {
        modalImageZoom(zoomElem);
      });
    };
    var zoomImageModalSliderInit = function zoomImageModalSliderInit(allZoom) {
      allZoom.forEach(function (zoomElem) {
        var colorId = zoomElem.dataset.colorId;
        var selectedSlickIndex = $(zoomElem).closest('.product-media--cell').attr('data-slick-index');
        zoomElem.addEventListener('click', function (e) {
          var zoomElement = this;
          $('.js-modal-content--side-slider').addClass('hide');
          $('.js-modal-content--side-slider').each(function () {
            if ($(this).hasClass('slick-initialized')) {
              $(this).slick('unslick');
            }
          });
          $('.js-modal-content--side-slider[data-color-id="' + colorId + '"]').removeClass('hide');
          setTimeout(function () {
            var jsModalContentSlider = $('.js-modal-content--side-slider[data-color-id="' + colorId + '"]').slick({
              dots: false,
              arrows: true,
              infinite: true,
              speed: 300,
              slidesToShow: 4,
              nextArrow: '<button class="product-media-thumbnail-arrow product-media-thumbnail-arrow-down js-product-thumbnail-arrow" aria-label="Next" data-type="down"></button>',
              prevArrow: '<button class="product-media-thumbnail-arrow product-media-thumbnail-arrow-up js-product-thumbnail-arrow" aria-label="Previous" data-type="up"></button>',
              lazyLoad: "progressive",
              vertical: true,
              draggable: false,
              verticalSwiping: true,
              responsive: [{
                breakpoint: 996,
                settings: {
                  vertical: false,
                  slidesToShow: 1,
                  draggable: false,
                  verticalSwiping: false,
                  dots: true,
                  touchMove: false,
                  swipe: false
                }
              }]
            });
            jsModalContentSlider.on('wheel', function (e) {
              e.preventDefault();
              if ($(window).width() > 991) {
                if (e.originalEvent.deltaY < 0) {
                  $(this).slick('slickPrev');
                } else {
                  $(this).slick('slickNext');
                }
              }
            });
            $('.js-modal-content--img-wrap-arrow-left').on('click', function () {
              jsModalContentSlider.slick('slickPrev');
            });
            $('.js-modal-content--img-wrap-arrow-right').on('click', function () {
              jsModalContentSlider.slick('slickNext');
            });
            $('.js-modal-content--side-slider[data-color-id="' + colorId + '"]').on('afterChange', function (event, slick, currentSlide) {
              var CurrentSlideDom = $(slick.$slides.get(currentSlide));
              var imgSrc = CurrentSlideDom.find('img').attr('src');
              modalImg.src = imgSrc;
              var wZoom = WZoom.create(modalImg, {
                dragScrollableOptions: {
                  onGrab: function onGrab() {
                    modalImg.style.cursor = 'grabbing';
                  },
                  onDrop: function onDrop() {
                    modalImg.style.cursor = 'grab';
                  }
                }
              });
              wZoom.prepare();
            });
            jsModalContentSlider.slick('slickGoTo', parseInt(selectedSlickIndex));
          }, 300);
        });
      });
      $('body').on('click', '.js-product__image-zoom-cell', function () {
        var image = $(this);
        var elemImgSrc = image.find('img').attr('data-zoom-src');
        var elemImgAlt = image.find('img').attr('alt');
        var imageObject = $(this)[0];
        modalImg.src = elemImgSrc;
        modalImg.alt = elemImgAlt;
        var wZoom = WZoom.create(modalImg, {
          dragScrollableOptions: {
            onGrab: function onGrab() {
              modalImg.style.cursor = 'grabbing';
            },
            onDrop: function onDrop() {
              modalImg.style.cursor = 'grab';
            }
          }
        });
        wZoom.prepare();
      });
    };
    var zoomImage = function zoomImage() {
      //   @wx-merge: Allyant ADA Updates
      var modals = document.querySelectorAll('.modal-content.modal-content--image-zoom');
      // console.log(modals.length);
      var allZoom = document.querySelectorAll('.js-zoom');
      zoomImageModalSliderInit(allZoom);
      zoomImageInit(allZoom);
      $(".modal-content.modal-content--image-zoom .js-close-modal").get(0).focus();
      initTrap(modals);

      // Add Enter key functionality for gallery image links
      $('.gallery-img-link').on('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var zoomElem = $(this).closest('.js-zoom');
          if (zoomElem.length) {
            var elemImgSrc = zoomElem.find('img').attr('data-src');
            var elemImgAlt = zoomElem.find('img').attr('alt');
            document.querySelector('.btn-img-zoom').click();
            var modalImg = document.querySelector('.js-img-zoom-modal');
            modalImg.src = elemImgSrc;
            modalImg.alt = elemImgAlt;
            document.body.classList.add('body--freeze');
            var wZoom = WZoom.create(modalImg, {
              dragScrollableOptions: {
                onGrab: function onGrab() {
                  modalImg.style.cursor = 'grabbing';
                },
                onDrop: function onDrop() {
                  modalImg.style.cursor = 'grab';
                }
              }
            });
            wZoom.prepare();
          }
        }
      });
      $('.gallery-img-link').on('click', function (e) {
        e.preventDefault();
        var zoomElem = $(this).closest('.js-zoom');
        if (zoomElem.length) {
          var elemImgSrc = zoomElem.find('img').attr('data-src');
          var elemImgAlt = zoomElem.find('img').attr('alt');
          document.querySelector('.btn-img-zoom').click();
          var modalImg = document.querySelector('.js-img-zoom-modal');
          modalImg.src = elemImgSrc;
          modalImg.alt = elemImgAlt;
          document.body.classList.add('body--freeze');
          var wZoom = WZoom.create(modalImg, {
            dragScrollableOptions: {
              onGrab: function onGrab() {
                modalImg.style.cursor = 'grabbing';
              },
              onDrop: function onDrop() {
                modalImg.style.cursor = 'grab';
              }
            }
          });
          wZoom.prepare();
        }
      });
    };
    window.theme.zoomImage = zoomImage;
  }
}(), "product" == theme.template.name && "bundle" != theme.template.suffix) {
  var uniq = function uniq(a) {
    return _toConsumableArray2(new Set(a));
  };
  // console.log('color_handles', color_handles);
  var colorJSONInitial = JSON.parse(color_handles);
  colorJSONInitial.push(theme.product.handle);
  var colorJSON = uniq(colorJSONInitial);
  var additionColorJSON = JSON.parse(add_color_handles);
  var monetateAddProductDetails = function monetateAddProductDetails(currentProduct) {
    var firstSKU = currentProduct.variants[0].sku;
    var productId = currentProduct.id;
    var productDetails = [];
    productDetails.push([{
      productId: productId,
      sku: firstSKU
    }]);
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(["setPageType", theme.template.page_type]);
    productDetails.forEach(function (product) {
      window.monetateQ.push(["addProductDetails", product]);
    });
    window.monetateQ.push(["trackData"]);
  };
  var colorSwatchesInit = function colorSwatchesInit() {
    // If no colors exist, then display swatch then exit
    if (colorJSON.length < 2) {
      initColorDOMGeneration();
      jQuery.ajaxSetup({
        async: false
      });
      $.get("/products/".concat(theme.product.handle, "?view=json"), function (resp) {
        var obj = JSON.parse(resp);
        var colorTitle = obj.title.indexOf('-') > -1 ? obj.title.split('- ')[1] : '';
        monetateAddProductDetails(obj);
        if (colorTitle.length > 1) {
          var colorHandle = obj.handle;
          var colorId = 'color--' + obj.id;
          var colorSwatch = '';
          var productId = obj.id;
          var colorHex = obj.metafields[0].color;
          var colorAvailable = obj.available;
          var colorFile = obj.color_file;
          var allFormColors = _toConsumableArray2(document.querySelectorAll('.js-form-colors'));
          var productATCText = theme.locales.product.add_to_bag;
          var productTag = '';
          var completeTheLookExclusionTag = true;
          var productSKUs = [];
          var appOnly = false;

          // SKUs
          obj.variants.forEach(function (variant) {
            var sku = variant.sku;
            productSKUs.push(sku);
          });
          productSKUs = JSON.stringify(productSKUs);

          // Checking Product ATC Text
          if (obj.tags.includes('swym-comingsoon')) {
            productATCText = theme.locales.product.coming_soon;
            productTag = theme.locales.product.coming_soon;
          } else if (obj.tags.includes('pdp_pre-order')) {
            productATCText = theme.locales.product.preorder;
            productTag = theme.locales.product.preorder;
          } else if (obj.tags.includes('app-exclusive')) {
            productATCText = theme.locales.product.download_app;
            productTag = 'app-exclusive';
          } else if (!obj.available) {
            productATCText = theme.locales.product.out_of_stock;
          }

          // Checking to see if it contains any pdp_ tags
          obj.tags.forEach(function (tag) {
            if (tag.includes('pdp_')) productTag = tag.split('pdp_')[1];
            if (tag.includes('complete-the-look-exclusion')) completeTheLookExclusionTag = false;
            if (tag === 'app-exclusive') appOnly = true;
          });

          // Determine if the color file exists
          /*
          $.ajax({
            type: 'HEAD',
            url: colorFile,
            error: function() {
              // page does not exist
              colorFile = null;
            }
          });
          */

          // Get the color hexcode/image for swatches
          // Product image with alt 'swatch'
          if (colorSwatch == '' && colorFile != null) {
            colorSwatch = "background-image: url('".concat(colorFile, "'); background-size: cover;");
          } else if (colorSwatch == '' && colorHex != null) {
            // Metafield hexcode - product.metafields.color.swatch
            colorSwatch = "background-color: ".concat(colorHex, ";");
          } else if (colorSwatch == '') {
            // Fallback to second half of title - don't result to this 
            colorSwatch = "background-color: ".concat(colorTitle.toLowerCase(), ";");
          }

          // Inserting the color swatches
          var _colorsElement = "\n                <div class=\"swatch radio radio--color js-swatch\">\n                  <input id=\"".concat(colorId, "\" type=\"radio\" name=\"Color\" title=\"").concat(colorTitle, "\" value=\"").concat(colorTitle, "\" class=\"form--product__option-selector js-option-selector js-color-option-value ").concat(colorId, "\" data-color-id=\"").concat(colorId, "\" data-skus='").concat(productSKUs, "' data-color=\"").concat(colorHandle, "\" data-option=\"option1\" checked>\n                  <label for=\"").concat(colorId, "\" data-product-id=\"").concat(productId, "\" class=\"js-color-label\" data-color=\"").concat(colorHandle, "\" data-available=\"").concat(colorAvailable, "\" data-app=\"").concat(appOnly, "\" data-complete-the-look=\"").concat(completeTheLookExclusionTag, "\" data-atc-text=\"").concat(productATCText, "\" data-tag=\"").concat(productTag, "\" data-color-id=\"").concat(colorId, "\" title=\"").concat(colorTitle, "\" data-product-title=\"").concat(obj.title, "\" tabindex=\"0\" role=\"radio\" aria-checked=\"true\">\n                    <span data-color-id=\"").concat(colorId, "\" style=\"").concat(colorSwatch, " border: 1px solid #000000;\">").concat(colorTitle, "</span>\n                  </label>\n                </div>\n              ");

          // Add color DOM
          if ($('input#' + colorId).length == 0) {
            allFormColors.forEach(function (block) {
              block.insertAdjacentHTML('beforeend', _colorsElement);
            });
          }
        }
      });
      return;
    }
    var currentProductHandle = theme.product.handle;
    var formColors = _toConsumableArray2(document.querySelectorAll('.js-form-colors'));
    var addformColors = _toConsumableArray2(document.querySelectorAll('.js-form-add-colors'));
    var colorsElement;
    var accordionText;
    var sizeElement = '';
    var ajax_calls = [];
    var allColors = [];
    var addColors = [];
    var allData = [];
    var addData = [];
    var variantLabelData = [];
    jQuery.ajaxSetup({
      async: true
    });
    function allSkippingErrors(promises) {
      return Promise.all(promises.map(function (p) {
        p["catch"](function (error) {
          return null;
        });
      }));
    }
    var promiseState = function promiseState(p) {
      return p.then(function (v) {
        return {
          v: v,
          status: "fulfilled"
        };
      }, function (e) {
        return {
          e: e,
          status: "rejected"
        };
      });
    };
    colorJSON.forEach(function (handle, index) {
      var overallLabel = _defineProperty({}, handle, {});
      variantLabelData.push(overallLabel);
      ajax_calls.push($.get("/products/".concat(handle, "?view=json"), function (resp) {
        allColors.push(JSON.parse(resp));
      }));
      ajax_calls.push($.get("/products/".concat(handle), function (data) {
        allData.push($(data).find('.form__size-wrapper .agc.form__field.form__field--sizes').data('product-variants'));
        var individualLabels = $(data).find('.form__size-wrapper .agc.form__field.form__field--sizes label');
        var tempArray = [];
        for (var i = 0; i < individualLabels.length; i++) {
          var individualOption = individualLabels[i].innerText;
          tempArray.push(_defineProperty({}, individualOption, Object.assign({}, individualLabels[i].dataset)));
        }
        variantLabelData[handle] = tempArray;
      }));
    });

    // additional colors
    additionColorJSON.forEach(function (handle, index) {
      var overallLabel = _defineProperty({}, handle, {});
      variantLabelData.push(overallLabel);
      ajax_calls.push($.get("/products/".concat(handle, "?view=json"), function (resp) {
        addColors.push(JSON.parse(resp));
      }));
      ajax_calls.push($.get("/products/".concat(handle), function (data) {
        addData.push($(data).find('.form__size-wrapper .agc.form__field.form__field--sizes').data('product-variants'));
        var individualLabels = $(data).find('.form__size-wrapper .agc.form__field.form__field--sizes label');
        var tempArray = [];
        for (var i = 0; i < individualLabels.length; i++) {
          var individualOption = individualLabels[i].innerText;
          tempArray.push(_defineProperty({}, individualOption, Object.assign({}, individualLabels[i].dataset)));
        }
        variantLabelData[handle] = tempArray;
      }));
    });
    var generateImages = function generateImages(image, imageId, imageAspectRatio, imageAlt, productId, imageType, imagePosition, imageClass) {
      // Generation of Images
      var ratio = 1 / imageAspectRatio * 100;
      return "\n          <div class=\"".concat(imageType, "\" data-index=\"").concat(imagePosition, "\">\n            <style>\n              .ImageWrapper-").concat(imageId, "-image::before {padding-top:").concat(ratio, "%;}\n            </style>\n            <div data-image-id=\"").concat(imageId, "\" class=\"responsive-image__wrapper product__image ").concat(imageClass, " ImageWrapper-").concat(imageId, "-image\" data-color-id=\"color--").concat(productId, "\">\n              <img\n                  data-image-id=\"").concat(imageId, "\"\n                  class=\"responsive-image__image lazyload ImageWrapper-").concat(imageId, "-").concat(theme.utils.uniqueNumber(5), "\"\n                  src=\"").concat(theme.utils.getSizedImageUrl(image, '700x'), "\"\n                  data-src=\"").concat(theme.utils.getSizedImageUrl(image, '1700x'), "\"\n                  data-widths=\"[360,540,720,900,1080,1440,2160,3240]\"\n                  data-sizes=\"auto\"\n                  data-aspectratio=\"").concat(imageAspectRatio, "\"\n                  alt=\"").concat(imageAlt, "\"\n                  tabindex=\"-1\"\n                >\n            </div>\n          </div>\n          ");
    };
    Promise.all(ajax_calls.map(promiseState)).then(function () {
      // Sort all the colors alphabetically
      var colorsJSONSortResult = [];
      var addcolorsJSONSortResult = [];
      var first = theme.product.handle;
      colorJSON.sort(function (x, y) {
        return x == first ? -1 : y == first ? 1 : 0;
      });
      additionColorJSON.sort(function (x, y) {
        return x == first ? -1 : y == first ? 1 : 0;
      });
      colorJSON.forEach(function (key) {
        var found = false;
        allColors = allColors.filter(function (item) {
          if (!found && item.handle == key) {
            colorsJSONSortResult.push(item);
            found = true;
            return false;
          } else return true;
        });
      });
      additionColorJSON.forEach(function (key) {
        var found = false;
        addColors = addColors.filter(function (item) {
          if (!found && item.handle == key) {
            addcolorsJSONSortResult.push(item);
            found = true;
            return false;
          } else return true;
        });
      });

      // Loop through each color
      colorsJSONSortResult.forEach(function (colorObj, index) {
        var colorTitle = colorObj.title.split('- ')[1];
        var colorHandle = colorObj.handle;
        var colorId = 'color--' + colorObj.id;
        var colorSwatch = '';
        var productId = colorObj.id;
        var colorHex = colorObj.metafields[0].color;
        var featuredImage = colorObj.featured_image;
        var colorFile = colorObj.color_file;
        var productATCText = theme.locales.product.add_to_bag;
        var productTag = '';
        var completeTheLookExclusionTag = true;
        var colorCompareAtPrice = colorObj.compare_at_price ? colorObj.compare_at_price : '';
        var colorPrice = colorObj.price;
        var colorAvailable = colorObj.available;
        var badgeTextForAttr = '';
        colorObj.tags.forEach(function (tag) {
          if (typeof tag === 'string' && tag.indexOf('badge_') === 0) {
            badgeTextForAttr = tag.slice(6);
          }
        });
        var productSKUs = [];
        var appOnly = false;
        var showSpecialMessage = false;
        if (index == 0) monetateAddProductDetails(colorObj);

        // SKUs
        colorObj.variants.forEach(function (variant) {
          var sku = variant.sku;
          productSKUs.push(sku);
        });
        productSKUs = JSON.stringify(productSKUs);

        // Determine if the color file exists
        /*
        jQuery.ajaxSetup({ async:false });
        $.ajax({
          type: 'HEAD',
          url: colorFile,
          error: function() {
            // page does not exist
            colorFile = null;
          }
        });
        */

        // console.log('colorObj', colorObj);
        // console.log('colorObj.title', colorObj.title);
        // Checking if special message needs to be displayed
        if (theme.settings.special_message_tag != '' && theme.settings.special_message != '') {
          if (colorObj.tags.includes(theme.settings.special_message_tag)) {
            showSpecialMessage = true;
          }
        }
        // Checking Product ATC Text
        if (colorObj.tags.includes('app-exclusive')) {
          productATCText = 'Download App';
          productTag = 'app-exclusive';
        } else {
          if (colorObj.tags.includes('swym-comingsoon')) {
            productATCText = theme.locales.product.coming_soon;
            productTag = theme.locales.product.coming_soon;
          } else if (colorObj.tags.includes('pdp_pre-order')) {
            productATCText = theme.locales.product.preorder;
            productTag = theme.locales.product.preorder;
          } else if (!colorAvailable) {
            productATCText = theme.locales.product.out_of_stock;
          }
        }

        // Checking to see if it contains any pdp_ tags
        colorObj.tags.forEach(function (tag) {
          if (tag.includes('pdp_')) productTag = tag.split('pdp_')[1];
          if (tag.includes('complete-the-look-exclusion')) completeTheLookExclusionTag = false;
          if (tag === 'app-exclusive') appOnly = true;
          if (tag == 'app-exclusive') productTag = tag;
        });

        // Get the color hexcode/image for swatches
        // Product image with alt 'swatch'
        if (colorSwatch == '' && colorFile != null) {
          colorSwatch = "background-image: url('".concat(colorFile, "'); background-size: cover;");
        } else if (colorSwatch == '' && colorHex != null) {
          // Metafield hexcode - product.metafields.color.swatch
          colorSwatch = "background-color: ".concat(colorHex, ";");
        } else if (colorSwatch == '') {
          // Fallback to second half of title - don't result to this 
          colorSwatch = "background-color: ".concat(colorTitle, ";");
        }

        // Inserting the color swatches
        colorsElement = "\n              <div class=\"swatch radio radio--color js-swatch js-swatch-".concat(colorHandle, "\">\n                <input type=\"radio\" name=\"Color\" title=\"").concat(colorTitle, "\" value=\"").concat(colorTitle, "\" class=\"sr-only form--product__option-selector js-option-selector js-color-option-value ").concat(colorId, "\" data-color=\"").concat(colorHandle, "\" data-color-id=\"").concat(colorId, "\" data-option=\"option1\" ").concat(currentProductHandle == colorHandle ? 'checked' : '', ">\n                <label class=\"").concat(currentProductHandle == colorHandle ? '' : 'swatch-hidden', "\" for=\"").concat(colorId, "\" data-skus='").concat(productSKUs, "' data-color=\"").concat(colorHandle, "\" data-available=\"").concat(colorAvailable, "\" data-app=\"").concat(appOnly, "\" data-complete-the-look=\"").concat(completeTheLookExclusionTag, "\" data-atc-text=\"").concat(productATCText, "\" data-tag=\"").concat(productTag, "\" data-compare-at-price=\"").concat(colorCompareAtPrice, "\" data-price=\"").concat(colorPrice, "\" data-product-id=\"").concat(colorObj.id, "\" class=\"js-color-label\" data-color-id=\"").concat(colorId, "\" title=\"").concat(colorTitle, "\" data-product-title=\"").concat(colorObj.title, "\" data-special-message=\"").concat(showSpecialMessage, "\" data-badge-text=\"").concat(encodeURIComponent(badgeTextForAttr), "\">\n                  <span data-color-id=\"").concat(colorId, "\" style=\"").concat(colorSwatch, " border: 1px solid #000000;\">").concat(colorTitle, "</span>\n                </label>\n              </div>\n            ");

        // Add color DOM
        if ($('input[data-color-id="' + colorId + '"]').length == 0) {
          formColors.forEach(function (block) {
            block.insertAdjacentHTML('beforeend', colorsElement);
          });
        }

        // RETURN = Skip the the first color because it's populated from form--product.liquid
        if (theme.template.name == 'product' && colorObj.handle == theme.product.handle) return;

        // Get the rest of the Images
        var imageHTML = '';
        colorObj.images.forEach(function (img, index) {
          var imageAlt = img.alt;
          var image = img.src;
          var imageId = img.id;
          var imagePosition = img.position;
          var imageAspectRatio = img.aspect_ratio;
          var imageClass = 'js-zoom';
          var imageType = 'product-media--cell';
          imageHTML = imageHTML + generateImages(image, imageId, imageAspectRatio, imageAlt, productId, imageType, imagePosition, imageClass);
        });
        var imageThubmailDOM = '';

        // Get the Mobile Images
        colorObj.images.forEach(function (img, index) {
          var imageAlt = img.alt;
          var mobImage = img.src;
          var mobImageId = img.id;
          var imagePosition = img.position;
          var mobImageAspectRatio = img.aspect_ratio;
          var mobImageAlt = img.alt;
          var mobImageType = 'product-media-thumbnail--cell js-product-media-thumbnail--cell';
          var mobImageClass = '';
          imageThubmailDOM = imageThubmailDOM + generateImages(mobImage, mobImageId, mobImageAspectRatio, mobImageAlt, productId, mobImageType, imagePosition, mobImageClass);
        });

        // Inserting the sizes of each of the color swatch
        var variantSize = colorObj.variants.length;
        var numberOfSizeDividedBy = parseInt(variantSize) / 6;
        var numberOfSizeRemainder = parseInt(variantSize) % 6;
        var variantsObj = colorObj.variants;
        var variantsData = allData[index].variants;
        var numberSize;
        var variantsJSON = {
          "variants": []
        };
        var variantsStringify;
        var variantsDataJSON = {
          "variants": []
        };
        variantsDataJSON.variants.push(variantsData);
        var variantsDataStringify = JSON.stringify(variantsDataJSON);
        var currentVariantSizes = [];

        // Check the quantity size and limited quantity
        if (numberOfSizeDividedBy > 1 || numberOfSizeRemainder == 1) {
          numberSize = 6;
        } else {
          numberSize = colorObj.variants.length;
        }
        var anyVariantOOS = false;
        // Need to get the variant object for data attribute
        variantsObj.forEach(function (variant) {
          var variantId = variant.id;
          var variantQty = variant.inventory_quantity;
          var variantPrice = variant.price;
          var variantsIdJSON = {};

          // Check if any variant is out of stock
          if (!variant.available) anyVariantOOS = true;

          // Creating variant information
          variantsJSON.variants.push({
            "id": variantId,
            "title": variant.title,
            "inventory": variantQty,
            "price": variantPrice
          });
          variantsStringify = JSON.stringify(variantsJSON);

          // Creating variant sizes array - for swym
          variantsIdJSON[variant.title] = variantId;
          currentVariantSizes.push(variantsIdJSON);
        });
        var variantLabels = variantLabelData[colorHandle];
        variantsObj.forEach(function (variant, index) {
          var variantId = variant.id;
          var variantQty = variant.inventory_quantity;
          var qtyLimit = document.querySelector('.js-form-size label').dataset.qtyLimit;
          var variantPrice = variant.price;
          var variantTitle = variant.title;
          var variantOption = 'SIZE: ' + variant.title;
          var variantSKU = variant.sku;
          var qtyLimitMessage = '';
          var variantPriceTitleClass = '';
          var arraySize = variantsObj.length - 1;
          var productHandle = colorObj.handle;
          var preorder = '';
          var preorderDate = '';
          if (typeof variantLabels[index] !== 'undefined' && typeof variantLabels[index][variantTitle] !== 'undefined') {
            preorder = variantLabels[index][variantTitle].preorder;
            preorderDate = variantLabels[index][variantTitle].preorderDate;
          }

          // Check if variant quantity vs limit quantity for message
          qtyLimitMessage = variantQty <= parseInt(qtyLimit) && variantQty > 0 ? 'Limited Quantities Available' : '';

          // Check if variant title has '$' to counter global E overlapping prices
          if (variant.title.indexOf('$') > -1 || variant.title.indexOf('€')) variantPriceTitleClass = "options__group--price-type-".concat(numberSize);
          var parentSizeWrapper = "<div class=\"form__field form__field--sizes options__group options__group--size-".concat(numberSize, " js-product-option hide ").concat(variantSize == 1 ? 'js-has-one-variant' : '', " ").concat(variantPriceTitleClass, "\" data-any-variant-oos=\"").concat(anyVariantOOS, "\" data-sizes-variants='").concat(JSON.stringify(currentVariantSizes), "' data-product-variants='").concat(variantsDataStringify, "' data-color-id=\"").concat(colorId, "\">");
          sizeElement = sizeElement + "\n                ".concat(index == 0 ? parentSizeWrapper : '', "\n                  <input id=\"").concat(variantId, "-").concat(numberSize, "\" name=\"").concat(variantId, "-").concat(numberSize, "\" class=\"is-hidden option-wx option sr-only\" value=\"").concat(variantId, "\" type=\"radio\">\n                  <label role=\"radio\" aria-checked=\"false\" data-current-variant='[{\"").concat(variant.title, "\": ").concat(variantId, "}]' data-current-sku=\"").concat(variantSKU, "\" data-color-id=\"").concat(colorId, "\" data-product-handle=\"").concat(productHandle, "\" data-product-title=\"").concat(colorObj.title, "\" data-product-id=\"").concat(productId, "\" data-variant-id=\"").concat(variantId, "\" for=\"").concat(variantId, "-").concat(numberSize, "\" data-variant-qty=\"").concat(variantQty, "\" data-qty-limit=\"").concat(qtyLimit, "\" data-limit-msg=\"").concat(qtyLimitMessage, "\" data-image=\"").concat(featuredImage, "\" data-price=\"").concat(variantPrice, "\" data-option1=\"").concat(variantOption, "\" data-preorder=\"").concat(preorder, "\" data-appexclusive=\"").concat(colorObj.tags.includes('app-exclusive') ? 'true' : 'false', "\" data-preorder-date=\"").concat(preorderDate, "\" class=\"").concat(variantQty < 1 || colorObj.tags.includes('swym-comingsoon') || colorObj.tags.includes('app-exclusive') ? 'is-disabled ' : '', "style style--secondary\" tabindex=\"0\">").concat(variant.title, "</label>\n                ").concat(index == arraySize ? '</div>' : '', "\n              ");
        });

        // Add product metafields to the product accordions
        var productDescription = colorObj.description;
        var productDetails = colorObj.metafields[0].details;
        var productFitDescription = colorObj.metafields[0].description;
        var productMeasurements = colorObj.metafields[0].measurements;
        var productClothesMeasurements = colorObj.metafields[0].product_measurements;
        var productFabric = colorObj.metafields[0].fabric;
        var productCare = colorObj.metafields[0].care;
        var productOrigin = colorObj.metafields[0].origin;
        var productDescriptionHTML = "\n            <li class=\"accordion__item accordion__item--desc js-accordion-item js-accordion-product is-active hide\" data-color-id=\"".concat(colorId, "\">\n              <a href=\"#\" class=\"accordion__label\">\n                ").concat(theme.svgs.accordion.icon_closed, "\n                <h2 class=\"heading--4\">").concat(theme.locales.product.description, "</h2>\n              </a>\n              <div class=\"accordion__info product__description js-accordion-wrapper js-product-description hide\">\n                ").concat(productDescription, "\n              </div>\n            </li>\n            ");
        var productFitHTML = "\n            <li class=\"accordion__item accordion__item--fit js-product-fit js-accordion-item js-accordion-product hide\" data-color-id=\"".concat(colorId, "\">\n              <a href=\"#\" class=\"accordion__label\">\n                ").concat(theme.svgs.accordion.icon_closed, "\n                <h2 class=\"heading--4\">").concat(theme.locales.product.fit, "</h2>\n              </a>\n              <div class=\"accordion__info product__fit js-accordion-wrapper hide\">\n                ").concat(productDetails == null ? '' : "<p>".concat(productDetails, "</p>"), "\n                ").concat(productFitDescription == null ? '' : "<p>".concat(productFitDescription, "</p>"), "\n                ").concat(productMeasurements == null ? '' : "<p>".concat(productMeasurements, "</p>"), "\n                ").concat(productClothesMeasurements == null ? '' : "<p>".concat(productClothesMeasurements, "</p>"), "\n              </div>\n            </li>\n            ");
        var productMaterialsHTML = "\n            <li class=\"accordion__item accordion__item--material js-product-material js-accordion-item js-accordion-product hide\" data-color-id=\"".concat(colorId, "\">\n              <a href=\"#\" class=\"accordion__label\">\n                ").concat(theme.svgs.accordion.icon_closed, "\n                <h2 class=\"heading--4\">").concat(theme.locales.product.material_care, "</h2>\n              </a>\n              \n              <div class=\"accordion__info product__material js-accordion-wrapper hide\">\n                ").concat(productFabric == null ? '' : "<p>".concat(productFabric, "</p>"), "\n                ").concat(productCare == null ? '' : "<p>".concat(productCare, "</p>"), "\n                ").concat(productOrigin == null ? '' : "<p>".concat(productOrigin, "</p>"), "\n              </div>\n            </li>\n            ");
        accordionText = "\n              ".concat(productDescription == null ? '' : productDescriptionHTML, "\n              ").concat(productDetails == null && productFitDescription == null && productMeasurements == null && productClothesMeasurements == null ? '' : productFitHTML, "\n              ").concat(productFabric == null && productCare == null && productOrigin == null ? '' : productMaterialsHTML, "\n            ");

        // Add DOM of mobile images
        var productThumbnailTrigger = "\n              <div class=\"product-media-thumbnail-arrow-wrap js-product-thumbnail-arrow-wrap hide\" data-color-id=\"".concat(colorId, "\">\n              <button class=\"product-media-thumbnail-arrow product-media-thumbnail-arrow-up js-product-thumbnail-arrow\" data-type=\"up\"></button>\n              <button class=\"product-media-thumbnail-arrow product-media-thumbnail-arrow-down js-product-thumbnail-arrow\" data-type=\"down\"></button>\n              </div>\n            ");
        var productImgWrapper = "\n              <div class=\"product-media-slider js-product-slider js-product-color-slider hide\" data-color-id=\"".concat(colorId, "\">").concat(imageHTML, "</div>\n            ");
        var productThumbnailImgWrapper = "\n              <div class=\"product-media-thumbnail js-product-thumbnail-slider js-product-color-thumbnail-slider hidden\" data-color-id=\"".concat(colorId, "\" data-scroll=\"").concat(colorObj.images.length > 4 ? 'true' : 'false', "\">").concat(imageThubmailDOM, "</div>\n            ");
        document.querySelector('.js-product-media-grid').insertAdjacentHTML('afterbegin', productThumbnailImgWrapper);
        document.querySelector('.js-product-media-grid').insertAdjacentHTML('afterbegin', productImgWrapper);
        if (colorObj.images.length > 4) {
          document.querySelector('.js-product-media-grid').insertAdjacentHTML('afterbegin', productThumbnailTrigger);
        }
        // Add DOM for product accordions
        document.querySelector('.js-accordion-product-wrapper').insertAdjacentHTML('afterbegin', accordionText);
        // Add DOM for desktop sizes
        sizeElement = "<fieldset><legend class='visually-hidden'>Sizes</legend>" + sizeElement + "</fieldset>";
        document.querySelector('.js-form-size').insertAdjacentHTML('beforeend', sizeElement);
        // Add DOM for mobile sizes
        //document.querySelector('.js-product-form-size--mobile .js-form-size').insertAdjacentHTML('beforeend', sizeElement);
        sizeElement = '';
      });

      // additional color loop
      addcolorsJSONSortResult.forEach(function (colorObj, index) {
        var colorTitle = colorObj.title.split('- ')[1];
        var colorHandle = colorObj.handle;
        var colorId = 'color--' + colorObj.id;
        var colorSwatch = '';
        var productId = colorObj.id;
        var colorHex = colorObj.metafields[0].color;
        var featuredImage = colorObj.featured_image;
        var colorFile = colorObj.color_file;
        var productATCText = theme.locales.product.add_to_bag;
        var productTag = '';
        var completeTheLookExclusionTag = true;
        var colorCompareAtPrice = colorObj.compare_at_price ? colorObj.compare_at_price : '';
        var colorPrice = colorObj.price;
        var colorAvailable = colorObj.available;
        var badgeTextForAttr = '';
        colorObj.tags.forEach(function (tag) {
          if (typeof tag === 'string' && tag.indexOf('badge_') === 0) {
            badgeTextForAttr = tag.slice(6);
          }
        });
        var productSKUs = [];
        var showSpecialMessage = false;
        if (index == 0) monetateAddProductDetails(colorObj);

        // SKUs
        colorObj.variants.forEach(function (variant) {
          var sku = variant.sku;
          productSKUs.push(sku);
        });
        productSKUs = JSON.stringify(productSKUs);

        // Determine if the color file exists
        /*
        jQuery.ajaxSetup({ async:false });
        $.ajax({
          type: 'HEAD',
          url: colorFile,
          error: function() {
            // page does not exist
            colorFile = null;
          }
        });
        */

        // console.log('colorObj', colorObj);
        // console.log('colorObj.title', colorObj.title);
        // Checking if special message needs to be displayed
        if (theme.settings.special_message_tag != '' && theme.settings.special_message != '') {
          if (colorObj.tags.includes(theme.settings.special_message_tag)) {
            showSpecialMessage = true;
          }
        }
        // Checking Product ATC Text
        if (colorObj.tags.includes('app-exclusive')) {
          productATCText = 'DOWNLOAD APP';
          productTag = 'app-exclusive';
        } else {
          if (colorObj.tags.includes('swym-comingsoon')) {
            productATCText = theme.locales.product.coming_soon;
            productTag = theme.locales.product.coming_soon;
          } else if (colorObj.tags.includes('pdp_pre-order')) {
            productATCText = theme.locales.product.preorder;
            productTag = theme.locales.product.preorder;
          } else if (!colorAvailable) {
            productATCText = theme.locales.product.out_of_stock;
          }
        }

        // Checking to see if it contains any pdp_ tags
        colorObj.tags.forEach(function (tag) {
          if (tag.includes('pdp_')) productTag = tag.split('pdp_')[1];
          if (tag.includes('complete-the-look-exclusion')) completeTheLookExclusionTag = false;
          if (tag == 'app-exclusive') productTag = tag;
        });

        // Get the color hexcode/image for swatches
        // Product image with alt 'swatch'
        if (colorSwatch == '' && colorFile != null) {
          colorSwatch = "background-image: url('".concat(colorFile, "'); background-size: cover;");
        } else if (colorSwatch == '' && colorHex != null) {
          // Metafield hexcode - product.metafields.color.swatch
          colorSwatch = "background-color: ".concat(colorHex, ";");
        } else if (colorSwatch == '') {
          // Fallback to second half of title - don't result to this 
          colorSwatch = "background-color: ".concat(colorTitle, ";");
        }

        // Inserting the color swatches
        colorsElement = "\n              <div class=\"swatch radio radio--color js-swatch js-swatch-".concat(colorHandle, "\">\n                <input type=\"radio\" name=\"Color\" title=\"").concat(colorTitle, "\" value=\"").concat(colorTitle, "\" class=\"sr-only form--product__option-selector js-option-selector js-color-option-value ").concat(colorId, "\" data-color=\"").concat(colorHandle, "\" data-color-id=\"").concat(colorId, "\" data-option=\"option1\" ").concat(currentProductHandle == colorHandle ? 'checked' : '', ">\n                <label class=\"").concat(currentProductHandle == colorHandle ? '' : 'swatch-hidden', "\" for=\"").concat(colorId, "\" data-skus='").concat(productSKUs, "' data-color=\"").concat(colorHandle, "\" data-available=\"").concat(colorAvailable, "\" data-complete-the-look=\"").concat(completeTheLookExclusionTag, "\" data-atc-text=\"").concat(productATCText, "\" data-tag=\"").concat(productTag, "\" data-compare-at-price=\"").concat(colorCompareAtPrice, "\" data-price=\"").concat(colorPrice, "\" data-product-id=\"").concat(colorObj.id, "\" class=\"js-color-label\" data-color-id=\"").concat(colorId, "\" title=\"").concat(colorTitle, "\" data-product-title=\"").concat(colorObj.title, "\" data-special-message=\"").concat(showSpecialMessage, "\" data-badge-text=\"").concat(encodeURIComponent(badgeTextForAttr), "\">\n                  <span data-color-id=\"").concat(colorId, "\" style=\"").concat(colorSwatch, " border: 1px solid #000000;\">").concat(colorTitle, "</span>\n                </label>\n              </div>\n            ");

        // Add color DOM
        if ($('input[data-color-id="' + colorId + '"]').length == 0) {
          addformColors.forEach(function (block) {
            block.insertAdjacentHTML('beforeend', colorsElement);
          });
        }

        // RETURN = Skip the the first color because it's populated from form--product.liquid
        if (theme.template.name == 'product' && colorObj.handle == theme.product.handle) return;

        // Get the rest of the Images
        var imageHTML = '';
        colorObj.images.forEach(function (img, index) {
          var imageAlt = img.alt;
          var image = img.src;
          var imageId = img.id;
          var imagePosition = img.position;
          var imageAspectRatio = img.aspect_ratio;
          var imageClass = 'js-zoom';
          var imageType = 'product-media--cell';
          imageHTML = imageHTML + generateImages(image, imageId, imageAspectRatio, imageAlt, productId, imageType, imagePosition, imageClass);
        });
        var imageThubmailDOM = '';

        // Get the Mobile Images
        colorObj.images.forEach(function (img, index) {
          var imageAlt = img.alt;
          var mobImage = img.src;
          var mobImageId = img.id;
          var imagePosition = img.position;
          var mobImageAspectRatio = img.aspect_ratio;
          var mobImageAlt = img.alt;
          var mobImageType = 'product-media-thumbnail--cell js-product-media-thumbnail--cell';
          var mobImageClass = '';
          imageThubmailDOM = imageThubmailDOM + generateImages(mobImage, mobImageId, mobImageAspectRatio, mobImageAlt, productId, mobImageType, imagePosition, mobImageClass);
        });

        // Inserting the sizes of each of the color swatch
        var variantSize = colorObj.variants.length;
        var numberOfSizeDividedBy = parseInt(variantSize) / 6;
        var numberOfSizeRemainder = parseInt(variantSize) % 6;
        var variantsObj = colorObj.variants;
        var variantsData = addData[index].variants;
        var numberSize;
        var variantsJSON = {
          "variants": []
        };
        var variantsStringify;
        var variantsDataJSON = {
          "variants": []
        };
        variantsDataJSON.variants.push(variantsData);
        var variantsDataStringify = JSON.stringify(variantsDataJSON);
        var currentVariantSizes = [];

        // Check the quantity size and limited quantity
        if (numberOfSizeDividedBy > 1 || numberOfSizeRemainder == 1) {
          numberSize = 6;
        } else {
          numberSize = colorObj.variants.length;
        }
        var anyVariantOOS = false;
        // Need to get the variant object for data attribute
        variantsObj.forEach(function (variant) {
          var variantId = variant.id;
          var variantQty = variant.inventory_quantity;
          var variantPrice = variant.price;
          var variantsIdJSON = {};

          // Check if any variant is out of stock
          if (!variant.available) anyVariantOOS = true;

          // Creating variant information
          variantsJSON.variants.push({
            "id": variantId,
            "title": variant.title,
            "inventory": variantQty,
            "price": variantPrice
          });
          variantsStringify = JSON.stringify(variantsJSON);

          // Creating variant sizes array - for swym
          variantsIdJSON[variant.title] = variantId;
          currentVariantSizes.push(variantsIdJSON);
        });
        var variantLabels = variantLabelData[colorHandle];
        variantsObj.forEach(function (variant, index) {
          var variantId = variant.id;
          var variantQty = variant.inventory_quantity;
          var qtyLimit = document.querySelector('.js-form-size label').dataset.qtyLimit;
          var variantPrice = variant.price;
          var variantTitle = variant.title;
          var variantOption = 'SIZE: ' + variant.title;
          var variantSKU = variant.sku;
          var qtyLimitMessage = '';
          var variantPriceTitleClass = '';
          var arraySize = variantsObj.length - 1;
          var productHandle = colorObj.handle;
          var preorder = '';
          var preorderDate = '';
          if (typeof variantLabels[index] !== 'undefined' && typeof variantLabels[index][variantTitle] !== 'undefined') {
            preorder = variantLabels[index][variantTitle].preorder;
            preorderDate = variantLabels[index][variantTitle].preorderDate;
          }

          // Check if variant quantity vs limit quantity for message
          qtyLimitMessage = variantQty <= parseInt(qtyLimit) && variantQty > 0 ? 'Limited Quantities Available' : '';

          // Check if variant title has '$' to counter global E overlapping prices
          if (variant.title.indexOf('$') > -1 || variant.title.indexOf('€')) variantPriceTitleClass = "options__group--price-type-".concat(numberSize);
          var parentSizeWrapper = "<div class=\"form__field form__field--sizes options__group options__group--size-".concat(numberSize, " js-product-option hide ").concat(variantSize == 1 ? 'js-has-one-variant' : '', " ").concat(variantPriceTitleClass, "\" data-any-variant-oos=\"").concat(anyVariantOOS, "\" data-sizes-variants='").concat(JSON.stringify(currentVariantSizes), "' data-product-variants='").concat(variantsDataStringify, "' data-color-id=\"").concat(colorId, "\">");
          sizeElement = sizeElement + "\n                ".concat(index == 0 ? parentSizeWrapper : '', "\n                  <input id=\"").concat(variantId, "-").concat(numberSize, "\" name=\"").concat(variantId, "-").concat(numberSize, "\" class=\"is-hidden option-wx option sr-only\" value=\"").concat(variantId, "\" type=\"radio\">\n                  <label role=\"radio\" aria-checked=\"false\" data-current-variant='[{\"").concat(variant.title, "\": ").concat(variantId, "}]' data-current-sku=\"").concat(variantSKU, "\" data-color-id=\"").concat(colorId, "\" data-product-handle=\"").concat(productHandle, "\" data-product-title=\"").concat(colorObj.title, "\" data-product-id=\"").concat(productId, "\" data-variant-id=\"").concat(variantId, "\" for=\"").concat(variantId, "-").concat(numberSize, "\" data-variant-qty=\"").concat(variantQty, "\" data-qty-limit=\"").concat(qtyLimit, "\" data-limit-msg=\"").concat(qtyLimitMessage, "\" data-image=\"").concat(featuredImage, "\" data-price=\"").concat(variantPrice, "\" data-option1=\"").concat(variantOption, "\" data-preorder=\"").concat(preorder, "\" data-appexclusive=\"").concat(colorObj.tags.includes('app-exclusive') ? 'true' : 'false', "\" data-preorder-date=\"").concat(preorderDate, "\" class=\"").concat(variantQty < 1 || colorObj.tags.includes('swym-comingsoon') || colorObj.tags.includes('app-exclusive') ? 'is-disabled ' : '', "style style--secondary\" tabindex=\"0\">").concat(variant.title, "</label>\n                ").concat(index == arraySize ? '</div>' : '', "\n              ");
        });

        // Add product metafields to the product accordions
        var productDescription = colorObj.description;
        var productDetails = colorObj.metafields[0].details;
        var productFitDescription = colorObj.metafields[0].description;
        var productMeasurements = colorObj.metafields[0].measurements;
        var productClothesMeasurements = colorObj.metafields[0].product_measurements;
        var productFabric = colorObj.metafields[0].fabric;
        var productCare = colorObj.metafields[0].care;
        var productOrigin = colorObj.metafields[0].origin;
        var productDescriptionHTML = "\n            <li class=\"accordion__item accordion__item--desc js-accordion-item js-accordion-product is-active hide\" data-color-id=\"".concat(colorId, "\">\n              <a href=\"#\" class=\"accordion__label\">\n                ").concat(theme.svgs.accordion.icon_closed, "\n                <h2 class=\"heading--4\">").concat(theme.locales.product.description, "</h2>\n              </a>\n              <div class=\"accordion__info product__description js-accordion-wrapper js-product-description hide\">\n                ").concat(productDescription, "\n              </div>\n            </li>\n            ");
        var productFitHTML = "\n            <li class=\"accordion__item accordion__item--fit js-product-fit js-accordion-item js-accordion-product hide\" data-color-id=\"".concat(colorId, "\">\n              <a href=\"#\" class=\"accordion__label\">\n                ").concat(theme.svgs.accordion.icon_closed, "\n                <h2 class=\"heading--4\">").concat(theme.locales.product.fit, "</h2>\n              </a>\n              <div class=\"accordion__info product__fit js-accordion-wrapper hide\">\n                ").concat(productDetails == null ? '' : "<p>".concat(productDetails, "</p>"), "\n                ").concat(productFitDescription == null ? '' : "<p>".concat(productFitDescription, "</p>"), "\n                ").concat(productMeasurements == null ? '' : "<p>".concat(productMeasurements, "</p>"), "\n                ").concat(productClothesMeasurements == null ? '' : "<p>".concat(productClothesMeasurements, "</p>"), "\n              </div>\n            </li>\n            ");
        var productMaterialsHTML = "\n            <li class=\"accordion__item accordion__item--material js-product-material js-accordion-item js-accordion-product hide\" data-color-id=\"".concat(colorId, "\">\n              <a href=\"#\" class=\"accordion__label\">\n                ").concat(theme.svgs.accordion.icon_closed, "\n                <h2 class=\"heading--4\">").concat(theme.locales.product.material_care, "</h2>\n              </a>\n              \n              <div class=\"accordion__info product__material js-accordion-wrapper hide\">\n                ").concat(productFabric == null ? '' : "<p>".concat(productFabric, "</p>"), "\n                ").concat(productCare == null ? '' : "<p>".concat(productCare, "</p>"), "\n                ").concat(productOrigin == null ? '' : "<p>".concat(productOrigin, "</p>"), "\n              </div>\n            </li>\n            ");
        accordionText = "\n              ".concat(productDescription == null ? '' : productDescriptionHTML, "\n              ").concat(productDetails == null && productFitDescription == null && productMeasurements == null && productClothesMeasurements == null ? '' : productFitHTML, "\n              ").concat(productFabric == null && productCare == null && productOrigin == null ? '' : productMaterialsHTML, "\n            ");

        // Add DOM of mobile images
        var productThumbnailTrigger = "\n              <div class=\"product-media-thumbnail-arrow-wrap js-product-thumbnail-arrow-wrap hide\" data-color-id=\"".concat(colorId, "\">\n              <button class=\"product-media-thumbnail-arrow product-media-thumbnail-arrow-up js-product-thumbnail-arrow\" data-type=\"up\"></button>\n              <button class=\"product-media-thumbnail-arrow product-media-thumbnail-arrow-down js-product-thumbnail-arrow\" data-type=\"down\"></button>\n              </div>\n            ");
        var productImgWrapper = "\n              <div class=\"product-media-slider js-product-slider js-product-color-slider hide\" data-color-id=\"".concat(colorId, "\">").concat(imageHTML, "</div>\n            ");
        var productThumbnailImgWrapper = "\n              <div class=\"product-media-thumbnail js-product-thumbnail-slider js-product-color-thumbnail-slider hidden\" data-color-id=\"".concat(colorId, "\" data-scroll=\"").concat(colorObj.images.length > 4 ? 'true' : 'false', "\">").concat(imageThubmailDOM, "</div>\n            ");
        document.querySelector('.js-product-media-grid').insertAdjacentHTML('afterbegin', productThumbnailImgWrapper);
        document.querySelector('.js-product-media-grid').insertAdjacentHTML('afterbegin', productImgWrapper);
        if (colorObj.images.length > 4) {
          document.querySelector('.js-product-media-grid').insertAdjacentHTML('afterbegin', productThumbnailTrigger);
        }
        // Add DOM for product accordions
        document.querySelector('.js-accordion-product-wrapper').insertAdjacentHTML('afterbegin', accordionText);
        // Add DOM for desktop sizes
        sizeElement = "<fieldset><legend class='visually-hidden'>Sizes</legend>" + sizeElement + "</fieldset>";
        document.querySelector('.js-form-size').insertAdjacentHTML('beforeend', sizeElement);
        // Add DOM for mobile sizes
        //document.querySelector('.js-product-form-size--mobile .js-form-size').insertAdjacentHTML('beforeend', sizeElement);
        sizeElement = '';
      });
      var allMobileImages = _toConsumableArray2(document.querySelectorAll('.js-product-color-slider'));
      allMobileImages.forEach(function (mobileImageWrapper) {
        $(mobileImageWrapper).slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          nextArrow: '<button class="slick-next slick-arrow slider-arrow slider-arrow--next" aria-label="Next" type="button" style="">Next</button>',
          prevArrow: '<button class="slick-prev slick-arrow slider-arrow slider-arrow--prev" aria-label="Previous" type="button" style="">Previous</button>',
          lazyLoad: 'progressive',
          responsive: [{
            breakpoint: 996,
            settings: {
              dots: true
            }
          }]
        });
      });

      // setTimeout(function(){
      //   const allThumbImages = [...document.querySelectorAll('.js-product-color-thumbnail-slider')];
      //   allThumbImages.forEach((thumbImageWrapper) => {
      //     var thumbImageWrapperScroll = thumbImageWrapper.dataset.scroll;
      //     var thumbColorSlider = $(thumbImageWrapper).slick({
      //       dots: false,
      //       arrows: true,
      //       infinite: true,
      //       speed: 300,
      //       slidesToShow: 4,
      //       nextArrow: '<button class="product-media-thumbnail-arrow product-media-thumbnail-arrow-down js-product-thumbnail-arrow" data-type="down"></button>',
      //       prevArrow: '<button class="product-media-thumbnail-arrow product-media-thumbnail-arrow-up js-product-thumbnail-arrow" data-type="up"></button>',
      //       lazyLoad: "progressive",
      //       vertical: true,
      //       verticalSwiping: true
      //     });

      //     if(thumbImageWrapperScroll == 'true'){
      //       thumbColorSlider.on('wheel', (function(e) {
      //         e.preventDefault();

      //         if (e.originalEvent.deltaY < 0) {
      //           $(this).slick('slickPrev');
      //         } else {
      //           $(this).slick('slickNext');
      //         }
      //       }));
      //     }
      //   })
      // }, 200)

      initColorDOMGeneration();
    });
  };
  var initColorDOMGeneration = function initColorDOMGeneration() {
    theme.initProductColor();
    theme.initAccordion();
    theme.zoomImage();
    $('body').on('click', '.js-product-media-thumbnail--cell', function () {
      var position = $(this).attr('data-index');
      var color = $(this).closest('.js-product-thumbnail-slider').attr('data-color-id');
      $('.js-product-media-thumbnail--cell').removeClass('active');
      $(this).addClass('active');
      $('.js-product-slider[data-color-id="' + color + '"]').slick('slickGoTo', position - 1);
    });
    $('.js-product-thumbnail-slider').on('scroll', function (e) {
      //// console.log(e.target);
      var color = $(this).attr('data-color-id');
      var tsScrollHeight = e.target.scrollHeight;
      var tsScrollTop = e.target.scrollTop;
      var tsClientHeight = e.target.clientHeight;
      if (tsScrollHeight < tsScrollTop + tsClientHeight + 10) {
        $('.js-product-thumbnail-arrow-wrap[data-color-id="' + color + '"]').find('[data-type="down"]').fadeOut();
        $('.js-product-thumbnail-arrow-wrap[data-color-id="' + color + '"]').find('[data-type="up"]').fadeIn();
      } else {
        $('.js-product-thumbnail-arrow-wrap[data-color-id="' + color + '"]').find('[data-type="down"]').fadeIn();
        $('.js-product-thumbnail-arrow-wrap[data-color-id="' + color + '"]').find('[data-type="up"]').fadeOut();
      }
    });
    $('body').on('click', '.js-product-thumbnail-arrow', function () {
      var colorID = $(this).closest('.js-product-thumbnail-arrow-wrap').attr('data-color-id');
      var cellHeight = $('.js-product-thumbnail-slider[data-color-id="' + colorID + '"] .js-product-media-thumbnail--cell').height();
      var targetType = $(this).attr('data-type');
      var tsClient = $('.js-product-thumbnail-slider[data-color-id="' + colorID + '"]')[0];
      var tsScrollHeight = tsClient.scrollHeight;
      var tsScrollTop = tsClient.scrollTop;
      var tsClientHeight = tsClient.clientHeight;
      if (targetType == 'up') {
        $('.js-product-thumbnail-slider[data-color-id="' + colorID + '"]').animate({
          scrollTop: tsScrollTop - cellHeight - 13
        }, 200);
      } else {
        $('.js-product-thumbnail-slider[data-color-id="' + colorID + '"]').animate({
          scrollTop: tsScrollTop + cellHeight + 13
        }, 200);
      }
    });
  };
  document.addEventListener("DOMContentLoaded", colorSwatchesInit);
}
if ("product" == theme.template.name && "bundle" == theme.template.suffix) {
  var bundleJSON = JSON.parse(bundle_handles),
    productBundleInit = function productBundleInit() {
      var E = theme.product.handle,
        x = "",
        T = "",
        o = [],
        i = [];
      jQuery.ajaxSetup({
        async: !0
      });
      bundleJSON.forEach(function (e, t) {
        o.push($.get("/products/" + e + "?view=json", function (e) {
          i.push(JSON.parse(e));
        }));
      });
      function n() {
        var e = [].concat(_toConsumableArray(document.querySelectorAll(".js-bundle-variants"))),
          s = [],
          c = [],
          l = [],
          d = [];
        e.forEach(function (e) {
          var o = e.value,
            t = function (t) {
              var e = theme.cart.content.items.filter(function (e) {
                return !(e.variant_id !== +t || e.properties && e.properties._gift);
              });
              return e.length ? {
                isInCart: !0,
                quantity: e[0].quantity
              } : {
                isInCart: !1
              };
            }(o),
            i = e.options[e.selectedIndex],
            n = i.getAttribute("data-variant-sku"),
            r = i.getAttribute("data-variant-price") / 100;
          if (t.isInCart) {
            var a = t.quantity + 1;
            theme.cart.content.items.filter(function (e) {
              var t = !e.properties || "true" !== e.properties._gift;
              e.variant_id == +o && t && (o = e.key, s.push({
                id: o,
                quantity: a
              }), d.push({
                productId: o,
                quantity: a,
                unitPrice: r,
                sku: n,
                currency: theme.shop.currency
              }));
            });
          } else c.push({
            id: o,
            quantity: 1
          }), l.push({
            productId: o,
            quantity: 1,
            unitPrice: r,
            sku: n,
            currency: theme.shop.currency
          });
        }), function (t, o, i, n) {
          var r = document.querySelector(".js-cart");
          document.querySelector(".js-cart").classList.add("is-loading"), document.querySelector(".js-cart-flyout-trigger").click(), new Promise(function (e) {
            0 < i.length && localStorage.setItem("updating-bundle", !0), theme.cart.update(t).then(function () {
              0 === i.length ? (localStorage.setItem("updating-bundle", !1), r.classList.remove("is-loading"), localStorage.removeItem("bundle-submit"), window.monetateQ.push(["trackData"])) : $.ajax({
                url: "/cart/add.js",
                data: {
                  items: i
                },
                type: "POST",
                dataType: "json"
              }).done(function (e) {
                theme.cart.fetch(), r.classList.remove("is-loading"), localStorage.removeItem("bundle-submit"), window.monetateQ = window.monetateQ || [], window.monetateQ.push(["addCartRows", n.concat(o)]), window.monetateQ.push(["setPageType", theme.template.page_type]), window.monetateQ.push(["trackData"]);
              }), e();
            });
          });
        }(s, d, c, l);
      }
      function d(e) {
        e.disabled = !1, e.classList.remove("button--secondary"), e.classList.add("button--primary"), e.innerText = theme.locales.product.add_to_bag;
      }
      function u(e) {
        var i = [];
        e.forEach(function (e) {
          var t = e.dataset.variantSku,
            o = e.dataset.productId;
          i.push({
            productId: o,
            sku: t
          });
        }), window.monetateQ = window.monetateQ || [], window.monetateQ.push(["setPageType", theme.template.page_type]), window.monetateQ.push(["addProductDetails", i]), window.monetateQ.push(["trackData"]);
      }
      Promise.all(o.map(function (e) {
        return e.then(function (e) {
          return {
            v: e,
            status: "fulfilled"
          };
        }, function (e) {
          return {
            e: e,
            status: "rejected"
          };
        });
      })).then(function () {
        var e = i;
        e.sort(function (e, t) {
          return bundleJSON.indexOf(e.handle) - bundleJSON.indexOf(t.handle);
        }), e.forEach(function (h) {
          var e,
            v = h.title.split("- ")[0],
            t = h.title.split("- ")[1],
            o = h.handle,
            _ = "color--" + h.id,
            i = "",
            n = h.color_file,
            y = h.id,
            r = h.metafields[0].color,
            g = h.featured_image,
            a = h.featured_image_id,
            s = h.featured_image_aspect_ratio,
            c = h.featured_image_alt,
            l = theme.locales.product.add_to_bag,
            d = h.compare_at_price ? h.compare_at_price : "",
            u = h.price,
            m = "" + theme.shop.url + h.url;
          jQuery.ajaxSetup({
            async: !1
          }), $.ajax({
            type: "HEAD",
            url: n,
            error: function error() {
              n = null;
            }
          }), "" == i && null != n ? i = "background-image: url('" + n + "'); background-size: cover;" : "" == i && null != r ? i = "background-color: " + r + ";" : "" == i && (i = "background-color: " + t + ";"), e = '\n          <div hello="3" class="swatch radio radio--color js-swatch">\n            <input aria-hidden="false" type="checkbox" name="Color" title="' + t + '" value="' + t + '" class="form--product__option-selector js-option-selector js-color-option-value ' + _ + '" data-color="' + o + '" data-color-id="' + _ + '" data-option="option1" checked>\n            <label class="' + (E == o ? "" : "swatch-hidden") + '" for="' + _ + '" data-atc-text="' + l + '" data-compare-at-price="' + d + '" data-price="' + u + '" data-product-id="' + h.id + '" class="js-color-label" data-color-id="' + _ + '" title="' + t + '" data-product-title="' + h.title + '" tabindex="0" role="button">\n              <span data-color-id="' + _ + '" style="' + i + ' border: 1px solid #000000;">' + t + "</span>\n            </label>\n          </div>\n        ";
          var p;
          p = function (e, t, o, i, n, r) {
            return '\n        <a href="' + r + '">\n          <div data-image-id="' + t + '" class="js-zoom responsive-image__wrapper product__image ImageWrapper-' + t + "-" + theme.utils.uniqueNumber(5) + '" data-color-id="color--' + n + '">\n            <img\n                data-image-id="' + t + '"\n                class="responsive-image__image lazyload ImageWrapper-' + t + "-" + theme.utils.uniqueNumber(5) + '"\n                src="' + theme.utils.getSizedImageUrl(e, "700x") + '"\n                data-src="' + theme.utils.getSizedImageUrl(e, "700x") + '"\n                data-widths="[360,540,720,900,1080,1440,2160,3240]"\n                data-sizes="auto"\n                data-aspectratio="' + o + '"\n                alt="' + i + '"\n                tabindex="-1"\n                style="position: static"\n              >\n          </div>\n        </a>\n      ';
          }(g, a, s, c, y, m);
          var b = h.variants.length,
            f = parseInt(b) / 6,
            w = parseInt(b) % 6,
            S = h.variants,
            k = void 0,
            q = {
              variants: []
            },
            j = void 0,
            A = [],
            C = !1;
          k = 1 < f || 1 == w ? 6 : h.variants.length, S.forEach(function (e) {
            var t = e.id,
              o = e.inventory_quantity,
              i = e.price,
              n = {};
            e.available || (C = !0), q.variants.push({
              id: t,
              title: e.title,
              inventory: o,
              price: i
            }), j = JSON.stringify(q), n[e.title] = t, A.push(n);
          }), S.forEach(function (e, t) {
            var o = e.id,
              i = e.inventory_quantity,
              n = e.price,
              r = e.sku,
              a = "Default Title" == e.title ? "ONE" : e.title,
              s = "SIZE: " + e.title,
              c = "",
              l = "",
              d = S.length - 1,
              u = h.handle,
              m = 1 == S.length && 0 < i ? "is-selected" : "";
            (-1 < e.title.indexOf("$") || e.title.indexOf("€")) && (c = "options__group--price-type-" + k);
            var p = '<div class="form__field form__field--sizes options__group options__group--size-' + k + " js-product-option " + (1 == b ? "js-has-one-variant" : "") + " " + c + '" data-any-variant-oos="' + C + "\" data-sizes-variants='" + JSON.stringify(A) + "' data-product-variants='" + j + "' data-color-id=\"" + _ + '">',
              f = '<select id="bundle-' + _ + '" class="js-bundle-variants js-bundle-variants--' + h.id + '">\n          ';
            x = x + "\n            " + (0 == t ? p : "") + '\n              <input class="option" name="id" value="' + o + '" type="radio" aria-hidden="true" aria-label="Hidden option input 1" checked>\n              <label role="button" data-current-variant=\'[{"' + e.title + '": ' + o + "}]' data-color-id=\"" + _ + '" data-product-handle="' + u + '" data-product-title="' + h.title + '" data-product-id="' + y + '" data-variant-id="' + o + '" data-variant-sku="' + r + '" for="' + o + "-" + k + '" data-variant-qty="' + i + '" data-image="' + g + '" data-price="' + n + '" data-option1="' + s + '" class="' + m + " " + (i < 1 ? "is-disabled " : "") + '" style style--secondary" tabindex="0" aria-label="' + s + '">' + a + "</label>\n            " + (t == d ? "</div>" : "") + "\n          ", 1 == S.length && 0 < i && (l = "selected"), T = T + "\n            " + (0 == t ? f : "") + "\n              " + ("" == l && 0 == t ? '<option value="default" selected>Select a Size</option>' : "") + '\n              <option value="' + o + '" data-variant-qty="' + i + '" data-variant-sku="' + r + '" data-variant-price="' + n + '" ' + l + ">" + v + " / " + e.title + "</option>\n            " + (t == d ? "</select>" : "") + "\n          ";
          });
          var L = '\n          <div class="product-individual-bundle js-bundle-color js-bundle-' + _ + '" data-price="' + u + '" data-variant-sku="' + S[0].sku + '" data-product-id="' + y + '">\n            <div class="product-individual-bundle__featured-image js-product-bundle-featured-image">' + p + '</div>\n            <div class="product-individual-bundle__info">\n              <h3 class="product-individual-bundle__title js-product-bundle-title">' + v + '</h3>\n              <div class="color-swatch">\n                <div class="color-swatch__name-wrapper">\n                  <span class="label label--has-value">\n                    <span class="color-swatch__name text-title-space js-color-name">' + t + '</span>\n                  </span>\n                </div>\n                <div class="color-swatch__wrapper">\n                  <div class="product-individual-bundle__color-swatch js-product-bundle-swatch">' + e + '</div>\n                </div>\n              </div>\n              <div class="product-individual-bundle__sizes js-product-bundle-sizes">' + x + "</div>\n            </div>\n          </div>\n        ";
          document.querySelector(".js-product-bundle").insertAdjacentHTML("beforeend", L), document.querySelector(".js-product-bundle").insertAdjacentHTML("beforeend", T), T = x = "";
        });
        var a = [].concat(_toConsumableArray(document.querySelectorAll(".js-bundle-variants"))),
          t = [].concat(_toConsumableArray(document.querySelectorAll(".js-bundle-color .js-product-bundle-sizes label"))),
          s = document.querySelector(".js-product-bundle-atc"),
          c = 0 < !a.filter(function (e) {
            return "default" == e.value;
          }).length,
          l = void 0;
        t.forEach(function (r) {
          r.onclick = function () {
            var e = 0 < r.dataset.variantQty,
              t = r.dataset.variantId,
              o = r.dataset.productId,
              i = [].concat(_toConsumableArray(document.querySelectorAll(".js-bundle-color--" + o + " .js-product-bundle-sizes label")));
            if (e) {
              var n = document.querySelector(".js-bundle-variants--" + o + ' option[value="' + t + '"]');
              i.forEach(function (e) {
                e.classList.remove("is-selected");
              }), r.classList.add("is-selected"), n.selected = !0, (c = 0 < !a.filter(function (e) {
                return "default" == e.value;
              }).length) && (d(s), l = [].concat(_toConsumableArray(document.querySelectorAll(".js-product-option .is-selected"))), u(l));
            }
          };
        });
        var o = [].concat(_toConsumableArray(document.querySelectorAll(".js-bundle-color")));
        u(o), c && d(s), document.getElementById("ProductForm--AddToCartBundle").addEventListener("submit", function (e) {
          e.preventDefault(), localStorage.setItem("bundle-submit", !0), n();
        }), theme.initAccordion(), theme.zoomImage();
      });
    };
  document.addEventListener("DOMContentLoaded", productBundleInit);
}
// PDP video control script
$(document).ready(function () {
  $('body').on('click', '.js-product-video-player-icon', function () {
    var video = $(this).closest('.responsive-image__wrapper').find('video');
    var vi = $(this);
    var attrPlay = vi.attr('aria-label');
    // console.log(attrPlay);
    if (attrPlay == 'Play') {
      vi.attr('aria-label', 'Pause');
      vi.attr('title', 'Pause');
      video.get(0).play();
      vi.find('.video-control-text').text('Pause');
    } else {
      video.get(0).pause();
      vi.attr('aria-label', 'Play');
      vi.attr('title', 'Play');
      vi.find('.video-control-text').text('Play');
    }
  });
});
$('body').on('click', '.js-trigger-search', function () {
  $('#isp_main_search_box').attr('aria-describedby', 'search-instructions');
  $('#isp_main_search_box').attr('aria-autocomplete', 'list');
});
$('body').keyup(function (e) {
  if (e.which === 27) {
    $('.cart-flyout__overlay').removeClass('is-active');
    $('.cart-flyout--container').removeClass('is-active');
  }
});
setTimeout(function () {
  $('.input--footer').attr('aria-describedby', 'requirements');
  $('#isp_main_search_box').attr('aria-describedby', 'search-instructions');
}, 500);
setTimeout(function () {
  $('#isp_main_search_box').attr('aria-describedby', 'search-instructions');
  $('#isp_main_search_box').attr('aria-controls', 'ui-id-1');
  $('.search-close__trigger').attr('tabindex', '0');
  $('.input--footer').attr('aria-describedby', 'requirements');
}, 1000);
setTimeout(function () {
  $('.input--footer').attr('aria-describedby', 'requirements');
}, 1500);
setInterval(function () {
  if ($('#ui-id-1').hasClass('is-open')) {
    $('#isp_main_search_box').attr('aria-expanded', 'true');
  } else {
    //$('#isp_main_search_box').attr('aria-expanded','false');
  }
}, 500);
function reorderResults() {
  //issue 264
  $(".ui-autocomplete > li").each(function (index) {
    var item = $(this).clone();
    $(this).remove();
    $('.ui-autocomplete').prepend(item);
  });
}
function postISPada() {
  // console.log('running post ISP event function to clean up ADA issues');

  // set product id if quickview mode is shown
  if ($("#isp_product_quick_view_model").length > 0) {
    var productId = $("#isp_product_quick_view_model .isp_quick_view_title").attr("product_id");
    localStorage.setItem('product', productId);

    // @wx-merge: 101
    document.activeElement.blur();
    setTimeout(function () {
      // $('#isp_product_quick_view_model #ModalCloseButton').attr("tabindex",-1).focus();
      $('#isp_product_quick_view_model').attr("tabindex", -1).focus();
    }, 1000);
    // @end-wx-merge: 101

    var modals = document.querySelectorAll('#isp_product_quick_view_model');
    initTrap(modals);
  }
  setTimeout(function () {
    // issue 130
    $('body').find('.isp_search_res_facets_container > .isp_single_facet_wrapper > .isp_facet_title').each(function () {
      $(this).removeAttr('role');
    });
    // issue 100
    $('body').find('.collection__filters-banner--left button').each(function () {
      $(this).removeAttr('aria-label');
    });
    // issue 112
    $('body').find('.isp_facet_title_name').each(function () {
      $(this).replaceWith(function () {
        return "<h2 class='isp_facet_title_name'>" + $(this).html() + "</h2>";
      });
    });
    // issue 104
    $('body').find('.isp_facet_value a').each(function () {
      var role = $(this).find('.isp_facet_check_box_icon').attr('role');
      var ariaChecked = $(this).find('.isp_facet_check_box_icon').attr('aria-checked');
      $(this).attr('role', role);
      $(this).attr('aria-checked', ariaChecked);
    });
    // issue 114
    $('body').find('#isp_search_results_container li').each(function () {
      //let label = $(this).find('.isp_product_title').text()
      $(this).attr('role', 'group');
      $(this).attr('aria-label', "Product");
    });
    // issue 115
    $('body').find('.isp_product_title').each(function () {
      $(this).replaceWith(function () {
        return "<h2 class='isp_product_title'>" + $(this).html() + "</h2>";
      });
    });
    // issue 121
    $('body').find('.isp_quick_view_title').each(function () {
      $(this).wrap('<h2 tabindex="0" ></h2>');
    });
    // issue 127 and 118
    $('body').find('#isp_product_quick_view_model').each(function () {
      $(this).attr('role', 'dialog');
      $(this).attr('aria-modal', 'true');
      var ariaLabel = $(this).find('.isp_quick_view_title').text();
      $(this).attr('aria-label', ariaLabel);
      $(this).attr('tabindex', 0);
    });
    //issue 120
    $('body').on("click", '.js-atc-quick-add', function (e) {
      $(this).focus();
    });
    $('#ModalCloseButton, .modal-close.js-close-modal ').attr('aria-label', "Close");
    //issue 197
    $('body').find('.isp_quick_view_type_description').attr('aria-label', "Sold Out");
    $('#my-signup-modal').attr('aria-label', "Sold Out - notify me");
  }, 1000);

  // issue 118
  setTimeout(function () {
    $('body').find('.is-checkout-view').each(function () {
      $(this).attr('aria-label', 'ADDED TO CART');
    });
    $('body').find('.collection__filter').attr({
      "aria-controls": 'single_facet_Size',
      "aria-expanded": false
    });
    $('body').find('.collection__sort').attr({
      "aria-controls": 'filter-dropdown',
      "aria-expanded": false
    });
  }, 2000);

  //close of postISPada
}

// issue 101
setInterval(function () {
  $('.content__img').attr('alt', '');
  $('.header__menu-close').attr('aria-label', 'Close menu');
}, 500);

// New Flickity slider
$(document).ready(function () {
  var mobileCarousel = function mobileCarousel(slider) {
    var sliderConfig = JSON.parse(slider.dataset.option);
    var breakpoints = {
      min: 768,
      max: 767
    };
    var disableMobile = slider.getAttribute("data-mobile-slider");
    if (disableMobile == 'false') {
      if (breakpoints.min || breakpoints.max) {
        if (breakpoints.max) {
          window.matchMedia("(max-width: ".concat(breakpoints.max, "px)")).matches ? $(slider).flickity(sliderConfig) : $(slider).addClass('destroy-slide');
        }
      }
    } else {
      $(slider).addClass('destroy-slide');
    }
  };
  var carousel = function carousel(slider) {
    var sliderConfig = JSON.parse(slider.dataset.option);
    if (slider) {
      $(slider).flickity(sliderConfig);
    }
  };
  var init = function init() {
    var msliders = _toConsumableArray2(document.querySelectorAll('.js-flickity-mobile-slider'));
    msliders.forEach(function (slider) {
      return mobileCarousel(slider);
    });
    var sliders = _toConsumableArray2(document.querySelectorAll('.js-flickity-slider'));
    sliders.forEach(function (slider) {
      return carousel(slider);
    });
  };
  init();

  // klarna script
  var globale_data = theme.utils.getCookie("GlobalE_Data");
  if (globale_data) {
    if (globale_data.includes('US') && globale_data.includes('USD')) {
      $('.product__klarna').removeClass('hide');
    }
  }
  $('.js-liveshow-all-cta').on('click', function () {
    var allVideoContent = '';
    if (liveshoppingJson.length > 0) {
      liveshoppingJson.forEach(function (liveshopping) {
        if (liveshopping.video_status == 'ended') {
          var liveShowCell = "<div class=\"live-show-cell\">\n              <div class=\"live-show-cell-wrap\">\n                <a href=\"".concat(liveshopping.link, "\">\n                  <div class=\"live-show-cell-image\">").concat(liveshopping.image, "</div>\n                  <div class=\"live-show-cell-content\">\n                    <h3 class=\"live-show-cell-title\">").concat(liveshopping.title, "</h3>\n                    <div class=\"live-show-cell-time\">").concat(liveshopping.date, "</div>\n                  </div>\n                </a>\n              </div>\n            </div>");
          allVideoContent = allVideoContent + liveShowCell;
        }
      });
    }
    $('.js-live-show-grid').empty().append(allVideoContent);
    $(this).hide();
  });
});

// PDP global e free shipping note bar
var anonunbarshippingbar = document.getElementById('GlobaleFreeShippingBannerContainer');
var pdpshippingbar = document.querySelector('.js-product-shipping-note-bar');
var cfshippingbar = document.querySelector('.js-cart-flyout-shipping-bar');
var cartPromoBars = document.querySelectorAll('.js-cart-promo-message');
var anonunbarshippingconfig = {
  attributes: true,
  childList: true,
  subtree: true
};
var anonunbarshippingbarcallback = function anonunbarshippingbarcallback(mutationsList, observer) {
  var _iterator = _createForOfIteratorHelper(mutationsList),
    _step;
  try {
    var _loop = function _loop() {
      var mutation = _step.value;
      freeshippingbar = document.getElementById('FreeShippingBanner');
      if (mutation.target.innerHTML != '' && freeshippingbar) {
        const pElement = document.querySelector("#GlobaleFreeShippingBannerContainer p");
        if (pElement) {
          pElement.remove();
        }
        var msg = mutation.target.innerText;
        if (pdpshippingbar) {
          pdpshippingbar.innerHTML = "<span data-gem-ignore>".concat(msg, "</span>");
          pdpshippingbar.style.display = 'block';
        }
        if (cfshippingbar) {
          cfshippingbar.innerHTML = "<span data-gem-ignore>".concat(msg, "</span>");
        }
        if (cartPromoBars && cartPromoBars.length > 0) {
          cartPromoBars.forEach(function (cartPromoBar) {
            cartPromoBar.innerHTML = "<span data-gem-ignore>".concat(msg, "</span>");
          });
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var freeshippingbar;
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var aobserver = new MutationObserver(anonunbarshippingbarcallback);
if (anonunbarshippingbar) {
  aobserver.observe(anonunbarshippingbar, anonunbarshippingconfig);
}

// content video sounds on off script
$(document).ready(function () {
  var muted = true;
  $('.video-sound-option button').on('click', function () {
    var soundType = $(this).attr('data-type');
    $('.video-sound-option button').addClass('active');
    $(this).removeClass('active');
    if (soundType == 'muted') {
      muted = false;
    } else {
      muted = true;
    }
    $(this).closest('.content-vd-wrapper').find('video').each(function () {
      $(this)[0].muted = muted;
    });
  });
  //v-next code
  $('#coming-soon-modal-wrap .js-close-modal,#out-of-stock-wrap .js-close-modal').on('click', function () {
    $(this).closest('.modal-overlay').addClass('hidden');
    $(this).closest('.modal-content.is-opened').removeClass('is-opened');
    $(this).closest('.modal-overlay>.modal-content').addClass('is-closed');
  });
  $('body').on('click', '.out-of-stock__submit-wrap.button', function (e) {
    e.preventDefault();
    var $submitbutton = $(this);
    if (!$submitbutton.attr('disabled')) {
      $(this).closest('.modal-overlay').addClass('showsuccess');
      setTimeout(function () {
        //$('.thank-you-success__button').trigger('click');
      }, 100);
    }
  });
});
$(document).ready(function () {
  // console.log('hiddenAnnouncementBar=', localStorage.getItem('hiddenAnnouncementBar'));
  if (localStorage.getItem('hiddenAnnouncementBar') === 'true') {
    $('.announcement-bar').addClass('is-hidden');
  } else {
    $('.announcement-bar').removeClass('is-hidden');
  }
  $(document).on('click', '#removeAnnouncements', function () {
    $('.announcement-bar').addClass('is-hidden');
    localStorage.setItem('hiddenAnnouncementBar', 'true');
  });
});

// /**** localization **********/
var storageCountry = "country_code";
var storageLanguage = "language_code";
function set_location(country, language) {
  var store_domain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var gleSelectCountry = $('#gle_selectedCountry');
  var formId = crypto.randomUUID();
  var glredirect = gleSelectCountry.find('option:selected').attr('data-redirecturl');
  var formHtml = "\n    <form id=\"".concat(formId, "\" action=\"").concat(store_domain, "/localization\" method=\"POST\" hidden>\n      <input name=\"_method\" value=\"PUT\">\n      <input name=\"country_code\" value=\"").concat(country, "\">\n      <input name=\"language_code\" value=\"").concat(language, "\">\n    </form>\n  ");
  document.body.insertAdjacentHTML("beforeend", formHtml);
  localStorage.setItem("localizationsetup", true);
  if (store_domain === '') {
    localStorage.setItem(storageCountry, country);
    localStorage.setItem(storageLanguage, language);
  }
  document.getElementById(formId).submit();
}
$(document).ready(function () {
  var euSites = ['AL', 'AM', 'BA', 'FO', 'BG', 'BI', 'CG', 'CZ', 'DK', 'GE', 'DE', 'GG', 'HU', 'IM', 'JE', 'LR', 'LI', 'YT', 'ME', 'MD', 'NO', 'PL', 'RO', 'RS', 'SX', 'SH', 'SE', 'CH', 'TR', 'GB', 'AD', 'BE', 'HR', 'CY', 'EE', 'GF', 'GR', 'GP', 'IT', 'LT', 'LU', 'MT', 'MQ', 'MC', 'NL', 'PT', 'RE', 'SK', 'SI', 'SM', 'ES', 'BL', 'VA', 'GI', 'GL', 'IS', 'IE', 'CH', 'FR', 'FI', 'AT'];
  var glePopup = $('#globalePopupWrapper');
  var gleSelectCountry = $('#gle_selectedCountry');
  var gleSelectCurrency = $('#gle_selectedCurrency');
  var glLocalInfo = null;
  $.ajax({
    url: window.Shopify.routes.root + 'browsing_context_suggestions.json' + '?country[enabled]=true' + "&country[exclude]=".concat(window.Shopify.country) + '&language[enabled]=true' + "&language[exclude]=".concat(window.Shopify.language),
    type: 'GET',
    dataType: 'json'
  }).done(function (localinfo) {
    // console.log('localinfo = ', localinfo);
    glLocalInfo = localinfo;
  }).always(function () {
    var setIpCheck = localStorage.getItem("setIpCheck");
    // console.log('setIpCheck = ', setIpCheck);
    // console.log('glLocalInfo.country = ', glLocalInfo.detected_values.country.handle);
    if (glLocalInfo != null) {
      if (euSites.includes(glLocalInfo.detected_values.country.handle)) {
        setIpCheck = true;
        localStorage.setItem("setIpCheck", true);
      }
    }
    if (setIpCheck == null || setIpCheck == false) {
      var langSelector = $("#md-form__select__country");
      if (langSelector) {
        setTimeout(function () {
          const bodyElement = document.querySelector('body');
          const countryCodeClass = Array.from(bodyElement.classList).find(className => className.startsWith('orbe-country-code--'));
          var currentCountry = '';
          if (countryCodeClass) {
            currentCountry = countryCodeClass.split('--')[1];
            // console.log('- currentCountry: ', currentCountry);
          }
          if (currentCountry == '') {
            if (glLocalInfo != null) {
              // console.log('- glLocalInfo:', glLocalInfo.detected_values.country.handle);
              currentCountry = glLocalInfo.detected_values.country.handle;
            }
          }
          const language = window.Shopify.locale;
          const store_country = window.Shopify.country;
          // console.log('- Country:', currentCountry); 
          // console.log('- language:', language); 
          // console.log('- window.Shopify.country:', store_country); 
          let store_domain = '';
          if (euSites.includes(currentCountry)) {
            store_domain = 'https://eu.aninebing.com';
          }
          localStorage.setItem("setIpCheck", true);
          if (currentCountry != store_country) {
            set_location(currentCountry, language, store_domain);
          }
        }, 1000);
      }
      /*
      fetch('https://ipinfo.io/json?token=23474cfa662c6c').then(function (response) {
        return response.json();
      }).then(function (data) {
        // console.log('data = ', data);
        // console.log('Country:', data.country);
        // console.log('Region:', data.region);
        // console.log('City:', data.city);
        // console.log('window.Shopify.country:', window.Shopify.country);
        var language = window.Shopify.locale;
        var store_country = window.Shopify.country;
        var store_domain = '';
        if (euSites.includes(data.country)) {
          store_domain = 'https://eu.aninebing.com';
        }
        localStorage.setItem("setIpCheck", true);
        if (data.country != store_country) {
          set_location(data.country, language, store_domain);
        }
      })["catch"](function (error) {
        return console.error('Error fetching IP info:', error);
      });
      */
    }
  });
  $('.glSaveBtn').on('click', function () {
    var country = gleSelectCountry.val();
    var language = window.Shopify.locale;
    var store_domain = '';
    if (euSites.includes(country)) {
      store_domain = 'https://eu.aninebing.com';
    }
    set_location(country, language, store_domain);
  });
  $('.js-localization-selector').on('click', function () {
    glePopup.fadeIn();
    setTimeout(function () {
      $('#gle_selectedCountry').focus();
    }, 100);
  });
  $('.globale_popup_wrapper .glClose,.globale_popup_wrapper .globale_overlay').on('click', function () {
    glePopup.fadeOut();
    $('.js-localization-selector').focus();
    setTimeout(function () {
      $('.js-localization-selector').focus();
    }, 500);
  });

  // $('body').click(function(e) {
  //   e.preventDefault();

  //   var container = $(".glDefaultPopupContainer");
  //   var locationSelectButton = document.querySelector('.js-localization-selector span');

  //   if(e.target != locationSelectButton){
  //     if (!container.is(e.target) && !container.has(e.target).length) {
  //       glePopup.fadeOut();
  //     }
  //   }
  // });

  function gle_popup_change(country) {
    gleSelectCountry.val(country).trigger("change");
  }

});
// console.log('window.location.href = ', window.location.href);
if (window.location.href) {
  // console.log('current url = ', window.location.href);
  // console.log('window.Shopify.routes.root = ', window.Shopify.routes.root);
  // console.log('window.Shopify.country = ', window.Shopify.country);
  // console.log('window.Shopify.locale = ', window.Shopify.locale);
  var current_url = window.location.href;
  var country_code = localStorage.getItem(storageCountry);
  var language_code = localStorage.getItem(storageLanguage);
  // console.log("country_code = ".concat(country_code, ", language_code = ").concat(language_code));
  if (country_code == null || country_code == '') {
    localStorage.setItem(storageCountry, window.Shopify.country);
    country_code = window.Shopify.country;
  }
  if (language_code == null || language_code == '') {
    localStorage.setItem(storageLanguage, window.Shopify.locale);
    language_code = window.Shopify.locale;
  }
  if (current_url.includes('aninebing.com/cart')) {
    if (country_code != window.Shopify.country || language_code != window.Shopify.locale) {
      set_location(country_code, language_code);
    }
  }
  if (!current_url.includes('aninebing.com/checkouts')) {
    if (document.referrer.includes('aninebing.com/checkouts')) {
      if (country_code != window.Shopify.country || language_code != window.Shopify.locale) {
        set_location(country_code, language_code);
      }
    }
  }
  if (document.referrer.includes('eu.aninebing.com')) {
    localStorage.setItem(storageCountry, window.Shopify.country);
    localStorage.setItem(storageLanguage, window.Shopify.locale);
  } else {
    if (document.referrer.includes('www.aninebing.com')) {
      if (country_code != window.Shopify.country || language_code != window.Shopify.locale) {
        set_location(country_code, language_code);
      }
    }
  }
  // console.log(":country_code = ".concat(localStorage.getItem(storageCountry), ", language_code = ").concat(localStorage.getItem(storageLanguage)));
  // console.log('Referrer:', document.referrer);
}
document.addEventListener('DOMContentLoaded', function () {
  var searchForm = document.querySelector('form[action="/pages/search-results"]');
  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      setTimeout(function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 500);
    });
  }
});
var statusVennCloseButton = false;
document.addEventListener("DOMContentLoaded", function (event) {
  var targetNode = document.body;
  var config = {
    childList: true,
    subtree: true
  };
  var callback = function callback(mutationsList, observer) {
    var _iterator2 = _createForOfIteratorHelper(mutationsList),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var mutation = _step2.value;
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === 'div') {
              if (node.textContent.includes('This product cannot be shipped to your country')) {
                // console.log('Alert is displayed.', node);
                node.classList.add('shipping-country-warning');
                var deviderDiv = document.createElement('div');
                deviderDiv.classList.add('divider');
                node.appendChild(deviderDiv);
                var footerDiv = document.createElement('div');
                footerDiv.classList.add('modal-footer');
                var actionBtn = document.createElement('button');
                actionBtn.textContent = 'OK';
                actionBtn.id = 'remove-warning-button';
                footerDiv.appendChild(actionBtn);
                node.appendChild(footerDiv);
              }
              if (node.id === 'venn-deeplink-banner' && !statusVennCloseButton) {
                var closeButton = node.querySelector('.venn-close-button');
                closeButton.innerHTML = '<svg class="svg-icon icon-close icon-close--small" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 10" fill-rule="evenodd" fill="#FFFFFF" stroke="#FFFFFF" stroke-linecap="square"><path d="M8.405 1l-8 8M8.405 9l-8-8"></path></svg>';
                statusVennCloseButton = true;
              }
              if (document.querySelector('.modal-overlay.js-modal-click-exclude')) {
                var saleGatewayModal = document.querySelector('.modal-overlay.js-modal-click-exclude #sale-gateway-modal');
                if (saleGatewayModal) {
                  var otherModals = document.querySelectorAll('.modal-overlay.js-modal-click-exclude .modal-content:not(#sale-gateway-modal)');
                  otherModals.forEach(function (modal) {
                    modal.remove();
                  });
                }
              }
            }
          });
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
  document.body.addEventListener('click', function (event) {
    if (event.target && event.target.id === 'remove-warning-button') {
      var warningElement = document.querySelector('.shipping-country-warning');
      if (warningElement) {
        warningElement.remove();
      }
    }
  });
  if (theme.template.name === 'collection') {
    var currentCartCount = "";
    const cartNode = document.querySelector('.header__count.js-cart-count span');
    const cartConfig = { childList: true, subtree: true };
    const cartCallback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          let updatedCartCount = mutation.target.textContent;
          // console.log(`cart count is changed. currentCartCount = ${currentCartCount}, updatedCartCount = ${updatedCartCount}`);
          if (currentCartCount !== updatedCartCount) {
            currentCartCount = updatedCartCount;
            window.theme.cart.fetch();
          }
        }
      }
    };
    const cartObserver = new MutationObserver(cartCallback);
    cartObserver.observe(cartNode, cartConfig);
  }
});
$(document).ready(function () {
  $(document).on('click', '.thank-you-success button.modal-close', function () {
    $(this).parent().css('display', 'none');
  });
});

document.addEventListener('click', function (e) {
  const quantityButton = e.target.closest('.js-cart-item-quantity-updater');
  if (quantityButton) {
    const lineItemKey = quantityButton.dataset.lineItemKey;
    const focusTarget = quantityButton.dataset.focusTarget;

    // Store the current focus target
    window.lastFocusedQuantity = focusTarget;
    // console.log('focusTarget',focusTarget);
  }
});


// New Gift Script Start


(function () {
  const box = document.querySelector(".js-cart-gift-note");
  const modalWrap = document.querySelector("#newgift-wrap");
  let closeBtn = null;
  if( box ){
    closeBtn = box.querySelector(".close-gift-popup");
  }
  let modalDismissed = false;
  let giftWasInCart = false;

  if (!box) return;

  const giftVariantId = Number(box.dataset.giftVariant);
  const allowPurchase = box.dataset.allowPurchase === "true";
  const addedMsg = box.dataset.addedMessage || "";
  const removedMsg = box.dataset.removedMessage || "";
  const eligibleMsg = box.dataset.eligibleMessage || "";

  const btn = box.querySelector(".js-gwp-add");
  const productbox = box.querySelector(".gift-embed__product");
  
  const msgEl = box.querySelector(".js-gwp-message");

  const GWP = window.GWP_SETTINGS || {};

  // 🔥 normalize
  const triggerType = Array.isArray(GWP.trigger_type)
    ? GWP.trigger_type[0]
    : GWP.trigger_type;

  const giftAddMethod = Array.isArray(GWP.gift_add_method)
    ? GWP.gift_add_method[0]
    : GWP.gift_add_method;

  let busy = false;
  // #updated GWP Code start
  let giftAddInFlight = false;
  let giftRemoveInFlight = false;
  // #updated GWP Code end

  // =========================
  // THEME HELPERS
  // =========================
  // #updated GWP Code start
  function getCart() {
    return fetch("/cart?view=gwp-json&t=" + Date.now(), { cache: "no-store" }).then(r => r.json());
  }
  // #updated GWP Code end

  // #updated GWP Code start
  function themeAdd(variantId) {
    if (window.theme?.cart?.add) {
      return window.theme.cart.add(variantId) || Promise.resolve();
    }
    return Promise.resolve();
  }

  function themeUpdate(key, qty) {
    if (window.theme?.cart?.update) {
      return window.theme.cart.update({
        id: key,
        quantity: qty
      }) || Promise.resolve();
    }
    return Promise.resolve();
  }
  // #updated GWP Code end

  function findGift(cart) {
    return cart.items.find(i => i.id === giftVariantId);
  }

  function isCustomerEligible() {
    let rule = GWP.eligible_customer_tags;
    const customerTags = GWP.customer_tags || [];

    // no rule → allow all
    if (!rule || rule.length === 0) return true;

    let allowed = [];

    // ⭐ HANDLE JSON STRING CASE (your bug)
    try {
      if (typeof rule === "string" && rule.trim().startsWith("[")) {
        allowed = JSON.parse(rule);
      } else if (Array.isArray(rule)) {
        allowed = rule;
      } else {
        allowed = String(rule).split(",");
      }
    } catch (e) {
      allowed = String(rule).split(",");
    }

    // normalize
    allowed = allowed.map(t => String(t).toLowerCase().trim());

    return customerTags.some(tag =>
      allowed.includes(String(tag).toLowerCase())
    );
  }

  const productTypeCache = {};

  function getProductType(handle) {
    if (!handle) return Promise.resolve("");
    if (productTypeCache[handle]) return Promise.resolve(productTypeCache[handle]);
    return fetch("/products/" + handle + ".js")
      .then(function (res) { return res.json(); })
      .then(function (data) {
        productTypeCache[handle] = data.type;
        return data.type;
      })
      .catch(function (e) {
        //console.warn("[GWP] failed to fetch product type for", handle, e);
        return "";
      });
  }

  function isEligible(cart) {
    if (!triggerType) return Promise.resolve(false);

    // ⭐ CUSTOMER GUARD (ADD THIS)
    if (!isCustomerEligible()) {
      //console.log("[GWP] customer not eligible");
      return Promise.resolve(false);
    }

    // ===== SPEND X GET Y (FINAL SAFE) =====
    if (triggerType === "spend_x_get_y") {
      let subtotalCents = 0;
      let promise = Promise.resolve();

      cart.items.forEach(function (item) {
        // gift skip
        if (item.id === giftVariantId) return;

        promise = promise.then(function () {
          // #updated GWP Code start
          if (GWP.eligible_collection_id) {
            const eligibleCollectionId = Number(GWP.eligible_collection_id);
            const itemCollectionIds = item.collection_ids || [];
            //console.log('itemCollectionIds',itemCollectionIds);
            if (!itemCollectionIds.includes(eligibleCollectionId)) {
              return;
            }
          }
          // #updated GWP Code end

          if (GWP.eligible_product_type) {
            const productType = item.product_type;
            if (productType) {
              if (productType === GWP.eligible_product_type) {
                subtotalCents += item.original_line_price;
              }
              return;
            }
            return getProductType(item.handle).then(function (fetchedType) {
              if (fetchedType === GWP.eligible_product_type) {
                subtotalCents += item.original_line_price;
              }
            });
          } else {
            subtotalCents += item.original_line_price;
          }
        });
      });

      return promise.then(function () {
        return subtotalCents >= Number(GWP.minimum_spend_cents || 0);
      });
    }

    // ===== BUY X GET Y =====
    if (triggerType === "buy_x_get_y") {
      let qty = 0;
      let promise = Promise.resolve();

      cart.items.forEach(function (item) {
        if (item.id === giftVariantId) return;

        promise = promise.then(function () {
          // #updated GWP Code start
          if (GWP.eligible_collection_id) {
            const eligibleCollectionId = Number(GWP.eligible_collection_id);
            const itemCollectionIds = item.collection_ids || [];
            if (!itemCollectionIds.includes(eligibleCollectionId)) {
              return;
            }
          }
          // #updated GWP Code end

          if (GWP.eligible_product_type) {
            const productType = item.product_type;
            if (productType) {
              if (productType === GWP.eligible_product_type) {
                qty += item.quantity;
              }
              return;
            }
            return getProductType(item.handle).then(function (fetchedType) {
              if (fetchedType === GWP.eligible_product_type) {
                qty += item.quantity;
              }
            });
          } else {
            qty += item.quantity;
          }
        });
      });

      return promise.then(function () {
        return qty >= Number(GWP.minimum_quantity || 1);
      });
    }

    return Promise.resolve(false);
  }

  function toggleGiftModal(active) {
    if (!modalWrap) return;

    if (active && !modalDismissed) {
      modalWrap.classList.add("modal-active");
    } else {
      modalWrap.classList.remove("modal-active");
    }
  }

  const autoPopup = document.querySelector("#gwp-auto-popup");
  const autoPopupClose = autoPopup?.querySelector(".gwp-auto-popup__close");

  let autoPopupShown = false;

function showAutoGiftPopup() {
    if (!autoPopup) return;

    if (autoPopupShown) return;

    autoPopupShown = true;
    autoPopup.classList.add("active");
}

function hideAutoGiftPopup() {
    autoPopupShown = false;
    autoPopup?.classList.remove("active");
} 

  autoPopupClose?.addEventListener("click", hideAutoGiftPopup);

  window.evaluate = async function () {
    if (busy) return;
    busy = true;

    try {
      const cart = await getCart();
      // if (lastCartToken && lastCartToken !== cart.token) {
      //   modalDismissed = false;
      // }

      // lastCartToken = cart.token;
      const giftLine = findGift(cart);
      // Gift removed -> allow popup next time
      if (!giftLine) {
          giftWasInCart = false;
          modalDismissed = false;
      }
      
      // #updated GWP Code start
      // Reset state machine flags based on whether the gift is confirmed in the cart
      if (giftLine) {
        giftAddInFlight = false;
      } else {
        giftRemoveInFlight = false;
      }
      // #updated GWP Code end

      const paidItems = cart.items.filter(i => i.id !== giftVariantId);
      const eligible = await isEligible(cart);

      // ⭐ RELEASE INITIAL LOCK (ADD THIS)
      if (box.classList.contains("gift-initial-hide")) {
        box.classList.remove("gift-initial-hide");
        box.classList.add("gwp-ready");
      }

      // 🚫 standalone
      // #updated GWP Code start
      if (!allowPurchase && giftLine && paidItems.length === 0 && !giftRemoveInFlight) {
        giftRemoveInFlight = true;
        await themeUpdate(giftLine.key, 0);
        if (window.theme?.cart?.fetch) {
          await window.theme.cart.fetch();
        }
        busy = false;
        return;
      }

      // 🔒 qty lock
      if (giftLine && giftLine.quantity > 1 && !giftAddInFlight && !giftRemoveInFlight) {
        await themeUpdate(giftLine.key, 1);
        if (window.theme?.cart?.fetch) {
          await window.theme.cart.fetch();
        }
        busy = false;
        return;
      }

      // ❌ remove when not eligible (NON-BLOCKING)
      if (!eligible && giftLine && !giftRemoveInFlight) {
        giftRemoveInFlight = true;
        await themeUpdate(giftLine.key, 0);
        if (window.theme?.cart?.fetch) {
          await window.theme.cart.fetch();
        }

        if (msgEl) msgEl.textContent = removedMsg;
        if (productbox) productbox.style.display = "none";

        modalDismissed = false;
      }
      // #updated GWP Code end

      // ✅ AUTO ADD
      // #updated GWP Code start
      if (
        eligible &&
        !giftLine &&
        giftAddMethod === "automatic" &&
        !giftAddInFlight
      ) {
        giftAddInFlight = true;
        await themeAdd(giftVariantId);

        // ⭐ show confirmation popup
        showAutoGiftPopup();

        if (msgEl) msgEl.textContent = addedMsg;
        if (productbox) productbox.style.display = "none";

        busy = false;
        return;
      }
      // #updated GWP Code end

      // ⭐ MODAL MODE SUPPORT (TOKEN SAFE)
      if (giftAddMethod === "modal") {

          if (giftLine && !giftWasInCart && !modalDismissed) {
              giftWasInCart = true;
              toggleGiftModal(true);
          } else {
              toggleGiftModal(false);
          }

      }

      // ⚠️ eligible but removed
      if (eligible && !giftLine) {
        if (msgEl) msgEl.textContent = eligibleMsg;
        if (productbox) productbox.style.display = "flex";
        busy = false;
        return;
      }

      // ✅ gift present
      if (eligible && giftLine) {
        if (msgEl) msgEl.textContent = addedMsg;
        if (productbox) productbox.style.display = "none";
      }
    } catch (e) {
      console.error("[GWP]", e);
    }

    busy = false;
  }

  // =========================
  // BUTTON
  // =========================
  btn?.addEventListener("click", () => {
    themeAdd(giftVariantId);
  });

  closeBtn?.addEventListener("click", () => {
    modalDismissed = true;
    toggleGiftModal(false);
  });

  // =========================
  // WATCHERS (IMPORTANT)
  // =========================
  $(document).on('Cart:set Cart:add Cart:change Cart:update Cart:clear', function () {
    setTimeout(evaluate, 300);
  });

  // fallback
  setInterval(evaluate, 3000);

  evaluate();
})();


// =========================
// 🔥 INITIAL CHECK ON LOAD
// =========================
document.addEventListener("DOMContentLoaded", function () {
  console.log('onload run test');
  if (typeof window.evaluate === "function") {
    console.log('onload run');
    setTimeout(() => {
      window.evaluate();
    }, 500);
  }
});



// =========================
// 🔥 CART AJAX WATCHER (ENTERPRISE SAFE)
// =========================
(function () {
  if (!window.fetch) return;

  const originalFetch = window.fetch;

  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);

    try {
      const url = arguments[0];

      if (
        typeof url === "string" &&
        (
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update")
        )
      ) {
        //console.log("[GWP] cart ajax detected → evaluate");

        setTimeout(() => {
          if (typeof window.evaluate === "function") {
            window.evaluate();
          }
        }, 500);
      }
    } catch (e) {
      //console.warn("[GWP] fetch hook error", e);
    }

    return response;
  };
})();